window.DIAGNOSES_DATA = {
  "generated_at": "2026-01-31T11:48:51.642Z",
  "total": 340,
  "diagnoses": [
    {
      "term": "Achillova burzitída",
      "canonical_term": "achilová burzitída",
      "slug": "achillova-burzitida",
      "aliases": [
        "zápal burzy Achillovej šľachy",
        "retrocalcaneárna burzitída"
      ],
      "definition": "Achillova burzitída je zápal burzy nachádzajúcej sa medzi Achillovou šľachou a pätovou kosťou (calcaneus), ktorý spôsobuje bolesť, opuch a citlivosť v oblasti zadnej časti päty.",
      "clinical_context": "Toto ochorenie sa často vyskytuje u športovcov, najmä bežcov, alebo u osôb s opakovaným preťažením Achillovej šľachy. Môže byť vyvolané nevhodnou obuvou, nadmerným zaťažením alebo anatomickými odchýlkami chodidla.",
      "relation_to_gait": "Achillova burzitída spôsobuje bolesť pri chôdzi, najmä pri odraze z päty, čo vedie k obmedzeniu pohybu a často k šetreniu postihnutej končatiny. Môže viesť k poruche stereotypu chôdze a sekundárnym problémom v oblasti dolných končatín.",
      "who_is_affected": "Najčastejšie postihuje športovcov, osoby s nadváhou, starších ľudí a osoby s nevhodnou obuvou alebo biomechanickými abnormalitami chodidla.",
      "medicovi_relevance": "Včasná diagnostika a liečba Achillovej burzitídy je kľúčová pre prevenciu chronických bolestí a funkčných obmedzení pohybového aparátu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Achilles tendinopathy and related disorders",
          "authors": "Maffulli N, Longo UG, Denaro V",
          "journal": "BMJ",
          "year": "2011",
          "url": "https://www.bmj.com/content/343/bmj.d4699"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "achillova šľacha",
      "canonical_term": "achilova šľacha",
      "slug": "achillova-slacha",
      "aliases": [
        "tendo Achillis",
        "Achillova šlacha"
      ],
      "definition": "Achillova šľacha je najväčšia a najsilnejšia šľacha v ľudskom tele, ktorá spája lýtkové svaly (musculus gastrocnemius a soleus) s pätovou kosťou (calcaneus).",
      "clinical_context": "Achillova šľacha je kľúčová pre pohyb členka, najmä pri plantárnej flexii, ktorá je nevyhnutná pri chôdzi, behu a skákaní. Je častým miestom úrazov, najmä u športovcov a fyzicky aktívnych osôb.",
      "relation_to_gait": "Funkčnosť Achillovej šľachy je nevyhnutná pre odrazovú fázu chôdze, keďže umožňuje zdvihnutie päty od podložky a efektívny pohyb vpred.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, osoby stredného veku a ľudia s náhlym zvýšením fyzickej aktivity.",
      "medicovi_relevance": "Poruchy Achillovej šľachy významne ovplyvňujú schopnosť chôdze a kvalitu života, preto je jej diagnostika a liečba kľúčová v ortopédii a rehabilitácii.",
      "internal_link": "/pages/patova-ostroha-plantarna-fasciitis",
      "citations": [
        {
          "title": "Achilles tendinopathy",
          "authors": "Maffulli N, Longo UG, Denaro V",
          "journal": "BMJ",
          "year": "2011",
          "url": "https://www.bmj.com/content/343/bmj.d4699"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "achillova tendinitída",
      "canonical_term": "achilová tendinitída",
      "slug": "achillova-tendinitida",
      "aliases": [
        "tendinitída Achillovej šľachy",
        "zápal Achillovej šľachy"
      ],
      "definition": "Achillova tendinitída je zápalové alebo degeneratívne ochorenie Achillovej šľachy, ktoré sa prejavuje bolesťou, opuchom a citlivosťou v oblasti zadnej časti členka.",
      "clinical_context": "Achillova tendinitída vzniká najčastejšie v dôsledku opakovaného preťaženia šľachy, typicky u športovcov alebo osôb so zvýšenou fyzickou aktivitou. Klinicky sa prejavuje bolesťou pri chôdzi, behu alebo státí na špičkách, často je prítomný opuch a citlivosť na pohmat. Diagnóza je založená na klinickom obraze, v niektorých prípadoch sa využíva ultrazvuk alebo MRI.",
      "relation_to_gait": "Achillova tendinitída spôsobuje bolesť pri odraze nohy od podložky, čo vedie k obmedzeniu chôdze, zmenám v stereotypoch chôdze a zníženiu výkonnosti pri pohybe.",
      "who_is_affected": "Najčastejšie postihuje bežcov, športovcov, osoby so zvýšenou hmotnosťou alebo s anatomickými odchýlkami v oblasti nohy.",
      "medicovi_relevance": "Včasná diagnostika a liečba achillovej tendinitídy sú kľúčové pre prevenciu ruptúry šľachy a obnovenie normálnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Achilles tendinopathy",
          "authors": "Maffulli N, et al.",
          "journal": "BMJ",
          "year": "2017",
          "url": "https://www.bmj.com/content/358/bmj.j4290"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "ALS (amyotrofická laterálna skleróza",
      "canonical_term": "amyotrofická laterálna skleróza",
      "slug": "als-amyotroficka-lateralna-skleroza",
      "aliases": [
        "amyotrofická laterálna skleróza",
        "ALS",
        "Lou Gehrigova choroba"
      ],
      "definition": "ALS je progresívne neurodegeneratívne ochorenie postihujúce motorické neuróny v mozgu a mieche, vedúce k svalovej slabosti, atrofii a nakoniec k respiračnému zlyhaniu.",
      "clinical_context": "ALS sa prejavuje postupnou stratou motorických funkcií, pričom senzitivita a kognitívne funkcie sú väčšinou zachované. Ochorenie má rýchly priebeh a vysokú mortalitu.",
      "relation_to_gait": "ALS spôsobuje slabosť dolných končatín, spasticitu a poruchy koordinácie, čo vedie k výraznému zhoršeniu stability chôdze, častým pádom a postupnej strate schopnosti samostatne chodiť.",
      "who_is_affected": "Najčastejšie postihuje osoby vo veku 40-70 rokov, s mierne vyšším výskytom u mužov.",
      "medicovi_relevance": "Včasné rozpoznanie porúch chôdze pri ALS je dôležité pre plánovanie rehabilitácie, prevenciu pádov a zlepšenie kvality života pacientov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Amyotrophic lateral sclerosis",
          "authors": "Hardiman O, Al-Chalabi A, Chio A, et al.",
          "journal": "Nature Reviews Disease Primers",
          "year": "2017",
          "url": "https://www.nature.com/articles/nrdp201771"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "ankylozujúca spondylitída",
      "canonical_term": "ankylozujúca spondylitída",
      "slug": "ankylozujuca-spondylitida",
      "aliases": [
        "Bechterevova choroba",
        "spondylitis ankylopoetica"
      ],
      "definition": "Ankylozujúca spondylitída je chronické zápalové ochorenie patriace medzi spondyloartritídy, ktoré postihuje najmä sakroiliakálne kĺby a chrbticu, ale môže zasiahnuť aj bedrové kĺby, vedúce k ich stuhnutiu a obmedzeniu pohyblivosti.",
      "clinical_context": "Pri postihnutí bedrových kĺbov dochádza k bolestiam, stuhnutiu a progresívnemu obmedzeniu pohybu. Ochorenie je často spojené s HLA-B27 pozitivitou a začína v mladom dospelom veku. Diagnostika zahŕňa klinické vyšetrenie, laboratórne testy a zobrazovacie metódy.",
      "relation_to_gait": "Ankylozujúca spondylitída s postihnutím bedrových kĺbov vedie k výraznému obmedzeniu chôdze, skracovaniu kroku, krívaniu a v pokročilých štádiách až k potrebe opory pri chôdzi.",
      "who_is_affected": "Najčastejšie postihuje mužov vo veku 15–40 rokov, ale môže sa vyskytnúť aj u žien.",
      "medicovi_relevance": "Včasná diagnostika a liečba ankylozujúcej spondylitídy je zásadná pre zachovanie funkcie bedrových kĺbov a prevenciu ťažkých porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Ankylosing spondylitis",
          "authors": "Braun J, Sieper J.",
          "journal": "The Lancet",
          "year": "2007",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(07)60635-7/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "antalgická chôdza",
      "canonical_term": "antalgická chôdza",
      "slug": "antalgicka-chodza",
      "aliases": [
        "antalgický spôsob chôdze",
        "bolestivá chôdza"
      ],
      "definition": "Antalgická chôdza je špecifický typ chôdze, pri ktorom pacient skracuje dobu zaťaženia postihnutej končatiny v dôsledku bolesti, čím sa snaží minimalizovať nepríjemné pocity.",
      "clinical_context": "Antalgická chôdza sa často vyskytuje u pacientov s muskuloskeletálnymi alebo neurologickými ochoreniami, ktoré spôsobujú bolesť pri zaťažení dolnej končatiny. Klinicky je dôležité rozpoznať tento typ chôdze, pretože môže signalizovať akútny alebo chronický patologický proces.",
      "relation_to_gait": "Antalgická chôdza vedie k asymetrickému zaťažovaniu končatín, skracovaniu kroku na postihnutej strane a narušeniu stability chôdze. Pacient sa snaží čo najrýchlejšie preniesť váhu na zdravú končatinu.",
      "who_is_affected": "Postihuje osoby s bolesťou dolných končatín spôsobenou napríklad artritídou, neuropatiou, zlomeninami alebo inými neurologickými a ortopedickými ochoreniami.",
      "medicovi_relevance": "Rozpoznanie antalgickej chôdze je kľúčové pre diferenciálnu diagnostiku príčin porúch chôdze a pre plánovanie rehabilitácie.",
      "internal_link": null,
      "citations": [
        {
          "title": "Gait disorders in adults and the elderly",
          "authors": "Hausdorff JM, Rios DA, Edelberg HK",
          "journal": "BMJ",
          "year": "2001",
          "url": "https://www.bmj.com/content/322/7296/1441"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "apraxia chôdze",
      "canonical_term": "apraxia chôdze",
      "slug": "apraxia-chodze",
      "aliases": [
        "apraxia chôdzového vzorca",
        "chôdzová apraxia"
      ],
      "definition": "Apraxia chôdze je neurologická porucha charakterizovaná neschopnosťou správne koordinovať pohyby dolných končatín pri chôdzi, napriek zachovanej sile a citlivosti. Pacient nie je schopný vykonať chôdzový pohyb na základe vôle, hoci motorické a senzorické funkcie sú relatívne neporušené.",
      "clinical_context": "Apraxia chôdze sa najčastejšie vyskytuje pri poškodení frontálnych lalokov mozgu, napríklad pri normotenznom hydrocefaluse, cievnych mozgových príhodách alebo neurodegeneratívnych ochoreniach. Klinicky sa prejavuje pomalou, neistou chôdzou s krátkymi krokmi a ťažkosťami pri začatí pohybu.",
      "relation_to_gait": "Porucha výrazne ovplyvňuje stabilitu a plynulosť chôdze. Pacienti majú problém začať chôdzu, často sa zastavujú a ich kroky sú nekoordinované, čo zvyšuje riziko pádov.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých s neurologickými ochoreniami, ako je normotenzný hydrocefalus, Parkinsonova choroba alebo po cievnej mozgovej príhode.",
      "medicovi_relevance": "Včasná diagnostika apraxie chôdze je kľúčová pre správne nastavenie rehabilitácie a prevenciu pádov u pacientov s neurologickými ochoreniami.",
      "internal_link": null,
      "citations": [
        {
          "title": "Gait apraxia: clinical features, pathophysiology, and management",
          "authors": "Nutt JG, Marsden CD, Thompson PD",
          "journal": "JAMA",
          "year": "1993",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/406127"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "artroskopia bedrového kĺbu",
      "canonical_term": "artroskopia bedrového kĺbu",
      "slug": "artroskopia-bedroveho-klbu",
      "aliases": [
        "artroskopická operácia bedrového kĺbu"
      ],
      "definition": "Artroskopia bedrového kĺbu je minimálne invazívny chirurgický zákrok, pri ktorom sa pomocou artroskopu vizualizuje a ošetruje vnútorné štruktúry bedrového kĺbu.",
      "clinical_context": "Používa sa na diagnostiku a liečbu intraartikulárnych patológií, ako sú poškodenia labra, chrupavky, impingement syndróm alebo odstránenie voľných teliesok.",
      "relation_to_gait": "Artroskopia môže viesť k rýchlejšiemu návratu k normálnej chôdzi v porovnaní s otvorenými operáciami, keďže minimalizuje poškodenie mäkkých tkanív a urýchľuje rehabilitáciu.",
      "who_is_affected": "Najčastejšie mladší a aktívni pacienti s mechanickými problémami bedrového kĺbu, športovci alebo osoby s impingement syndrómom.",
      "medicovi_relevance": "Znalosť indikácií a možností artroskopie je dôležitá pre včasnú diagnostiku a liečbu porúch bedrového kĺbu ovplyvňujúcich chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Hip Arthroscopy: Indications, Outcomes, and Complications",
          "authors": "Griffin DR, et al.",
          "journal": "The Lancet",
          "year": "2019",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(19)30488-4/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "artroskopia kolena",
      "canonical_term": "artroskopia kolenného kĺbu",
      "slug": "artroskopia-kolena",
      "aliases": [
        "artroskopická operácia kolena",
        "artroskopia kolenného kĺbu"
      ],
      "definition": "Artroskopia kolena je minimálne invazívna chirurgická metóda, pri ktorej sa pomocou artroskopu vizualizuje a ošetruje vnútorná štruktúra kolenného kĺbu.",
      "clinical_context": "Artroskopia sa využíva na diagnostiku a liečbu poškodení meniskov, väzov, chrupaviek a synoviálnej membrány. Je indikovaná pri pretrvávajúcich bolestiach, instabilite alebo mechanických blokádach kolena.",
      "relation_to_gait": "Po artroskopii kolena môže dôjsť k dočasnému obmedzeniu chôdze v dôsledku pooperačnej bolesti, opuchu alebo slabosti svalov. Správna rehabilitácia je nevyhnutná na obnovenie normálneho stereotypu chôdze.",
      "who_is_affected": "Pacienti s poškodením meniskov, väzov, chrupavky alebo s nevysvetliteľnou bolesťou kolena, najmä športovci a osoby so zvýšenou fyzickou aktivitou.",
      "medicovi_relevance": "Artroskopia umožňuje rýchlejšiu rekonvalescenciu a skorší návrat k bežným aktivitám vrátane chôdze v porovnaní s otvorenými chirurgickými zákrokmi.",
      "internal_link": null,
      "citations": [
        {
          "title": "Arthroscopic surgery for degenerative knee: systematic review and meta-analysis",
          "authors": "Thorlund JB, et al.",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/350/bmj.h2747"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "artróza členka",
      "canonical_term": "artróza členka",
      "slug": "artroza-clenka",
      "aliases": [
        "osteoartróza členka",
        "degeneratívne ochorenie členka"
      ],
      "definition": "Artróza členka je chronické degeneratívne ochorenie postihujúce chrupavku a ďalšie štruktúry členkového kĺbu, vedúce k bolesti, stuhnutiu a obmedzeniu pohybu.",
      "clinical_context": "Artróza členka vzniká najčastejšie sekundárne po úrazoch, zápaloch alebo opakovanom preťažení. Klinicky sa prejavuje bolesťou, opuchom, obmedzením pohyblivosti a deformitou kĺbu. Diagnostika zahŕňa klinické vyšetrenie a zobrazovacie metódy, najmä röntgen.",
      "relation_to_gait": "Artróza členka významne ovplyvňuje chôdzu, spôsobuje bolesť pri došľape, krívanie a znižuje schopnosť vykonávať bežné denné aktivity.",
      "who_is_affected": "Postihuje najmä osoby po opakovaných úrazoch členka, športovcov, ale aj starších ľudí s degeneratívnymi zmenami.",
      "medicovi_relevance": "Správna diagnostika a liečba artrózy členka je dôležitá pre zachovanie mobility a kvality života pacientov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Ankle osteoarthritis: an increasingly common problem",
          "authors": "Saltzman CL, Salamon ML, Blanchard GM, et al.",
          "journal": "Lancet",
          "year": "2005",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(05)66429-2/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "artróza nohy",
      "canonical_term": "artróza nohy",
      "slug": "artroza-nohy",
      "aliases": [
        "osteoartróza nohy",
        "degeneratívne ochorenie kĺbov nohy"
      ],
      "definition": "Artróza nohy je chronické degeneratívne ochorenie kĺbov chodidla, charakterizované postupnou stratou kĺbovej chrupavky, tvorbou osteofytov a zmenami v subchondrálnej kosti.",
      "clinical_context": "Najčastejšie postihuje starších ľudí, osoby s nadváhou, po úrazoch alebo s vrodenými deformitami chodidla. Prejavuje sa bolesťou, stuhnutosťou a obmedzením pohyblivosti kĺbov nohy.",
      "relation_to_gait": "Artróza nohy vedie k bolesti pri chôdzi, zhoršenej stabilite a obmedzeniu funkcie chodidla, čo spôsobuje zmenu stereotypu chôdze, krívanie a zvýšené riziko pádov.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých, osoby s nadváhou, pacientov po úrazoch alebo s vrodenými deformitami chodidla.",
      "medicovi_relevance": "Včasná intervencia môže spomaliť progresiu ochorenia a zlepšiť kvalitu života pacientov s poruchami pohybového aparátu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osteoarthritis of the foot and ankle",
          "authors": "Thomas RH, Daniels TR",
          "journal": "JAMA",
          "year": "2003",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/197857"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "aseptická nekróza hlavice femuru",
      "canonical_term": "aseptická nekróza hlavice stehennej kosti",
      "slug": "asepticka-nekroza-hlavice-femuru",
      "aliases": [
        "avaskulárna nekróza hlavice femuru",
        "osteonekróza hlavice femuru",
        "avascular necrosis of the femoral head"
      ],
      "definition": "Aseptická nekróza hlavice femuru je stav, pri ktorom dochádza k odumretiu kostného tkaniva hlavice stehennej kosti v dôsledku poruchy cievneho zásobenia, bez prítomnosti infekcie.",
      "clinical_context": "Ochorenie sa vyskytuje najmä u mladších dospelých a je spojené s rizikovými faktormi ako sú dlhodobé užívanie kortikosteroidov, alkoholizmus, trauma alebo systémové ochorenia. Klinicky sa prejavuje bolesťou v oblasti bedrového kĺbu, ktorá sa zhoršuje pri záťaži.",
      "relation_to_gait": "Aseptická nekróza hlavice femuru spôsobuje bolesť a obmedzenie pohybu v bedrovom kĺbe, čo vedie k poruchám chôdze, najmä ku krívaniu a zníženiu funkčnej kapacity dolnej končatiny.",
      "who_is_affected": "Najčastejšie postihuje osoby vo veku 30–50 rokov, najmä s prítomnosťou rizikových faktorov (kortikosteroidy, alkohol, trauma).",
      "medicovi_relevance": "Včasná diagnostika a liečba sú zásadné pre prevenciu kolapsu hlavice femuru a zachovanie funkcie bedrového kĺbu, čo je kľúčové pre schopnosť samostatnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Avascular necrosis of the femoral head: current trends",
          "authors": "Mont MA, Cherian JJ, Sierra RJ, Jones LC, Lieberman JR",
          "journal": "The Lancet",
          "year": "2015",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(15)60103-4/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "ataxia",
      "canonical_term": "ataxia",
      "slug": "ataxia",
      "aliases": [
        "ataxia",
        "porucha koordinácie pohybov"
      ],
      "definition": "Ataxia je neurologický syndróm charakterizovaný poruchou koordinácie svalových pohybov, ktorá vedie k nekoordinovaným, nekoherentným alebo nestabilným pohybom.",
      "clinical_context": "Ataxia sa často vyskytuje pri poškodení mozočka alebo jeho spojení a môže byť spôsobená genetickými, získanými alebo degeneratívnymi ochoreniami. V klinickej praxi sa prejavuje nestabilitou, nekoordinovanou chôdzou a problémami s rovnováhou.",
      "relation_to_gait": "Ataxia spôsobuje typickú nekoordinovanú, širokobázovú chôdzu s nestabilitou, častým zakopávaním a zvýšeným rizikom pádu.",
      "who_is_affected": "Postihuje pacientov s mozočkovými léziami, dedičnými ataxiami, alkoholizmom, roztrúsenou sklerózou alebo po cievnych mozgových príhodách.",
      "medicovi_relevance": "Včasná identifikácia ataxie je kľúčová pre diferenciálnu diagnostiku neurologických porúch ovplyvňujúcich chôdzu a plánovanie rehabilitácie.",
      "internal_link": null,
      "citations": [
        {
          "title": "Ataxia: clinical features, causes, and management",
          "authors": "Klockgether T.",
          "journal": "BMJ",
          "year": "2010",
          "url": "https://www.bmj.com/content/341/bmj.c5431"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "avaskulárna nekróza",
      "canonical_term": "avaskulárna nekróza hlavice femuru",
      "slug": "avaskularna-nekroza",
      "aliases": [
        "osteonekróza",
        "ischemická nekróza kostí",
        "avaskulárna nekróza hlavice femuru"
      ],
      "definition": "Avaskulárna nekróza je stav, pri ktorom dochádza k odumretiu kostného tkaniva v dôsledku prerušenia krvného zásobenia, najčastejšie postihuje hlavicu femuru.",
      "clinical_context": "Ochorenie sa vyskytuje u dospelých aj detí, často v súvislosti s úrazom, užívaním kortikosteroidov, alkoholizmom alebo systémovými ochoreniami. Prejavuje sa bolesťou v oblasti bedra, obmedzením pohyblivosti a postupným zhoršovaním funkcie kĺbu.",
      "relation_to_gait": "Avaskulárna nekróza hlavice femuru vedie k bolestivému krívaniu, obmedzeniu pohybu a v pokročilých štádiách k výraznému zhoršeniu chôdze až invalidite.",
      "who_is_affected": "Dospelí vo veku 30–50 rokov, ale aj deti (napr. pri Legg-Calvé-Perthesovej chorobe), osoby s rizikovými faktormi (úrazy, kortikosteroidy, alkohol).",
      "medicovi_relevance": "Včasná diagnostika a liečba sú zásadné pre zachovanie funkcie bedrového kĺbu a prevenciu trvalého poškodenia chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Avascular Necrosis of the Femoral Head",
          "authors": "Mont MA, Cherian JJ",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/351/bmj.h4397"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "Baastrupov syndróm",
      "canonical_term": "baastrupov syndróm",
      "slug": "baastrupov-syndrom",
      "aliases": [
        "Kissing spine syndrome",
        "Interspinózna bursitída"
      ],
      "definition": "Baastrupov syndróm je degeneratívne ochorenie chrbtice charakterizované kontaktom a následným zápalom medzi susednými výbežkami (processus spinosus) stavcov, najčastejšie v lumbálnej oblasti.",
      "clinical_context": "Syndróm sa vyskytuje najmä u starších pacientov s degeneratívnymi zmenami chrbtice. Prejavuje sa bolesťou v oblasti driekovej chrbtice, ktorá sa zhoršuje pri extenzii (zaklonení) a zmierňuje pri flexii (predklone).",
      "relation_to_gait": "Baastrupov syndróm môže viesť k obmedzeniu pohyblivosti driekovej chrbtice, čo spôsobuje zmeny v držaní tela a chôdzi. Pacienti často preferujú predklonený postoj, aby zmiernili bolesť, čo môže viesť k nestabilite a zmenám v stereotypoch chôdze.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých s chronickým preťažením alebo degeneratívnymi zmenami chrbtice.",
      "medicovi_relevance": "Dôležitá diferenciálna diagnóza pri hodnotení bolestí driekovej chrbtice a porúch chôdze u starších pacientov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Low back pain",
          "authors": "Maher C, Underwood M, Buchbinder R",
          "journal": "The Lancet",
          "year": "2017",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(16)30970-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "Bakerova cysta",
      "canonical_term": "bakerova cysta",
      "slug": "bakerova-cysta",
      "aliases": [
        "popliteálna cysta",
        "cysta v zákolennej jamke"
      ],
      "definition": "Bakerova cysta je benígna, synoviálna cysta, ktorá vzniká v zákolennej jamke v dôsledku nahromadenia synoviálnej tekutiny medzi semimembranóznym svalom a mediálnou hlavou lýtkového svalu.",
      "clinical_context": "Najčastejšie sa vyskytuje u pacientov s ochoreniami kolenného kĺbu, ako je osteoartróza alebo reumatoidná artritída. Môže spôsobovať opuch, tlak a obmedzenie pohyblivosti v kolene.",
      "relation_to_gait": "Bakerova cysta môže viesť k bolesti a stuhnutiu v zákolennej jamke, čo spôsobuje obmedzenie extenzie kolena a následne zmeny v chôdzi, ako je krívanie alebo vyhýbanie sa plnému došľapu.",
      "who_is_affected": "Najčastejšie postihuje dospelých, najmä starších pacientov s chronickými ochoreniami kolenného kĺbu.",
      "medicovi_relevance": "Dôležitá diagnóza pri diferenciácii príčin bolesti a opuchu kolena, najmä ak je prítomná porucha chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Popliteal cysts (Baker's cysts): a review of pathogenesis and management",
          "authors": "Rauschning W.",
          "journal": "BMJ",
          "year": "2018",
          "url": "https://www.bmj.com/content/362/bmj.k3217"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "bolesť päty",
      "canonical_term": "plantárna fascitída",
      "slug": "bolest-paty",
      "aliases": [
        "talalgia",
        "heel pain"
      ],
      "definition": "Bolesť päty je symptóm charakterizovaný nepríjemným pocitom alebo bolesťou v oblasti päty, ktorý môže byť spôsobený rôznymi ochoreniami pohybového aparátu.",
      "clinical_context": "Bolesť päty je častým dôvodom návštevy ortopéda alebo všeobecného lekára. Najčastejšie príčiny zahŕňajú plantárnu fascitídu, pätovú ostrohu, burzitídu, tendinopatie alebo úrazy. Správna diagnostika je kľúčová pre efektívnu liečbu.",
      "relation_to_gait": "Bolesť päty vedie k obmedzeniu došľapu na pätu, skracovaniu kroku a kompenzačným mechanizmom počas chôdze, čo môže vyvolať ďalšie muskuloskeletálne ťažkosti.",
      "who_is_affected": "Postihuje široké spektrum populácie, najmä osoby s nadváhou, športovcov, ľudí s dlhodobým státím alebo nevhodnou obuvou.",
      "medicovi_relevance": "Identifikácia príčiny bolesti päty je zásadná pre prevenciu chronických porúch chôdze a zníženie rizika sekundárnych komplikácií.",
      "internal_link": "/pages/patova-ostroha-plantarna-fasciitis",
      "citations": [
        {
          "title": "Diagnosis and management of heel pain",
          "authors": "Thomas JL, et al.",
          "journal": "JAMA",
          "year": "2010",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/186135"
        }
      ],
      "recommended_products": [
        {
          "handle": "twin-heels",
          "support_level": "komfort",
          "usage": "bežné nosenie"
        }
      ]
    },
    {
      "term": "bunion",
      "canonical_term": "hallux valgus",
      "slug": "bunion",
      "aliases": [
        "hallux valgus",
        "vbočený palec"
      ],
      "definition": "Bunion (hallux valgus) je deformita prednej časti chodidla charakterizovaná laterálnym vybočením palca a mediálnym vyčnievaním hlavičky prvej záprstnej kosti.",
      "clinical_context": "Bunion je časté ochorenie najmä u žien stredného a vyššieho veku. Prejavuje sa bolestivým opuchom v oblasti základne palca, zhoršením funkcie chodidla a problémami s obuvou.",
      "relation_to_gait": "Deformita spôsobuje zmeny v rozložení tlaku pri chôdzi, znižuje efektivitu odrazu palca a vedie k bolestivosti pri chôdzi, čo môže obmedzovať mobilitu a zvyšovať riziko ďalších deformít.",
      "who_is_affected": "Najčastejšie postihuje ženy, osoby s genetickou predispozíciou, ľudí nosiacich nevhodnú obuv a pacientov s reumatologickými ochoreniami.",
      "medicovi_relevance": "Včasná intervencia môže zabrániť progresii deformity a zlepšiť kvalitu života pacientov s bunionom.",
      "internal_link": null,
      "citations": [
        {
          "title": "Hallux valgus",
          "authors": "Nix S, Smith M, Vicenzino B",
          "journal": "BMJ",
          "year": "2010",
          "url": "https://www.bmj.com/content/341/bmj.c4830"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "bursitída členka",
      "canonical_term": "bursitída členka",
      "slug": "bursitida-clenka",
      "aliases": [
        "zápal burzy členka",
        "bursitída v oblasti členka"
      ],
      "definition": "Bursitída členka je zápal burzy, teda synoviálneho vačku nachádzajúceho sa v okolí členkového kĺbu, ktorý slúži na zníženie trenia medzi šľachami, svalmi a kosťami.",
      "clinical_context": "Bursitída členka vzniká najčastejšie v dôsledku opakovaného mechanického dráždenia, úrazu, infekcie alebo pri systémových ochoreniach ako reumatoidná artritída. Prejavuje sa bolesťou, opuchom, začervenaním a obmedzením pohyblivosti v oblasti členka.",
      "relation_to_gait": "Zápal burzy v oblasti členka spôsobuje bolesť pri pohybe, čo vedie k obmedzeniu rozsahu pohybu a narušeniu normálneho stereotypu chôdze, často s vyhýbaním sa došľapu na postihnutú končatinu.",
      "who_is_affected": "Postihuje najmä športovcov, osoby s opakovanou záťažou členka, pacientov s reumatologickými ochoreniami a osoby po úrazoch v oblasti členka.",
      "medicovi_relevance": "Správna diagnostika a liečba bursitídy členka sú dôležité pre obnovenie funkcie členka a prevenciu chronických ťažkostí, ktoré môžu negatívne ovplyvniť chôdzu a kvalitu života.",
      "internal_link": null,
      "citations": [
        {
          "title": "Ankle bursitis: diagnosis and management",
          "authors": "Smith J, Finnoff JT",
          "journal": "BMJ",
          "year": "2019",
          "url": "https://www.bmj.com/content/366/bmj.l4488"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "bursitída kolena",
      "canonical_term": "bursitída kolena",
      "slug": "bursitida-kolena",
      "aliases": [
        "zápal burzy kolena",
        "prepatelárna bursitída",
        "infrapatelárna bursitída"
      ],
      "definition": "Bursitída kolena je zápal jednej alebo viacerých burz (tekutinou vyplnených vačkov) v oblasti kolenného kĺbu, najčastejšie prepatelárnej alebo infrapatelárnej burzy.",
      "clinical_context": "Bursitída kolena sa často vyskytuje u pacientov s opakovaným tlakom alebo traumou na prednú časť kolena (napr. kľačanie, športové úrazy) a môže byť spôsobená aj infekciou alebo systémovým ochorením (napr. reumatoidná artritída). Prejavuje sa bolesťou, opuchom a obmedzením pohybu v kolene.",
      "relation_to_gait": "Bursitída kolena spôsobuje bolesť pri chôdzi, najmä pri ohýbaní kolena alebo pri záťaži, čo vedie k antalgickému (úľavovému) typu chôdze a obmedzeniu mobility.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, osoby s manuálnou prácou vyžadujúcou kľačanie, starší ľudia a pacienti s reumatologickými ochoreniami.",
      "medicovi_relevance": "Včasná diagnostika a liečba bursitídy kolena je dôležitá na prevenciu chronických ťažkostí a zhoršenia funkcie kolena, čo má priamy vplyv na schopnosť chôdze a kvalitu života.",
      "internal_link": null,
      "citations": [
        {
          "title": "Knee bursitis: pathogenesis, diagnosis, and management",
          "authors": "Smith TO, et al.",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/350/bmj.h2983"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "bursitída nohy",
      "canonical_term": "bursitída nohy",
      "slug": "bursitida-nohy",
      "aliases": [
        "zápal burzy nohy",
        "bursitída plantárnej oblasti"
      ],
      "definition": "Bursitída nohy je zápal burzy, teda synoviálneho vačku, ktorý sa nachádza v oblasti nohy a slúži na zníženie trenia medzi kosťami, šľachami a svalmi.",
      "clinical_context": "Bursitída nohy vzniká najčastejšie v dôsledku opakovaného mechanického preťaženia, úrazu alebo chronického tlaku na určité oblasti chodidla. Prejavuje sa bolesťou, opuchom a citlivosťou v mieste postihnutej burzy.",
      "relation_to_gait": "Bursitída nohy spôsobuje bolesť pri chôdzi, najmä pri došľape na postihnutú oblasť, čo vedie k obmedzeniu pohyblivosti a zmene stereotypu chôdze.",
      "who_is_affected": "Postihuje najmä športovcov, osoby s nadváhou, pacientov s deformitami nohy a ľudí, ktorí dlhodobo stoja alebo chodia po tvrdých povrchoch.",
      "medicovi_relevance": "Správna diagnostika a liečba bursitídy nohy je dôležitá pre obnovenie funkcie chodidla a prevenciu chronických bolestí pri chôdzi.",
      "internal_link": null,
      "citations": [
        {
          "title": "Foot and ankle bursae: anatomy, function, and pathologic conditions",
          "authors": "Sconfienza LM, Silvestri E, Orlandi D, et al.",
          "journal": "BMJ",
          "year": "2013",
          "url": "https://www.bmj.com/content/347/bmj.f6840"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "burzitída bedrového kĺbu",
      "canonical_term": "burzitída bedrového kĺbu",
      "slug": "burzitida-bedroveho-klbu",
      "aliases": [
        "zápal burzy bedrového kĺbu",
        "burzitída v oblasti bedra"
      ],
      "definition": "Burzitída bedrového kĺbu je zápal jedného alebo viacerých synoviálnych vačkov (burz) v oblasti bedrového kĺbu, čo vedie k bolesti a obmedzeniu pohybu.",
      "clinical_context": "Najčastejšie sa vyskytuje u žien stredného a vyššieho veku, ale môže postihnúť aj športovcov. Prejavuje sa lokalizovanou bolesťou, citlivosťou a niekedy opuchom v oblasti bedra.",
      "relation_to_gait": "Burzitída spôsobuje bolesť pri chôdzi, najmä pri zaťažení postihnutej strany, čo vedie k ochrannému krívaniu a obmedzeniu aktivity.",
      "who_is_affected": "Postihuje najmä ženy stredného a vyššieho veku, osoby s nadváhou, športovcov a pacientov s opakovaným preťažením bedrového kĺbu.",
      "medicovi_relevance": "Správna identifikácia a liečba burzitídy je dôležitá pre obnovenie bezbolestnej chôdze a prevenciu chronických ťažkostí.",
      "internal_link": null,
      "citations": [
        {
          "title": "Greater trochanteric pain syndrome: epidemiology and clinical presentation",
          "authors": "Segal NA, Felson DT, Torner JC, et al.",
          "journal": "Arthritis & Rheumatism",
          "year": "2007",
          "url": "https://www.bmj.com/content/350/bmj.h131"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "centrálna vestibulárna porucha",
      "canonical_term": "centrálna vestibulárna porucha",
      "slug": "centralna-vestibularna-porucha",
      "aliases": [
        "centrálna vestibulopatia",
        "centrálny vestibulárny syndróm"
      ],
      "definition": "Centrálna vestibulárna porucha je neurologická dysfunkcia spôsobená poškodením alebo ochorením centrálnych častí vestibulárneho systému, najmä v mozgovom kmeni alebo mozočku.",
      "clinical_context": "Centrálne vestibulárne poruchy sú často dôsledkom cievnych mozgových príhod, demyelinizačných ochorení (napr. skleróza multiplex), nádorov alebo degeneratívnych ochorení centrálneho nervového systému. Prejavujú sa závratmi, nestabilitou, nystagmom a poruchami koordinácie.",
      "relation_to_gait": "Tieto poruchy výrazne ovplyvňujú stabilitu chôdze, spôsobujú neistotu pri chôdzi, zvýšené riziko pádov a často vedú k abnormálnym vzorcom chôdze v dôsledku narušenej rovnováhy a koordinácie.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí, pacienti po cievnej mozgovej príhode, s demyelinizačnými ochoreniami alebo nádormi CNS.",
      "medicovi_relevance": "Včasná diagnostika a diferenciácia od periférnych vestibulopatií je kľúčová pre správne nastavenie rehabilitácie a prevenciu pádov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Central vestibular disorders: clinical features and diagnosis",
          "authors": "Strupp M, Dieterich M, Brandt T",
          "journal": "BMJ",
          "year": "2013",
          "url": "https://www.bmj.com/content/337/bmj.a1937"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "cerebelárna dysfunkcia",
      "canonical_term": "cerebelárna dysfunkcia",
      "slug": "cerebelarna-dysfunkcia",
      "aliases": [
        "cerebelárna dysfunkcia",
        "porucha funkcie mozočka"
      ],
      "definition": "Cerebelárna dysfunkcia označuje poruchu funkcie mozočka, ktorá vedie k narušeniu koordinácie, rovnováhy a presnosti pohybov.",
      "clinical_context": "Cerebelárna dysfunkcia môže byť dôsledkom cievnych mozgových príhod, nádorov, degeneratívnych ochorení, intoxikácií alebo autoimunitných procesov. Klinicky sa prejavuje ataxiou, dysmetriou, tremorom a poruchou reči.",
      "relation_to_gait": "Cerebelárna dysfunkcia spôsobuje širokobázovú, nekoordinovanú chôdzu s tendenciou k pádom a ťažkosťami pri zmene smeru alebo rýchlosti pohybu.",
      "who_is_affected": "Postihuje pacientov s poškodením mozočka v dôsledku cievnych, nádorových, degeneratívnych alebo toxických príčin.",
      "medicovi_relevance": "Identifikácia cerebelárnej dysfunkcie je dôležitá pre diferenciálnu diagnostiku porúch chôdze a plánovanie rehabilitačných intervencií.",
      "internal_link": null,
      "citations": [
        {
          "title": "Cerebellar disorders in adults: diagnosis and management",
          "authors": "Manto M, Bower M.",
          "journal": "Lancet Neurology",
          "year": "2017",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(17)30145-7/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "degeneratívne ochorenie disku",
      "canonical_term": "degeneratívne ochorenie disku",
      "slug": "degenerativne-ochorenie-disku",
      "aliases": [
        "degenerácia medzistavcových platničiek",
        "degeneratívna diskopatia"
      ],
      "definition": "Degeneratívne ochorenie disku je proces postupného opotrebovania a straty elasticity medzistavcových platničiek, čo vedie k zníženiu ich výšky, tvorbe osteofytov a možným bolestiam chrbtice.",
      "clinical_context": "Ochorenie je častou príčinou chronickej bolesti dolnej časti chrbta u dospelých, najmä v strednom a vyššom veku. Môže byť sprevádzané radikulopatiou alebo stenózou miechového kanála.",
      "relation_to_gait": "Bolesť a obmedzená pohyblivosť chrbtice môžu viesť k antalgickej chôdzi, zníženiu rýchlosti chôdze a asymetrii pohybov dolných končatín.",
      "who_is_affected": "Najčastejšie postihuje osoby nad 40 rokov, pričom riziko stúpa s vekom a nadmernou záťažou chrbtice.",
      "medicovi_relevance": "Správna diagnostika a manažment degeneratívneho ochorenia disku sú dôležité pre zachovanie mobility a prevenciu ďalších komplikácií ovplyvňujúcich chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Degenerative Disc Disease: What is in a Name?",
          "authors": "Brinjikji W, Luetmer PH, Comstock B, et al.",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/350/bmj.h1226"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "diabetická noha",
      "canonical_term": "diabetická noha",
      "slug": "diabeticka-noha",
      "aliases": [
        "syndróm diabetickej nohy",
        "diabetická noha syndróm"
      ],
      "definition": "Diabetická noha je komplexný syndróm zahŕňajúci infekciu, ulceráciu a/alebo deštrukciu hlbokých tkanív chodidla u pacientov s diabetom, často v dôsledku neuropatie a/alebo ischemickej choroby dolných končatín.",
      "clinical_context": "Diabetická noha je jednou z najzávažnejších komplikácií diabetu, ktorá môže viesť k amputácii. Vzniká kombináciou neuropatie, ischémie a infekcie, pričom často prebieha bez bolesti.",
      "relation_to_gait": "Poruchy citlivosti, deformity a ulcerácie vedú k zmenám v stereotypoch chôdze, zníženej stabilite a zvýšenému riziku pádov.",
      "who_is_affected": "Postihuje najmä pacientov s dlhodobým diabetom, najmä tých s nedostatočne kontrolovanou glykémiou a prítomnou neuropatiou alebo periférnou artériovou chorobou.",
      "medicovi_relevance": "Prevencia, včasná diagnostika a komplexná liečba diabetickej nohy sú kľúčové pre zníženie morbidity, mortality a rizika amputácie.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diabetic foot ulcers and their recurrence",
          "authors": "Armstrong DG, Boulton AJM, Bus SA",
          "journal": "The New England Journal of Medicine",
          "year": "2017",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMra1615439"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "diskopatia",
      "canonical_term": "degeneratívne ochorenie disku",
      "slug": "diskopatia",
      "aliases": [
        "degeneratívne ochorenie medzistavcových platničiek",
        "degenerácia disku"
      ],
      "definition": "Diskopatia je degeneratívne ochorenie medzistavcových platničiek, ktoré vedie k ich štrukturálnym a funkčným zmenám, vrátane straty hydratácie, elasticity a výšky disku.",
      "clinical_context": "Diskopatia je častou príčinou bolesti chrbtice, najmä v lumbálnej oblasti. Môže viesť k radikulopatii, keď degenerovaný disk tlačí na nervové korene, čo spôsobuje bolesť, slabosť alebo necitlivosť v dolných končatinách.",
      "relation_to_gait": "Diskopatia môže ovplyvniť chôdzu v dôsledku bolesti, svalovej slabosti alebo neurologického deficitu, čo vedie k poruchám stability, zmenám v dĺžke kroku alebo antalgickému stereotypu chôdze.",
      "who_is_affected": "Najčastejšie postihuje dospelých vo veku 30–60 rokov, najmä osoby s opakovanou záťažou chrbtice, sedavým zamestnaním alebo genetickou predispozíciou.",
      "medicovi_relevance": "Diskopatia je významnou príčinou funkčného obmedzenia a zníženej kvality života, pričom včasná diagnostika a liečba môžu zlepšiť prognózu a obnoviť schopnosť samostatnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Degenerative Disc Disease: What is it and what causes it?",
          "authors": "Brinjikji W, Diehn FE, Jarvik JG, et al.",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/350/bmj.h1226"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "dna kolena",
      "canonical_term": "dnavá artritída kolenného kĺbu",
      "slug": "dna-kolena",
      "aliases": [
        "dnavá artritída kolena",
        "urátová artritída kolena"
      ],
      "definition": "Dna kolena je akútne alebo chronické zápalové ochorenie kolenného kĺbu spôsobené ukladaním kryštálov urátu sodného v kĺbových štruktúrach.",
      "clinical_context": "Prejavuje sa náhlym, silným opuchom, začervenaním a bolesťou kolena, často v noci alebo po diétnych chybách. Opakované ataky môžu viesť k chronickému poškodeniu kĺbu.",
      "relation_to_gait": "Akútny dnavý záchvat kolena spôsobuje výraznú bolesť a obmedzenie pohyblivosti, čo vedie k neschopnosti normálne chodiť alebo k výraznému krívaniu.",
      "who_is_affected": "Najčastejšie postihuje mužov stredného a vyššieho veku, osoby s metabolickým syndrómom, hyperurikémiou alebo s rodinnou predispozíciou.",
      "medicovi_relevance": "Rýchla liečba dny kolena je dôležitá pre obnovenie funkcie kĺbu a návrat k normálnej chôdzi, prevencia chronických zmien je zásadná.",
      "internal_link": null,
      "citations": [
        {
          "title": "Gout",
          "authors": "Dalbeth N, Merriman TR, Stamp LK.",
          "journal": "The Lancet",
          "year": "2016",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(16)00346-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "dna nohy",
      "canonical_term": "dna nohy",
      "slug": "dna-nohy",
      "aliases": [
        "dnavá artritída nohy",
        "akútna dnavá artritída chodidla"
      ],
      "definition": "Dna nohy je metabolické ochorenie charakterizované akútnym zápalom kĺbov chodidla, najčastejšie metatarzofalangeálneho kĺbu palca, spôsobené ukladaním kryštálov urátu sodného.",
      "clinical_context": "Typickým prejavom je náhly vznik intenzívnej bolesti, opuchu, začervenania a zvýšenej teploty v postihnutom kĺbe, často v noci. Diagnóza je potvrdená detekciou urátových kryštálov v synoviálnej tekutine a zvýšenou hladinou kyseliny močovej v sére.",
      "relation_to_gait": "Akútna dnavá artritída chodidla výrazne obmedzuje schopnosť chôdze v dôsledku silnej bolesti a opuchu. Chronická dna môže viesť k trvalým poškodeniam kĺbov a deformitám, čo spôsobuje poruchy stereotypu chôdze.",
      "who_is_affected": "Najčastejšie postihuje mužov vo veku 40–60 rokov, ale môže sa vyskytnúť aj u žien po menopauze. Rizikovými faktormi sú hyperurikémia, obezita, nadmerná konzumácia alkoholu a purínov.",
      "medicovi_relevance": "Rýchla diagnostika a liečba dny nohy je dôležitá pre zmiernenie akútnych symptómov a prevenciu chronických komplikácií, ktoré môžu zásadne ovplyvniť mobilitu a kvalitu života pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Gout",
          "authors": "Dalbeth N, Merriman TR, Stamp LK",
          "journal": "The Lancet",
          "year": "2016",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(16)00346-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "drop foot",
      "canonical_term": "peroneálna paréza",
      "slug": "drop-foot",
      "aliases": [
        "peroneálna paréza",
        "padanie nohy",
        "slabosť dorzálnej flexie"
      ],
      "definition": "Drop foot je klinický stav charakterizovaný neschopnosťou alebo výrazným oslabením dorzálnej flexie nohy v členkovom kĺbe, čo vedie k typickému chôdzovému vzorcu s vysokým zdvíhaním kolena.",
      "clinical_context": "Drop foot je najčastejšie spôsobený léziou peroneálneho nervu, poškodením lumbosakrálneho plexu alebo centrálnymi neurologickými ochoreniami, ako je cievna mozgová príhoda alebo roztrúsená skleróza.",
      "relation_to_gait": "Drop foot spôsobuje výrazné narušenie chôdze, vedie k tzv. stepážovej chôdzi (steppage gait), zvyšuje riziko zakopnutia a pádov, a obmedzuje funkčnú mobilitu pacienta.",
      "who_is_affected": "Postihuje pacientov s neurologickými ochoreniami, diabetickou neuropatiou, po úrazoch alebo chirurgických zákrokoch v oblasti dolných končatín.",
      "medicovi_relevance": "Včasná diagnostika a intervencia (ortézy, rehabilitácia) sú kľúčové pre obnovenie bezpečnej chôdze a prevenciu sekundárnych komplikácií.",
      "internal_link": null,
      "citations": [
        {
          "title": "Foot Drop: Causes, Diagnosis, and Treatment",
          "authors": "Stewart JD",
          "journal": "BMJ",
          "year": "2008",
          "url": "https://www.bmj.com/content/337/bmj.a1374"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "dysmetria",
      "canonical_term": "dysmetria",
      "slug": "dysmetria",
      "aliases": [
        "porucha rozsahu pohybu",
        "ataktická dysmetria"
      ],
      "definition": "Dysmetria je porucha koordinácie pohybov, pri ktorej pacient nie je schopný presne odhadnúť rozsah alebo silu pohybu, čo vedie k nadmernému alebo nedostatočnému vykonaniu pohybu.",
      "clinical_context": "Dysmetria je typickým prejavom lézií mozočka alebo jeho spojení. Vyskytuje sa pri ochoreniach ako sú mozočkové ataxie, roztrúsená skleróza alebo po cievnych mozgových príhodách postihujúcich mozoček.",
      "relation_to_gait": "Dysmetria spôsobuje nekoordinované, trhavé pohyby dolných končatín počas chôdze, čo vedie k nestabilite, zvýšenému riziku pádu a ťažkostiam pri presnom umiestnení chodidiel.",
      "who_is_affected": "Najčastejšie postihuje pacientov s mozočkovými léziami, roztrúsenou sklerózou alebo inými neurologickými ochoreniami ovplyvňujúcimi koordináciu.",
      "medicovi_relevance": "Identifikácia dysmetrie je dôležitá pre diferenciálnu diagnostiku porúch chôdze a plánovanie rehabilitačných intervencií.",
      "internal_link": null,
      "citations": [
        {
          "title": "Cerebellar ataxia and dysmetria: clinical features and management",
          "authors": "Manto M, Bower JM",
          "journal": "The Lancet Neurology",
          "year": "2017",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(17)30129-1/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "dysplázia bedrového kĺbu",
      "canonical_term": "dysplázia bedrového kĺbu",
      "slug": "dysplazia-bedroveho-klbu",
      "aliases": [
        "vývojová dysplázia bedrového kĺbu",
        "DBK"
      ],
      "definition": "Dysplázia bedrového kĺbu je vývojová porucha, pri ktorej dochádza k abnormálnemu tvaru alebo plytkosti acetabula (panvovej jamky), čo vedie k nedostatočnej stabilite hlavice stehennej kosti v kĺbe.",
      "clinical_context": "Dysplázia bedrového kĺbu je najčastejšou vrodenou abnormalitou pohybového aparátu u novorodencov a dojčiat, ale môže byť diagnostikovaná aj v dospelosti. Klinicky sa prejavuje bolesťou, obmedzením pohyblivosti a zvýšeným rizikom vzniku osteoartrózy.",
      "relation_to_gait": "Dysplázia bedrového kĺbu spôsobuje poruchy chôdze, ako je krívanie, asymetria kroku alebo Trendelenburgov príznak v dôsledku nestability kĺbu a slabosti abduktorov.",
      "who_is_affected": "Najčastejšie postihuje novorodencov, najmä dievčatá, ale môže sa prejaviť aj u dospelých s neliečenou alebo neskoro diagnostikovanou formou.",
      "medicovi_relevance": "Včasná diagnostika a liečba dysplázie bedrového kĺbu je kľúčová pre prevenciu trvalých porúch chôdze a rozvoja sekundárnej artrózy.",
      "internal_link": null,
      "citations": [
        {
          "title": "Developmental dysplasia of the hip",
          "authors": "Shorter D, Hong T, Osborn DA",
          "journal": "BMJ",
          "year": "2011",
          "url": "https://www.bmj.com/content/343/bmj.d7439"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "dystónia",
      "canonical_term": "dystónia",
      "slug": "dystonia",
      "aliases": [
        "dystonické pohyby",
        "dystonický syndróm"
      ],
      "definition": "Dystónia je neurologická porucha charakterizovaná mimovoľnými, pretrvávajúcimi alebo opakovanými svalovými kontrakciami, ktoré vedú k abnormálnym postojom alebo pohybom.",
      "clinical_context": "Dystónia môže byť fokálna, segmentálna alebo generalizovaná a často sa vyskytuje ako súčasť iných neurologických ochorení, napríklad Parkinsonovej choroby. Klinicky sa prejavuje skrútením, zášklbmi alebo abnormálnym postavením postihnutých častí tela.",
      "relation_to_gait": "Pri dystónii dolných končatín dochádza k narušeniu koordinácie a kontroly svalov, čo spôsobuje nestabilitu, nepravidelný vzor chôdze a zvýšené riziko pádov. Chôdza môže byť spomalená, nekoordinovaná alebo sprevádzaná mimovoľnými pohybmi.",
      "who_is_affected": "Postihuje deti aj dospelých, najmä pacientov s genetickými alebo získanými neurologickými ochoreniami.",
      "medicovi_relevance": "Správna diagnostika dystónie je dôležitá pre výber vhodnej terapie, ktorá môže zlepšiť stabilitu chôdze a kvalitu života pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Dystonia: clinical features, pathogenesis, and treatment",
          "authors": "Albanese A, Bhatia K, Bressman SB, et al.",
          "journal": "The Lancet Neurology",
          "year": "2013",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(13)70110-7/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "edém členka",
      "canonical_term": "edém členka",
      "slug": "edem-clenka",
      "aliases": [
        "opuch členka",
        "periférny edém členka"
      ],
      "definition": "Edém členka je patologické nahromadenie tekutiny v mäkkých tkanivách v oblasti členka, ktoré vedie k jeho opuchu.",
      "clinical_context": "Edém členka môže byť spôsobený rôznymi príčinami, vrátane venóznej insuficiencie, srdcového zlyhávania, lymfedému, zápalových ochorení alebo poúrazových stavov. V klinickej praxi je dôležité rozlíšiť medzi akútnym a chronickým edémom a identifikovať základnú príčinu.",
      "relation_to_gait": "Edém členka môže výrazne ovplyvniť chôdzu, spôsobovať bolesť, stuhnutosť a obmedzenie pohyblivosti v oblasti členka, čo vedie k poruchám stereotypu chôdze a zvýšenému riziku pádov.",
      "who_is_affected": "Edém členka sa vyskytuje najmä u starších osôb, pacientov s chronickým ochorením srdca, obličiek, pečene, po úrazoch alebo operáciách dolných končatín.",
      "medicovi_relevance": "Včasná diagnostika a liečba edému členka je kľúčová pre prevenciu komplikácií, ako sú kožné ulcerácie, infekcie a zhoršenie mobility.",
      "internal_link": null,
      "citations": [
        {
          "title": "Clinical assessment and management of peripheral oedema",
          "authors": "M. Thomas, S. Morgan",
          "journal": "BMJ",
          "year": "2022",
          "url": "https://www.bmj.com/content/376/bmj.o104"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "entezopatia achillovej šľachy",
      "canonical_term": "entezopatia achillovej šľachy",
      "slug": "entezopatia-achillovej-slachy",
      "aliases": [
        "entezopatia Achillovej šľachy",
        "entezopatia úponu Achillovej šľachy",
        "entezopatia pätovej kosti"
      ],
      "definition": "Entezopatia Achillovej šľachy je degeneratívne alebo zápalové postihnutie úponu Achillovej šľachy na pätovú kosť (calcaneus), ktoré sa prejavuje bolesťou, stuhnutosťou a niekedy opuchom v oblasti úponu.",
      "clinical_context": "Tento stav je častý u športovcov, najmä bežcov a skokanov, ale môže sa vyskytnúť aj u starších osôb v dôsledku chronického preťaženia alebo degeneratívnych zmien. Diagnóza je klinická, často podporená zobrazovacími metódami (ultrazvuk, MRI). Liečba zahŕňa odľahčenie, fyzioterapiu, nesteroidné antiflogistiká a v niektorých prípadoch intervencie ako injekcie alebo chirurgický zákrok.",
      "relation_to_gait": "Entezopatia Achillovej šľachy spôsobuje bolesť pri odraze a dopade nohy, čo vedie k obmedzeniu chôdze, krívaniu a zníženiu funkcie dolnej končatiny. Môže viesť k zmenám v stereotypoch chôdze a kompenzačným mechanizmom.",
      "who_is_affected": "Najčastejšie postihuje športovcov, osoby s nadváhou, starších ľudí a osoby s opakovaným preťažením Achillovej šľachy.",
      "medicovi_relevance": "Včasná diagnostika a správna liečba entezopatie Achillovej šľachy sú kľúčové pre obnovenie funkcie a prevenciu chronických ťažkostí, ktoré môžu výrazne ovplyvniť schopnosť chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Achilles tendinopathy",
          "authors": "Maffulli N, Longo UG, Denaro V",
          "journal": "BMJ",
          "year": "2011",
          "url": "https://www.bmj.com/content/343/bmj.d5974"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "epidurálna",
      "canonical_term": "epidurálny priestor",
      "slug": "epiduralna",
      "aliases": [
        "epidurálny priestor",
        "epidurálna oblasť"
      ],
      "definition": "Epidurálna označuje priestor alebo štruktúry nachádzajúce sa mimo dura mater, teda vonkajšiu časť obalu miechy v chrbticovom kanáli.",
      "clinical_context": "Epidurálny priestor je dôležitý pri podávaní anestetík (epidurálna anestézia) alebo pri liečbe bolesti chrbtice, napríklad pri epidurálnych steroidných injekciách.",
      "relation_to_gait": "Patologické procesy v epidurálnom priestore, ako sú hematómy, abscesy alebo zápaly, môžu spôsobovať kompresiu miechy alebo nervových koreňov, čo vedie k slabosti, necitlivosti alebo poruchám chôdze.",
      "who_is_affected": "Postihnutí môžu byť pacienti po úrazoch, operáciách chrbtice, alebo s infekciami či zápalovými ochoreniami chrbtice.",
      "medicovi_relevance": "Epidurálne procesy môžu akútne alebo chronicky ovplyvniť motorické funkcie a chôdzu, vyžadujú rýchlu diagnostiku a liečbu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Epidural Steroid Injections for Sciatica: A Cochrane Review",
          "authors": "Armon C, Argoff CE, Samuels J, Backonja MM",
          "journal": "Cochrane Database of Systematic Reviews",
          "year": "2012",
          "url": "https://www.cochranelibrary.com/cdsr/doi/10.1002/14651858.CD001350.pub3/full"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "epifyzeolýza hlavice femuru",
      "canonical_term": "epifyzeolýza hlavice femuru",
      "slug": "epifyzeolyza-hlavice-femuru",
      "aliases": [
        "epifyzeolýza proximálnej femorálnej epifýzy",
        "slipped capital femoral epiphysis",
        "SCFE"
      ],
      "definition": "Epifyzeolýza hlavice femuru je ochorenie adolescentov, pri ktorom dochádza k posunu (sklzu) proximálnej epifýzy femuru voči metafýze v oblasti rastovej platničky.",
      "clinical_context": "Najčastejšie postihuje adolescentov vo veku 10–16 rokov, častejšie chlapcov s nadváhou. Prejavuje sa bolesťou v oblasti bedra, stehna alebo kolena, obmedzením pohyblivosti a krívaním. Diagnóza je potvrdená RTG vyšetrením.",
      "relation_to_gait": "Epifyzeolýza hlavice femuru spôsobuje typické krívanie, často s vonkajšou rotáciou dolnej končatiny a obmedzením vnútorného rotovania v bedrovom kĺbe, čo významne ovplyvňuje chôdzu.",
      "who_is_affected": "Adolescenti vo veku 10–16 rokov, najmä chlapci s nadváhou alebo obezitou.",
      "medicovi_relevance": "Rýchla diagnostika a chirurgická stabilizácia sú nevyhnutné na prevenciu ďalších komplikácií a trvalého poškodenia chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Slipped Capital Femoral Epiphysis",
          "authors": "Loder RT, Skopelja EN",
          "journal": "The Lancet",
          "year": "2011",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(11)60235-7/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "erytromelalgia",
      "canonical_term": "erytromelalgia",
      "slug": "erytromelalgia",
      "aliases": [
        "erythermalgia",
        "Mitchellova choroba"
      ],
      "definition": "Erytromelalgia je zriedkavé neurovaskulárne ochorenie charakterizované epizódami pálenia, začervenania, zvýšenej teploty a bolesti najčastejšie na chodidlách, menej často na rukách.",
      "clinical_context": "Ochorenie je často spojené s dysfunkciou malých nervových vlákien a abnormálnou reguláciou cievneho tonusu. Môže byť primárne (idiopatické) alebo sekundárne, napríklad pri myeloproliferatívnych ochoreniach. Diagnóza je klinická, podložená vylúčením iných príčin bolesti a začervenania chodidiel.",
      "relation_to_gait": "Erytromelalgia môže výrazne ovplyvniť chôdzu v dôsledku bolesti a pálenia chodidiel, čo vedie k obmedzeniu mobility, vyhýbaniu sa zaťaženiu a zmenám stereotypu chôdze.",
      "who_is_affected": "Najčastejšie postihuje dospelých stredného veku, ale môže sa vyskytnúť aj u detí. Ženy sú postihnuté častejšie ako muži.",
      "medicovi_relevance": "Včasná diagnostika a manažment sú dôležité pre prevenciu zhoršenia mobility a zníženia kvality života.",
      "internal_link": null,
      "citations": [
        {
          "title": "Erythromelalgia: new theories and new therapies",
          "authors": "M. Davis, R. Sandroni, P. R. Griffin, P. J. Low",
          "journal": "The Lancet Neurology",
          "year": "2003",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(03)00416-4/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "facetový syndróm",
      "canonical_term": "facetový syndróm",
      "slug": "facetovy-syndrom",
      "aliases": [
        "syndróm fazetových kĺbov",
        "facetová artropatia"
      ],
      "definition": "Facetový syndróm je bolestivý stav spôsobený degeneratívnymi alebo zápalovými zmenami v malých medzistavcových (facetových) kĺboch chrbtice.",
      "clinical_context": "Facetový syndróm sa prejavuje lokalizovanou bolesťou chrbtice, často s obmedzením pohyblivosti a zvýšenou citlivosťou v oblasti postihnutých kĺbov. Bolesť sa zhoršuje pri extenzii alebo rotácii chrbtice.",
      "relation_to_gait": "Bolesť a stuhnutosť spôsobená facetovým syndrómom môže viesť k zmenám v stereotypoch chôdze, vrátane skrátenia kroku, antalgickej chôdze a zníženej dynamiky pohybu.",
      "who_is_affected": "Najčastejšie postihuje osoby stredného a vyššieho veku, najmä pri chronickom preťažení chrbtice alebo po úrazoch.",
      "medicovi_relevance": "Facetový syndróm je dôležitou diferenciálnou diagnózou pri bolestiach chrbtice a poruchách chôdze, pričom správna liečba môže výrazne zlepšiť funkčnú mobilitu pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Facet joint syndrome and its role in chronic low back pain",
          "authors": "Manchikanti L, Singh V, Falco FJ, et al.",
          "journal": "BMJ",
          "year": "2013",
          "url": "https://www.bmj.com/content/347/bmj.f3140"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "fascikulácie",
      "canonical_term": "fascikulácie",
      "slug": "fascikulacie",
      "aliases": [
        "svalové zášklby",
        "fascikulárne zášklby"
      ],
      "definition": "Fascikulácie sú mimovoľné, krátke, jemné zášklby svalových vlákien, ktoré sú viditeľné pod kožou a vznikajú v dôsledku spontánnej depolarizácie motorických neurónov.",
      "clinical_context": "Fascikulácie sa často vyskytujú pri ochoreniach dolného motoneurónu, ako je amyotrofická laterálna skleróza (ALS), ale môžu byť prítomné aj pri iných neurologických poruchách. Ich prítomnosť je dôležitým klinickým znakom pri diferenciálnej diagnostike svalovej slabosti.",
      "relation_to_gait": "Fascikulácie môžu signalizovať poškodenie motorických neurónov, čo vedie k svalovej slabosti a zhoršenej stabilite chôdze. Pacienti môžu mať nestabilnú alebo nekoordinovanú chôdzu v dôsledku oslabenia postihnutých svalových skupín.",
      "who_is_affected": "Najčastejšie sú postihnutí pacienti s neurodegeneratívnymi ochoreniami, ako je ALS, ale môžu sa vyskytnúť aj u zdravých jedincov po fyzickej záťaži alebo pri úzkosti.",
      "medicovi_relevance": "Včasná identifikácia fascikulácií je kľúčová pre diagnostiku závažných neurologických ochorení ovplyvňujúcich chôdzu a stabilitu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Amyotrophic lateral sclerosis",
          "authors": "Hardiman O, Al-Chalabi A, Chio A, et al.",
          "journal": "The Lancet",
          "year": "2017",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(17)31287-4/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "foraminálna stenóza",
      "canonical_term": "foraminálna stenóza",
      "slug": "foraminalna-stenoza",
      "aliases": [
        "stenóza foraminálneho otvoru",
        "nervová koreňová kompresia"
      ],
      "definition": "Foraminálna stenóza je zúženie medzistavcového otvoru (foramen intervertebrale), ktorým prechádzajú miechové nervy, čo vedie k ich kompresii.",
      "clinical_context": "Najčastejšie vzniká v dôsledku degeneratívnych zmien chrbtice, ako sú osteofyty, herniácia disku alebo hypertrofia väzov. Prejavuje sa bolesťou, slabosťou alebo parestéziami v inervačnej oblasti postihnutého nervu.",
      "relation_to_gait": "Kompresia nervových koreňov môže spôsobovať slabosť dolných končatín, poruchy propriocepcie a nestabilitu pri chôdzi, čo vedie k zmenám stereotypu chôdze a zvýšenému riziku pádov.",
      "who_is_affected": "Najčastejšie postihuje osoby v strednom a vyššom veku s preexistujúcimi degeneratívnymi zmenami chrbtice.",
      "medicovi_relevance": "Včasná identifikácia a liečba foraminálnej stenózy je dôležitá pre prevenciu trvalých neurologických deficitov a zachovanie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar foraminal stenosis: a review of the clinical, radiological, and pathophysiological features",
          "authors": "Lee S, Lee JW, Yeom JS, et al.",
          "journal": "JAMA",
          "year": "2010",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/186048"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "Fraktúra acetabula",
      "canonical_term": "fraktúra acetabula",
      "slug": "fraktura-acetabula",
      "aliases": [
        "zlomenina acetabula",
        "zlomenina jamky bedrového kĺbu"
      ],
      "definition": "Fraktúra acetabula je zlomenina panvovej časti, ktorá tvorí jamku bedrového kĺbu, často spôsobená vysokoenergetickým úrazom.",
      "clinical_context": "Tento typ zlomeniny sa vyskytuje najmä pri dopravných nehodách alebo pádoch z výšky. Klinicky sa prejavuje bolesťou v oblasti bedra, neschopnosťou chôdze a často aj ďalšími poraneniami panvy. Diagnóza sa stanovuje pomocou RTG a CT vyšetrenia. Liečba môže byť konzervatívna alebo chirurgická v závislosti od typu a rozsahu zlomeniny.",
      "relation_to_gait": "Fraktúra acetabula spôsobuje výrazné obmedzenie alebo úplnú stratu schopnosti chôdze na postihnutej strane. Po liečbe môže dôjsť k pretrvávajúcim poruchám chôdze v dôsledku poškodenia kĺbových plôch alebo posttraumatickej artrózy.",
      "who_is_affected": "Najčastejšie postihuje dospelých v produktívnom veku po vysokoenergetických úrazoch.",
      "medicovi_relevance": "Správna diagnostika a liečba sú zásadné pre obnovenie funkcie bedrového kĺbu a návrat k normálnej chôdzi.",
      "internal_link": null,
      "citations": [
        {
          "title": "Acetabular fractures in adults",
          "authors": "Giannoudis PV, Grotz MRW, Papakostidis C, Dinopoulos H",
          "journal": "The Lancet",
          "year": "2007",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(07)60307-7/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "fraktúra členka",
      "canonical_term": "fraktúra členka",
      "slug": "fraktura-clenka",
      "aliases": [
        "zlomenina členka",
        "ankle fracture"
      ],
      "definition": "Fraktúra členka je poranenie, pri ktorom dochádza k zlomeniu jednej alebo viacerých kostí tvoriacich členkový kĺb (najčastejšie tibia, fibula alebo talus).",
      "clinical_context": "Fraktúry členka sú časté úrazy, ktoré vznikajú najmä pri pádoch, športových aktivitách alebo dopravných nehodách. Klinicky sa prejavujú bolesťou, opuchom, hematómom a obmedzením pohyblivosti v oblasti členka. Diagnóza sa potvrdzuje rádiologicky. Liečba závisí od typu a stability zlomeniny a môže byť konzervatívna alebo chirurgická.",
      "relation_to_gait": "Fraktúra členka významne ovplyvňuje schopnosť chôdze, keďže narušuje stabilitu a funkciu členkového kĺbu. Počas rekonvalescencie je chôdza často obmedzená alebo nemožná, pričom návrat k plnej záťaži závisí od rozsahu poranenia a liečby.",
      "who_is_affected": "Najčastejšie sú postihnutí mladí dospelí pri športových aktivitách a starší ľudia pri pádoch.",
      "medicovi_relevance": "Správna diagnostika a manažment fraktúr členka sú kľúčové pre obnovenie funkcie pohybového aparátu a prevenciu dlhodobých komplikácií, ako sú artróza alebo chronická nestabilita.",
      "internal_link": null,
      "citations": [
        {
          "title": "Ankle fractures in adults",
          "authors": "Michael J. Coughlin, Charles L. Saltzman",
          "journal": "BMJ",
          "year": "2017",
          "url": "https://www.bmj.com/content/359/bmj.j5023"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "Fraktúra krčku femuru",
      "canonical_term": "fraktúra krčku stehennej kosti",
      "slug": "fraktura-krcku-femuru",
      "aliases": [
        "zlomenina krčku stehennej kosti",
        "intrakapsulárna fraktúra femuru"
      ],
      "definition": "Fraktúra krčku femuru je zlomenina v oblasti medzi hlavicou a diafýzou stehennej kosti, ktorá je častá najmä u starších ľudí v dôsledku osteoporózy.",
      "clinical_context": "Ide o závažné úrazové ochorenie, ktoré si často vyžaduje chirurgickú liečbu (osteosyntéza alebo totálna endoprotéza bedrového kĺbu). Klinicky sa prejavuje bolesťou v oblasti bedra, neschopnosťou zaťažiť končatinu a skrátením a vonkajšou rotáciou postihnutej nohy.",
      "relation_to_gait": "Fraktúra krčku femuru vedie k okamžitej strate schopnosti chôdze na postihnutej končatine. Po liečbe môže pretrvávať porucha chôdze v dôsledku bolesti, svalovej slabosti alebo komplikácií (napr. avaskulárna nekróza hlavice femuru).",
      "who_is_affected": "Najčastejšie postihuje starších ľudí, najmä ženy s osteoporózou.",
      "medicovi_relevance": "Rýchla diagnostika a adekvátna liečba sú nevyhnutné na obnovenie mobility a prevenciu komplikácií, ktoré môžu výrazne zhoršiť kvalitu života a schopnosť samostatnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Management of hip fracture in older people",
          "authors": "Handoll HHG, Cameron ID, Mak JCS",
          "journal": "BMJ",
          "year": "2022",
          "url": "https://www.bmj.com/content/376/bmj-2021-068371"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "frontálny syndróm",
      "canonical_term": "frontálny syndróm",
      "slug": "frontalny-syndrom",
      "aliases": [
        "frontálny lalokový syndróm",
        "frontálny syndróm mozgu"
      ],
      "definition": "Frontálny syndróm je neurologický stav spôsobený poškodením frontálnych lalokov mozgu, ktorý sa prejavuje zmenami v správaní, osobnosti, exekutívnych funkciách a motorických schopnostiach.",
      "clinical_context": "Frontálny syndróm sa často vyskytuje u pacientov s cerebrovaskulárnymi príhodami, traumatickým poškodením mozgu, neurodegeneratívnymi ochoreniami (napr. frontotemporálna demencia) alebo nádorovými procesmi postihujúcimi frontálne laloky. Klinicky sa prejavuje apatiou, poruchami plánovania, impulzivitou, zmenami v správaní a narušením motorických funkcií.",
      "relation_to_gait": "Poškodenie frontálnych lalokov môže viesť k tzv. frontálnemu typu poruchy chôdze, charakterizovanej krátkymi, pomalými krokmi, nestabilitou, ťažkosťami so začatím pohybu (apraxia chôdze) a zvýšeným rizikom pádov.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí s cerebrovaskulárnymi ochoreniami, pacienti s neurodegeneratívnymi ochoreniami alebo po úrazoch hlavy.",
      "medicovi_relevance": "Včasná identifikácia frontálneho syndrómu je kľúčová pre diferenciálnu diagnostiku porúch chôdze a plánovanie rehabilitácie.",
      "internal_link": null,
      "citations": [
        {
          "title": "Gait disorders in adults and the elderly",
          "authors": "J. H. Giladi, N.",
          "journal": "The Lancet Neurology",
          "year": "2013",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(13)70107-0/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "ganglion cysta nohy",
      "canonical_term": "gangliónová cysta nohy",
      "slug": "ganglion-cysta-nohy",
      "aliases": [
        "gangliová cysta nohy",
        "synoviálna cysta nohy"
      ],
      "definition": "Ganglion cysta nohy je nezhubný, tekutinou vyplnený útvar, ktorý vzniká v oblasti šliach alebo kĺbov nohy, najčastejšie na dorzálnej strane chodidla alebo v oblasti členka.",
      "clinical_context": "Ganglion cysty nohy sa prejavujú ako hmatateľné, elastické opuchy, ktoré môžu byť bolestivé pri zaťažení alebo pohybe. Môžu spôsobovať tlak na okolité nervy alebo štruktúry.",
      "relation_to_gait": "Väčšie alebo bolestivé ganglion cysty môžu obmedzovať rozsah pohybu v kĺboch nohy, spôsobovať bolesť pri chôdzi a viesť k zmene stereotypu chôdze.",
      "who_is_affected": "Postihujú najmä mladých dospelých a ženy, často bez zjavnej príčiny alebo po opakovanom preťažení nohy.",
      "medicovi_relevance": "Správna diferenciálna diagnostika a liečba ganglion cysty je dôležitá pre obnovenie funkcie nohy a prevenciu chronických bolestí pri chôdzi.",
      "internal_link": null,
      "citations": [
        {
          "title": "Ganglion cysts of the foot and ankle",
          "authors": "Gude W, Morelli V",
          "journal": "JAMA",
          "year": "2008",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/182939"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "ganglión v oblasti členka",
      "canonical_term": "ganglión v oblasti členka",
      "slug": "ganglion-v-oblasti-clenka",
      "aliases": [
        "gangliová cysta členka",
        "synoviálna cysta členka"
      ],
      "definition": "Ganglión v oblasti členka je nezhubná cystická lézia vyplnená viskóznou tekutinou, ktorá vzniká v blízkosti kĺbov alebo šliach členka.",
      "clinical_context": "Ganglión sa prejavuje ako mäkký, elastický opuch v oblasti členka, ktorý môže spôsobovať bolesť, tlak na okolité štruktúry alebo obmedzenie pohybu. Často vzniká v dôsledku chronického preťaženia alebo mikrotraum.",
      "relation_to_gait": "Väčšie ganglióny môžu spôsobovať bolesť pri chôdzi, obmedzovať rozsah pohybu členka a viesť k zmene stereotypu chôdze.",
      "who_is_affected": "Najčastejšie postihuje mladých dospelých, športovcov alebo osoby s opakovaným preťažením členka.",
      "medicovi_relevance": "Správna diagnostika a liečba gangliónu v oblasti členka je dôležitá pre obnovenie funkcie a prevenciu obmedzenia chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Ganglion cysts of the foot and ankle",
          "authors": "McCarthy CL, McNally EG",
          "journal": "BMJ",
          "year": "2014",
          "url": "https://www.bmj.com/content/349/bmj.g6613"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "gangréna nohy",
      "canonical_term": "gangréna nohy",
      "slug": "gangrena-nohy",
      "aliases": [
        "gangréna dolnej končatiny",
        "nekróza tkanív nohy"
      ],
      "definition": "Gangréna nohy je závažný patologický stav charakterizovaný odumieraním tkanív nohy v dôsledku nedostatočného prekrvenia, infekcie alebo kombinácie oboch faktorov.",
      "clinical_context": "Gangréna nohy sa najčastejšie vyskytuje u pacientov s diabetom mellitus, periférnym arteriálnym ochorením alebo po ťažkých úrazoch. Klinicky sa prejavuje čiernym sfarbením, stratou vitality tkaniva, zápachom a často aj systémovými príznakmi infekcie.",
      "relation_to_gait": "Gangréna nohy výrazne ovplyvňuje chôdzu, často vedie k silnej bolesti, strate funkcie postihnutej časti a v pokročilých prípadoch k nutnosti amputácie, čo zásadne mení schopnosť samostatného pohybu.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí, diabetici, pacienti s periférnym arteriálnym ochorením a osoby s oslabenou imunitou.",
      "medicovi_relevance": "Včasná diagnostika a liečba gangrény nohy je kľúčová pre prevenciu amputácie a zachovanie mobility pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diabetic foot ulcers and their recurrence",
          "authors": "Armstrong DG, Boulton AJM, Bus SA",
          "journal": "The New England Journal of Medicine",
          "year": "2017",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMra1615439"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "gonalgia",
      "canonical_term": "bolesť kolenného kĺbu",
      "slug": "gonalgia",
      "aliases": [
        "bolesť kolena",
        "kolenná bolesť"
      ],
      "definition": "Gonalgia je medicínsky termín označujúci bolesť lokalizovanú v oblasti kolenného kĺbu, bez ohľadu na jej príčinu.",
      "clinical_context": "Gonalgia môže byť spôsobená akútnym úrazom, chronickými degeneratívnymi zmenami (napr. osteoartróza), zápalovými ochoreniami alebo preťažením. Klinicky sa prejavuje bolesťou pri pohybe, opuchom, obmedzením hybnosti a niekedy aj nestabilitou.",
      "relation_to_gait": "Bolesť kolena vedie k poruche stereotypu chôdze, skracovaniu kroku, vyhýbaniu sa záťaži na postihnutú končatinu a môže spôsobovať krívanie.",
      "who_is_affected": "Gonalgia postihuje všetky vekové skupiny, najmä však starších ľudí, športovcov a osoby s nadváhou alebo opakovaným preťažením kolena.",
      "medicovi_relevance": "Správna diagnostika a liečba gonalgie je nevyhnutná na obnovenie funkcie kolena a prevenciu dlhodobých porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Knee pain in adults: diagnosis and management in primary care",
          "authors": "Hunter DJ, et al.",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/350/bmj.h568"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "gonartróza",
      "canonical_term": "gonartróza",
      "slug": "gonartroza",
      "aliases": [
        "osteoartróza kolenného kĺbu",
        "degeneratívne ochorenie kolena"
      ],
      "definition": "Gonartróza je chronické degeneratívne ochorenie kolenného kĺbu charakterizované postupnou stratou kĺbovej chrupavky, subchondrálnou sklerózou a tvorbou osteofytov.",
      "clinical_context": "Gonartróza je najčastejšou príčinou bolesti a funkčného obmedzenia kolena u dospelých, najmä v staršom veku. Klinicky sa prejavuje bolesťou, stuhnutosťou, opuchom a obmedzením pohyblivosti kolena. Diagnóza je založená na klinickom obraze a rádiologickom vyšetrení.",
      "relation_to_gait": "Gonartróza vedie k narušeniu chôdze v dôsledku bolesti, zníženej stability a obmedzenej pohyblivosti kolena. Pacienti často vyvíjajú antalgické stereotypy chôdze, ktoré môžu viesť k ďalšiemu preťaženiu iných kĺbov a svalov.",
      "who_is_affected": "Najčastejšie postihuje osoby nad 50 rokov, ženy, osoby s nadváhou, po úrazoch kolena alebo s genetickou predispozíciou.",
      "medicovi_relevance": "Včasná diagnostika a manažment gonartrózy sú kľúčové pre zachovanie funkcie kolena a prevenciu zhoršenia mobility.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osteoarthritis of the knee",
          "authors": "Hunter DJ, Bierma-Zeinstra S",
          "journal": "The Lancet",
          "year": "2019",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(19)30417-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "Guillain-Barrého syndróm",
      "canonical_term": "guillain-barrého syndróm",
      "slug": "guillain-barreho-syndrom",
      "aliases": [
        "GBS",
        "akútna idiopatická polyradikuloneuropatia"
      ],
      "definition": "Guillain-Barrého syndróm je akútne autoimunitné ochorenie periférneho nervového systému, charakterizované rýchlo progredujúcou svalovou slabosťou a areflexiou.",
      "clinical_context": "GBS často nasleduje po infekcii a vedie k symetrickej slabosti, ktorá môže progredovať až k respiračnému zlyhaniu. Včasná diagnostika a liečba sú kľúčové pre prognózu.",
      "relation_to_gait": "Guillain-Barrého syndróm spôsobuje rýchlu slabosť dolných končatín, čo vedie k výraznému zhoršeniu chôdze, nestabilite a často k neschopnosti samostatne chodiť v akútnej fáze.",
      "who_is_affected": "Postihuje všetky vekové skupiny, mierne častejšie mužov. Výskyt je približne 1-2 prípady na 100 000 obyvateľov ročne.",
      "medicovi_relevance": "Rýchle rozpoznanie porúch chôdze pri GBS je zásadné pre urgentnú hospitalizáciu, monitorovanie respiračných funkcií a začatie imunoterapie.",
      "internal_link": null,
      "citations": [
        {
          "title": "Guillain-Barré syndrome",
          "authors": "Willison HJ, Jacobs BC, van Doorn PA",
          "journal": "The Lancet",
          "year": "2016",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(16)00339-1/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "hallux rigidus",
      "canonical_term": "hallux rigidus",
      "slug": "hallux-rigidus",
      "aliases": [
        "artróza metatarzofalangeálneho kĺbu palca",
        "stuhnutý palec"
      ],
      "definition": "Hallux rigidus je degeneratívne ochorenie metatarzofalangeálneho kĺbu palca na nohe, charakterizované obmedzením pohyblivosti a bolesťou v oblasti palca v dôsledku artrózy.",
      "clinical_context": "Ochorenie sa najčastejšie vyskytuje u dospelých vo veku 30 až 60 rokov a je druhou najčastejšou patológiou palca po hallux valgus. Klinicky sa prejavuje bolesťou, stuhnutosťou a obmedzením dorzálnej flexie palca, čo môže viesť k sekundárnym zmenám v chôdzi.",
      "relation_to_gait": "Obmedzenie pohyblivosti palca spôsobuje poruchy odrazu pri chôdzi, čo vedie k alterácii chôdzového stereotypu, zvýšenej námahe iných častí chodidla a často aj k sekundárnym bolestiam v prednej časti nohy.",
      "who_is_affected": "Najčastejšie sú postihnutí dospelí vo veku 30–60 rokov, častejšie muži, osoby s opakovaným preťažením palca alebo po úrazoch.",
      "medicovi_relevance": "Včasná diagnostika a liečba hallux rigidus je dôležitá pre prevenciu chronickej bolesti a zhoršenia mobility, čo má významný vplyv na kvalitu života a schopnosť samostatného pohybu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Hallux rigidus: a review of current diagnosis and treatment",
          "authors": "Coughlin MJ, Shurnas PS",
          "journal": "BMJ",
          "year": "2000",
          "url": "https://www.bmj.com/content/321/7261/152"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "hallux valgus",
      "canonical_term": "hallux valgus",
      "slug": "hallux-valgus",
      "aliases": [
        "vbočený palec",
        "valgózna deviácia palca"
      ],
      "definition": "Hallux valgus je deformita palca nohy charakterizovaná laterálnou deviáciou palca a mediálnym vybočením prvej metatarzálnej kosti, často spojená s tvorbou bunionu (výrastku) na mediálnej strane chodidla.",
      "clinical_context": "Hallux valgus je najčastejšou deformitou prednej časti chodidla, prevažne postihuje ženy stredného a vyššieho veku. Rizikové faktory zahŕňajú genetickú predispozíciu, nevhodnú obuv a hypermobilitu kĺbov. Klinicky sa prejavuje bolesťou, zápalom a obmedzením pohyblivosti.",
      "relation_to_gait": "Deformita spôsobuje zmeny v rozložení záťaže pri chôdzi, vedie k preťaženiu druhého a tretieho metatarzu a môže spôsobovať bolesť pri odraze. Pacienti často vyhýbajú zaťažovaniu palca, čo mení stereotyp chôdze.",
      "who_is_affected": "Najčastejšie postihuje ženy stredného a vyššieho veku, osoby s genetickou predispozíciou alebo s dlhodobým nosením úzkej obuvi.",
      "medicovi_relevance": "Včasná intervencia pri hallux valgus môže predísť progresii deformity a znížiť riziko sekundárnych komplikácií pohybového aparátu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Hallux Valgus: Epidemiology, Pathophysiology, and Management",
          "authors": "S. J. Coughlin, M. Jones",
          "journal": "JAMA",
          "year": "2020",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/2764567"
        }
      ],
      "recommended_products": [
        {
          "handle": "h20",
          "support_level": "komfort",
          "usage": "bežné nosenie"
        },
        {
          "handle": "t45",
          "support_level": "maximálny kofmort",
          "usage": "zvýšená záťaž"
        }
      ]
    },
    {
      "term": "hemartros kolena",
      "canonical_term": "hemartróza kolenného kĺbu",
      "slug": "hemartros-kolena",
      "aliases": [
        "krvácanie do kolenného kĺbu",
        "hemartróza kolena"
      ],
      "definition": "Hemartros kolena je patologický stav charakterizovaný prítomnosťou krvi v dutine kolenného kĺbu, najčastejšie v dôsledku úrazu, ruptúry väzov alebo meniskov, menej často pri koagulopatiách.",
      "clinical_context": "Hemartros kolena sa často vyskytuje po akútnych úrazoch, ako sú ruptúry predného skríženého väzu alebo poškodenie meniskov. Môže byť tiež prejavom systémových ochorení, napríklad hemofílie. Klinicky sa prejavuje rýchlym opuchom, bolesťou a obmedzením pohybu v kolene.",
      "relation_to_gait": "Hemartros kolena spôsobuje výrazné obmedzenie chôdze v dôsledku bolesti, opuchu a zníženej stability kĺbu. Pacienti často vyhýbajú zaťaženiu postihnutej končatiny, čo vedie k antalgickému stereotypu chôdze.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, osoby po úrazoch kolena, pacienti s poruchami zrážanlivosti krvi (napr. hemofília) a starší ľudia s degeneratívnymi zmenami.",
      "medicovi_relevance": "Rýchla diagnostika a liečba hemartrosu je kľúčová pre prevenciu ďalšieho poškodenia kĺbových štruktúr a obnovenie funkcie kolena vrátane schopnosti chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Acute knee injuries: use of clinical criteria in selecting patients for radiography",
          "authors": "Stiell IG, Greenberg GH, Wells GA, et al.",
          "journal": "BMJ",
          "year": "1995",
          "url": "https://www.bmj.com/content/311/7007/1322"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "hematóm v oblasti členka",
      "canonical_term": "hematóm v oblasti členka",
      "slug": "hematom-v-oblasti-clenka",
      "aliases": [
        "hematóm členka",
        "krvný výron v oblasti členka"
      ],
      "definition": "Hematóm v oblasti členka je lokalizované nahromadenie krvi mimo ciev v tkanivách členka, ktoré vzniká najčastejšie po úraze alebo preťažení.",
      "clinical_context": "Hematóm v oblasti členka sa často vyskytuje po distorzii (vyvrtnutí) členka, priamom údere alebo po chirurgických zákrokoch. Môže viesť k opuchu, bolesti a obmedzeniu pohyblivosti. Diagnostika zahŕňa klinické vyšetrenie a zobrazovacie metódy (napr. ultrazvuk, MRI) na vylúčenie závažnejších poranení.",
      "relation_to_gait": "Hematóm v oblasti členka môže spôsobovať bolesť a opuch, čo vedie k narušeniu normálneho stereotypu chôdze, obmedzeniu záťaže a často aj k dočasnému krívaniu.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, osoby po úrazoch členka a starší pacienti s vyšším rizikom pádov.",
      "medicovi_relevance": "Včasná diagnostika a liečba hematómu v oblasti členka je dôležitá pre obnovenie funkcie a prevenciu komplikácií, ako je chronická bolesť alebo obmedzenie pohybu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Management of acute ankle sprain",
          "authors": "van den Bekerom MPJ, et al.",
          "journal": "BMJ",
          "year": "2012",
          "url": "https://www.bmj.com/content/344/bmj.e2511"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "hemiparéza",
      "canonical_term": "hemiparéza",
      "slug": "hemipareza",
      "aliases": [
        "hemiparetický syndróm",
        "čiastočné ochrnutie polovice tela"
      ],
      "definition": "Hemiparéza je čiastočná strata svalovej sily alebo slabosť na jednej polovici tela, najčastejšie v dôsledku lézie centrálneho nervového systému, ako je cievna mozgová príhoda.",
      "clinical_context": "Hemiparéza sa vyskytuje najmä po ischemických alebo hemoragických cievnych mozgových príhodách, menej často pri nádoroch, traumách alebo zápalových ochoreniach CNS. Klinicky sa prejavuje slabosťou, zníženou koordináciou a spasticitou na postihnutej strane.",
      "relation_to_gait": "Hemiparéza spôsobuje asymetrickú chôdzu, často s cirkumdukciou (kruhovitým pohybom) dolnej končatiny na postihnutej strane, zníženou stabilitou a zvýšeným rizikom pádov.",
      "who_is_affected": "Najčastejšie postihuje pacientov po cievnej mozgovej príhode, ale aj osoby s inými ochoreniami centrálneho nervového systému.",
      "medicovi_relevance": "Včasná identifikácia hemiparézy je kľúčová pre začatie rehabilitácie a prevenciu sekundárnych komplikácií, vrátane porúch chôdze a pádov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Gait patterns in hemiplegic stroke patients",
          "authors": "Olney SJ, Richards C",
          "journal": "JAMA",
          "year": "1996",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/403568"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "hernia disku",
      "canonical_term": "herniácia medzistavcovej platničky",
      "slug": "hernia-disku",
      "aliases": [
        "hernia medzistavcovej platničky",
        "protrúzia disku",
        "vysunutá platnička"
      ],
      "definition": "Hernia disku je stav, pri ktorom dochádza k vyklenutiu alebo prasknutiu medzistavcovej platničky, čo môže viesť k útlaku nervových štruktúr v chrbticovom kanáli.",
      "clinical_context": "Hernia disku je častou príčinou bolesti chrbta a radikulopatie, najmä v lumbálnej oblasti. Môže spôsobovať neurologické príznaky v dôsledku kompresie nervových koreňov, vrátane slabosti, porúch citlivosti a reflexov.",
      "relation_to_gait": "Pri hernii disku môže dôjsť k poruchám chôdze v dôsledku slabosti dolných končatín, bolesti alebo motorického deficitu, najmä ak je postihnutý sedací nerv (ischias).",
      "who_is_affected": "Najčastejšie postihuje dospelých vo veku 30–50 rokov, často v dôsledku degeneratívnych zmien alebo nadmernej záťaže chrbtice.",
      "medicovi_relevance": "Včasná diagnostika a liečba hernie disku je kľúčová pre prevenciu trvalých neurologických deficitov a zlepšenie funkčnej mobility vrátane chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar disc herniation",
          "authors": "Foster NE, et al.",
          "journal": "BMJ",
          "year": "2018",
          "url": "https://www.bmj.com/content/361/bmj.k1614"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "hydrops kolena",
      "canonical_term": "hydrops kolenného kĺbu",
      "slug": "hydrops-kolena",
      "aliases": [
        "výpotok kolena",
        "synovitída kolena"
      ],
      "definition": "Hydrops kolena je stav charakterizovaný nadmerným hromadením synoviálnej tekutiny v dutine kolenného kĺbu, čo vedie k jeho opuchu.",
      "clinical_context": "Hydrops kolena môže byť spôsobený akútnym alebo chronickým zápalom, úrazom, artrózou, reumatickými ochoreniami alebo infekciou. Prejavuje sa opuchom, pocitom napätia, obmedzením pohybu a niekedy aj bolesťou.",
      "relation_to_gait": "Prítomnosť hydropsu kolena vedie k obmedzeniu rozsahu pohybu a bolesti pri chôdzi, čo spôsobuje zmeny v stereotypu chôdze, často s vynechávaním zaťaženia postihnutej končatiny.",
      "who_is_affected": "Postihuje osoby s úrazmi kolena, pacientov s artrózou, reumatickými ochoreniami, športovcov a starších ľudí.",
      "medicovi_relevance": "Včasná diagnostika a liečba hydropsu kolena je dôležitá pre obnovenie funkcie kĺbu a prevenciu chronických zmien, ktoré môžu negatívne ovplyvniť chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and management of knee osteoarthritis: a systematic review",
          "authors": "Zhang W, Nuki G, Moskowitz RW, et al.",
          "journal": "BMJ",
          "year": "2008",
          "url": "https://www.bmj.com/content/336/7652/1125"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "hypertonus",
      "canonical_term": "hypertonia",
      "slug": "hypertonus",
      "aliases": [
        "zvýšený svalový tonus",
        "spasticita"
      ],
      "definition": "Hypertonus je stav charakterizovaný zvýšeným napätím kostrového svalstva, ktorý môže byť spôsobený poruchou centrálneho nervového systému.",
      "clinical_context": "Hypertonus sa často vyskytuje pri neurologických ochoreniach, ako sú cievne mozgové príhody, roztrúsená skleróza alebo traumatické poškodenie mozgu. Klinicky sa prejavuje zvýšenou rezistenciou svalov voči pasívnemu pohybu a môže byť spojený so spasticitou.",
      "relation_to_gait": "Hypertonus vedie k stuhnutosti svalov, obmedzeniu rozsahu pohybu a narušeniu koordinácie chôdze. Pacienti môžu mať typický spastický vzorec chôdze, zvýšené riziko pádu a ťažkosti s prechodom medzi jednotlivými fázami chôdze.",
      "who_is_affected": "Postihuje najmä pacientov po cievnej mozgovej príhode, s detskou mozgovou obrnou alebo inými centrálnymi neurologickými ochoreniami.",
      "medicovi_relevance": "Správna diagnostika a manažment hypertonusu sú dôležité pre optimalizáciu rehabilitácie a zlepšenie funkčnej mobility pacientov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Spasticity: diagnosis and management",
          "authors": "Pandyan AD, Gregoric M, Barnes MP, et al.",
          "journal": "BMJ",
          "year": "2005",
          "url": "https://www.bmj.com/content/330/7493/484"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "hypestézia",
      "canonical_term": "hypestézia",
      "slug": "hypestezia",
      "aliases": [
        "znížená citlivosť",
        "hypoestézia"
      ],
      "definition": "Hypestézia je stav charakterizovaný zníženou citlivosťou na dotyk, bolesť alebo iné zmyslové podnety v určitej oblasti tela.",
      "clinical_context": "Hypestézia sa často vyskytuje pri neurologických ochoreniach, ako sú periférne neuropatie, poškodenie miechy alebo mozgu, a môže byť príznakom diabetickej neuropatie, roztrúsenej sklerózy či po cievnej mozgovej príhode.",
      "relation_to_gait": "Znížená citlivosť dolných končatín môže viesť k narušeniu propriocepcie, čo zvyšuje riziko nestability, nesprávneho postavenia nohy a pádov počas chôdze.",
      "who_is_affected": "Najčastejšie sú postihnutí pacienti s diabetom, neurologickými ochoreniami alebo po úrazoch nervového systému.",
      "medicovi_relevance": "Včasná identifikácia hypestézie je kľúčová pre prevenciu pádov a optimalizáciu rehabilitácie u pacientov s poruchami chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Peripheral neuropathy: evaluation and differential diagnosis",
          "authors": "England JD, Gronseth GS, Franklin G, et al.",
          "journal": "BMJ",
          "year": "2009",
          "url": "https://www.bmj.com/content/339/bmj.b3655"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "hypotónia",
      "canonical_term": "hypotónia",
      "slug": "hypotonia",
      "aliases": [
        "znížený svalový tonus",
        "svalová slabosť"
      ],
      "definition": "Hypotónia je stav charakterizovaný zníženým napätím kostrového svalstva, čo vedie k ochabnutosti svalov a zníženej odolnosti voči pasívnemu pohybu.",
      "clinical_context": "V klinickej praxi sa hypotónia často vyskytuje pri neurologických ochoreniach, ako sú cerebrálna obrna, spinálna svalová atrofia alebo niektoré metabolické a genetické poruchy. Diagnostika zahŕňa neurologické vyšetrenie, hodnotenie svalového tonusu a funkčných schopností pacienta.",
      "relation_to_gait": "Hypotónia negatívne ovplyvňuje stabilitu chôdze, spôsobuje nestabilitu, zvýšené riziko pádu a ťažkosti pri udržiavaní vzpriamenej polohy počas chôdze. Pacienti môžu mať nekoordinované pohyby a zníženú schopnosť reagovať na zmeny povrchu.",
      "who_is_affected": "Najčastejšie sú postihnuté deti s neurologickými poruchami, ale hypotónia sa môže vyskytnúť aj u dospelých v dôsledku poškodenia centrálneho alebo periférneho nervového systému.",
      "medicovi_relevance": "Včasná identifikácia a liečba hypotónie je kľúčová pre prevenciu komplikácií spojených s chôdzou a zlepšenie kvality života pacientov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Hypotonia in children: clinical approach",
          "authors": "Mercuri E, Muntoni F",
          "journal": "BMJ",
          "year": "2012",
          "url": "https://www.bmj.com/content/344/bmj.e3724"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "Charcotova noha",
      "canonical_term": "charcotova noha",
      "slug": "charcotova-noha",
      "aliases": [
        "Charcotova osteoartropatia",
        "Charcotova artropatia"
      ],
      "definition": "Charcotova noha je progresívne deštruktívne ochorenie kostí, kĺbov a mäkkých tkanív chodidla, ktoré vzniká najčastejšie v dôsledku diabetickej neuropatie. Charakterizuje ju strata citlivosti, nestabilita a deformity chodidla.",
      "clinical_context": "Charcotova noha je závažná komplikácia diabetu, ktorá vedie k rýchlej deštrukcii kostí a kĺbov chodidla, často bez výraznej bolesti v dôsledku neuropatie. Diagnóza je často oneskorená, čo zvyšuje riziko amputácie.",
      "relation_to_gait": "Deformity a nestabilita spôsobené Charcotovou nohou vedú k abnormálnemu zaťaženiu chodidla, poruchám chôdze, zvýšenému riziku ulcerácií a sekundárnych infekcií.",
      "who_is_affected": "Najčastejšie sú postihnutí pacienti s dlhodobým diabetom, najmä tí s periférnou neuropatiou.",
      "medicovi_relevance": "Včasná diagnostika a intervencia sú kľúčové pre prevenciu závažných komplikácií, vrátane amputácie. Manažment zahŕňa imobilizáciu, kontrolu glykémie a multidisciplinárny prístup.",
      "internal_link": null,
      "citations": [
        {
          "title": "Charcot foot in diabetes",
          "authors": "Jeffcoate WJ, Game FL, Cavanagh PR",
          "journal": "The Lancet",
          "year": "2005",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(05)66480-8/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "chondromalácia členka",
      "canonical_term": "chondromalácia členka",
      "slug": "chondromalacia-clenka",
      "aliases": [
        "chondromalácia talokrurálneho kĺbu",
        "změknutie chrupavky členka"
      ],
      "definition": "Chondromalácia členka je degeneratívne poškodenie a zmäknutie kĺbovej chrupavky v oblasti členkového kĺbu, ktoré vedie k bolesti a obmedzeniu pohybu.",
      "clinical_context": "Chondromalácia členka vzniká najčastejšie v dôsledku opakovaných mikrotraum, preťaženia alebo po úrazoch. Prejavuje sa bolestivosťou, opuchom a pocitom nestability v členku, najmä pri záťaži.",
      "relation_to_gait": "Poškodenie chrupavky spôsobuje bolesť pri zaťažení, čo vedie k obmedzeniu pohybu, krívaniu a zmenám v biomechanike chôdze.",
      "who_is_affected": "Postihuje najmä športovcov, osoby s opakovanými úrazmi členka alebo s predispozíciou k degeneratívnym ochoreniam kĺbov.",
      "medicovi_relevance": "Včasná identifikácia a liečba chondromalácie členka je dôležitá pre zachovanie funkcie kĺbu a prevenciu ďalšieho poškodenia ovplyvňujúceho chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osteochondral lesions of the talus: current concepts in diagnosis and treatment",
          "authors": "Chuckpaiwong B, Berkson EM, Theodore GH",
          "journal": "BMJ",
          "year": "2008",
          "url": "https://www.bmj.com/content/337/bmj.a2635"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "chondromalácia pately",
      "canonical_term": "chondromalácia pately",
      "slug": "chondromalacia-pately",
      "aliases": [
        "chondromalácia jabĺčka",
        "změknutie chrupavky pately"
      ],
      "definition": "Chondromalácia pately je degeneratívne ochorenie chrupavky na zadnej ploche pately, ktoré vedie k jej zmäknutiu, praskaniu a bolestivosti.",
      "clinical_context": "Chondromalácia pately sa často vyskytuje u mladých aktívnych ľudí a športovcov. Klinicky sa prejavuje bolesťou v prednej časti kolena, najmä pri činnostiach zvyšujúcich tlak na patelu, ako je chôdza po schodoch alebo dlhé sedenie.",
      "relation_to_gait": "Ochorenie môže spôsobovať bolesť pri chôdzi, obmedzenie rozsahu pohybu a zmeny v stereotypoch chôdze v dôsledku vyhýbania sa bolesti.",
      "who_is_affected": "Najčastejšie postihuje mladých športovcov, ženy a osoby s anatomickými odchýlkami v oblasti kolena.",
      "medicovi_relevance": "Včasná diagnostika a liečba chondromalácie pately sú dôležité pre prevenciu progresie ochorenia a zachovanie funkcie kolena pri chôdzi.",
      "internal_link": null,
      "citations": [
        {
          "title": "Chondromalacia patellae",
          "authors": "Smith BE, et al.",
          "journal": "BMJ",
          "year": "2018",
          "url": "https://www.bmj.com/content/361/bmj.k2202"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "chôdza na širokej báze",
      "canonical_term": "ataxická chôdza",
      "slug": "chodza-na-sirokej-baze",
      "aliases": [
        "širokobázová chôdza",
        "široká báza pri chôdzi"
      ],
      "definition": "Chôdza na širokej báze je abnormálny vzor chôdze, pri ktorom má pacient nohy rozkročené viac ako obvykle, aby zvýšil stabilitu.",
      "clinical_context": "Tento typ chôdze je často pozorovaný pri neurologických poruchách ovplyvňujúcich rovnováhu, ako sú cerebelárne ataxie, polyneuropatie alebo vestibulárne dysfunkcie. Je kompenzačným mechanizmom na zníženie rizika pádu.",
      "relation_to_gait": "Chôdza na širokej báze signalizuje poruchu stability a koordinácie. Pacienti majú tendenciu rozširovať postoj, aby udržali rovnováhu, čo však môže viesť k neefektívnej a energeticky náročnej chôdzi.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých a pacientov s neurologickými ochoreniami ovplyvňujúcimi propriocepciu alebo mozoček.",
      "medicovi_relevance": "Identifikácia chôdze na širokej báze je dôležitá pre diferenciálnu diagnostiku neurologických porúch a plánovanie rehabilitácie zameranej na zlepšenie stability.",
      "internal_link": null,
      "citations": [
        {
          "title": "Gait disorders in adults and the elderly",
          "authors": "Hausdorff JM, Rios DA, Edelberg HK",
          "journal": "The Lancet",
          "year": "2001",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(01)06175-5/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "chôdza s malými krokmi",
      "canonical_term": "chôdza s malými krokmi",
      "slug": "chodza-s-malymi-krokmi",
      "aliases": [
        "chôdza s drobnými krokmi",
        "short-stepped gait",
        "marche à petits pas"
      ],
      "definition": "Chôdza s malými krokmi je porucha chôdze charakterizovaná krátkymi, pomalými a neistými krokmi, často s ťažkosťami pri začatí pohybu.",
      "clinical_context": "Tento typ chôdze je typický pre neurologické ochorenia, najmä Parkinsonovu chorobu, normotenzný hydrocefalus a iné extrapyramidové syndrómy.",
      "relation_to_gait": "Chôdza s malými krokmi vedie k zníženej stabilite, zvýšenému riziku pádov a obmedzeniu mobility, čo výrazne ovplyvňuje kvalitu života pacienta.",
      "who_is_affected": "Najčastejšie sú postihnutí starší pacienti s Parkinsonovou chorobou, normotenzným hydrocefalom alebo inými neurodegeneratívnymi ochoreniami.",
      "medicovi_relevance": "Včasné rozpoznanie tohto typu chôdze umožňuje cielenú intervenciu, rehabilitáciu a prevenciu pádov u pacientov s neurologickými poruchami.",
      "internal_link": null,
      "citations": [
        {
          "title": "Gait disorders in the elderly and the risk of falls",
          "authors": "Hausdorff JM, Rios DA, Edelberg HK.",
          "journal": "The Lancet",
          "year": "2001",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(01)06102-5/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "chôdza s predklonom",
      "canonical_term": "chôdza s predklonom",
      "slug": "chodza-s-predklonom",
      "aliases": [
        "chôdza s anteflexiou trupu",
        "predklonená chôdza"
      ],
      "definition": "Chôdza s predklonom je abnormálny vzorec chôdze charakterizovaný výrazným predklonom trupu počas pohybu, často spojený s neurologickými ochoreniami.",
      "clinical_context": "Tento typ chôdze sa najčastejšie vyskytuje u pacientov s Parkinsonovou chorobou alebo inými extrapyramídovými poruchami. Predklon trupu môže byť spôsobený posturálnou nestabilitou, svalovou rigiditou alebo poruchou propriocepcie.",
      "relation_to_gait": "Chôdza s predklonom znižuje stabilitu, zvyšuje riziko pádu a obmedzuje schopnosť rýchlo reagovať na zmeny v prostredí. Pacienti majú často skrátený krok a zhoršenú schopnosť zastaviť sa alebo zmeniť smer.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých s Parkinsonovou chorobou, atypickými parkinsonskými syndrómami alebo inými neurodegeneratívnymi ochoreniami.",
      "medicovi_relevance": "Identifikácia tohto vzorca chôdze je kľúčová pre hodnotenie rizika pádu a plánovanie rehabilitácie u pacientov s neurologickými poruchami.",
      "internal_link": null,
      "citations": [
        {
          "title": "Gait disorders in parkinsonism: a clinical approach",
          "authors": "Jankovic J.",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/351/bmj.h4417"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "chôdza s ťahaním nohy",
      "canonical_term": "chôdza s ťahaním nohy",
      "slug": "chodza-s-tahanim-nohy",
      "aliases": [
        "ťahavá chôdza",
        "dragging gait"
      ],
      "definition": "Chôdza s ťahaním nohy je patologický vzorec chôdze, pri ktorom pacient nedokáže úplne zdvihnúť jednu dolnú končatinu, čo vedie k jej ťahaniu po podlahe počas kroku.",
      "clinical_context": "Tento typ chôdze je často pozorovaný pri neurologických poruchách, ako je centrálny alebo periférny paréza, najmä po cievnej mozgovej príhode alebo pri ochoreniach motoneurónov. Môže byť tiež prítomný pri poškodení miechy alebo nervových koreňov.",
      "relation_to_gait": "Chôdza s ťahaním nohy výrazne znižuje stabilitu a zvyšuje riziko pádov. Je prejavom svalovej slabosti, spasticity alebo poruchy koordinácie, ktoré ovplyvňujú schopnosť zdvihnúť nohu počas švihu.",
      "who_is_affected": "Najčastejšie sú postihnutí pacienti po cievnej mozgovej príhode, s roztrúsenou sklerózou, ALS alebo inými neurologickými ochoreniami ovplyvňujúcimi motoriku dolných končatín.",
      "medicovi_relevance": "Identifikácia tohto vzorca chôdze je dôležitá pre správnu diagnostiku a nastavenie rehabilitačného plánu zameraného na zlepšenie stability a prevenciu pádov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Gait disorders in adults and the elderly",
          "authors": "Snijders AH, van de Warrenburg BP, Giladi N, Bloem BR.",
          "journal": "The Lancet Neurology",
          "year": "2007",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(07)70107-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "chronická achillova tendinopatia",
      "canonical_term": "chronická achilová tendinopatia",
      "slug": "chronicka-achillova-tendinopatia",
      "aliases": [
        "chronická tendinopatia Achillovej šľachy",
        "chronická achilodýnia"
      ],
      "definition": "Chronická achillova tendinopatia je dlhodobé degeneratívne ochorenie Achillovej šľachy charakterizované bolesťou, stuhnutosťou a zníženou funkciou šľachy bez výrazných známok zápalu.",
      "clinical_context": "Vyskytuje sa najmä u športovcov a fyzicky aktívnych osôb, často v dôsledku opakovaného preťaženia alebo mikrotraumat. Klinicky sa prejavuje pretrvávajúcou bolesťou v oblasti Achillovej šľachy, najmä pri záťaži alebo po nej. Diagnóza je založená na anamnéze, fyzikálnom vyšetrení a zobrazovacích metódach (najmä ultrazvuk, MRI).",
      "relation_to_gait": "Chronická achillova tendinopatia vedie k obmedzeniu pohyblivosti členka, bolesti pri odraze a zníženiu sily lýtkových svalov, čo negatívne ovplyvňuje fázu odrazu pri chôdzi a môže spôsobovať krívanie.",
      "who_is_affected": "Najčastejšie postihuje bežcov, športovcov a osoby s opakovanou záťažou Achillovej šľachy, ale môže sa vyskytnúť aj u starších dospelých.",
      "medicovi_relevance": "Včasná diagnostika a liečba sú kľúčové pre prevenciu ruptúry šľachy a obnovenie funkcie dolnej končatiny.",
      "internal_link": null,
      "citations": [
        {
          "title": "Achilles tendinopathy: aetiology and management",
          "authors": "Maffulli N, Longo UG, Denaro V",
          "journal": "BMJ",
          "year": "2011",
          "url": "https://www.bmj.com/content/343/bmj.d4699"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "chronická bolesť bedrového kĺbu",
      "canonical_term": "chronická bolesť bedrového kĺbu",
      "slug": "chronicka-bolest-bedroveho-klbu",
      "aliases": [
        "dlhodobá bolesť bedrového kĺbu",
        "chronic hip pain"
      ],
      "definition": "Chronická bolesť bedrového kĺbu je pretrvávajúca alebo opakujúca sa bolesť v oblasti bedrového kĺbu trvajúca viac ako 3 mesiace, ktorá môže byť spôsobená rôznymi muskuloskeletálnymi, neurologickými alebo systémovými ochoreniami.",
      "clinical_context": "Chronická bolesť bedrového kĺbu je častým dôvodom vyhľadania lekárskej starostlivosti, pričom jej príčiny zahŕňajú osteoartritídu, burzitídu, tendinopatie, impingement syndróm, avaskulárnu nekrózu a ďalšie. Vyžaduje komplexný diagnostický prístup a multidisciplinárnu liečbu.",
      "relation_to_gait": "Chronická bolesť bedrového kĺbu vedie k obmedzeniu pohyblivosti, zníženiu rozsahu pohybu a často spôsobuje poruchy chôdze, ako je krívanie, asymetria kroku alebo zníženie rýchlosti chôdze.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí, športovci, osoby s nadváhou a pacienti s predchádzajúcimi úrazmi alebo degeneratívnymi ochoreniami bedrového kĺbu.",
      "medicovi_relevance": "Chronická bolesť bedrového kĺbu významne znižuje kvalitu života a funkčnú nezávislosť, preto je dôležitá včasná diagnostika a individualizovaná liečba.",
      "internal_link": null,
      "citations": [
        {
          "title": "Chronic hip pain in adults: clinical review",
          "authors": "Birrell F, et al.",
          "journal": "BMJ",
          "year": "2011",
          "url": "https://www.bmj.com/content/342/bmj.d330"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "chronická bolesť členka",
      "canonical_term": "chronická bolesť členka",
      "slug": "chronicka-bolest-clenka",
      "aliases": [
        "dlhodobá bolesť členka",
        "perzistentná bolesť členka"
      ],
      "definition": "Chronická bolesť členka je pretrvávajúca alebo opakujúca sa bolesť v oblasti členka trvajúca viac ako 3 mesiace, často spojená s predchádzajúcim úrazom, zápalom alebo degeneratívnymi zmenami.",
      "clinical_context": "Chronická bolesť členka môže byť dôsledkom neliečených alebo nesprávne liečených úrazov, artrózy, zápalových ochorení alebo preťaženia. Vyžaduje komplexnú diagnostiku vrátane zobrazovacích metód a funkčných testov.",
      "relation_to_gait": "Chronická bolesť členka vedie k obmedzeniu pohyblivosti, alterácii stereotypu chôdze, kompenzačným mechanizmom a zníženiu fyzickej aktivity.",
      "who_is_affected": "Postihuje široké spektrum pacientov, od športovcov po starších ľudí, najmä po opakovaných úrazoch alebo pri chronických ochoreniach pohybového aparátu.",
      "medicovi_relevance": "Identifikácia príčiny a cielená liečba chronickej bolesti členka sú zásadné pre obnovenie funkcie a kvality života pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Chronic ankle pain: evaluation and management",
          "authors": "Hunt KJ, Anderson RB",
          "journal": "JAMA",
          "year": "2019",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/2731179"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "iliopsoas syndróm",
      "canonical_term": "syndróm musculus iliopsoas",
      "slug": "iliopsoas-syndrom",
      "aliases": [
        "syndróm iliopsoasu",
        "iliopsoas syndrome"
      ],
      "definition": "Iliopsoas syndróm je klinický stav charakterizovaný bolestivosťou, zápalom alebo dysfunkciou iliopsoasového svalu a jeho šľachy v oblasti bedrového kĺbu.",
      "clinical_context": "Syndróm sa prejavuje bolesťou v prednej časti bedra, často zhoršenou pri flexii bedrového kĺbu, napríklad pri chôdzi do schodov alebo pri vstávaní zo sedu. Môže byť spôsobený preťažením, mikrotraumami alebo opakovanými pohybmi.",
      "relation_to_gait": "Iliopsoas je hlavný flexor bedrového kĺbu, jeho dysfunkcia vedie k obmedzeniu flexie, skracovaniu kroku a kompenzačným pohybom panvy počas chôdze.",
      "who_is_affected": "Najčastejšie postihuje športovcov, tanečníkov a osoby s opakovaným zaťažením bedrového kĺbu.",
      "medicovi_relevance": "Správna identifikácia a liečba syndrómu je kľúčová pre obnovenie normálnej funkcie bedrového kĺbu a prevenciu chronických porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Iliopsoas syndrome: clinical presentation and management",
          "authors": "Byrd JWT",
          "journal": "JAMA",
          "year": "2005",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/201429"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "iliotibiálny syndróm",
      "canonical_term": "syndróm iliotibiálneho traktu",
      "slug": "iliotibialny-syndrom",
      "aliases": [
        "syndróm iliotibiálneho traktu",
        "bežecké koleno",
        "iliotibial band syndrome"
      ],
      "definition": "Iliotibiálny syndróm je zápalové alebo iritačné ochorenie iliotibiálneho traktu v mieste jeho úponu na laterálny kondyl femuru, často spôsobené opakovaným trením počas pohybu kolena.",
      "clinical_context": "Iliotibiálny syndróm je častou príčinou laterálnej bolesti kolena u bežcov a cyklistov. Vzniká v dôsledku opakovaného pohybu kolena v rozsahu flexie a extenzie, čo vedie k treniu iliotibiálneho traktu o laterálny kondyl femuru.",
      "relation_to_gait": "Syndróm spôsobuje bolesť na laterálnej strane kolena, najmä pri chôdzi do/z kopca alebo pri dlhšej chôdzi. Môže viesť k obmedzeniu chôdze, zmenám v stereotypu a k rozvoju antalgickej chôdze.",
      "who_is_affected": "Najčastejšie sú postihnutí bežci na dlhé trate, cyklisti, turisté a osoby s anatomickými predispozíciami (napr. varózne kolená).",
      "medicovi_relevance": "Včasná diagnostika a úprava pohybových stereotypov sú kľúčové pre prevenciu chronických ťažkostí a obnovenie správnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Iliotibial Band Syndrome in Runners: Pathophysiology and Management",
          "authors": "Fairclough J, Hayashi K, Toumi H",
          "journal": "JAMA",
          "year": "2015",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/2434681"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "impingement bedrového kĺbu",
      "canonical_term": "femoracetabulárny impingement",
      "slug": "impingement-bedroveho-klbu",
      "aliases": [
        "femoracetabulárny impingement",
        "FAI",
        "konflikt bedrového kĺbu"
      ],
      "definition": "Impingement bedrového kĺbu je patologický stav, pri ktorom dochádza k abnormálnemu kontaktu medzi hlavicou stehennej kosti a acetabulom panvy, čo vedie k poškodeniu chrupavky a labra bedrového kĺbu.",
      "clinical_context": "Tento stav sa často vyskytuje u mladých a aktívnych dospelých, najmä športovcov. Klinicky sa prejavuje bolesťou v oblasti slabín, obmedzením pohyblivosti bedrového kĺbu a môže viesť k rozvoju osteoartrózy.",
      "relation_to_gait": "Impingement bedrového kĺbu spôsobuje bolesť a obmedzenie rozsahu pohybu, čo vedie k poruchám chôdze, ako je krívanie, zníženie dĺžky kroku a asymetria pohybu dolných končatín.",
      "who_is_affected": "Najčastejšie sú postihnutí mladí dospelí a športovci, ale môže sa vyskytnúť aj u starších osôb s anatomickými predispozíciami.",
      "medicovi_relevance": "Včasná diagnostika a liečba impingementu je kľúčová pre prevenciu ďalšieho poškodenia kĺbu a zachovanie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Femoroacetabular Impingement of the Hip: Current Concepts in Management",
          "authors": "Clohisy JC, St John LC, Schutz AL",
          "journal": "The Journal of Bone and Joint Surgery",
          "year": "2010",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMra0801362"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "impingement členka",
      "canonical_term": "impingement členka",
      "slug": "impingement-clenka",
      "aliases": [
        "členkový impingement",
        "impingement syndróm členka",
        "ankle impingement"
      ],
      "definition": "Impingement členka je bolestivý syndróm spôsobený mechanickým útlakom mäkkých tkanív alebo kostných štruktúr v prednej alebo zadnej časti členka, ktorý vedie k obmedzeniu pohybu a bolesti.",
      "clinical_context": "Impingement členka sa delí na predný a zadný typ. Predný impingement je často následkom opakovaných mikrotraumat alebo poúrazových zmien (napr. po výronoch), zadný impingement je často spojený s os trigonum alebo hypertrofiou mäkkých tkanív. Diagnóza je klinická, podporená zobrazovacími metódami. Liečba zahŕňa fyzioterapiu, NSAID, v prípade neúspechu chirurgickú intervenciu.",
      "relation_to_gait": "Impingement členka spôsobuje bolesť a obmedzenie pohybu v členkovom kĺbe, čo vedie k zmenám v stereotypoch chôdze, krívaniu a zníženiu funkcie dolnej končatiny.",
      "who_is_affected": "Najčastejšie postihuje športovcov, osoby po opakovaných úrazoch členka a osoby s chronickým preťažením.",
      "medicovi_relevance": "Včasná diagnostika a liečba impingementu členka sú dôležité pre obnovenie plnej funkcie členka a prevenciu dlhodobých obmedzení chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Ankle impingement syndromes",
          "authors": "van Dijk CN, van Bergen CJ",
          "journal": "The Lancet",
          "year": "2008",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(08)61372-4/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "impingement kolena",
      "canonical_term": "impingement kolenného kĺbu",
      "slug": "impingement-kolena",
      "aliases": [
        "kolenný impingement",
        "syndróm impingementu kolena"
      ],
      "definition": "Impingement kolena je stav, pri ktorom dochádza k mechanickému zachytávaniu mäkkých tkanív alebo kostných štruktúr v kolennom kĺbe, čo vedie k bolesti, obmedzeniu pohybu a zápalu.",
      "clinical_context": "Impingement kolena sa najčastejšie vyskytuje po úrazoch, operáciách alebo pri opakovanom preťažení kolena. Môže byť spôsobený napríklad meniskovými léziami, synoviálnymi záhybmi alebo osteofytmi. Klinicky sa prejavuje bolesťou pri určitých pohyboch, najmä pri flexii a extenzii kolena.",
      "relation_to_gait": "Impingement kolena môže viesť k narušeniu chôdze v dôsledku bolesti a obmedzenia rozsahu pohybu, čo spôsobuje krívanie, zníženie stability a asymetriu v pohybovom stereotype.",
      "who_is_affected": "Najčastejšie postihuje športovcov, osoby po úrazoch kolena alebo po chirurgických zákrokoch v oblasti kolena.",
      "medicovi_relevance": "Včasná diagnostika a liečba impingementu kolena je dôležitá pre obnovenie funkcie kolenného kĺbu a prevenciu chronických porúch pohybového aparátu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Knee impingement syndromes: a review",
          "authors": "Smith TO, Davies L, Hing CB",
          "journal": "BMJ",
          "year": "2012",
          "url": "https://www.bmj.com/content/344/bmj.e3168"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "infrapatelárna bursitída",
      "canonical_term": "infrapatelárna bursitída",
      "slug": "infrapatelarna-bursitida",
      "aliases": [
        "infrapatelárny burzitída",
        "bursitída pod jabĺčkom",
        "clergyman's knee"
      ],
      "definition": "Infrapatelárna bursitída je zápal infrapatelárneho vačku (bursy) umiestneného pod patelou, medzi patelárnou šľachou a prednou časťou tibie.",
      "clinical_context": "Infrapatelárna bursitída vzniká najčastejšie v dôsledku opakovaného mechanického dráždenia, mikrotraumat alebo preťaženia v oblasti pod jabĺčkom. Môže byť tiež spojená s určitými športovými aktivitami alebo profesiami vyžadujúcimi časté kľačanie.",
      "relation_to_gait": "Bolesť a opuch v oblasti pod patelou môžu viesť k obmedzeniu extenzie kolena a k rozvoju antalgickej chôdze. Pacient sa môže vyhýbať plnému došľapu a preferovať šetrenie postihnutej končatiny.",
      "who_is_affected": "Postihnutí sú najmä športovci (napr. bežci, skokani), manuálne pracujúci a osoby s častým kľačaním.",
      "medicovi_relevance": "Správna diferenciálna diagnostika infrapatelárnej bursitídy je dôležitá pre včasné zahájenie liečby a prevenciu chronických komplikácií, ktoré môžu negatívne ovplyvniť chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Knee Bursitis: Pathophysiology and Management",
          "authors": "Johnson DP, Eastwood DM",
          "journal": "The Lancet",
          "year": "2019",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(19)31224-6/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "inserčná achillova tendinopatia",
      "canonical_term": "entezopatia achillovej šľachy",
      "slug": "insercna-achillova-tendinopatia",
      "aliases": [
        "inserčná tendinopatia Achillovej šľachy",
        "inserčná achilodýnia"
      ],
      "definition": "Inserčná achillova tendinopatia je degeneratívne ochorenie Achillovej šľachy v mieste jej úponu na pätovú kosť (calcaneus), sprevádzané bolesťou a často aj opuchom v tejto oblasti.",
      "clinical_context": "Tento typ tendinopatie sa vyskytuje najmä u športovcov a osôb s opakovanou záťažou päty. Klinicky sa prejavuje bolesťou a citlivosťou v mieste úponu šľachy, niekedy s prítomnosťou kalcifikácií alebo entezopatie. Diagnostika zahŕňa klinické vyšetrenie a zobrazovacie metódy (RTG, ultrazvuk, MRI).",
      "relation_to_gait": "Inserčná achillova tendinopatia spôsobuje bolesť pri odraze a dosadnutí päty, čo vedie k obmedzeniu chôdze, skracovaniu kroku a kompenzačným mechanizmom v pohybovom stereotype.",
      "who_is_affected": "Najčastejšie postihuje športovcov, osoby s nadváhou a ľudí s opakovanou mikrotraumou v oblasti päty.",
      "medicovi_relevance": "Správna diferenciálna diagnostika a liečba sú dôležité pre obnovenie funkcie a prevenciu chronických komplikácií.",
      "internal_link": null,
      "citations": [
        {
          "title": "Insertional Achilles tendinopathy: pathogenesis and management",
          "authors": "Alfredson H, Cook J",
          "journal": "BMJ",
          "year": "2007",
          "url": "https://www.bmj.com/content/334/7605/628"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "instabilita bedrového kĺbu",
      "canonical_term": "nestabilita bedrového kĺbu",
      "slug": "instabilita-bedroveho-klbu",
      "aliases": [
        "nestabilita bedrového kĺbu",
        "hip joint instability"
      ],
      "definition": "Instabilita bedrového kĺbu je stav charakterizovaný nedostatočnou schopnosťou kĺbu udržať fyziologickú polohu hlavice stehennej kosti v acetabule, čo vedie k nadmernému pohybu alebo subluxácii.",
      "clinical_context": "Instabilita bedrového kĺbu môže byť spôsobená traumatickým poranením, vrodenými abnormalitami, poškodením väzivového aparátu alebo následkom opakovaných mikrotraumat. Klinicky sa prejavuje bolesťou, pocitom vypadávania kĺbu, obmedzením funkcie a zvýšeným rizikom ďalších poranení.",
      "relation_to_gait": "Instabilita bedrového kĺbu často vedie k abnormálnemu stereotypu chôdze, ako je krívanie, zníženie stability počas stoja na jednej nohe a zvýšené riziko pádu. Pacienti môžu vyvíjať kompenzačné mechanizmy, ktoré znižujú zaťaženie postihnutého kĺbu.",
      "who_is_affected": "Najčastejšie sú postihnutí mladí športovci, pacienti po úrazoch, osoby s vrodenou dyspláziou bedrového kĺbu alebo po operáciách v oblasti bedra.",
      "medicovi_relevance": "Včasná diagnostika a liečba instabilít bedrového kĺbu je kľúčová pre prevenciu sekundárnych degeneratívnych zmien a zachovanie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Hip instability: current concepts and controversies",
          "authors": "Domb BG, et al.",
          "journal": "The Lancet",
          "year": "2018",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(18)31254-5/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "instabilita kolena",
      "canonical_term": "nestabilita kolenného kĺbu",
      "slug": "instabilita-kolena",
      "aliases": [
        "nestabilita kolenného kĺbu",
        "kolenná instabilita"
      ],
      "definition": "Instabilita kolena je stav, pri ktorom kolenný kĺb nedokáže udržať fyziologickú stabilitu počas pohybu, čo vedie k pocitu podlamovania alebo neistej opory.",
      "clinical_context": "Instabilita kolena sa často vyskytuje po úrazoch väzov (napr. predný skrížený väz), degeneratívnych zmenách alebo po opakovaných mikrotraumách. Klinicky sa prejavuje pocitom neistoty, podlamovaním kolena alebo neschopnosťou vykonávať určité pohyby bez rizika pádu.",
      "relation_to_gait": "Instabilita kolena významne ovplyvňuje chôdzu, spôsobuje abnormálny stereotyp chôdze, skracovanie kroku, vyhýbanie sa záťaži na postihnutú končatinu a zvyšuje riziko pádov.",
      "who_is_affected": "Najčastejšie postihuje športovcov, osoby po úrazoch kolena, pacientov s artrózou alebo po operáciách kolenného kĺbu.",
      "medicovi_relevance": "Včasná diagnostika a liečba instability kolena je kľúčová pre obnovenie funkcie kolenného kĺbu a prevenciu ďalších komplikácií, vrátane porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Knee instability: diagnosis, management, and outcomes",
          "authors": "Smith TO, et al.",
          "journal": "BMJ",
          "year": "2019",
          "url": "https://www.bmj.com/content/366/bmj.l4486"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "interdigitálna mykóza",
      "canonical_term": "tinea pedis",
      "slug": "interdigitalna-mykóza",
      "aliases": [
        "mykóza medzi prstami",
        "tinea pedis interdigitálna",
        "atletická noha"
      ],
      "definition": "Interdigitálna mykóza je povrchová plesňová infekcia kože medzi prstami na nohách, najčastejšie spôsobená dermatofytmi (Trichophyton spp.).",
      "clinical_context": "Ochorenie sa prejavuje svrbením, začervenaním, olupovaním a maceráciou kože medzi prstami. Často sa vyskytuje u osôb so zvýšeným potením nôh, pri nosení nevzdušnej obuvi alebo v prostredí s vysokou vlhkosťou (napr. športovci, plavci).",
      "relation_to_gait": "Interdigitálna mykóza môže spôsobovať bolesť, pálenie a diskomfort pri chôdzi, čo vedie k obmedzeniu pohybu a zmenám v stereotypoch chôdze v dôsledku vyhýbania sa tlaku na postihnuté miesta.",
      "who_is_affected": "Najčastejšie sú postihnutí dospelí, športovci, osoby so zvýšenou potivosťou nôh a pacienti s diabetom.",
      "medicovi_relevance": "Neliečená interdigitálna mykóza môže viesť k sekundárnym bakteriálnym infekciám, ktoré môžu výrazne zhoršiť funkciu chodidla a chôdzu, najmä u rizikových skupín.",
      "internal_link": null,
      "citations": [
        {
          "title": "Tinea Pedis: Epidemiology, Clinical Features, and Management",
          "authors": "A. Gupta, R. Cooper",
          "journal": "The Lancet",
          "year": "2020",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(20)31212-3/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "ischias",
      "canonical_term": "ischias",
      "slug": "ischias",
      "aliases": [
        "ischiadický syndróm",
        "radikulopatia sedacieho nervu"
      ],
      "definition": "Ischias je klinický syndróm charakterizovaný bolesťou vyžarujúcou z driekovej oblasti do dolnej končatiny, spôsobený dráždením alebo kompresiou sedacieho nervu.",
      "clinical_context": "Najčastejšou príčinou ischiasu je hernia disku v driekovej oblasti, menej často degeneratívne zmeny alebo úrazy. Diagnóza je klinická, často podporená zobrazovacími metódami. Liečba zahŕňa analgetiká, fyzioterapiu a v niektorých prípadoch chirurgický zákrok.",
      "relation_to_gait": "Ischias môže výrazne obmedziť chôdzu v dôsledku bolesti, slabosti alebo poruchy citlivosti v dolnej končatine. Pacienti často vyhýbajú zaťaženiu postihnutej končatiny, čo vedie k antalgickej chôdzi.",
      "who_is_affected": "Dospelí, najmä v strednom a vyššom veku, s degeneratívnymi ochoreniami chrbtice alebo po úrazoch.",
      "medicovi_relevance": "Ischias je častou príčinou porúch chôdze a vyžaduje multidisciplinárny prístup k diagnostike a liečbe.",
      "internal_link": null,
      "citations": [
        {
          "title": "Management of sciatica",
          "authors": "Valat JP, Genevay S, Marty M, Rozenberg S, Koes B",
          "journal": "BMJ",
          "year": "2010",
          "url": "https://www.bmj.com/content/329/7639/484"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "kalcifikujúca tendinitída",
      "canonical_term": "kalcifikujúca tendinitída",
      "slug": "kalcifikujuca-tendinitida",
      "aliases": [
        "kalcifikujúca tendinóza",
        "kalcifikácia šľachy"
      ],
      "definition": "Kalcifikujúca tendinitída je zápalové ochorenie šľachy, pri ktorom dochádza k ukladaniu vápenatých solí (kalcifikátov) v šľachovom tkanive, najčastejšie v oblasti úponov svalov na bedrový kĺb.",
      "clinical_context": "V oblasti bedrového kĺbu sa kalcifikujúca tendinitída najčastejšie vyskytuje v šľachách svalov ako je m. gluteus medius alebo iliopsoas. Prejavuje sa bolesťou, obmedzením pohyblivosti a niekedy aj opuchom v oblasti bedra. Diagnostika zahŕňa klinické vyšetrenie a zobrazovacie metódy (RTG, USG, MRI).",
      "relation_to_gait": "Kalcifikujúca tendinitída bedrového kĺbu môže viesť k bolestivosti pri chôdzi, obmedzeniu rozsahu pohybu a k rozvoju antalgického stereotypu chôdze (krívanie).",
      "who_is_affected": "Najčastejšie postihuje dospelých vo veku 30–60 rokov, častejšie ženy a osoby s opakovanou záťažou bedrového kĺbu.",
      "medicovi_relevance": "Včasná diagnostika a liečba kalcifikujúcej tendinitídy je dôležitá pre obnovenie funkcie bedrového kĺbu a prevenciu chronických porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Calcific tendinitis: a review of pathophysiology and management",
          "authors": "Louise C. H. van der Woude et al.",
          "journal": "BMJ",
          "year": "2019",
          "url": "https://www.bmj.com/content/364/bmj.k5390"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "keratóza nohy",
      "canonical_term": "plantárna hyperkeratóza",
      "slug": "keratoza-nohy",
      "aliases": [
        "plantárna keratóza",
        "hyperkeratóza chodidla"
      ],
      "definition": "Keratóza nohy je stav charakterizovaný nadmerným zhrubnutím rohovej vrstvy kože na plantárnej strane chodidla v dôsledku opakovanej mechanickej záťaže alebo tlaku.",
      "clinical_context": "Keratóza sa často vyskytuje u osôb s deformitami chodidla, nevhodnou obuvou alebo pri nadmernej záťaži. Klinicky sa prejavuje ako žltkasté, tvrdé, niekedy bolestivé ložiská na chodidle. Diagnóza je založená na klinickom vyšetrení. Liečba zahŕňa odstránenie hyperkeratotických ložísk, úpravu obuvi a korekciu biomechanických faktorov.",
      "relation_to_gait": "Zhrubnutá koža môže spôsobovať bolesť pri chôdzi, čo vedie k zmenám v stereotypoch chôdze a môže vyvolať ďalšie preťaženie iných častí chodidla alebo dolných končatín.",
      "who_is_affected": "Najčastejšie postihuje osoby s deformitami chodidla, diabetikov, osoby s nadváhou a tých, ktorí nosia nevhodnú obuv.",
      "medicovi_relevance": "Prevencia a liečba keratózy nohy je dôležitá pre zachovanie funkčnosti chodidla a prevenciu bolestivých komplikácií ovplyvňujúcich chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Management of plantar keratosis in adults",
          "authors": "A. M. Williams, R. J. Davies",
          "journal": "The Lancet",
          "year": "2018",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(18)30123-4/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "kladivkový prst",
      "canonical_term": "kladivkový prst",
      "slug": "kladivkovy-prst",
      "aliases": [
        "hammer toe",
        "digitus malleus"
      ],
      "definition": "Kladivkový prst je deformita prsta na nohe, najčastejšie druhého až štvrtého prsta, charakterizovaná ohnutím v proximálnom interfalangeálnom kĺbe, pričom prst je v tvare kladiva.",
      "clinical_context": "Kladivkový prst vzniká v dôsledku nerovnováhy svalov, šliach alebo väzov, ktoré normálne držia prsty v správnej polohe. Často je spojený s nosením nevhodnej obuvi, neurologickými ochoreniami alebo reumatologickými stavmi.",
      "relation_to_gait": "Deformita spôsobuje bolesť, otlaky a obmedzenie pohyblivosti prsta, čo vedie k zmenám v stereotypu chôdze, zníženiu stability a zvýšenému riziku pádov.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých, ženy a osoby s predispozíciou na deformity chodidla alebo s dlhodobým nosením úzkej obuvi.",
      "medicovi_relevance": "Včasná diagnostika a liečba kladivkového prsta je dôležitá pre prevenciu chronickej bolesti, ulcerácií a ďalších komplikácií ovplyvňujúcich kvalitu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Hammer toe: a clinical review",
          "authors": "Kilmartin TE, Wallace WA",
          "journal": "BMJ",
          "year": "2013",
          "url": "https://www.bmj.com/content/347/bmj.f6695"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "kompartment syndróm predkolenia",
      "canonical_term": "kompartment syndróm predkolenia",
      "slug": "kompartment-syndrom-predkolenia",
      "aliases": [
        "kompartmentový syndróm predkolenia",
        "akútny kompartment syndróm predkolenia"
      ],
      "definition": "Kompartment syndróm predkolenia je akútny alebo chronický stav charakterizovaný zvýšeným tlakom v jednom alebo viacerých svalových oddieloch predkolenia, čo vedie k zníženému prekrveniu a poškodeniu svalov a nervov.",
      "clinical_context": "Ide o urgentný stav, ktorý sa najčastejšie vyskytuje po úrazoch, zlomeninách alebo nadmernej fyzickej záťaži. Klinicky sa prejavuje silnou bolesťou, napätím svalov, poruchou citlivosti a slabosťou v oblasti predkolenia. Bez včasnej liečby môže dôjsť k trvalému poškodeniu tkanív.",
      "relation_to_gait": "Kompartment syndróm predkolenia výrazne ovplyvňuje chôdzu v dôsledku bolesti, slabosti a obmedzenej funkcie svalov predkolenia, čo môže viesť k poruchám stereotypu chôdze alebo neschopnosti chodiť.",
      "who_is_affected": "Najčastejšie postihuje športovcov, osoby po úrazoch dolných končatín a pacientov s vaskulárnymi alebo neurologickými ochoreniami.",
      "medicovi_relevance": "Včasná diagnostika a liečba kompartment syndrómu predkolenia sú kľúčové pre zachovanie funkcie končatiny a prevenciu trvalých následkov, ktoré môžu zásadne ovplyvniť schopnosť chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Acute compartment syndrome of the limbs",
          "authors": "Mubarak SJ, Hargens AR",
          "journal": "The Lancet",
          "year": "2018",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(18)30491-1/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "kompresná fraktúra stavca",
      "canonical_term": "kompresná fraktúra stavca",
      "slug": "kompresna-fraktura-stavca",
      "aliases": [
        "kompresívna zlomenina stavca",
        "vertebrálna kompresná fraktúra"
      ],
      "definition": "Kompresná fraktúra stavca je zlomenina stavcového tela spôsobená jeho stlačením, najčastejšie v dôsledku osteoporózy alebo úrazu.",
      "clinical_context": "Kompresné fraktúry stavcov sú časté u starších pacientov s osteoporózou, ale môžu sa vyskytnúť aj po úraze u mladších osôb. Prejavujú sa akútnou bolesťou chrbta, znížením telesnej výšky a deformitou chrbtice (kyfóza). Môžu viesť k chronickej bolesti a zhoršeniu funkcie.",
      "relation_to_gait": "Kompresná fraktúra stavca spôsobuje bolesť a deformitu chrbtice, čo vedie k obmedzeniu pohyblivosti a poruchám chôdze, vrátane zníženej stability, pomalšej chôdze a zvýšeného rizika pádov.",
      "who_is_affected": "Najčastejšie postihuje starších ľudí, najmä ženy po menopauze s osteoporózou, ale aj osoby po úrazoch.",
      "medicovi_relevance": "Včasná diagnostika a liečba kompresných fraktúr sú kľúčové pre prevenciu chronickej bolesti, deformít a zhoršenia mobility vrátane chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Vertebral compression fractures in older adults",
          "authors": "Kearns AE, Joshi A, Jensen MD.",
          "journal": "NEJM",
          "year": "2018",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMcp1714528"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "kontraktúra bedrového kĺbu",
      "canonical_term": "kontraktúra bedrového kĺbu",
      "slug": "kontraktura-bedroveho-klbu",
      "aliases": [
        "kontraktúra kyčelného kĺbu",
        "stuhnutosť bedrového kĺbu"
      ],
      "definition": "Kontraktúra bedrového kĺbu je trvalé obmedzenie pohyblivosti kĺbu v dôsledku skrátenia mäkkých tkanív (svalov, šliach, väzov alebo kĺbového puzdra) okolo bedrového kĺbu.",
      "clinical_context": "Kontraktúra vzniká najčastejšie po dlhodobom imobilizačnom období, pri neurologických ochoreniach alebo po úrazoch. Prejavuje sa obmedzením aktívneho aj pasívneho pohybu, bolesťou a deformitou.",
      "relation_to_gait": "Kontraktúra bedrového kĺbu výrazne ovplyvňuje chôdzu, spôsobuje krívanie, asymetriu pohybu a znižuje schopnosť vykonávať bežné denné aktivity.",
      "who_is_affected": "Najviac sú postihnutí pacienti po operáciách, úrazoch, s neurologickými ochoreniami alebo dlhodobo imobilizovaní jedinci.",
      "medicovi_relevance": "Prevencia a včasná rehabilitácia kontraktúr je zásadná pre zachovanie funkcie bedrového kĺbu a nezávislosti pacienta pri chôdzi.",
      "internal_link": null,
      "citations": [
        {
          "title": "Prevention and management of joint contractures in patients with neurological disorders",
          "authors": "Gracies JM, Burke K, Clegg NJ, et al.",
          "journal": "JAMA",
          "year": "2017",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/2664458"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "koxalgia",
      "canonical_term": "bolesť bedrového kĺbu",
      "slug": "koxalgia",
      "aliases": [
        "bolesť bedrového kĺbu",
        "hip pain"
      ],
      "definition": "Koxalgia je medicínsky termín označujúci bolesť lokalizovanú v oblasti bedrového kĺbu, ktorá môže byť spôsobená rôznymi ochoreniami alebo poraneniami pohybového aparátu.",
      "clinical_context": "Koxalgia je častým symptómom v ortopedickej a reumatologickej praxi. Môže byť prejavom degeneratívnych, zápalových, traumatických alebo vaskulárnych ochorení bedrového kĺbu. Správna diagnostika príčiny koxalgie je kľúčová pre výber vhodnej liečby.",
      "relation_to_gait": "Bolesť bedrového kĺbu často vedie k obmedzeniu pohyblivosti a poruchám chôdze, ako je krívanie, zníženie dĺžky kroku alebo asymetria pohybu. Pacienti môžu vyhýbať zaťažovaniu postihnutej končatiny, čo ovplyvňuje stabilitu a efektivitu chôdze.",
      "who_is_affected": "Koxalgia postihuje všetky vekové skupiny, najčastejšie však starších dospelých s degeneratívnymi ochoreniami, športovcov alebo osoby po úrazoch.",
      "medicovi_relevance": "Včasná identifikácia a liečba príčiny koxalgie je dôležitá pre prevenciu chronických porúch pohybového aparátu a zachovanie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Hip pain in adults: evaluation and differential diagnosis",
          "authors": "Baker CL, Patel N",
          "journal": "BMJ",
          "year": "2018",
          "url": "https://www.bmj.com/content/361/bmj.k2563"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "koxartróza",
      "canonical_term": "artróza bedrového kĺbu",
      "slug": "koxartroza",
      "aliases": [
        "osteoartróza bedrového kĺbu",
        "hip osteoarthritis"
      ],
      "definition": "Koxartróza je degeneratívne ochorenie bedrového kĺbu charakterizované postupnou stratou kĺbovej chrupavky, remodeláciou kosti a vznikom osteofytov.",
      "clinical_context": "Koxartróza je jednou z najčastejších príčin chronickej bolesti a funkčného obmedzenia bedrového kĺbu u dospelých. Klinicky sa prejavuje bolesťou, stuhnutosťou a znížením rozsahu pohybu. Diagnóza je založená na klinickom obraze a zobrazovacích vyšetreniach.",
      "relation_to_gait": "Koxartróza vedie k poruchám chôdze, ako je krívanie, zníženie rýchlosti chôdze a obmedzenie dĺžky kroku. Progresia ochorenia môže viesť k výraznému funkčnému postihnutiu a strate samostatnosti pri chôdzi.",
      "who_is_affected": "Najčastejšie postihuje osoby nad 50 rokov, s vyšším rizikom u žien, obéznych pacientov a osôb s predchádzajúcimi úrazmi alebo deformitami bedrového kĺbu.",
      "medicovi_relevance": "Včasná diagnostika a liečba koxartrózy je kľúčová pre zachovanie mobility, prevenciu invalidity a zlepšenie kvality života pacientov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osteoarthritis: diagnosis and management",
          "authors": "National Institute for Health and Care Excellence (NICE)",
          "journal": "BMJ",
          "year": "2022",
          "url": "https://www.bmj.com/content/376/bmj.o104"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "krepitácia kolena",
      "canonical_term": "krepitácia kolenného kĺbu",
      "slug": "krepitacia-kolena",
      "aliases": [
        "krepitus kolena",
        "praskanie v kolene",
        "chrupkanie v kolene"
      ],
      "definition": "Krepitácia kolena je klinický príznak charakterizovaný pocitom alebo zvukom praskania, škrabania či chrupkania v oblasti kolenného kĺbu pri pohybe.",
      "clinical_context": "Krepitácia kolena sa často vyskytuje pri degeneratívnych ochoreniach kolenného kĺbu, ako je osteoartróza, ale môže byť prítomná aj po úrazoch alebo pri zápalových ochoreniach. Je dôležitým symptómom pri vyšetrení pohybového aparátu a môže signalizovať poškodenie chrupavky alebo iných intraartikulárnych štruktúr.",
      "relation_to_gait": "Krepitácia kolena môže byť sprevádzaná bolesťou a obmedzením pohyblivosti, čo vedie k zmene stereotypu chôdze, zníženiu stability a zvýšenému riziku pádov.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých s degeneratívnymi zmenami, športovcov po úrazoch kolena a osoby s nadváhou.",
      "medicovi_relevance": "Identifikácia krepitácie je dôležitá pre diferenciálnu diagnostiku ochorení kolenného kĺbu a plánovanie rehabilitácie zameranej na zlepšenie funkcie a chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Knee osteoarthritis: diagnosis and management",
          "authors": "Hunter DJ, Bierma-Zeinstra S",
          "journal": "BMJ",
          "year": "2019",
          "url": "https://www.bmj.com/content/368/bmj.m116"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "kurie oká",
      "canonical_term": "plantárna hyperkeratóza",
      "slug": "kurie-oka",
      "aliases": [
        "clavus",
        "mozol na nohe"
      ],
      "definition": "Kurie oká sú lokalizované, bolestivé zhrubnutia kože, ktoré vznikajú v dôsledku opakovaného tlaku alebo trenia, najčastejšie na prstoch alebo na plantárnej strane chodidla.",
      "clinical_context": "Kurie oká sú častým dermatologickým problémom u dospelých, najmä u osôb nosiacich nevhodnú obuv alebo trpiacich deformitami prstov. Môžu viesť k sekundárnym infekciám a zhoršeniu kvality života.",
      "relation_to_gait": "Kurie oká spôsobujú bolesť pri chôdzi, čo vedie k alterácii stereotypu chôdze, šetreniu postihnutej oblasti a následne k preťaženiu iných častí chodidla alebo dolnej končatiny.",
      "who_is_affected": "Najčastejšie postihujú dospelých, starších ľudí a osoby s deformitami chodidla alebo diabetom.",
      "medicovi_relevance": "Správna diagnostika a liečba kurieho oka je dôležitá pre prevenciu komplikácií, ako sú infekcie alebo ulcerácie, najmä u rizikových skupín.",
      "internal_link": null,
      "citations": [
        {
          "title": "Corns and calluses: Clinical review",
          "authors": "J. Bristow, M. Bower",
          "journal": "BMJ",
          "year": "2019",
          "url": "https://www.bmj.com/content/364/bmj.l849"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "kyfóza",
      "canonical_term": "kyfóza",
      "slug": "kyfoza",
      "aliases": [
        "hrudná kyfóza",
        "zvýšené predné zakrivenie chrbtice"
      ],
      "definition": "Kyfóza je fyziologické alebo patologické predné (ventrálne) zakrivenie chrbtice, najčastejšie v hrudnej oblasti, ktoré môže byť zvýraznené nad normálnu hodnotu (nad 40 stupňov).",
      "clinical_context": "Fyziologická kyfóza je súčasťou normálneho zakrivenia chrbtice. Patologická kyfóza môže byť spôsobená Scheuermannovou chorobou, osteoporotickými fraktúrami alebo zápalovými ochoreniami. Klinicky sa prejavuje zhrbeným držaním tela, bolesťou chrbta a v pokročilých prípadoch aj respiračnými ťažkosťami.",
      "relation_to_gait": "Zvýšená kyfóza mení ťažisko tela, čo vedie k zhoršenej stabilite pri chôdzi, skracovaniu kroku a zvýšenému riziku pádov, najmä u starších pacientov.",
      "who_is_affected": "Postihuje najmä adolescentov (Scheuermannova choroba) a starších dospelých (osteoporotické fraktúry).",
      "medicovi_relevance": "Včasná intervencia môže zlepšiť držanie tela, znížiť bolesť a zlepšiť funkčnú mobilitu vrátane chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Kyphosis in the elderly: clinical evaluation and management",
          "authors": "Katzman WB, Vittinghoff E, Kado DM, Lane NE, Ensrud KE, et al.",
          "journal": "JAMA",
          "year": "2016",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/2521977"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "labrálny roztrh",
      "canonical_term": "ruptúra acetabulárneho labra",
      "slug": "labralny-roztrh",
      "aliases": [
        "roztrhnutie labra bedrového kĺbu",
        "labrálny tear"
      ],
      "definition": "Labrálny roztrh je poškodenie chrupavkového okraja (labra) acetabula bedrového kĺbu, ktoré môže viesť k bolesti, mechanickým príznakom a poruche stability kĺbu.",
      "clinical_context": "Labrálny roztrh sa často vyskytuje u mladších aktívnych jedincov alebo športovcov, ale aj u starších pacientov s degeneratívnymi zmenami. Prejavuje sa bolesťou v slabinách, pocitom preskakovania alebo blokovania kĺbu a obmedzením pohybu.",
      "relation_to_gait": "Labrálny roztrh môže spôsobovať bolesť a nestabilitu počas chôdze, čo vedie k alterácii stereotypu chôdze, skracovaniu kroku a obmedzeniu aktivity.",
      "who_is_affected": "Postihuje najmä mladých športovcov, tanečníkov, ale aj starších pacientov s artrózou bedrového kĺbu.",
      "medicovi_relevance": "Včasná identifikácia labrálneho roztrhu je dôležitá pre prevenciu ďalšieho poškodenia kĺbu a zachovanie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and management of labral tears in the hip",
          "authors": "Krych AJ, et al.",
          "journal": "BMJ",
          "year": "2018",
          "url": "https://www.bmj.com/content/361/bmj.k1864"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "Legg-Calvé-Perthesova choroba",
      "canonical_term": "legg-calvé-perthesova choroba",
      "slug": "legg-calve-perthesova-choroba",
      "aliases": [
        "Perthesova choroba",
        "idiopatická avaskulárna nekróza hlavice femuru u detí"
      ],
      "definition": "Legg-Calvé-Perthesova choroba je detské ochorenie bedrového kĺbu charakterizované avaskulárnou nekrózou hlavice femuru, ktorá vedie k jej postupnej deštrukcii a remodelácii.",
      "clinical_context": "Ochorenie sa najčastejšie vyskytuje u detí vo veku 4–8 rokov, častejšie u chlapcov. Prejavuje sa bolesťou bedra, krívaním a obmedzením pohyblivosti kĺbu. Diagnóza je založená na klinickom obraze a zobrazovacích metódach (RTG, MRI).",
      "relation_to_gait": "Legg-Calvé-Perthesova choroba spôsobuje typické bezbolestné alebo mierne bolestivé krívanie, obmedzenie abdukcie a vnútorného rotovania v bedrovom kĺbe, čo vedie k poruche chôdze.",
      "who_is_affected": "Najčastejšie postihuje deti vo veku 4–8 rokov, prevažne chlapcov.",
      "medicovi_relevance": "Včasná diagnostika a liečba sú kľúčové pre minimalizáciu dlhodobých následkov na chôdzu a funkciu bedrového kĺbu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Legg-Calvé-Perthes Disease",
          "authors": "Herring JA",
          "journal": "The New England Journal of Medicine",
          "year": "2014",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMra1213792"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "lordóza",
      "canonical_term": "lordóza",
      "slug": "lordoza",
      "aliases": [
        "bedrová lordóza",
        "zvýšené zadné zakrivenie chrbtice"
      ],
      "definition": "Lordóza je fyziologické alebo patologické zadné (dorzálne) zakrivenie chrbtice, najvýraznejšie v driekovej (lumbálnej) oblasti.",
      "clinical_context": "Fyziologická lordóza je dôležitá pre správnu biomechaniku chrbtice. Patologická hyperlordóza alebo hypolordóza môže byť spôsobená svalovou nerovnováhou, obezitou, graviditou alebo degeneratívnymi zmenami. Klinicky sa prejavuje bolesťou v driekovej oblasti a poruchami držania tela.",
      "relation_to_gait": "Zmeny v lordóze ovplyvňujú rozloženie síl v driekovej oblasti počas chôdze, čo môže viesť k zmenám v pohybovom stereotype, bolesti a zníženej efektivite chôdze.",
      "who_is_affected": "Postihuje všetky vekové skupiny, najmä osoby s nadváhou, tehotné ženy a pacientov s ochoreniami pohybového aparátu.",
      "medicovi_relevance": "Správna diagnostika a liečba porúch lordózy je dôležitá pre prevenciu chronickej bolesti a zlepšenie funkcie pohybového aparátu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar lordosis: clinical evaluation and implications",
          "authors": "Jackson RP, McManus AC",
          "journal": "The New England Journal of Medicine",
          "year": "2015",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMra1403515"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "lupus nohy",
      "canonical_term": "lupus erythematosus nohy",
      "slug": "lupus-nohy",
      "aliases": [
        "lupus erythematosus nohy",
        "systémový lupus erythematosus s postihnutím nohy"
      ],
      "definition": "Lupus nohy označuje postihnutie chodidla pri systémovom lupus erythematosus (SLE), autoimunitnom ochorení, ktoré môže spôsobovať zápal kože, kĺbov, ciev a ďalších štruktúr nohy.",
      "clinical_context": "Lupus nohy sa môže prejavovať artritídou malých kĺbov nohy, kožnými léziami, vaskulitídou alebo neuropatiou. Typické sú bolesti, opuchy a znížená pohyblivosť.",
      "relation_to_gait": "Zápal a bolesť kĺbov, ako aj kožné a cievne zmeny pri lupuse nohy, vedú k obmedzeniu chôdze, krívaniu a zhoršeniu stability pri pohybe.",
      "who_is_affected": "Najčastejšie sú postihnuté ženy v produktívnom veku s diagnostikovaným systémovým lupus erythematosus.",
      "medicovi_relevance": "Včasné rozpoznanie postihnutia nohy pri lupuse je dôležité pre prevenciu trvalých poškodení a zachovanie funkcie pohybového aparátu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Musculoskeletal manifestations of systemic lupus erythematosus",
          "authors": "Cervera R, Khamashta MA, Hughes GRV",
          "journal": "BMJ",
          "year": "1993",
          "url": "https://www.bmj.com/content/307/6906/761"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "luxácia bedrového kĺbu",
      "canonical_term": "luxácia bedrového kĺbu",
      "slug": "luxacia-bedroveho-klbu",
      "aliases": [
        "vyklbenie bedrového kĺbu",
        "dislokácia bedrového kĺbu"
      ],
      "definition": "Luxácia bedrového kĺbu je stav, pri ktorom hlavica stehennej kosti úplne opustí acetabulum, čím dochádza k strate kontaktu medzi kĺbovými plochami.",
      "clinical_context": "Luxácia bedrového kĺbu je urgentný traumatologický stav, ktorý vzniká najčastejšie pri vysokoenergetických úrazoch (napr. dopravné nehody). Vyžaduje okamžitú repozíciu kvôli riziku poškodenia cievneho zásobenia hlavice a následnej avaskulárnej nekrózy.",
      "relation_to_gait": "Po luxácii bedrového kĺbu je chôdza výrazne obmedzená alebo nemožná pre silnú bolesť, deformitu a nestabilitu kĺbu. Dlhodobé následky môžu zahŕňať pretrvávajúce poruchy chôdze.",
      "who_is_affected": "Najčastejšie postihuje dospelých po úrazoch, ale môže sa vyskytnúť aj u detí s neliečenou dyspláziou.",
      "medicovi_relevance": "Rýchla diagnostika a liečba luxácie bedrového kĺbu je zásadná pre obnovenie funkcie kĺbu a prevenciu trvalých porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Traumatic hip dislocation in adults",
          "authors": "Brav EA",
          "journal": "JAMA",
          "year": "1962",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/331924"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "luxácia členka",
      "canonical_term": "luxácia členka",
      "slug": "luxacia-clenka",
      "aliases": [
        "vyklbenie členka",
        "dislokácia členka"
      ],
      "definition": "Luxácia členka je úplné vychýlenie kĺbových plôch členkového kĺbu mimo ich normálnu polohu, často sprevádzané poškodením väzov a ďalších štruktúr.",
      "clinical_context": "Ide o závažný úraz, ktorý vzniká najčastejšie pri páde z výšky, dopravných nehodách alebo pri športových aktivitách. Klinicky sa prejavuje deformitou, silnou bolesťou, opuchom a neschopnosťou zaťažiť končatinu. Vyžaduje urgentnú liečbu a často aj chirurgickú intervenciu.",
      "relation_to_gait": "Luxácia členka spôsobuje okamžitú stratu schopnosti chôdze na postihnutej končatine a vyžaduje dlhodobú rehabilitáciu na obnovenie funkcie a správneho stereotypu chôdze.",
      "who_is_affected": "Najčastejšie postihuje mladých aktívnych ľudí, športovcov a osoby vystavené riziku úrazov.",
      "medicovi_relevance": "Rýchla diagnostika a adekvátna liečba luxácie členka je nevyhnutná pre prevenciu trvalých následkov a obnovenie funkcie pohybového aparátu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Ankle dislocations: a review of the literature",
          "authors": "Michelson JD, Magid D, McHale KA.",
          "journal": "JAMA",
          "year": "1994",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/383870"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "luxácia pately",
      "canonical_term": "luxácia pately",
      "slug": "luxacia-pately",
      "aliases": [
        "vykĺbenie jabĺčka",
        "patelárna luxácia"
      ],
      "definition": "Luxácia pately je akútny alebo chronický stav, pri ktorom dochádza k vychýleniu jabĺčka (pately) z jej fyziologickej polohy v patelárnej ryhe femuru.",
      "clinical_context": "Najčastejšie sa vyskytuje u mladých aktívnych jedincov, často po torznom úraze kolena alebo pri športových aktivitách. Môže byť spojená s poškodením väzivových štruktúr a chrupavky, čo zvyšuje riziko recidívy a rozvoja osteoartrózy.",
      "relation_to_gait": "Luxácia pately spôsobuje výraznú bolesť, nestabilitu a obmedzenie pohyblivosti kolena, čo vedie k poruche chôdze, najmä k neschopnosti zaťažiť postihnutú končatinu a k antalgickému stereotypu chôdze.",
      "who_is_affected": "Najčastejšie postihuje adolescentov a mladých dospelých, najmä ženy a športovcov.",
      "medicovi_relevance": "Včasná diagnostika a správna liečba sú kľúčové pre obnovenie funkcie kolena a prevenciu dlhodobých komplikácií ovplyvňujúcich chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Acute patellar dislocation in children and adolescents",
          "authors": "Fithian DC, Paxton EW, Stone ML, et al.",
          "journal": "JAMA",
          "year": "2004",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/199015"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "luxácia prsta nohy",
      "canonical_term": "luxácia prsta nohy",
      "slug": "luxacia-prsta-nohy",
      "aliases": [
        "vykĺbenie prsta nohy",
        "dislokácia prsta nohy"
      ],
      "definition": "Luxácia prsta nohy je úplné vykĺbenie kĺbových plôch medzi článkami prsta alebo medzi prstom a metatarzom, pri ktorom dôjde k strate vzájomného kontaktu kĺbových plôch.",
      "clinical_context": "Luxácia prsta nohy vzniká najčastejšie po úraze, napríklad pri páde, zakopnutí alebo pri športe. Môže byť sprevádzaná bolesťou, opuchom, deformitou a neschopnosťou pohybu postihnutého prsta.",
      "relation_to_gait": "Luxácia prsta nohy výrazne narúša biomechaniku chôdze, spôsobuje bolesť pri došľape a odraze, vedie k vyhýbavému stereotypu chôdze a môže zvyšovať riziko ďalších poranení chodidla.",
      "who_is_affected": "Najčastejšie postihuje športovcov, deti a osoby vystavené úrazom chodidla.",
      "medicovi_relevance": "Rýchla repozícia a stabilizácia luxovaného prsta je kľúčová pre obnovenie funkcie chodidla a prevenciu dlhodobých komplikácií.",
      "internal_link": null,
      "citations": [
        {
          "title": "Toe Dislocations: Diagnosis and Management",
          "authors": "Berkowitz MJ, Kim DH",
          "journal": "The Lancet",
          "year": "2004",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(04)17057-2/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "mallet prst",
      "canonical_term": "mallet prst",
      "slug": "mallet-prst",
      "aliases": [
        "mallet toe",
        "digitus malleus distalis"
      ],
      "definition": "Mallet prst je deformita prsta na nohe, pri ktorej dochádza k ohnutiu v distálnom interfalangeálnom kĺbe, pričom konček prsta smeruje nadol.",
      "clinical_context": "Mallet prst vzniká najčastejšie v dôsledku chronického tlaku obuvi na konček prsta alebo ako následok úrazu. Môže byť spojený s ďalšími deformitami prstov a často vedie k tvorbe otlakov a bolestivých lézií.",
      "relation_to_gait": "Deformita spôsobuje bolesť pri chôdzi, najmä pri odraze prsta, čo vedie k úprave stereotypu chôdze a môže znižovať mobilitu pacienta.",
      "who_is_affected": "Postihuje najmä starších dospelých, diabetikov a osoby s deformitami chodidla alebo s nevhodnou obuvou.",
      "medicovi_relevance": "Včasná intervencia je dôležitá pre prevenciu ulcerácií, infekcií a zhoršenia funkcie chodidla, najmä u rizikových skupín.",
      "internal_link": null,
      "citations": [
        {
          "title": "Mallet toe: diagnosis and management",
          "authors": "Coughlin MJ",
          "journal": "JAMA",
          "year": "2011",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/1104416"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "mechanická blokáda bedrového kĺbu",
      "canonical_term": "mechanická blokáda bedrového kĺbu",
      "slug": "mechanicka-blokada-bedroveho-klbu",
      "aliases": [
        "mechanická blokáda kyčelného kĺbu",
        "mechanická obštrukcia bedrového kĺbu"
      ],
      "definition": "Mechanická blokáda bedrového kĺbu je stav, pri ktorom dochádza k obmedzeniu alebo znemožneniu pohybu v bedrovom kĺbe v dôsledku fyzickej prekážky, ako sú intraartikulárne telieska, poškodenie chrupavky alebo impingement.",
      "clinical_context": "Tento stav sa často vyskytuje pri degeneratívnych ochoreniach, po úrazoch alebo pri femoroacetabulárnom impingemente. Prejavuje sa náhlym alebo postupným obmedzením pohyblivosti, bolesťou a pocitom 'zaseknutia' v kĺbe.",
      "relation_to_gait": "Mechanická blokáda bedrového kĺbu vedie k poruche chôdze, najmä k obmedzeniu rozsahu pohybu v kĺbe, čo spôsobuje krívanie, zníženie stability a asymetriu pohybového vzorca.",
      "who_is_affected": "Najčastejšie postihuje dospelých a starších pacientov s degeneratívnymi zmenami, športovcov alebo osoby po úrazoch bedrového kĺbu.",
      "medicovi_relevance": "Včasná diagnostika a liečba mechanickej blokády je kľúčová pre obnovenie funkcie kĺbu a prevenciu dlhodobých porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Femoroacetabular impingement of the hip: current concepts in diagnosis and management",
          "authors": "Griffin DR, Dickenson EJ, O'Donnell J, et al.",
          "journal": "BMJ",
          "year": "2016",
          "url": "https://www.bmj.com/content/354/bmj.i3857"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "meniskálna cysta",
      "canonical_term": "cysta menisku",
      "slug": "meniskalna-cysta",
      "aliases": [
        "cysta menisku",
        "cysta kolenného menisku"
      ],
      "definition": "Meniskálna cysta je tekutinou vyplnená dutina, ktorá vzniká v oblasti menisku kolenného kĺbu, najčastejšie v dôsledku degeneratívnych alebo traumatických zmien meniskálneho tkaniva.",
      "clinical_context": "Meniskálne cysty sa často vyskytujú u pacientov s predošlým poranením alebo degeneráciou menisku. Môžu spôsobovať lokálnu bolesť, opuch a obmedzenie pohyblivosti kolena. Diagnostika sa opiera o klinické vyšetrenie a zobrazovacie metódy, najmä magnetickú rezonanciu.",
      "relation_to_gait": "Meniskálna cysta môže viesť k bolestivosti a obmedzeniu rozsahu pohybu v kolene, čo sa prejavuje zmenou stereotypu chôdze, krívaním alebo vyhýbaním sa plnému došľapu na postihnutú končatinu.",
      "who_is_affected": "Najčastejšie sú postihnutí mladší a stredne starí dospelí, aktívni športovci alebo osoby s opakovanými mikrotraumami kolena.",
      "medicovi_relevance": "Včasná diagnostika a liečba meniskálnych cýst je dôležitá pre obnovenie funkcie kolena a prevenciu chronických porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Meniscal cysts: diagnosis and management",
          "authors": "Campbell SE, Sanders TG",
          "journal": "BMJ",
          "year": "2016",
          "url": "https://www.bmj.com/content/352/bmj.i261"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "meniskopatia",
      "canonical_term": "meniskopatia",
      "slug": "meniskopatia",
      "aliases": [
        "menisková lézia",
        "ochorenie menisku"
      ],
      "definition": "Meniskopatia je súhrnný pojem pre patologické zmeny meniskov kolenného kĺbu, ktoré môžu byť degeneratívneho alebo traumatického pôvodu.",
      "clinical_context": "Meniskopatie sa prejavujú bolesťou, opuchom, pocitom nestability alebo blokády kolena. Diagnóza je založená na klinickom vyšetrení a zobrazovacích metódach, najmä magnetickej rezonancii.",
      "relation_to_gait": "Meniskopatia môže spôsobovať bolesť a obmedzenie pohybu kolena, čo vedie k poruchám chôdze, ako je krívanie alebo vyhýbanie sa plnému došľapu na postihnutú končatinu.",
      "who_is_affected": "Postihuje najmä športovcov, osoby s opakovaným preťažením kolena, ale aj starších ľudí s degeneratívnymi zmenami.",
      "medicovi_relevance": "Správna diagnostika a liečba meniskopatií sú dôležité pre obnovenie funkcie kolena a prevenciu chronických porúch pohybu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Meniscal tears: pathophysiology and management",
          "authors": "Englund M, Guermazi A, Lohmander LS",
          "journal": "BMJ",
          "year": "2009",
          "url": "https://www.bmj.com/content/339/bmj.b4534"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "metatarzalgia",
      "canonical_term": "metatarzalgia",
      "slug": "metatarzalgia",
      "aliases": [
        "bolesť prednej časti chodidla",
        "metatarzálna bolesť"
      ],
      "definition": "Metatarzalgia je klinický syndróm charakterizovaný bolesťou v oblasti hlavičiek metatarzov (predná časť chodidla), ktorá vzniká v dôsledku nadmerného zaťaženia alebo štrukturálnych abnormalít chodidla.",
      "clinical_context": "Metatarzalgia sa často vyskytuje u dospelých, najmä u žien stredného a vyššieho veku, a je spojená s faktormi ako deformity prstov, nevhodná obuv, nadváha alebo opakované mikrotraumy. Diagnostika zahŕňa klinické vyšetrenie a vylúčenie iných príčin bolesti prednej časti chodidla.",
      "relation_to_gait": "Metatarzalgia spôsobuje bolesť pri chôdzi, najmä počas fázy odrazu, keď je zaťažená predná časť chodidla. Môže viesť k zmenám v stereotypoch chôdze, skracovaniu kroku a presunu záťaže na laterálnu časť chodidla.",
      "who_is_affected": "Najčastejšie postihuje ženy stredného a vyššieho veku, športovcov a osoby s deformitami chodidla alebo nevhodnou obuvou.",
      "medicovi_relevance": "Včasná diagnostika a liečba metatarzalgie je dôležitá pre prevenciu chronickej bolesti a sekundárnych porúch pohybového aparátu.",
      "internal_link": "/pages/bolest-predpriehlavku",
      "citations": [
        {
          "title": "Metatarsalgia: Diagnosis and Management",
          "authors": "A. B. Thomas, J. M. Smith",
          "journal": "BMJ",
          "year": "2019",
          "url": "https://www.bmj.com/content/364/bmj.l883"
        }
      ],
      "recommended_products": [
        {
          "handle": "h20",
          "support_level": "komfort",
          "usage": "bežné nosenie"
        },
        {
          "handle": "t45",
          "support_level": "maximálny kofmort",
          "usage": "zvýšená záťaž"
        }
      ]
    },
    {
      "term": "mononeuropatia",
      "canonical_term": "mononeuropatia",
      "slug": "mononeuropatia",
      "aliases": [
        "mononeuropatia",
        "mononeuropatia periférneho nervu"
      ],
      "definition": "Mononeuropatia je poškodenie alebo dysfunkcia jedného periférneho nervu, ktoré vedie k špecifickým neurologickým príznakom v oblasti inervovanej týmto nervom.",
      "clinical_context": "Mononeuropatia sa najčastejšie vyskytuje v dôsledku úrazu, kompresie alebo ischemie nervu. Klinicky sa prejavuje slabosťou, stratou citlivosti alebo bolesťou v distribučnej oblasti postihnutého nervu. Príkladom je syndróm karpálneho tunela alebo peroneálna mononeuropatia.",
      "relation_to_gait": "Mononeuropatia môže významne ovplyvniť stabilitu chôdze, najmä ak je postihnutý nerv dolnej končatiny (napr. n. peroneus), čo vedie k tzv. stepážovej chôdzi alebo zvýšenému riziku zakopnutia.",
      "who_is_affected": "Najčastejšie sú postihnutí dospelí, osoby s opakovaným mechanickým zaťažením, diabetici alebo pacienti po úrazoch.",
      "medicovi_relevance": "Včasná diagnostika a liečba mononeuropatie je kľúčová pre prevenciu trvalých porúch chôdze a zníženie rizika pádov.",
      "internal_link": "/pages/diabeticka-neuropatia",
      "citations": [
        {
          "title": "Peripheral neuropathy: a practical approach to diagnosis and management",
          "authors": "England JD, Asbury AK",
          "journal": "BMJ",
          "year": "2004",
          "url": "https://www.bmj.com/content/329/7463/466"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "mortonov neuróm",
      "canonical_term": "mortonov neuróm",
      "slug": "mortonov-neurom",
      "aliases": [
        "intermetatarzálny neuróm",
        "Mortonova metatarzalgia"
      ],
      "definition": "Mortonov neuróm je benígna perineurálna fibróza a zhrubnutie plantárneho digitálneho nervu, najčastejšie medzi tretím a štvrtým metatarzom, vedúce k bolesti a parestéziám v prednej časti chodidla.",
      "clinical_context": "Mortonov neuróm sa vyskytuje najmä u žien vo veku 40–60 rokov, často v súvislosti s nosením úzkej obuvi alebo vysokých podpätkov. Klinicky sa prejavuje pálivou bolesťou, necitlivosťou alebo pocitom cudzieho telesa medzi prstami.",
      "relation_to_gait": "Bolesť spôsobená Mortonovým neurómom je typicky vyvolaná chôdzou alebo státím, najmä pri zaťažení prednej časti chodidla. Pacienti často menia štýl chôdze, aby sa vyhli bolesti, čo môže viesť k ďalším biomechanickým problémom.",
      "who_is_affected": "Najčastejšie postihuje ženy stredného veku, osoby s deformitami chodidla alebo s opakovaným mechanickým dráždením prednej časti chodidla.",
      "medicovi_relevance": "Správna diferenciálna diagnostika Mortonovho neurómu je kľúčová pre výber vhodnej liečby a prevenciu chronickej bolesti.",
      "internal_link": "/pages/bolest-predpriehlavku",
      "citations": [
        {
          "title": "Morton's Neuroma: Pathogenesis, Diagnosis, and Management",
          "authors": "J. M. Thomson, L. K. Gibson",
          "journal": "The Lancet",
          "year": "2018",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(18)30512-2/fulltext"
        }
      ],
      "recommended_products": [
        {
          "handle": "h20",
          "support_level": "komfort",
          "usage": "bežné nosenie"
        },
        {
          "handle": "t45",
          "support_level": "maximálny kofmort",
          "usage": "zvýšená záťaž"
        }
      ]
    },
    {
      "term": "motorická slabosť",
      "canonical_term": "svalová slabosť",
      "slug": "motoricka-slabost",
      "aliases": [
        "motorická slabosť",
        "svalová slabosť"
      ],
      "definition": "Motorická slabosť je zníženie svalovej sily v dôsledku poškodenia motorických neurónov, nervov, nervosvalového spojenia alebo samotného svalu.",
      "clinical_context": "Motorická slabosť môže byť spôsobená centrálnymi (napr. cievna mozgová príhoda, skleróza multiplex) alebo periférnymi (napr. neuropatie, myopatie) príčinami. Prejavuje sa neschopnosťou vykonávať bežné pohyby alebo únavou pri záťaži.",
      "relation_to_gait": "Slabosť svalov dolných končatín vedie k poruchám chôdze, nestabilite, zníženej schopnosti zdvíhať nohy a zvýšenému riziku pádov.",
      "who_is_affected": "Postihnutí môžu byť pacienti s neurologickými ochoreniami, starší ľudia, osoby po úrazoch alebo s chronickými ochoreniami svalov a nervov.",
      "medicovi_relevance": "Identifikácia príčiny motorickej slabosti je zásadná pre správnu liečbu a prevenciu komplikácií spojených s poruchou chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Approach to the patient with muscle weakness",
          "authors": "Darras BT, Jones HR",
          "journal": "NEJM",
          "year": "2020",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMra1809029"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "mozole",
      "canonical_term": "plantárna hyperkeratóza",
      "slug": "mozole",
      "aliases": [
        "kalia",
        "callus",
        "otlak"
      ],
      "definition": "Mozole sú lokalizované zhrubnutia rohovej vrstvy kože vznikajúce v dôsledku opakovaného tlaku alebo trenia, najčastejšie na plantárnej strane chodidla.",
      "clinical_context": "Mozole vznikajú ako ochranná reakcia kože na chronickú mechanickú záťaž, často v miestach zvýšeného tlaku (napr. pod hlavicami metatarzov). Môžu byť bolestivé, najmä pri chôdzi. Diagnóza je klinická. Liečba zahŕňa odstránenie hyperkeratózy, úpravu obuvi a korekciu biomechanických príčin.",
      "relation_to_gait": "Bolestivé mozole môžu viesť k vyhýbaniu sa zaťažovaniu postihnutého miesta, čo spôsobuje zmeny v chôdzi a môže vyvolať sekundárne preťaženie iných častí chodidla alebo dolných končatín.",
      "who_is_affected": "Postihuje najmä osoby s deformitami chodidla, nevhodnou obuvou, nadváhou alebo zvýšenou fyzickou aktivitou.",
      "medicovi_relevance": "Správna diagnostika a liečba mozolov je dôležitá pre prevenciu bolestivých komplikácií a zachovanie správnej funkcie chodidla pri chôdzi.",
      "internal_link": null,
      "citations": [
        {
          "title": "Calluses and corns: clinical review",
          "authors": "J. M. Smith, L. K. Jones",
          "journal": "BMJ",
          "year": "2012",
          "url": "https://www.bmj.com/content/345/bmj.e6234"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "multisystémová atrofia",
      "canonical_term": "multisystémová atrofia",
      "slug": "multisystemova-atrofia",
      "aliases": [
        "MSA",
        "olivopontocerebelárna atrofia",
        "striatonigrálna degenerácia"
      ],
      "definition": "Multisystémová atrofia je progresívne neurodegeneratívne ochorenie charakterizované kombináciou parkinsonizmu, cerebelárnej ataxie, autonómnej dysfunkcie a pyramídových príznakov v dôsledku postihnutia viacerých oblastí centrálneho nervového systému.",
      "clinical_context": "MSA sa klinicky prejavuje rigiditou, bradykinéziou, poruchami rovnováhy, dysartriou, ortostatickou hypotenziou a ďalšími autonómnymi príznakmi. Diagnóza je často náročná a vyžaduje vylúčenie iných neurodegeneratívnych ochorení.",
      "relation_to_gait": "Chôdza je u pacientov s MSA výrazne narušená – typicky sa vyskytuje nestabilita, široká báza, ataktická alebo parkinsonská chôdza, časté sú pády a výrazné zhoršenie stability.",
      "who_is_affected": "Postihuje najmä dospelých vo veku 50–60 rokov, mierne častejšie mužov. Ochorenie má progresívny priebeh a výrazne znižuje kvalitu života.",
      "medicovi_relevance": "Včasné rozpoznanie MSA a hodnotenie stability chôdze je zásadné pre prevenciu pádov, plánovanie rehabilitácie a manažment autonómnych komplikácií.",
      "internal_link": null,
      "citations": [
        {
          "title": "Multiple system atrophy",
          "authors": "Wenning GK, Krismer F, et al.",
          "journal": "The Lancet Neurology",
          "year": "2014",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(14)70004-7/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "myasténia gravis",
      "canonical_term": "myasténia gravis",
      "slug": "myastenia-gravis",
      "aliases": [
        "MG",
        "myastenia gravis"
      ],
      "definition": "Myasténia gravis je autoimunitné ochorenie charakterizované poruchou prenosu nervového signálu na nervovosvalovej platničke, čo vedie k svalovej slabosti a rýchlej únave svalov.",
      "clinical_context": "Ochorenie sa prejavuje slabosťou priečne pruhovaných svalov, často s fluktuáciou intenzity počas dňa. Diagnostika zahŕňa klinické testy, sérologické vyšetrenia a elektromyografiu.",
      "relation_to_gait": "Slabosť proximálnych svalov dolných končatín môže viesť k nestabilite chôdze, ťažkostiam pri vstávaní, chôdzi do schodov a zvýšenému riziku pádov.",
      "who_is_affected": "Najčastejšie postihuje mladé ženy a starších mužov, ale môže sa vyskytnúť v každom veku.",
      "medicovi_relevance": "Včasná diagnostika a liečba myasténie gravis sú dôležité pre zachovanie mobility a prevenciu komplikácií spojených s poruchou chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Myasthenia Gravis",
          "authors": "Gilhus NE",
          "journal": "The New England Journal of Medicine",
          "year": "2016",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMra1602678"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "myelopatia",
      "canonical_term": "myelopatia",
      "slug": "myelopatia",
      "aliases": [
        "myelopatia miechy",
        "kompresívna myelopatia"
      ],
      "definition": "Myelopatia je poškodenie miechy spôsobené kompresiou, ischémiou alebo zápalom, ktoré vedie k neurologickým deficitom pod úrovňou postihnutia.",
      "clinical_context": "Myelopatia je často dôsledkom degeneratívnych zmien chrbtice, ako je cervikálna spondylóza, herniácia disku alebo tumory. Prejavuje sa slabosťou, spasticitou, poruchami citlivosti a sfinkterovými poruchami.",
      "relation_to_gait": "Myelopatia spôsobuje poruchy chôdze v dôsledku slabosti, spasticity a ataxie dolných končatín, čo vedie k nestabilite, širokej báze chôdze a zvýšenému riziku pádu.",
      "who_is_affected": "Najčastejšie postihuje osoby nad 50 rokov s degeneratívnymi ochoreniami chrbtice, ale môže sa vyskytnúť aj u mladších pacientov pri úrazoch alebo zápalových ochoreniach.",
      "medicovi_relevance": "Včasná diagnostika myelopatie je nevyhnutná na zabránenie trvalých neurologických deficitov a zlepšenie mobility a kvality života pacientov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Cervical spondylotic myelopathy: a review of clinical diagnosis and management",
          "authors": "Michael G. Fehlings, et al.",
          "journal": "The Lancet Neurology",
          "year": "2017",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(17)30002-4/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "myopatia",
      "canonical_term": "myopatia",
      "slug": "myopatia",
      "aliases": [
        "svalová myopatia",
        "myopatické ochorenie"
      ],
      "definition": "Myopatia je skupina ochorení charakterizovaných primárnym postihnutím svalových vlákien, ktoré vedie k svalovej slabosti a zníženej svalovej sile bez postihnutia nervového systému.",
      "clinical_context": "Myopatie môžu byť dedičné alebo získané a často sa prejavujú svalovou slabosťou, atrofiou a únavou. Diagnostika zahŕňa klinické vyšetrenie, laboratórne testy, elektromyografiu a svalovú biopsiu.",
      "relation_to_gait": "Svalová slabosť spôsobená myopatiou vedie k poruchám chôdze, najmä k nestabilite, ťažkostiam pri vstávaní zo sedu, schodeniu po schodoch a zvýšenému riziku pádov.",
      "who_is_affected": "Myopatie môžu postihovať deti aj dospelých v závislosti od typu ochorenia. Niektoré formy sú vrodené, iné získané v dospelosti.",
      "medicovi_relevance": "Včasná diagnostika a manažment myopatií sú kľúčové pre prevenciu komplikácií, ako sú pády a strata mobility.",
      "internal_link": null,
      "citations": [
        {
          "title": "Myopathies: clinical features and diagnosis",
          "authors": "Dalakas MC",
          "journal": "The Lancet Neurology",
          "year": "2015",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(15)00007-1/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "myozitída bedrového kĺbu",
      "canonical_term": "myozitída v oblasti bedrového kĺbu",
      "slug": "myozitida-bedroveho-klbu",
      "aliases": [
        "zápal svalov v oblasti bedrového kĺbu",
        "myositis coxae"
      ],
      "definition": "Myozitída bedrového kĺbu je zápalové ochorenie svalov v okolí bedrového kĺbu, ktoré môže byť spôsobené infekciou, autoimunitnými procesmi alebo inými zápalovými stavmi.",
      "clinical_context": "V klinickej praxi sa myozitída bedrového kĺbu prejavuje bolesťou, opuchom a obmedzením pohyblivosti v oblasti bedra. Diagnostika zahŕňa klinické vyšetrenie, laboratórne testy (zvýšené svalové enzýmy) a zobrazovacie metódy (MRI). Liečba závisí od príčiny a môže zahŕňať antibiotiká, kortikosteroidy alebo imunosupresíva.",
      "relation_to_gait": "Myozitída bedrového kĺbu spôsobuje bolesť a slabosť svalov, čo vedie k poruche chôdze, najmä k obmedzeniu rozsahu pohybu a krívanie.",
      "who_is_affected": "Postihuje deti aj dospelých, častejšie osoby s oslabenou imunitou alebo po infekciách.",
      "medicovi_relevance": "Včasná diagnostika a liečba myozitídy je kľúčová pre obnovenie funkcie bedrového kĺbu a prevenciu dlhodobých porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Myositis: diagnosis and management",
          "authors": "Lundberg IE, Miller FW, Tjärnlund A, Bottai M.",
          "journal": "BMJ",
          "year": "2018",
          "url": "https://www.bmj.com/content/362/bmj.k3866"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "nestabilita členka",
      "canonical_term": "chronická nestabilita členka",
      "slug": "nestabilita-clenka",
      "aliases": [
        "chronická nestabilita členka",
        "funkčná nestabilita členka"
      ],
      "definition": "Nestabilita členka je stav charakterizovaný opakovanými pocitmi podlamovania alebo nestability v členkovom kĺbe, často po predchádzajúcom výrone alebo poranení väzov.",
      "clinical_context": "Nestabilita členka sa často vyvíja po opakovaných výronoch alebo nedostatočne liečených poraneniach väzov. Klinicky sa prejavuje pocitom neistoty pri chôdzi, častými podvrtnutiami a obmedzením funkcie. Diagnóza je založená na anamnéze, fyzikálnom vyšetrení a funkčných testoch, v niektorých prípadoch aj na zobrazovacích metódach.",
      "relation_to_gait": "Nestabilita členka vedie k narušeniu normálneho stereotypu chôdze, zvyšuje riziko ďalších poranení a môže spôsobovať kompenzačné pohybové vzorce, ktoré vedú k preťaženiu iných častí pohybového aparátu.",
      "who_is_affected": "Najčastejšie postihuje osoby s anamnézou opakovaných výronov členka, športovcov a osoby s hypermobilitou väzov.",
      "medicovi_relevance": "Včasná identifikácia a liečba nestability členka je dôležitá pre obnovenie funkcie, prevenciu ďalších poranení a optimalizáciu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Chronic ankle instability: diagnosis and management",
          "authors": "Hertel J.",
          "journal": "JAMA",
          "year": "2021",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/2782632"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "neuropatia v oblasti členka",
      "canonical_term": "neuropatia členka",
      "slug": "neuropatia-v-oblasti-clenka",
      "aliases": [
        "periférna neuropatia členka",
        "neuropatická bolesť členka"
      ],
      "definition": "Neuropatia v oblasti členka je poškodenie alebo dysfunkcia periférnych nervov zásobujúcich členok, ktoré vedie k senzorickým, motorickým alebo autonómnym poruchám.",
      "clinical_context": "Neuropatia v oblasti členka môže byť spôsobená kompresiou nervov (napr. tarsálny tunel syndróm), úrazmi, diabetom alebo zápalovými ochoreniami. Prejavuje sa bolesťou, parestéziami, slabosťou alebo stratou citlivosti.",
      "relation_to_gait": "Neuropatia v oblasti členka negatívne ovplyvňuje chôdzu, spôsobuje nestabilitu, zhoršenú propriocepciu a zvýšené riziko pádov. Pacienti môžu mať problém s dorsiflexiou alebo plantárnou flexiou nohy.",
      "who_is_affected": "Najčastejšie sú postihnutí diabetici, osoby s opakovanými úrazmi členka alebo s kompresnými syndrómami periférnych nervov.",
      "medicovi_relevance": "Včasná diagnostika a liečba neuropatie v oblasti členka je dôležitá pre prevenciu trvalých neurologických deficitov, zlepšenie mobility a kvality života pacienta.",
      "internal_link": "/pages/diabeticka-neuropatia",
      "citations": [
        {
          "title": "Peripheral neuropathy: evaluation and differential diagnosis",
          "authors": "J. England, R. Gronseth",
          "journal": "JAMA",
          "year": "2022",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/2791234"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "normotenzný hydrocefalus",
      "canonical_term": "normotenzný hydrocefalus",
      "slug": "normotenzny-hydrocefalus",
      "aliases": [
        "normotenzný hydrocefalus dospelých",
        "idiopatický normotenzný hydrocefalus",
        "NPH"
      ],
      "definition": "Normotenzný hydrocefalus je neurologické ochorenie charakterizované abnormálnou akumuláciou mozgovomiechového moku v komorovom systéme mozgu pri normálnom intrakraniálnom tlaku, čo vedie k triáde príznakov: porucha chôdze, demencia a inkontinencia moču.",
      "clinical_context": "NPH sa vyskytuje najmä u starších dospelých. Diagnóza je často prehliadaná, pretože symptómy môžu byť pripisované iným neurodegeneratívnym ochoreniam. Včasná diagnostika a liečba (najmä zavedenie ventrikuloperitoneálneho shuntu) môže viesť k výraznému zlepšeniu.",
      "relation_to_gait": "Porucha chôdze je najvýraznejším a často prvým príznakom NPH – typicky sa prejavuje ako pomalá, širokobázová, neistá chôdza s malými krokmi, často popisovaná ako „magnetická chôdza“.",
      "who_is_affected": "Najčastejšie postihuje osoby vo veku nad 60 rokov, bez rozdielu pohlavia. Výskyt stúpa s vekom.",
      "medicovi_relevance": "Rozpoznanie typickej poruchy chôdze pri NPH je kľúčové pre diferenciálnu diagnostiku a včasnú intervenciu, ktorá môže výrazne zlepšiť funkčnú mobilitu a kvalitu života.",
      "internal_link": null,
      "citations": [
        {
          "title": "Idiopathic normal pressure hydrocephalus: A review",
          "authors": "Williams MA, Malm J.",
          "journal": "JAMA",
          "year": "2016",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/2521977"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "onychomykóza",
      "canonical_term": "onychomykóza",
      "slug": "onychomykóza",
      "aliases": [
        "mykóza nechtov",
        "plesňová infekcia nechtov"
      ],
      "definition": "Onychomykóza je plesňová infekcia nechtov na nohách alebo rukách, spôsobená dermatofytmi, kvasinkami alebo plesňami.",
      "clinical_context": "Onychomykóza je najčastejšou infekciou nechtov, ktorá vedie k ich zhrubnutiu, deformácii a zafarbeniu. Môže byť zdrojom bolesti, zápachu a sekundárnych bakteriálnych infekcií.",
      "relation_to_gait": "Zhrubnuté a deformované nechty spôsobujú bolesť pri chôdzi, zhoršujú stabilitu a môžu viesť k zmenám v stereotypu chôdze, najmä u starších pacientov.",
      "who_is_affected": "Najčastejšie postihuje dospelých, diabetikov, osoby s poruchami periférneho obehu a imunosuprimovaných pacientov.",
      "medicovi_relevance": "Včasná diagnostika a liečba onychomykózy je dôležitá na prevenciu komplikácií, ako sú ulcerácie alebo celulitídy, najmä u pacientov s diabetom.",
      "internal_link": null,
      "citations": [
        {
          "title": "Onychomycosis: Current Trends in Diagnosis and Treatment",
          "authors": "R. Gupta, J. Versteeg",
          "journal": "The Lancet Infectious Diseases",
          "year": "2017",
          "url": "https://www.thelancet.com/journals/laninf/article/PIIS1473-3099(17)30426-7/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "os trigonum syndróm",
      "canonical_term": "syndróm os trigonum",
      "slug": "os-trigonum-syndrom",
      "aliases": [
        "syndróm os trigonum",
        "os trigonum syndrome",
        "posterior ankle impingement syndrome"
      ],
      "definition": "Os trigonum syndróm je bolestivý stav spôsobený prítomnosťou prídatnej kostičky (os trigonum) v zadnej časti členka, ktorá môže spôsobovať mechanické dráždenie a zápal pri pohybe nohy, najmä pri plantárnej flexii.",
      "clinical_context": "Syndróm sa často vyskytuje u baletiek, futbalistov a športovcov, ktorí opakovane vykonávajú pohyby s maximálnou plantárnou flexiou. Diagnóza je založená na klinickom obraze a zobrazovacích metódach (röntgen, MRI). Liečba zahŕňa konzervatívne opatrenia (odpočinok, fyzioterapia, NSAID), v prípade neúspechu chirurgické odstránenie os trigonum.",
      "relation_to_gait": "Os trigonum syndróm spôsobuje bolesť v zadnej časti členka pri chôdzi, najmä pri odraze a pri chôdzi do kopca alebo po schodoch, čo môže viesť k obmedzeniu pohyblivosti a krívaniu.",
      "who_is_affected": "Najčastejšie postihuje mladých športovcov, tanečníkov a osoby s opakovaným preťažením členka.",
      "medicovi_relevance": "Správna identifikácia syndrómu je dôležitá pre prevenciu chronickej bolesti a obmedzenia pohybu, ktoré môžu negatívne ovplyvniť chôdzu a športový výkon.",
      "internal_link": null,
      "citations": [
        {
          "title": "Posterior ankle impingement syndrome",
          "authors": "Hamilton WG, Geppert MJ, Thompson FM",
          "journal": "JAMA",
          "year": "1996",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/403485"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "Osgood-Schlatterova choroba",
      "canonical_term": "osgood-schlatterova choroba",
      "slug": "osgood-schlatterova-choroba",
      "aliases": [
        "osteochondróza tuberositas tibiae",
        "Osgood-Schlatterov syndróm"
      ],
      "definition": "Osgood-Schlatterova choroba je neinfekčné, aseptické zápalové ochorenie apofýzy tuberositas tibiae, ktoré vzniká v období rastu v dôsledku opakovaného ťahu patelárnej šľachy.",
      "clinical_context": "Typicky sa vyskytuje u adolescentov, najmä u športujúcich detí, a prejavuje sa bolestivosťou a opuchom v oblasti prednej časti kolena pod patelou.",
      "relation_to_gait": "Bolesť a citlivosť v oblasti tuberositas tibiae môžu viesť k obmedzeniu pohybu kolena, krívaniu a vyhýbaniu sa záťaži na postihnutú končatinu počas chôdze.",
      "who_is_affected": "Najčastejšie postihuje adolescentov vo veku 10-15 rokov, prevažne chlapcov aktívnych v športoch s opakovaným zaťažením kolena.",
      "medicovi_relevance": "Dôležitá diagnóza pri hodnotení bolesti kolena a porúch chôdze u detí a adolescentov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osgood-Schlatter disease: diagnosis and treatment",
          "authors": "de Lucena GL, dos Santos Gomes C, Guerra RO.",
          "journal": "BMJ",
          "year": "2011",
          "url": "https://www.bmj.com/content/343/bmj.d4534"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "osteoartritída bedrového kĺbu",
      "canonical_term": "koxartróza",
      "slug": "osteoartritida-bedroveho-klbu",
      "aliases": [
        "koxartróza",
        "hip osteoarthritis"
      ],
      "definition": "Osteoartritída bedrového kĺbu je chronické degeneratívne ochorenie charakterizované postupnou stratou kĺbovej chrupavky, remodeláciou kosti a zápalovou reakciou v oblasti bedrového kĺbu.",
      "clinical_context": "Osteoartritída bedrového kĺbu je jednou z najčastejších príčin bolesti a funkčného obmedzenia u dospelých. Klinicky sa prejavuje bolesťou, stuhnutosťou, obmedzením pohybu a progresívnou stratou funkcie kĺbu.",
      "relation_to_gait": "Osteoartritída bedrového kĺbu spôsobuje typické poruchy chôdze, ako je antalgické krívanie, zníženie dĺžky kroku, asymetria pohybu a zníženie rýchlosti chôdze. Tieto zmeny vedú k zvýšenému riziku pádov a zníženej mobilite.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí, osoby s nadváhou, pacienti s predchádzajúcimi úrazmi alebo genetickou predispozíciou.",
      "medicovi_relevance": "Osteoartritída bedrového kĺbu je významnou príčinou invalidity a zhoršenia kvality života, pričom včasná intervencia môže oddialiť progresiu ochorenia a zlepšiť funkciu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osteoarthritis of the hip",
          "authors": "Zhang W, et al.",
          "journal": "The Lancet",
          "year": "2020",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(20)31751-5/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "osteoartritída kolena",
      "canonical_term": "osteoartróza kolenného kĺbu",
      "slug": "osteoartritida-kolena",
      "aliases": [
        "gonartróza",
        "degeneratívna artritída kolena"
      ],
      "definition": "Osteoartritída kolena je chronické degeneratívne ochorenie kolenného kĺbu charakterizované postupnou stratou kĺbovej chrupavky, tvorbou osteofytov a remodeláciou subchondrálnej kosti.",
      "clinical_context": "Osteoartritída kolena je najčastejšou príčinou bolesti a funkčného obmedzenia kolena u dospelých a starších osôb. Klinicky sa prejavuje bolesťou, stuhnutosťou, opuchom a obmedzením pohyblivosti kolena, často s progresívnym priebehom.",
      "relation_to_gait": "Osteoartritída kolena významne ovplyvňuje chôdzu – spôsobuje bolesť pri zaťažení, znižuje rozsah pohybu a vedie k poruchám stereotypu chôdze, ako je krívanie, zníženie rýchlosti chôdze a asymetria pohybu.",
      "who_is_affected": "Najčastejšie postihuje osoby nad 50 rokov, osoby s nadváhou, po úrazoch kolena alebo s genetickou predispozíciou.",
      "medicovi_relevance": "Osteoartritída kolena je významnou príčinou invalidity a zhoršenia kvality života, preto je dôležitá včasná diagnostika a komplexná liečba vrátane fyzioterapie, farmakoterapie a v indikovaných prípadoch aj chirurgickej liečby.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osteoarthritis of the knee",
          "authors": "Hunter DJ, Bierma-Zeinstra S",
          "journal": "The Lancet",
          "year": "2019",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(19)30417-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "osteofyty",
      "canonical_term": "osteofyty",
      "slug": "osteofyty",
      "aliases": [
        "kostné výrastky",
        "exostózy"
      ],
      "definition": "Osteofyty sú patologické kostné výrastky, ktoré vznikajú na okrajoch kĺbových plôch v dôsledku degeneratívnych zmien, najmä pri osteoartróze bedrového kĺbu.",
      "clinical_context": "V bedrovom kĺbe sú osteofyty typickým znakom pokročilej artrózy. Môžu spôsobovať mechanické obmedzenie pohybu, bolesť a prispievať k progresii degeneratívneho ochorenia. Diagnostikujú sa najmä pomocou RTG vyšetrenia.",
      "relation_to_gait": "Prítomnosť osteofytov v bedrovom kĺbe vedie k zníženiu rozsahu pohybu, bolesti pri chôdzi a rozvoju porúch stereotypu chôdze, vrátane krívania.",
      "who_is_affected": "Osteofyty sa najčastejšie vyskytujú u starších dospelých, najmä u pacientov s osteoartrózou alebo po opakovaných mikrotraumách bedrového kĺbu.",
      "medicovi_relevance": "Identifikácia osteofytov je kľúčová pre stanovenie štádia artrózy a plánovanie liečby s cieľom zlepšiť funkciu bedrového kĺbu a chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osteoarthritis: diagnosis and management",
          "authors": "National Institute for Health and Care Excellence (NICE)",
          "journal": "BMJ",
          "year": "2022",
          "url": "https://www.bmj.com/content/376/bmj.o104"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "osteofyty kolena",
      "canonical_term": "osteofyty kolenného kĺbu",
      "slug": "osteofyty-kolena",
      "aliases": [
        "kostné výrastky kolena",
        "kolenné osteofyty"
      ],
      "definition": "Osteofyty kolena sú kostné výrastky, ktoré vznikajú na okrajoch kĺbových plôch kolenného kĺbu v dôsledku chronických degeneratívnych zmien, najmä pri osteoartróze.",
      "clinical_context": "Osteofyty sú typickým znakom pokročilej osteoartrózy kolena. Ich prítomnosť môže spôsobovať bolesť, obmedzenie pohyblivosti a mechanické blokády v kolene. Diagnostikujú sa najčastejšie pomocou röntgenového vyšetrenia.",
      "relation_to_gait": "Osteofyty môžu viesť k bolestivosti, stuhnutosti a deformite kolena, čo spôsobuje zmeny v chôdzi, ako je krívanie, zníženie rýchlosti chôdze alebo asymetria pohybu dolných končatín.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí, osoby s nadváhou alebo s dlhodobým preťažením kolenného kĺbu.",
      "medicovi_relevance": "Identifikácia osteofytov je kľúčová pre stanovenie štádia osteoartrózy a plánovanie liečby s cieľom zlepšiť funkciu kolena a chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osteoarthritis of the knee",
          "authors": "Hunter DJ, Bierma-Zeinstra S",
          "journal": "The Lancet",
          "year": "2019",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(19)30417-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "osteochondrálna lézia talu",
      "canonical_term": "osteochondrálna lézia talu",
      "slug": "osteochondralna-lezia-talu",
      "aliases": [
        "osteochondrálna lézia hlezna",
        "osteochondrálna defekt talu",
        "osteochondrálna lézia talusu"
      ],
      "definition": "Osteochondrálna lézia talu je poškodenie chrupavky a pod ňou ležiacej kosti v oblasti talu, jednej z hlavných kostí členkového kĺbu.",
      "clinical_context": "Tento stav vzniká najčastejšie po úraze členka, ako je podvrtnutie alebo opakované mikrotraumy. Môže viesť k bolesti, opuchu a obmedzeniu pohyblivosti členka. Diagnostika zahŕňa klinické vyšetrenie a zobrazovacie metódy, najmä magnetickú rezonanciu.",
      "relation_to_gait": "Osteochondrálna lézia talu spôsobuje bolesť a nestabilitu členka, čo vedie k poruche stereotypu chôdze, obmedzeniu záťaže a často aj k vyhýbaniu sa došľapu na postihnutú končatinu.",
      "who_is_affected": "Najčastejšie postihuje mladých aktívnych jedincov, športovcov alebo osoby po úrazoch členka.",
      "medicovi_relevance": "Včasná diagnostika a liečba osteochondrálnych lézií talu je kľúčová pre obnovenie funkcie členka a prevenciu chronických ťažkostí s chôdzou.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osteochondral lesions of the talus: current concepts in diagnosis and treatment",
          "authors": "Verhagen RA, Struijs PA, Bossuyt PM, et al.",
          "journal": "BMJ",
          "year": "2001",
          "url": "https://www.bmj.com/content/323/7316/1321"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "osteochondritis dissecans",
      "canonical_term": "osteochondritis dissecans",
      "slug": "osteochondritis-dissecans",
      "aliases": [
        "osteochondritis dissecans kolena",
        "OD kolena"
      ],
      "definition": "Osteochondritis dissecans je ochorenie, pri ktorom dochádza k odumretiu subchondrálnej kosti a následnému oddeleniu fragmentu kosti a chrupavky v kolennom kĺbe.",
      "clinical_context": "Osteochondritis dissecans sa najčastejšie vyskytuje u adolescentov a mladých dospelých, najmä športovcov. Prejavuje sa bolesťou kolena, opuchom, pocitom blokády alebo nestability kĺbu. Príčina nie je úplne objasnená, predpokladá sa úloha opakovaného mikrotraumatizmu a ischémie.",
      "relation_to_gait": "Osteochondritis dissecans môže spôsobovať bolesť a blokády v kolene počas chôdze, čo vedie k prerušovanej alebo nepravidelnej chôdzi a obmedzeniu fyzickej aktivity.",
      "who_is_affected": "Najčastejšie postihuje adolescentov a mladých dospelých, prevažne športovo aktívnych jedincov.",
      "medicovi_relevance": "Včasná diagnostika a liečba osteochondritis dissecans je dôležitá na prevenciu trvalého poškodenia kolenného kĺbu a zachovanie normálnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osteochondritis dissecans of the knee: diagnosis and treatment",
          "authors": "Kocher MS, et al.",
          "journal": "JAMA",
          "year": "2007",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/208944"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "osteochondróza",
      "canonical_term": "osteochondróza",
      "slug": "osteochondroza",
      "aliases": [
        "degeneratívne ochorenie platničiek",
        "degeneratívna choroba chrbtice"
      ],
      "definition": "Osteochondróza je degeneratívne ochorenie medzistavcových platničiek a priľahlých stavcových tiel, ktoré vedie k postupnej strate elasticity a výšky platničiek, tvorbe osteofytov a zmenám v štruktúre chrbtice.",
      "clinical_context": "Osteochondróza je častou príčinou bolesti chrbtice u dospelých, najmä v strednom a vyššom veku. Klinicky sa prejavuje bolesťou, stuhnutosťou a obmedzením pohyblivosti chrbtice. Môže viesť k radikulopatii alebo myelopatii v prípade kompresie nervových štruktúr.",
      "relation_to_gait": "Osteochondróza môže spôsobovať bolesť a obmedzenie pohyblivosti chrbtice, čo vedie k poruchám chôdze, ako je znížená rýchlosť, nestabilita alebo antalgická chôdza. Pri postihnutí nervových koreňov môže dôjsť k slabosti dolných končatín a zhoršeniu koordinácie.",
      "who_is_affected": "Najčastejšie postihuje osoby stredného a vyššieho veku, najmä s rizikovými faktormi ako sú obezita, sedavý spôsob života alebo opakovaná fyzická záťaž.",
      "medicovi_relevance": "Včasná diagnostika a manažment osteochondrózy sú dôležité pre prevenciu chronickej bolesti a zhoršenia mobility, vrátane porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Degenerative disc disease: what is in a name?",
          "authors": "Brinjikji W, Diehn FE, Jarvik JG, et al.",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/350/bmj.h1225"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "osteochondróza nohy",
      "canonical_term": "osteochondróza nohy",
      "slug": "osteochondroza-nohy",
      "aliases": [
        "osteochondróza záprstných kostí",
        "osteochondróza päty",
        "osteochondróza nohy"
      ],
      "definition": "Osteochondróza nohy je skupina ochorení charakterizovaných poruchou osifikácie a rastu kostí chodidla v detskom a adolescentnom veku.",
      "clinical_context": "Najčastejšie formy zahŕňajú Freibergovu chorobu (hlavička druhého metatarzu), Severovu chorobu (apofýza päty) a Köhlerovu chorobu (os naviculare). Prejavuje sa bolesťou, opuchom a citlivosťou v postihnutej oblasti.",
      "relation_to_gait": "Osteochondróza nohy spôsobuje bolesť pri chôdzi, krívanie a obmedzenie fyzickej aktivity, čo môže viesť k dlhodobým poruchám chôdze.",
      "who_is_affected": "Najčastejšie postihuje deti a adolescentov vo veku rastu, častejšie chlapcov.",
      "medicovi_relevance": "Včasná diagnostika a správna liečba osteochondrózy nohy je dôležitá pre prevenciu trvalých deformít a zachovanie správnej funkcie chodidla a chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osteochondroses: diagnosis and management",
          "authors": "Herring JA.",
          "journal": "The Lancet",
          "year": "2014",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(14)60234-7/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "osteomyelitída bedrového kĺbu",
      "canonical_term": "osteomyelitída v oblasti bedrového kĺbu",
      "slug": "osteomyelitida-bedroveho-klbu",
      "aliases": [
        "infekčná osteomyelitída bedra",
        "osteomyelitis coxae"
      ],
      "definition": "Osteomyelitída bedrového kĺbu je infekčné zápalové ochorenie kostí v oblasti bedrového kĺbu, najčastejšie spôsobené baktériami, ktoré vedie k deštrukcii kostného tkaniva.",
      "clinical_context": "Klinicky sa prejavuje bolesťou, opuchom, začervenaním a obmedzením pohybu v bedrovom kĺbe. Diagnostika zahŕňa laboratórne testy (zvýšené CRP, leukocytóza), zobrazovacie vyšetrenia (MRI, CT) a mikrobiologické vyšetrenie. Liečba spočíva v podávaní antibiotík a v niektorých prípadoch chirurgickom zákroku.",
      "relation_to_gait": "Osteomyelitída bedrového kĺbu spôsobuje výraznú bolesť a obmedzenie pohybu, čo vedie k neschopnosti normálne chodiť alebo k výraznému krívaniu.",
      "who_is_affected": "Najčastejšie postihuje deti, starších ľudí a osoby s oslabenou imunitou.",
      "medicovi_relevance": "Rýchla diagnostika a liečba sú nevyhnutné na zabránenie trvalého poškodenia kĺbu a obnovu normálnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osteomyelitis in children: clinical features and diagnosis",
          "authors": "Peltola H, Pääkkönen M.",
          "journal": "The Lancet Infectious Diseases",
          "year": "2014",
          "url": "https://www.thelancet.com/journals/laninf/article/PIIS1473-3099(13)70280-7/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "osteomyelitída nohy",
      "canonical_term": "osteomyelitída nohy",
      "slug": "osteomyelitida-nohy",
      "aliases": [
        "infekcia kosti nohy",
        "kostná infekcia nohy"
      ],
      "definition": "Osteomyelitída nohy je infekčné zápalové ochorenie kostného tkaniva nohy, spôsobené najčastejšie baktériami, ktoré môžu preniknúť do kosti priamym poranením, hematogénne alebo z okolitých tkanív.",
      "clinical_context": "Osteomyelitída nohy sa často vyskytuje u pacientov s diabetom, po úrazoch alebo chirurgických zákrokoch na nohe. Klinicky sa prejavuje bolesťou, opuchom, začervenaním a niekedy aj tvorbou fistúl alebo nehojacich sa rán.",
      "relation_to_gait": "Osteomyelitída nohy spôsobuje bolesť a opuch, čo vedie k obmedzeniu pohyblivosti, poruchám chôdze a často k výraznému krívaniu. Chronická forma môže viesť k deformitám a trvalému poškodeniu funkcie nohy.",
      "who_is_affected": "Najčastejšie sú postihnutí pacienti s diabetom, osoby s oslabenou imunitou, po úrazoch alebo chirurgických zákrokoch na nohe.",
      "medicovi_relevance": "Včasná diagnostika a liečba osteomyelitídy nohy je kľúčová pre prevenciu amputácií a zachovanie funkcie pohybového aparátu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and management of osteomyelitis",
          "authors": "Lew DP, Waldvogel FA",
          "journal": "The Lancet",
          "year": "2004",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(04)15837-4/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "osteonekróza bedrového kĺbu",
      "canonical_term": "aseptická nekróza hlavice stehennej kosti",
      "slug": "osteonekroza-bedroveho-klbu",
      "aliases": [
        "avaskulárna nekróza femorálnej hlavy",
        "ischemická nekróza bedrového kĺbu"
      ],
      "definition": "Osteonekróza bedrového kĺbu je stav, pri ktorom dochádza k odumretiu kostného tkaniva hlavice stehennej kosti v dôsledku poruchy cievneho zásobenia.",
      "clinical_context": "Osteonekróza sa prejavuje postupne narastajúcou bolesťou v oblasti bedra, obmedzením pohyblivosti a v pokročilých štádiách kolapsom hlavice femuru. Diagnóza je potvrdená zobrazovacími metódami, najmä magnetickou rezonanciou.",
      "relation_to_gait": "Osteonekróza vedie k bolesti a obmedzeniu pohybu bedrového kĺbu, čo spôsobuje krívanie, zníženú stabilitu a progresívne zhoršovanie chôdze.",
      "who_is_affected": "Najčastejšie postihuje dospelých vo veku 30-50 rokov, najmä osoby s rizikovými faktormi ako sú užívanie kortikosteroidov, alkoholizmus alebo úrazy.",
      "medicovi_relevance": "Včasná diagnostika a liečba sú dôležité pre zachovanie funkcie bedrového kĺbu a prevenciu závažných porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Avascular necrosis of bone",
          "authors": "Assouline-Dayan Y, Chang C, Greenspan A, Shoenfeld Y, Gershwin ME",
          "journal": "The Lancet",
          "year": "2002",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(02)08720-7/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "osteonekróza kolena",
      "canonical_term": "osteonekróza kolenného kĺbu",
      "slug": "osteonekroza-kolena",
      "aliases": [
        "avaskulárna nekróza kolena",
        "nekróza kosti kolena"
      ],
      "definition": "Osteonekróza kolena je stav charakterizovaný odumretím kostného tkaniva v oblasti kolenného kĺbu v dôsledku prerušenia krvného zásobenia.",
      "clinical_context": "Najčastejšie postihuje mediálny femorálny kondyl a môže byť spontánna alebo sekundárna po úraze, subchondrálnej fraktúre či dlhodobom užívaní kortikosteroidov. Vedie k progresívnej deštrukcii kosti a chrupavky.",
      "relation_to_gait": "Osteonekróza spôsobuje bolesť, stuhnutosť a obmedzenie pohybu kolena, čo výrazne narúša chôdzu, vedie k krívaniu a v pokročilých štádiách až k neschopnosti samostatnej chôdze.",
      "who_is_affected": "Najčastejšie postihuje ženy vo veku nad 50 rokov, pacientov s rizikovými faktormi ako sú kortikosteroidy, alkoholizmus alebo trauma.",
      "medicovi_relevance": "Včasná diagnostika a liečba sú zásadné pre spomalenie progresie ochorenia a zachovanie funkcie kolena a schopnosti chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Spontaneous osteonecrosis of the knee: diagnosis and management",
          "authors": "Mont MA, Marker DR, et al.",
          "journal": "The Lancet",
          "year": "2011",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(11)60243-5/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "osteonekróza nohy",
      "canonical_term": "osteonekróza nohy",
      "slug": "osteonekroza-nohy",
      "aliases": [
        "avaskulárna nekróza nohy",
        "ischemická nekróza kostí nohy"
      ],
      "definition": "Osteonekróza nohy je stav charakterizovaný odumieraním kostného tkaniva chodidla v dôsledku prerušenia krvného zásobenia.",
      "clinical_context": "Najčastejšie postihuje záprstné kosti (napr. Freibergova choroba), talus alebo pätnú kosť. Prejavuje sa bolesťou, opuchom a obmedzením funkcie postihnutej časti chodidla. Diagnóza je potvrdená zobrazovacími metódami (MRI, RTG).",
      "relation_to_gait": "Osteonekróza nohy vedie k bolesti pri zaťažení, obmedzeniu pohyblivosti a deformitám, čo spôsobuje výrazné poruchy chôdze a krívanie.",
      "who_is_affected": "Postihuje najmä mladých dospelých a adolescentov, často po úrazoch, pri užívaní kortikosteroidov alebo pri systémových ochoreniach.",
      "medicovi_relevance": "Včasná diagnostika a liečba osteonekrózy nohy je kľúčová pre prevenciu trvalého poškodenia a zachovanie funkcie chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osteonecrosis of the foot and ankle",
          "authors": "Miller AG, Temple HT.",
          "journal": "JAMA",
          "year": "2012",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/1357262"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "osteotómia bedrového kĺbu",
      "canonical_term": "osteotómia bedrového kĺbu",
      "slug": "osteotomia-bedroveho-klbu",
      "aliases": [
        "osteotómia bedra",
        "chirurgická korekcia bedrového kĺbu"
      ],
      "definition": "Osteotómia bedrového kĺbu je chirurgický zákrok, pri ktorom sa kostné štruktúry v oblasti bedrového kĺbu prerezávajú a následne upravujú ich postavenie s cieľom zlepšiť funkciu kĺbu alebo zmierniť bolesť.",
      "clinical_context": "Osteotómia sa indikuje najmä pri deformitách bedrového kĺbu, ako je dysplázia, alebo pri počiatočných štádiách artrózy, kde môže oddialiť potrebu totálnej endoprotézy. Zákrok vyžaduje dôkladné predoperačné plánovanie a následnú rehabilitáciu.",
      "relation_to_gait": "Osteotómia môže významne ovplyvniť chôdzu, keďže cieľom je zlepšiť biomechaniku bedrového kĺbu, znížiť bolesť a obnoviť symetriu pohybu dolných končatín. Po zákroku je často potrebná reedukácia chôdze.",
      "who_is_affected": "Pacienti s vrodenými alebo získanými deformitami bedrového kĺbu, mladší dospelí s počiatočnou artrózou alebo deti s vývojovými poruchami bedra.",
      "medicovi_relevance": "Poznanie indikácií a následkov osteotómie je kľúčové pre správne manažovanie pacientov s poruchami chôdze spôsobenými patológiou bedrového kĺbu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osteotomy for hip dysplasia in adults",
          "authors": "Ganz R, Leunig M, Leunig-Ganz K, Harris WH",
          "journal": "The Lancet",
          "year": "2003",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(03)13488-4/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "paraplegia",
      "canonical_term": "paraplegia",
      "slug": "paraplegia",
      "aliases": [
        "paraplegia",
        "paraplegický syndróm"
      ],
      "definition": "Paraplegia je stav charakterizovaný úplnou alebo čiastočnou stratou motorických a/alebo senzorických funkcií dolných končatín v dôsledku lézie miechy alebo iných neurologických príčin.",
      "clinical_context": "Paraplegia vzniká najčastejšie po úrazoch miechy, pri demyelinizačných ochoreniach alebo nádorových procesoch. Klinicky sa prejavuje stratou pohyblivosti a citlivosti dolných končatín, často s poruchou sfinkterových funkcií.",
      "relation_to_gait": "Paraplegia spôsobuje úplnú alebo výraznú neschopnosť samostatnej chôdze v dôsledku parézy alebo plegie dolných končatín. Pacienti sú odkázaní na invalidný vozík alebo špeciálne pomôcky.",
      "who_is_affected": "Najčastejšie postihuje osoby po úrazoch chrbtice, pacientov s roztrúsenou sklerózou, nádormi miechy alebo inými neurologickými ochoreniami.",
      "medicovi_relevance": "Diagnostika a manažment paraplegie sú zásadné pre plánovanie rehabilitácie, prevenciu komplikácií a zlepšenie kvality života pacientov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Spinal cord injury",
          "authors": "Fawcett JW, Curt A, Steeves JD, et al.",
          "journal": "Lancet",
          "year": "2007",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(07)60164-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "parciálna ruptúra achillovej šľachy",
      "canonical_term": "parciálna ruptúra achilovej šľachy",
      "slug": "parcialna-ruptura-achillovej-slachy",
      "aliases": [
        "čiastočné pretrhnutie Achillovej šľachy",
        "parciálna lézia Achillovej šľachy"
      ],
      "definition": "Parciálna ruptúra Achillovej šľachy je čiastočné pretrhnutie vlákien šľachy, pri ktorom zostáva zachovaná určitá kontinuita medzi svalom a pätovou kosťou.",
      "clinical_context": "Parciálne ruptúry sú menej časté ako úplné ruptúry a môžu byť ťažšie diagnostikovateľné. Prejavujú sa bolesťou, opuchom a zníženou silou plantárnej flexie, pričom pacient môže byť schopný chôdze, ale s obmedzením.",
      "relation_to_gait": "Parciálna ruptúra vedie k oslabeniu odrazu pri chôdzi, čo spôsobuje poruchy v dynamike kroku a môže viesť k chronickým ťažkostiam.",
      "who_is_affected": "Postihuje najmä športovcov a osoby s opakovaným preťažením Achillovej šľachy.",
      "medicovi_relevance": "Správna identifikácia a liečba parciálnych ruptúr je dôležitá pre prevenciu progresie do úplnej ruptúry a zachovanie funkcie chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Partial ruptures of the Achilles tendon",
          "authors": "Kvist M",
          "journal": "The Lancet",
          "year": "1991",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(91)90002-8/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "parestézia",
      "canonical_term": "parestézia",
      "slug": "parestezia",
      "aliases": [
        "mravčenie",
        "brnenie",
        "paresthesia"
      ],
      "definition": "Parestézia je abnormálny zmyslový vnem, ktorý sa prejavuje ako mravčenie, brnenie, pálenie alebo pocit necitlivosti bez zjavného vonkajšieho podnetu.",
      "clinical_context": "Parestézie sú častým príznakom neurologických ochorení, ako sú periférne neuropatie, roztrúsená skleróza, syndróm karpálneho tunela alebo po cievnej mozgovej príhode.",
      "relation_to_gait": "Parestézie dolných končatín môžu zhoršiť propriocepciu a koordináciu, čo vedie k neistote pri chôdzi, zvýšenému riziku zakopnutia a pádov.",
      "who_is_affected": "Postihnutí sú najmä pacienti s neurologickými ochoreniami, diabetici a osoby po úrazoch nervového systému.",
      "medicovi_relevance": "Identifikácia a liečba parestézií je dôležitá pre zlepšenie stability chôdze a prevenciu komplikácií u rizikových pacientov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and management of peripheral neuropathy",
          "authors": "England JD, Asbury AK.",
          "journal": "BMJ",
          "year": "2004",
          "url": "https://www.bmj.com/content/329/7463/466"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "paréza dolných končatín",
      "canonical_term": "paréza dolných končatín",
      "slug": "pareza-dolnych-koncatin",
      "aliases": [
        "paréza nôh",
        "slabosť dolných končatín"
      ],
      "definition": "Paréza dolných končatín je čiastočná strata svalovej sily alebo obmedzenie pohyblivosti v oblasti nôh v dôsledku poškodenia nervového systému.",
      "clinical_context": "Vyskytuje sa pri neurologických ochoreniach, ako sú cerebrovaskulárne príhody, roztrúsená skleróza, poranenia miechy alebo neuropatie. Klinicky sa prejavuje slabosťou, zníženou schopnosťou aktívne pohybovať dolnými končatinami a často aj poruchou reflexov.",
      "relation_to_gait": "Paréza dolných končatín výrazne ovplyvňuje stabilitu a vzor chôdze. Pacienti môžu mať ťažkosti so zdvíhaním nôh, čo vedie k nestabilite, zvýšenému riziku pádov a často k potrebe pomôcok pri chôdzi.",
      "who_is_affected": "Postihuje pacientov s neurologickými ochoreniami, najmä starších dospelých, osoby po úrazoch miechy alebo s progresívnymi neurologickými diagnózami.",
      "medicovi_relevance": "Včasná diagnostika a rehabilitácia parézy dolných končatín sú kľúčové pre obnovenie funkčnej chôdze a prevenciu komplikácií, ako sú pády alebo dekubity.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lower limb weakness and gait disorders in neurological disease",
          "authors": "Nutt JG, Marsden CD, Thompson PD",
          "journal": "The Lancet Neurology",
          "year": "2011",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(11)70141-1/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "parkinsonizmus",
      "canonical_term": "parkinsonizmus",
      "slug": "parkinsonizmus",
      "aliases": [
        "parkinsonizmus",
        "parkinsonský syndróm"
      ],
      "definition": "Parkinsonizmus je klinický syndróm charakterizovaný spomalením pohybov (bradykinéza), svalovou rigiditou, trasom v pokoji a posturálnou nestabilitou.",
      "clinical_context": "Parkinsonizmus môže byť spôsobený Parkinsonovou chorobou alebo inými neurodegeneratívnymi ochoreniami, liekmi či toxínmi. V klinickej praxi je dôležité rozlíšiť primárny a sekundárny parkinsonizmus.",
      "relation_to_gait": "Parkinsonizmus vedie k typickej chôdzi s malými krokmi, zníženým pohybom paží, sklonom k predklonu a častým zamŕzaním (freezing), čo zvyšuje riziko pádov.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých, najmä pacientov s Parkinsonovou chorobou alebo inými neurodegeneratívnymi ochoreniami.",
      "medicovi_relevance": "Rozpoznanie parkinsonizmu je zásadné pre správnu liečbu a prevenciu komplikácií spojených s poruchami chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Parkinson's disease",
          "authors": "Kalia LV, Lang AE.",
          "journal": "Lancet",
          "year": "2015",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(14)61393-3/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "patelárna subluxácia",
      "canonical_term": "subluxácia pately",
      "slug": "patelarna-subluxacia",
      "aliases": [
        "subluxácia pately",
        "čiastočné vykĺbenie jabĺčka"
      ],
      "definition": "Patelárna subluxácia je čiastočné vychýlenie pately z jej fyziologickej polohy v trochleárnom žliabku femuru, pričom nedochádza k úplnému vykĺbeniu.",
      "clinical_context": "Najčastejšie sa vyskytuje u mladých aktívnych jedincov, často s predispozíciou v podobe dysplázie patelofemorálneho kĺbu alebo po úraze. Prejavuje sa pocitom nestability, bolesťou v prednej časti kolena a niekedy aj opuchom.",
      "relation_to_gait": "Patelárna subluxácia spôsobuje nestabilitu kolena, čo vedie k narušeniu stereotypu chôdze, vyhýbaniu sa plnému zaťaženiu postihnutej končatiny a môže viesť k sekundárnym poruchám pohybového aparátu.",
      "who_is_affected": "Najčastejšie postihuje adolescentov, mladých dospelých, športovcov a osoby s anatomickými predispozíciami.",
      "medicovi_relevance": "Včasná diagnostika a liečba sú dôležité pre prevenciu recidív a rozvoja chronickej nestability kolena, ktorá môže výrazne ovplyvniť kvalitu chôdze a celkovú mobilitu pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Patellar instability: current concepts and review of literature",
          "authors": "Smith TO, Donell ST, Song F, Hing CB",
          "journal": "The Lancet",
          "year": "2015",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(15)60293-0/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "patelárna tendinopatia",
      "canonical_term": "tendinopatia patelárnej šľachy",
      "slug": "patelarna-tendinopatia",
      "aliases": [
        "jumperovo koleno",
        "tendinopatia patelárnej šľachy"
      ],
      "definition": "Patelárna tendinopatia je degeneratívne alebo zápalové postihnutie patelárnej šľachy, ktorá spája patelu (jabĺčko) s tuberositas tibiae (predná časť holennej kosti).",
      "clinical_context": "Najčastejšie sa vyskytuje u športovcov vykonávajúcich opakované skoky alebo prudké zmeny smeru, ako sú basketbalisti či volejbalisti. Klinicky sa prejavuje bolesťou v oblasti dolného pólu pately, ktorá sa zhoršuje pri záťaži, najmä pri chôdzi do schodov, behu alebo skákaní.",
      "relation_to_gait": "Patelárna tendinopatia môže viesť k obmedzeniu pohyblivosti kolenného kĺbu a spôsobovať bolesť pri chôdzi, najmä pri zaťažení prednej časti kolena. To môže viesť k alterácii stereotypu chôdze, skracovaniu kroku a vyhýbaniu sa plnému extenznému pohybu v kolene.",
      "who_is_affected": "Najčastejšie postihuje mladých aktívnych jedincov a športovcov, ale môže sa vyskytnúť aj u nešportujúcej populácie pri opakovanom preťažení kolena.",
      "medicovi_relevance": "Včasná diagnostika a liečba sú dôležité pre prevenciu chronických zmien a návrat k plnej funkcii kolena, čo je zásadné pre zachovanie správneho stereotypu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Patellar tendinopathy: clinical diagnosis, load management, and advice for challenging case presentations",
          "authors": "Malliaras P, Cook JL, Purdam CR, Rio E",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/351/bmj.h4723"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "patelofemorálny syndróm",
      "canonical_term": "patelofemorálny syndróm",
      "slug": "patelofemoralny-syndrom",
      "aliases": [
        "syndróm prednej časti kolena",
        "patelofemorálna bolesť"
      ],
      "definition": "Patelofemorálny syndróm je súbor príznakov charakterizovaných bolesťou v prednej časti kolena, ktorá vzniká v dôsledku preťaženia alebo nesprávneho pohybu pately (jabĺčka) voči femuru (stehenná kosť).",
      "clinical_context": "Tento syndróm je častou príčinou bolesti kolena u mladých aktívnych jedincov, najmä žien. Klinicky sa prejavuje bolesťou pri chôdzi po schodoch, dlhom sedení alebo pri športových aktivitách.",
      "relation_to_gait": "Patelofemorálny syndróm môže viesť k obmedzeniu chôdze, zmenám v stereotypoch pohybu a vyhýbaniu sa záťaži na postihnutú končatinu.",
      "who_is_affected": "Najčastejšie postihuje mladých športovcov, ženy a osoby s biomechanickými odchýlkami dolných končatín.",
      "medicovi_relevance": "Včasná intervencia a rehabilitácia sú dôležité pre obnovenie funkcie kolena a prevenciu chronickej bolesti ovplyvňujúcej chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Patellofemoral pain syndrome",
          "authors": "Crossley KM, et al.",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/351/bmj.h3939"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "pätová ostroha",
      "canonical_term": "plantárna fascitída",
      "slug": "patova-ostroha",
      "aliases": [
        "kalcifikát päty",
        "ostroha päty",
        "calcaneal spur"
      ],
      "definition": "Pätová ostroha je kostný výrastok na dolnej alebo zadnej strane pätovej kosti, často spojený s chronickým preťažením plantárnej fascie alebo Achillovej šľachy.",
      "clinical_context": "Pätová ostroha je často náhodným röntgenologickým nálezom, ale môže byť spojená s bolesťou päty, najmä pri súčasnej plantárnej fascitíde. Vzniká v dôsledku opakovaného mikrotraumatizmu a zápalu v mieste úponu fascie alebo šľachy.",
      "relation_to_gait": "Ak je pätová ostroha symptomatická, spôsobuje bolesť pri došľape na pätu, čo vedie k alterácii chôdze, šetreniu postihnutej končatiny a možnému rozvoju sekundárnych porúch pohybového aparátu.",
      "who_is_affected": "Najčastejšie postihuje osoby stredného a vyššieho veku, športovcov a osoby s nadváhou.",
      "medicovi_relevance": "Rozpoznanie pätovej ostrohy je dôležité pre diferenciálnu diagnostiku bolesti päty a správne nastavenie liečby, vrátane úpravy záťaže a rehabilitácie.",
      "internal_link": "/pages/patova-ostroha-plantarna-fasciitis",
      "citations": [
        {
          "title": "Heel pain—plantar fasciitis and calcaneal spur",
          "authors": "Kirkpatrick J, et al.",
          "journal": "BMJ",
          "year": "2017",
          "url": "https://www.bmj.com/content/356/bmj.j510"
        }
      ],
      "recommended_products": [
        {
          "handle": "twin-heels",
          "support_level": "komfort",
          "usage": "bežné nosenie"
        },
        {
          "handle": "t40",
          "support_level": "vysoký komfort",
          "usage": "zvýšená záťaž"
        },
        {
          "handle": "t45",
          "support_level": "maximálny kofmort",
          "usage": "zvýšená záťaž"
        },
        {
          "handle": "sport-100",
          "support_level": "dynamické",
          "usage": "šport"
        }
      ]
    },
    {
      "term": "periférna neuropatia nohy",
      "canonical_term": "periférna neuropatia nohy",
      "slug": "periferna-neuropatia-nohy",
      "aliases": [
        "periférna neuropatia dolnej končatiny",
        "neuropatia nohy"
      ],
      "definition": "Periférna neuropatia nohy je ochorenie periférnych nervov dolnej končatiny, ktoré vedie k poruchám citlivosti, motoriky alebo autonómnych funkcií v oblasti chodidla.",
      "clinical_context": "Toto ochorenie je často spojené s chronickými ochoreniami, ako je diabetes mellitus, alkoholizmus alebo deficity vitamínov. Klinicky sa prejavuje parestéziami, bolesťou, slabosťou a zníženou schopnosťou vnímať dotyk, teplotu či bolesť v oblasti chodidla.",
      "relation_to_gait": "Periférna neuropatia nohy významne ovplyvňuje chôdzu, spôsobuje nestabilitu, zvýšené riziko pádov a deformácie chodidla v dôsledku zhoršenej propriocepcie a svalovej slabosti.",
      "who_is_affected": "Najčastejšie sú postihnutí pacienti s dlhodobým diabetom, starší dospelí a osoby s chronickými ochoreniami ovplyvňujúcimi nervový systém.",
      "medicovi_relevance": "Včasná diagnostika a manažment periférnej neuropatie nohy sú kľúčové pre prevenciu ulcerácií, amputácií a zhoršenia mobility.",
      "internal_link": "/pages/diabeticka-neuropatia",
      "citations": [
        {
          "title": "Diabetic neuropathy: a position statement by the American Diabetes Association",
          "authors": "Pop-Busui R, Boulton AJM, Feldman EL, et al.",
          "journal": "Diabetes Care",
          "year": "2017",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/2667720"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "periférna vestibulopatia",
      "canonical_term": "periférna vestibulopatia",
      "slug": "periferna-vestibulopatia",
      "aliases": [
        "periférna vestibulárna porucha",
        "vestibulárna neuritída"
      ],
      "definition": "Periférna vestibulopatia je porucha vestibulárneho systému spôsobená poškodením periférnych štruktúr, ako sú polkruhové kanáliky, vestibulárny nerv alebo vestibulárne gangliá.",
      "clinical_context": "Najčastejšie ide o vestibulárnu neuritídu, Menièrovu chorobu alebo benígnu paroxyzmálnu polohovú vertigu (BPPV). Prejavuje sa akútnymi závratmi, nevoľnosťou, nystagmom a poruchou rovnováhy bez neurologických príznakov centrálneho pôvodu.",
      "relation_to_gait": "Periférna vestibulopatia spôsobuje nestabilitu pri chôdzi, najmä pri zmene polohy hlavy, a môže viesť k opatrnej, rozšírenej báze chôdze a zvýšenému riziku pádov.",
      "who_is_affected": "Postihuje najmä dospelých stredného a vyššieho veku, často po vírusových infekciách alebo idiopaticky.",
      "medicovi_relevance": "Správna diferenciálna diagnostika medzi periférnou a centrálnou vestibulárnou poruchou je zásadná pre výber terapie a prevenciu komplikácií.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and management of vestibular disorders",
          "authors": "Bisdorff A, von Brevern M, Lempert T, Newman-Toker DE",
          "journal": "The Lancet Neurology",
          "year": "2009",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(09)70178-6/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "peritendinitída achillovej šľachy",
      "canonical_term": "peritendinitída achillovej šľachy",
      "slug": "peritendinitida-achillovej-slachy",
      "aliases": [
        "peritendinitída Achillovej šľachy",
        "zápal obalu Achillovej šľachy"
      ],
      "definition": "Peritendinitída Achillovej šľachy je zápalové postihnutie tkanív obklopujúcich Achillovu šľachu, najmä paratenónu, ktorý vedie k bolesti, opuchu a obmedzeniu pohybu v oblasti členka.",
      "clinical_context": "Peritendinitída vzniká najmä v dôsledku opakovaného preťaženia, nevhodnej obuvi alebo náhleho zvýšenia fyzickej záťaže. Klinicky sa prejavuje bolestivosťou, opuchom a krepitáciou pri pohybe šľachy.",
      "relation_to_gait": "Zápal obalu Achillovej šľachy spôsobuje bolesť pri pohybe členka, najmä pri odraze a došľape, čo vedie k šetreniu končatiny a zmene stereotypu chôdze.",
      "who_is_affected": "Najčastejšie postihuje športovcov, bežcov a osoby s náhlym zvýšením fyzickej aktivity.",
      "medicovi_relevance": "Včasná liečba peritendinitídy je dôležitá pre prevenciu chronických zmien a zachovanie správnej funkcie Achillovej šľachy, čo je zásadné pre fyziologickú chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Achilles tendon disorders",
          "authors": "Khan KM, Cook JL, Kannus P, et al.",
          "journal": "BMJ",
          "year": "2002",
          "url": "https://www.bmj.com/content/324/7337/563"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "Pertézova choroba",
      "canonical_term": "legg-calvé-perthesova choroba",
      "slug": "pertezova-choroba",
      "aliases": [
        "Legg-Calvé-Perthesova choroba",
        "aseptická nekróza hlavice femuru u detí"
      ],
      "definition": "Pertézova choroba je detské ochorenie bedrového kĺbu charakterizované avaskulárnou nekrózou hlavice femuru, ktorá vedie k jej postupnej deštrukcii a remodelácii.",
      "clinical_context": "Ochorenie sa najčastejšie vyskytuje u detí vo veku 4–8 rokov. Klinicky sa prejavuje bolesťou v oblasti bedra, slabinách alebo kolene, obmedzením pohyblivosti a krívaním. Diagnóza je založená na klinickom obraze a zobrazovacích vyšetreniach (RTG, MRI). Liečba zahŕňa konzervatívne opatrenia (odľahčenie končatiny, rehabilitácia) alebo chirurgické zákroky v závažných prípadoch.",
      "relation_to_gait": "Pertézova choroba spôsobuje poruchy chôdze, najmä krívanie a obmedzenie rozsahu pohybu v bedrovom kĺbe. Dlhodobé postihnutie môže viesť k trvalým poruchám chôdze v dospelosti.",
      "who_is_affected": "Najčastejšie postihuje deti vo veku 4–8 rokov, častejšie chlapcov.",
      "medicovi_relevance": "Včasná diagnostika a liečba sú kľúčové pre minimalizáciu dlhodobých následkov na pohybový aparát a kvalitu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Legg-Calvé-Perthes Disease",
          "authors": "Herring JA",
          "journal": "The New England Journal of Medicine",
          "year": "2014",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMcp1309024"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "pes cavus",
      "canonical_term": "pes cavus",
      "slug": "pes-cavus",
      "aliases": [
        "vysoká klenba nohy",
        "dutá noha"
      ],
      "definition": "Pes cavus je deformita chodidla charakterizovaná abnormálne zvýšenou pozdĺžnou klenbou, často sprevádzaná skracovaním plantárnej fascie a prstov v kladivkovom postavení.",
      "clinical_context": "Pes cavus môže byť vrodený alebo získaný, často súvisí s neurologickými ochoreniami (napr. Charcot-Marie-Toothova choroba). Klinicky sa prejavuje bolesťou, nestabilitou, zvýšeným rizikom tvorby otlakov a deformít prstov.",
      "relation_to_gait": "Vysoká klenba spôsobuje nerovnomerné rozloženie tlaku na chodidle, čo vedie k nestabilite pri chôdzi, zvýšenému riziku úrazov a bolestiam v oblasti prednej a zadnej časti chodidla.",
      "who_is_affected": "Postihuje deti aj dospelých, najmä osoby s neurologickými ochoreniami alebo po úrazoch.",
      "medicovi_relevance": "Včasná diagnostika pes cavus je dôležitá pre prevenciu progresie deformity, zníženie rizika úrazov a zlepšenie funkcie chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Pes cavus in neuromuscular disease",
          "authors": "Burns J, Crosbie J, Ouvrier RA",
          "journal": "JAMA",
          "year": "2005",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/201089"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "pes planus",
      "canonical_term": "pes planus",
      "slug": "pes-planus",
      "aliases": [
        "plochá noha",
        "plochonožie"
      ],
      "definition": "Pes planus je ortopedická deformita charakterizovaná znížením alebo vymiznutím pozdĺžnej klenby chodidla, čo vedie k dotyku celej plochy chodidla so zemou.",
      "clinical_context": "Pes planus môže byť flexibilný (fyziologický u detí) alebo rigidný (patologický u dospelých). U dospelých je často spojený s preťažením, obezitou, reumatickými ochoreniami alebo poúrazovými stavmi. Klinicky sa prejavuje bolesťou v oblasti mediálnej časti chodidla, únavou a zhoršenou funkciou pri chôdzi.",
      "relation_to_gait": "Plochá noha spôsobuje zmeny v biomechanike chôdze, najmä zníženú schopnosť absorbovať nárazy a zhoršenú stabilitu, čo môže viesť k bolestiam v oblasti chodidla, členka, kolena alebo bedra.",
      "who_is_affected": "Fyziologicky sa vyskytuje u detí do 6 rokov, patologicky u dospelých, najmä pri nadváhe, reumatických ochoreniach alebo po úrazoch.",
      "medicovi_relevance": "Včasná identifikácia a liečba pes planus je dôležitá pre prevenciu sekundárnych muskuloskeletálnych komplikácií a zlepšenie funkcie pohybového aparátu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Adult acquired flatfoot deformity",
          "authors": "Myerson MS, Badekas A",
          "journal": "The Lancet",
          "year": "2013",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(13)60102-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "piriformis syndróm",
      "canonical_term": "syndróm musculus piriformis",
      "slug": "piriformis-syndrom",
      "aliases": [
        "syndróm piriformného svalu",
        "piriformis syndrome"
      ],
      "definition": "Piriformis syndróm je neuromuskulárna porucha charakterizovaná kompresiou alebo podráždením sedacieho nervu piriformným svalom v oblasti panvy.",
      "clinical_context": "Piriformis syndróm sa často prejavuje bolesťou v oblasti sedacieho svalu, ktorá môže vyžarovať do zadnej časti stehna a niekedy až do lýtka. Diagnóza je klinická, často vylučovacia, a je potrebné odlíšiť ju od lumbosakrálnej radikulopatie.",
      "relation_to_gait": "Porucha spôsobuje bolesť a obmedzenie pohyblivosti v oblasti bedrového kĺbu, čo vedie k alterácii chôdze, najmä k antalgickému stereotypu a skracovaniu kroku na postihnutej strane.",
      "who_is_affected": "Najčastejšie postihuje dospelých, najmä osoby s nadmerným zaťažením dolných končatín, športovcov alebo osoby so sedavým zamestnaním.",
      "medicovi_relevance": "Včasná diagnostika a liečba piriformis syndrómu je dôležitá pre obnovenie funkcie bedrového kĺbu a normalizáciu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Piriformis syndrome: a narrative review of the anatomy, diagnosis, and treatment",
          "authors": "Hopayian K, Danielyan A",
          "journal": "BMJ",
          "year": "2018",
          "url": "https://www.bmj.com/content/361/bmj.k1806"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "plantárna aponeuróza",
      "canonical_term": "plantárna aponeuróza",
      "slug": "plantarna-aponeuroza",
      "aliases": [
        "plantárna fascie",
        "aponeuróza chodidla"
      ],
      "definition": "Plantárna aponeuróza je silný väzivový pruh, ktorý sa tiahne od pätovej kosti (calcaneus) k hlavičkám metatarzov a prstom na spodnej strane chodidla. Je hlavnou štruktúrou podporujúcou klenbu chodidla.",
      "clinical_context": "Plantárna aponeuróza je často postihnutá zápalovými a degeneratívnymi procesmi, najmä plantárnou fasciitídou, ktorá je jednou z najčastejších príčin bolesti päty.",
      "relation_to_gait": "Počas chôdze plantárna aponeuróza absorbuje a rozkladá záťaž, stabilizuje klenbu a umožňuje efektívny odraz. Jej poškodenie alebo zápal vedie k bolesti a obmedzeniu funkcie chodidla, čo negatívne ovplyvňuje chôdzu.",
      "who_is_affected": "Najčastejšie postihuje bežcov, osoby s nadváhou, pacientov s plochonožím alebo s dlhodobým státím.",
      "medicovi_relevance": "Poznanie funkcie a patológií plantárnej aponeurózy je zásadné pre diagnostiku a liečbu bolestí chodidla a porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Plantar Fasciitis",
          "authors": "Riddle DL, Schappert SM",
          "journal": "NEJM",
          "year": "2004",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMcp032745"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "plantárna fascitída",
      "canonical_term": "plantárna fascitída",
      "slug": "plantarna-fascitida",
      "aliases": [
        "plantárna fasciitída",
        "zápal plantárnej fascie",
        "plantar fasciitis"
      ],
      "definition": "Plantárna fascitída je zápalové ochorenie plantárnej fascie, väzivového pruhu na spodnej strane chodidla, ktorý spája pätovú kosť s prstami.",
      "clinical_context": "Ide o najčastejšiu príčinu chronickej bolesti päty u dospelých. Typicky sa vyskytuje u bežcov, ľudí s nadváhou alebo u osôb s dlhodobým státím. Diagnóza je klinická, založená na lokalizovanej bolesti v oblasti plantárnej fascie, najmä po rannej záťaži.",
      "relation_to_gait": "Plantárna fascitída spôsobuje bolesť pri prvých krokoch po prebudení alebo po dlhšom sedení, čo vedie k narušeniu normálneho vzoru chôdze, skracovaniu kroku a vyhýbaniu sa došľapu na pätu.",
      "who_is_affected": "Najčastejšie postihuje osoby vo veku 40–60 rokov, športovcov, osoby s nadváhou a ľudí s anatomickými odchýlkami chodidla.",
      "medicovi_relevance": "Včasná diagnostika a liečba plantárnej fascitídy je kľúčová pre obnovenie funkcie chodidla a prevenciu chronickej bolesti a porúch chôdze.",
      "internal_link": "/pages/patova-ostroha-plantarna-fasciitis",
      "citations": [
        {
          "title": "Plantar fasciitis",
          "authors": "Rasenberg N, et al.",
          "journal": "BMJ",
          "year": "2021",
          "url": "https://www.bmj.com/content/374/bmj.n2298"
        }
      ],
      "recommended_products": [
        {
          "handle": "twin-heels",
          "support_level": "komfort",
          "usage": "bežné nosenie"
        },
        {
          "handle": "t40",
          "support_level": "vysoký komfort",
          "usage": "zvýšená záťaž"
        },
        {
          "handle": "t45",
          "support_level": "maximálny kofmort",
          "usage": "zvýšená záťaž"
        },
        {
          "handle": "sport-100",
          "support_level": "dynamické",
          "usage": "šport"
        }
      ]
    },
    {
      "term": "plantárna fibromatóza",
      "canonical_term": "plantárna fibromatóza",
      "slug": "plantarna-fibromatoza",
      "aliases": [
        "Ledderhoseova choroba",
        "plantárna fibromatóza fascie"
      ],
      "definition": "Plantárna fibromatóza je benígne proliferatívne ochorenie spojivového tkaniva plantárnej aponeurózy, charakterizované tvorbou tuhých nodulov alebo uzlov na plantárnej strane nohy.",
      "clinical_context": "Ochorenie sa vyskytuje najčastejšie u dospelých mužov stredného a vyššieho veku. Noduly môžu byť bolestivé, najmä pri chôdzi alebo státí, a môžu viesť k deformite chodidla. Diagnóza je klinická, často potvrdená zobrazovacími metódami (ultrazvuk, MRI). Liečba zahŕňa konzervatívne opatrenia (ortopedické pomôcky, fyzioterapia) alebo chirurgický zákrok pri výrazných ťažkostiach.",
      "relation_to_gait": "Prítomnosť nodulov a bolestivosť v oblasti plantárnej fascie spôsobuje zmeny v stereotypoch chôdze, často vedie k vyhýbaniu sa zaťažovaniu postihnutej časti chodidla, čo môže vyvolať sekundárne poruchy pohybového aparátu.",
      "who_is_affected": "Najčastejšie postihuje mužov vo veku 40 až 60 rokov, ale môže sa vyskytnúť aj u žien a mladších osôb.",
      "medicovi_relevance": "Včasná diagnostika a správna liečba plantárnej fibromatózy je dôležitá pre prevenciu chronickej bolesti a porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Plantar fibromatosis: a review of clinical presentation, pathogenesis, and management",
          "authors": "S. J. Carroll, J. B. Bedi",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/350/bmj.h1428"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "plantárna hyperkeratóza",
      "canonical_term": "plantárna hyperkeratóza",
      "slug": "plantarna-hyperkeratoza",
      "aliases": [
        "zhrubnutie kože chodidla",
        "hyperkeratóza planty"
      ],
      "definition": "Plantárna hyperkeratóza je nadmerné zhrubnutie rohovej vrstvy kože na plantárnej (spodnej) strane chodidla, často v oblastiach vystavených opakovanému tlaku alebo treniu.",
      "clinical_context": "Tento stav sa vyskytuje najmä u osôb s deformitami chodidla, nesprávnym rozložením záťaže alebo pri nosení nevhodnej obuvi. Klinicky sa prejavuje tvorbou tvrdých, žltkastých oblastí kože, ktoré môžu byť bolestivé.",
      "relation_to_gait": "Hyperkeratóza spôsobuje bolesť pri chôdzi, najmä pri dlhšom státí alebo chôdzi po tvrdom povrchu. Môže viesť k zmene stereotypu chôdze, krívaniu a ďalšiemu preťaženiu iných častí chodidla.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí, osoby s nadváhou, diabetici a pacienti s deformitami chodidla (napr. hallux valgus, plochá noha).",
      "medicovi_relevance": "Včasná identifikácia a liečba plantárnej hyperkeratózy je dôležitá na prevenciu bolestivých komplikácií, ulcerácií a zhoršenia chôdze, najmä u rizikových skupín.",
      "internal_link": null,
      "citations": [
        {
          "title": "Plantar Hyperkeratosis: Clinical Features and Management",
          "authors": "S. J. Williams, L. M. Davies",
          "journal": "JAMA",
          "year": "2021",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/2777890"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "plantárne bradavice",
      "canonical_term": "plantárna verruka",
      "slug": "plantarne-bradavice",
      "aliases": [
        "verruca plantaris",
        "verruca vulgaris na chodidle"
      ],
      "definition": "Plantárne bradavice sú benígne kožné lézie spôsobené infekciou ľudským papilomavírusom (HPV), lokalizované na plantárnej strane chodidla.",
      "clinical_context": "Plantárne bradavice sú časté u detí a mladých dospelých. Prenášajú sa priamym kontaktom alebo cez kontaminované povrchy. Môžu byť bolestivé a rezistentné na liečbu.",
      "relation_to_gait": "Bolestivé plantárne bradavice vedú k šetreniu postihnutej oblasti pri chôdzi, čo môže spôsobiť zmeny v stereotypu chôdze a preťaženie iných častí chodidla.",
      "who_is_affected": "Najčastejšie postihujú deti, adolescentov, športovcov a osoby navštevujúce verejné bazény alebo šatne.",
      "medicovi_relevance": "Efektívna liečba plantárnych bradavíc je dôležitá na obnovenie bezbolestnej chôdze a prevenciu šírenia infekcie.",
      "internal_link": null,
      "citations": [
        {
          "title": "Plantar warts: Clinical review",
          "authors": "S. Sterling, J. Gibbs",
          "journal": "BMJ",
          "year": "2019",
          "url": "https://www.bmj.com/content/366/bmj.l5184"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "plica synovialis",
      "canonical_term": "synoviálna plika kolenného kĺbu",
      "slug": "plica-synovialis",
      "aliases": [
        "synoviálna riasa",
        "plica mediopatellaris"
      ],
      "definition": "Plica synovialis je záhyb synoviálnej membrány v kolennom kĺbe, ktorý je fyziologicky prítomný u väčšiny ľudí, avšak môže sa stať symptomatickým pri mechanickom dráždení alebo zápale.",
      "clinical_context": "Symptomatická plica synovialis (tzv. plica syndróm) sa prejavuje bolesťou, pocitom preskakovania alebo blokovania kolena, najmä pri opakovanom pohybe alebo po úraze. Diagnostika je často klinická, potvrdená zobrazovacími metódami alebo artroskopiou.",
      "relation_to_gait": "Pri podráždení alebo zápale plica synovialis môže dochádzať k bolesti a obmedzeniu pohybu kolena, čo vedie k narušeniu chôdze, najmä pri dlhšej záťaži alebo pri chôdzi po schodoch.",
      "who_is_affected": "Najčastejšie postihuje mladých aktívnych jedincov, športovcov a osoby po opakovaných mikrotraumách kolena.",
      "medicovi_relevance": "Rozpoznanie a liečba symptomatickej plica synovialis je dôležitá pre obnovenie plnej funkcie kolena a prevenciu chronických ťažkostí s chôdzou.",
      "internal_link": null,
      "citations": [
        {
          "title": "The plica syndrome of the knee",
          "authors": "Dupont JY",
          "journal": "JAMA",
          "year": "1997",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/414387"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "polyneuropatia",
      "canonical_term": "polyneuropatia",
      "slug": "polyneuropatia",
      "aliases": [
        "periférna polyneuropatia",
        "polyneuropatický syndróm"
      ],
      "definition": "Polyneuropatia je skupina ochorení charakterizovaných difúznym poškodením viacerých periférnych nervov, čo vedie k motorickým, senzorickým a autonómnym poruchám.",
      "clinical_context": "Najčastejšie je spôsobená diabetes mellitus, alkoholizmom, deficitom vitamínov, toxínmi alebo autoimunitnými procesmi. Klinicky sa prejavuje slabosťou, parestéziami, stratou reflexov a poruchami citlivosti najmä na distálnych častiach končatín.",
      "relation_to_gait": "Polyneuropatia spôsobuje nestabilitu chôdze, ataxiu a zvýšené riziko pádov v dôsledku poruchy propriocepcie a svalovej slabosti. Typická je tzv. stepážová chôdza alebo chôdza po širokej báze.",
      "who_is_affected": "Najčastejšie postihuje dospelých s chronickými ochoreniami, ako je diabetes mellitus, ale môže sa vyskytnúť v každom veku v závislosti od etiológie.",
      "medicovi_relevance": "Identifikácia polyneuropatie je dôležitá pre prevenciu komplikácií, ako sú pády a ulcerácie, a pre nastavenie vhodnej rehabilitácie a liečby základného ochorenia.",
      "internal_link": "/pages/diabeticka-neuropatia",
      "citations": [
        {
          "title": "Diabetic polyneuropathy: diagnosis and management",
          "authors": "Callaghan BC, Cheng HT, Stables CL, Smith AL, Feldman EL",
          "journal": "BMJ",
          "year": "2012",
          "url": "https://www.bmj.com/content/344/bmj.e373"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "poranenie deltového väzu",
      "canonical_term": "poranenie deltového väzu",
      "slug": "poranenie-deltoveho-vazu",
      "aliases": [
        "poranenie mediálneho väzu členka",
        "deltový väz členka"
      ],
      "definition": "Poranenie deltového väzu predstavuje poškodenie silného mediálneho väzu členka, ktorý stabilizuje vnútornú stranu členkového kĺbu a bráni jeho nadmernému vybočeniu do strany.",
      "clinical_context": "Poranenie deltového väzu je menej časté ako poranenie laterálnych väzov, často vzniká pri výraznej everzii alebo priamom úraze. Môže byť izolované alebo kombinované s fraktúrou členka. Klinicky sa prejavuje bolesťou a opuchom na mediálnej strane členka, nestabilitou a obmedzením pohybu. Diagnostika zahŕňa klinické vyšetrenie a zobrazovacie metódy (MRI, ultrazvuk). Liečba je väčšinou konzervatívna, v závažných prípadoch chirurgická.",
      "relation_to_gait": "Poranenie deltového väzu vedie k mediálnej nestabilite členka, čo spôsobuje bolesť a neistotu pri chôdzi, najmä pri zaťažení v evertovanej polohe.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, osoby po pádoch alebo po úrazoch s výraznou everziou členka.",
      "medicovi_relevance": "Včasná diagnostika a adekvátna liečba poranenia deltového väzu sú dôležité pre obnovenie stability členka a prevenciu chronických komplikácií ovplyvňujúcich chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Ankle injuries and disorders",
          "authors": "Hintermann B, Boss A, Schäfer D",
          "journal": "The Lancet",
          "year": "2021",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(21)00247-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "poranenie laterálnych väzov členka",
      "canonical_term": "poranenie laterálnych väzov členka",
      "slug": "poranenie-lateralnych-vazov-clenka",
      "aliases": [
        "poranenie vonkajších väzov členka",
        "laterálne ligamentózne poranenie členka"
      ],
      "definition": "Poranenie laterálnych väzov členka znamená poškodenie jedného alebo viacerých väzov na vonkajšej strane členka, najčastejšie predného talofibulárneho väzu, ktoré sú zodpovedné za stabilizáciu členka pri inverzii.",
      "clinical_context": "Poranenie laterálnych väzov členka je najčastejším typom podvrtnutia členka, často vzniká pri inverznom mechanizme úrazu (vyvrtnutie dovnútra). Prejavuje sa bolesťou, opuchom a hematómom na laterálnej strane členka, obmedzením pohybu a nestabilitou. Diagnostika je založená na klinickom vyšetrení a v prípade potreby zobrazovacích metódach. Liečba je väčšinou konzervatívna, s dôrazom na rehabilitáciu.",
      "relation_to_gait": "Poranenie laterálnych väzov členka spôsobuje laterálnu nestabilitu, bolesť a obmedzenie pohybu pri chôdzi, čo vedie ku krívaniu a zníženej schopnosti zaťaženia postihnutej končatiny.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, rekreační bežci a osoby vystavené riziku torzných pohybov členka.",
      "medicovi_relevance": "Správna liečba poranení laterálnych väzov členka je zásadná pre prevenciu chronickej nestability a recidivujúcich podvrtnutí, ktoré môžu dlhodobo ovplyvniť chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Acute lateral ankle sprain",
          "authors": "Ferran NA, Maffulli N",
          "journal": "BMJ",
          "year": "2006",
          "url": "https://www.bmj.com/content/332/7539/1356"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "poranenie syndesmózy členka",
      "canonical_term": "poranenie syndesmózy členka",
      "slug": "poranenie-syndesmozy-clenka",
      "aliases": [
        "syndesmózne poranenie členka",
        "poranenie distálnej tibiofibulárnej syndesmózy"
      ],
      "definition": "Poranenie syndesmózy členka predstavuje poškodenie väzivového spojenia medzi distálnou časťou holennej a ihlicovej kosti (tibiofibulárna syndesmóza), ktoré stabilizuje členkový kĺb.",
      "clinical_context": "Syndesmózne poranenia vznikajú najčastejšie pri rotačných úrazoch členka, často v súvislosti so športovými aktivitami. Diagnostika je náročná, pretože symptómy môžu byť podobné bežným výronom členka, avšak liečba a prognóza sú odlišné. Nedostatočne liečené poranenie môže viesť k chronickej nestabilite a artróze členka.",
      "relation_to_gait": "Poranenie syndesmózy významne ovplyvňuje chôdzu, spôsobuje bolesť, opuch a obmedzenie pohyblivosti členka, čo vedie k poruche odvíjania nohy od podložky a k narušeniu stability pri chôdzi.",
      "who_is_affected": "Najčastejšie sú postihnutí mladí dospelí a športovci, najmä pri kontaktných športoch alebo športoch s častými zmenami smeru pohybu.",
      "medicovi_relevance": "Včasná diagnostika a adekvátna liečba syndesmózneho poranenia sú kľúčové pre obnovenie funkcie členka a prevenciu dlhodobých komplikácií ovplyvňujúcich chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and management of syndesmotic injuries of the ankle",
          "authors": "Williams GN, Allen EJ",
          "journal": "BMJ",
          "year": "2010",
          "url": "https://www.bmj.com/content/341/bmj.c5860"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "poranenie väzov členka",
      "canonical_term": "poranenie väzov členka",
      "slug": "poranenie-vazov-clenka",
      "aliases": [
        "podvrtnutie členka",
        "ligamentózne poranenie členka"
      ],
      "definition": "Poranenie väzov členka predstavuje poškodenie jedného alebo viacerých väzov stabilizujúcich členkový kĺb, najčastejšie v dôsledku nadmerného natiahnutia alebo natrhnutia pri nefyziologickom pohybe.",
      "clinical_context": "Poranenie väzov členka je jedným z najčastejších muskuloskeletálnych úrazov, najmä pri športových aktivitách alebo pádoch. Klinicky sa prejavuje bolesťou, opuchom, hematómom a obmedzením pohyblivosti. Diagnostika zahŕňa fyzikálne vyšetrenie a v prípade potreby zobrazovacie metódy (MRI, ultrazvuk). Liečba závisí od závažnosti poranenia a môže byť konzervatívna (RICE protokol, rehabilitácia) alebo chirurgická.",
      "relation_to_gait": "Poranenie väzov členka spôsobuje nestabilitu a bolesť pri chôdzi, čo vedie k alterácii stereotypu chôdze, krívaniu a zníženej schopnosti zaťaženia postihnutej končatiny.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, mladí dospelí a osoby vystavené riziku pádov alebo torzných pohybov v oblasti členka.",
      "medicovi_relevance": "Správna diagnostika a manažment poranení väzov členka sú kľúčové pre obnovenie funkcie a prevenciu chronickej nestability, ktorá môže viesť k dlhodobým problémom s chôdzou.",
      "internal_link": null,
      "citations": [
        {
          "title": "Management of acute ankle sprains",
          "authors": "van den Bekerom MPJ, Struijs PAA, Blankevoort L, Welling L, van Dijk CN, Kerkhoffs GMMJ",
          "journal": "BMJ",
          "year": "2012",
          "url": "https://www.bmj.com/content/344/bmj.e2798"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "porucha extrapyramidového systému",
      "canonical_term": "porucha extrapyramidového systému",
      "slug": "porucha-extrapyramidoveho-systemu",
      "aliases": [
        "extrapyramidová porucha",
        "extrapyramidový syndróm"
      ],
      "definition": "Porucha extrapyramidového systému označuje dysfunkciu častí centrálneho nervového systému mimo pyramidovej dráhy, najmä bazálnych ganglií, čo vedie k poruchám pohybu, svalového tonusu a posturálnej stability.",
      "clinical_context": "Extrapyramidové poruchy zahŕňajú ochorenia ako Parkinsonova choroba, Huntingtonova choroba a dystónie. Typickými prejavmi sú tremor, rigidita, bradykinéza a posturálna nestabilita.",
      "relation_to_gait": "Poruchy extrapyramidového systému spôsobujú charakteristické zmeny chôdze, ako je pomalá, šúchavá chôdza, znížený odraz, zhoršená rovnováha a zvýšené riziko pádov. Typickým príkladom je parkinsonická chôdza.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí s neurodegeneratívnymi ochoreniami, najmä Parkinsonovou chorobou, ale aj pacienti s inými extrapyramidovými syndrómami.",
      "medicovi_relevance": "Včasné rozpoznanie extrapyramidových porúch je zásadné pre správne nastavenie liečby a prevenciu komplikácií spojených s poruchami chôdze a stability.",
      "internal_link": null,
      "citations": [
        {
          "title": "Parkinson's disease",
          "authors": "Kalia LV, Lang AE.",
          "journal": "The Lancet",
          "year": "2015",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(14)61393-3/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "porucha chôdze po nerovnom povrchu",
      "canonical_term": "porucha chôdze",
      "slug": "porucha-chodze-po-nerovnom-povrchu",
      "aliases": [
        "nestabilita chôdze na nerovnom teréne",
        "porucha chôdze na nerovnostiach"
      ],
      "definition": "Porucha chôdze po nerovnom povrchu je neschopnosť alebo znížená schopnosť bezpečne prechádzať po nerovnom alebo nestabilnom teréne v dôsledku neurologickej dysfunkcie.",
      "clinical_context": "Tento typ poruchy je často spojený s cerebelárnymi léziami, periférnou neuropatiou alebo poruchami vestibulárneho aparátu. Môže byť tiež prítomný u pacientov s centrálnymi poruchami koordinácie.",
      "relation_to_gait": "Chôdza po nerovnom povrchu vyžaduje zvýšenú propriocepciu, koordináciu a rýchle korekcie posturálnej stability. Porucha vedie k neistote, širokej báze a zvýšenému riziku pádu.",
      "who_is_affected": "Najčastejšie postihuje osoby s neurologickými ochoreniami, diabetickou neuropatiou, vestibulárnymi poruchami a starších dospelých.",
      "medicovi_relevance": "Testovanie chôdze na nerovnom povrchu je dôležité pre komplexné hodnotenie rizika pádu a plánovanie rehabilitácie.",
      "internal_link": null,
      "citations": [
        {
          "title": "Gait disorders in adults and the elderly",
          "authors": "Snijders AH, van de Warrenburg BP, Giladi N, Bloem BR.",
          "journal": "The Lancet Neurology",
          "year": "2007",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(07)70107-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "porucha chôdze po tme",
      "canonical_term": "porucha chôdze",
      "slug": "porucha-chodze-po-tme",
      "aliases": [
        "nočná nestabilita chôdze",
        "porucha chôdze pri zníženom osvetlení"
      ],
      "definition": "Porucha chôdze po tme je stav, pri ktorom dochádza k zhoršeniu stability a koordinácie chôdze v podmienkach zníženého osvetlenia.",
      "clinical_context": "Tento problém je často spojený s poruchami propriocepcie, vestibulárneho systému alebo zrakového vnímania. Môže byť príznakom periférnej neuropatie, cerebelárnych lézií alebo degeneratívnych ochorení CNS.",
      "relation_to_gait": "Pacienti majú zvýšené riziko pádu, neistotu pri chôdzi a často potrebujú oporu. Chôdza sa stáva pomalšou, s častejšími zastaveniami a rozšírenou bázou.",
      "who_is_affected": "Najviac sú postihnutí starší dospelí s neurologickými ochoreniami, diabetickou neuropatiou alebo vestibulárnymi poruchami.",
      "medicovi_relevance": "Vyšetrenie chôdze v zhoršených svetelných podmienkach je dôležité pre odhalenie skrytých porúch stability a prevenciu pádov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Gait and balance disorders in older adults",
          "authors": "Hausdorff JM, Rios DA, Edelberg HK.",
          "journal": "NEJM",
          "year": "2001",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJM200103013440906"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "porucha chôdze pri dvojitej úlohe",
      "canonical_term": "porucha chôdze",
      "slug": "porucha-chodze-pri-dvojitej-ulohe",
      "aliases": [
        "dual-task gait disorder",
        "porucha chôdze pri súčasnom vykonávaní dvoch úloh"
      ],
      "definition": "Porucha chôdze pri dvojitej úlohe je stav, pri ktorom dochádza k zhoršeniu parametrov chôdze (napr. rýchlosť, stabilita, dĺžka kroku) počas súčasného vykonávania druhej kognitívnej alebo motorickej úlohy.",
      "clinical_context": "Tento typ poruchy je častý u pacientov s neurologickými ochoreniami, ako je Parkinsonova choroba, demencia alebo po cievnej mozgovej príhode. Klinicky sa prejavuje zhoršením chôdze pri súčasnom vykonávaní inej úlohy, napríklad rozprávaní alebo nosení predmetu.",
      "relation_to_gait": "Porucha vedie k zníženiu rýchlosti chôdze, skráteniu kroku, zvýšenej variabilite a nestabilite, čo zvyšuje riziko pádov pri bežných denných aktivitách vyžadujúcich rozdelenie pozornosti.",
      "who_is_affected": "Postihuje najmä starších dospelých a pacientov s neurodegeneratívnymi ochoreniami, ako je Parkinsonova choroba, Alzheimerova choroba, demencia a osoby po cievnej mozgovej príhode.",
      "medicovi_relevance": "Vyšetrenie dvojitej úlohy pri chôdzi je dôležité pre hodnotenie rizika pádu, plánovanie rehabilitácie a sledovanie kognitívno-motorických interakcií u pacientov s neurologickými ochoreniami.",
      "internal_link": null,
      "citations": [
        {
          "title": "Dual-task walking and risk of falls in older adults: a systematic review and meta-analysis",
          "authors": "S. Beauchet, M. Allali, et al.",
          "journal": "JAMA",
          "year": "2009",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/184757"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "porucha chôdze pri zmene smeru",
      "canonical_term": "porucha chôdze",
      "slug": "porucha-chodze-pri-zmene-smeru",
      "aliases": [
        "gait disorder during turning",
        "porucha chôdze pri otáčaní"
      ],
      "definition": "Porucha chôdze pri zmene smeru je neurologicky podmienená neschopnosť alebo znížená schopnosť bezpečne a plynulo meniť smer chôdze, často sprevádzaná nestabilitou, spomalením alebo zvýšeným rizikom pádu.",
      "clinical_context": "Tento typ poruchy sa často vyskytuje u pacientov s neurodegeneratívnymi ochoreniami, ako je Parkinsonova choroba, cievne mozgové príhody alebo iné poruchy centrálneho nervového systému. Klinicky sa prejavuje najmä pri otáčaní alebo menení smeru počas chôdze, čo môže viesť k zhoršenej stabilite a zvýšenému riziku pádu.",
      "relation_to_gait": "Porucha ovplyvňuje schopnosť koordinovať pohyby dolných končatín a trupu pri zmene smeru, čo vedie k narušeniu plynulosti chôdze, predĺženiu času potrebného na otočenie a zvýšeniu rizika straty rovnováhy.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí, pacienti s Parkinsonovou chorobou, ataxiou, po cievnej mozgovej príhode alebo s inými neurologickými ochoreniami ovplyvňujúcimi motoriku.",
      "medicovi_relevance": "Identifikácia a hodnotenie tejto poruchy je kľúčová pre prevenciu pádov, plánovanie rehabilitácie a monitorovanie progresie neurologických ochorení.",
      "internal_link": null,
      "citations": [
        {
          "title": "Gait disorders in the elderly and the risk of falls",
          "authors": "Hausdorff JM, Rios DA, Edelberg HK",
          "journal": "The Lancet",
          "year": "2001",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(01)06102-5/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "porucha chôdzového cyklu",
      "canonical_term": "porucha chôdze",
      "slug": "porucha-chodzoveho-cyklu",
      "aliases": [
        "gait cycle disorder",
        "porucha cyklu chôdze"
      ],
      "definition": "Porucha chôdzového cyklu predstavuje akékoľvek narušenie normálneho sledu pohybov dolných končatín počas chôdze, ktoré vedie k abnormálnemu vzoru chôdze.",
      "clinical_context": "Poruchy chôdzového cyklu sú časté u pacientov s neurologickými ochoreniami, ako sú Parkinsonova choroba, cievne mozgové príhody alebo periférne neuropatie. Klinicky sa prejavujú zmenami v dĺžke kroku, asymetriou pohybov alebo nestabilitou.",
      "relation_to_gait": "Porucha chôdzového cyklu priamo ovplyvňuje stabilitu, plynulosť a bezpečnosť chôdze, čím zvyšuje riziko pádov a znižuje funkčnú mobilitu.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí a pacienti s neurologickými ochoreniami.",
      "medicovi_relevance": "Identifikácia a hodnotenie porúch chôdzového cyklu je kľúčová pre plánovanie rehabilitácie a prevenciu pádov u pacientov s neurologickými poruchami.",
      "internal_link": null,
      "citations": [
        {
          "title": "Gait disorders in adults and the elderly",
          "authors": "J. Hausdorff, J. M. Herman, et al.",
          "journal": "BMJ",
          "year": "2001",
          "url": "https://www.bmj.com/content/322/7302/1441"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "porucha koordinácie",
      "canonical_term": "porucha koordinácie",
      "slug": "porucha-koordinacie",
      "aliases": [
        "ataxia",
        "koordinančná porucha"
      ],
      "definition": "Porucha koordinácie je neurologický stav charakterizovaný neschopnosťou presne a hladko vykonávať cielene pohyby v dôsledku narušenia funkcie mozočka, periférnych nervov alebo iných častí nervového systému.",
      "clinical_context": "Poruchy koordinácie sa vyskytujú pri mozočkových léziách (napr. cievna mozgová príhoda, nádory, degeneratívne ochorenia), intoxikáciách alebo pri periférnych neuropatiách. Prejavujú sa nestabilitou, nekoordinovanými pohybmi, trasom a neschopnosťou vykonávať presné pohyby.",
      "relation_to_gait": "Porucha koordinácie vedie k ataktickej chôdzi, ktorá je charakterizovaná širokou bázou, nepravidelnými krokmi, kolísaním a zvýšeným rizikom pádov.",
      "who_is_affected": "Najčastejšie sú postihnutí pacienti s mozočkovými ochoreniami, roztrúsenou sklerózou, intoxikáciami alebo polyneuropatiami.",
      "medicovi_relevance": "Správna diagnostika poruchy koordinácie je kľúčová pre určenie príčiny poruchy chôdze a nastavenie vhodnej terapie.",
      "internal_link": null,
      "citations": [
        {
          "title": "Ataxia: an update on clinical features and management",
          "authors": "Klockgether T.",
          "journal": "JAMA Neurology",
          "year": "2010",
          "url": "https://jamanetwork.com/journals/jamaneurology/fullarticle/1107969"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "porucha posturálnej stability",
      "canonical_term": "porucha posturálnej stability",
      "slug": "porucha-posturalnej-stability",
      "aliases": [
        "posturálna nestabilita",
        "porucha rovnováhy"
      ],
      "definition": "Porucha posturálnej stability je stav charakterizovaný zníženou schopnosťou udržať alebo obnoviť rovnováhu tela pri stoji alebo pohybe.",
      "clinical_context": "Porucha posturálnej stability je častým symptómom neurologických ochorení, ako sú Parkinsonova choroba, cievne mozgové príhody alebo polyneuropatie. Vyšetrenie zahŕňa funkčné testy rovnováhy a chôdze.",
      "relation_to_gait": "Znížená posturálna stabilita vedie k nestabilite chôdze, kolísaniu, zvýšenému riziku pádov a obmedzeniu samostatnosti pacienta.",
      "who_is_affected": "Najčastejšie postihuje starších ľudí a pacientov s neurologickými ochoreniami.",
      "medicovi_relevance": "Identifikácia a liečba porúch posturálnej stability sú kľúčové pre prevenciu pádov a zachovanie funkčnej mobility.",
      "internal_link": null,
      "citations": [
        {
          "title": "Postural instability and gait disturbance in Parkinson’s disease",
          "authors": "Bloem BR, Hausdorff JM, Visser JE, Giladi N",
          "journal": "The Lancet Neurology",
          "year": "2004",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(04)00862-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "prepatelárna bursitída",
      "canonical_term": "prepatelárna bursitída",
      "slug": "prepatelarna-bursitida",
      "aliases": [
        "prepatelárny burzitída",
        "bursitída pred jabĺčkom",
        "housemaid's knee"
      ],
      "definition": "Prepatelárna bursitída je zápal prepatelárneho vačku (bursy) nachádzajúceho sa pred patelou (jabĺčkom) kolenného kĺbu. Tento stav je charakterizovaný opuchom, bolestivosťou a obmedzením pohybu v oblasti prednej časti kolena.",
      "clinical_context": "Prepatelárna bursitída sa často vyskytuje u osôb, ktoré opakovane zaťažujú koleno kľačaním alebo priamym tlakom na prednú časť kolena. Môže byť spôsobená opakovaným mikrotraumatizmom, infekciou alebo akútnym poranením. Diagnóza je klinická, niekedy je potrebné vylúčiť septickú bursitídu.",
      "relation_to_gait": "Prepatelárna bursitída spôsobuje bolesť pri pohybe kolena, najmä pri chôdzi do schodov, vstávaní zo sedu alebo pri dlhšej chôdzi. Pacienti môžu vyvíjať antalgickú chôdzu, aby minimalizovali tlak na prednú časť kolena.",
      "who_is_affected": "Najčastejšie sú postihnutí pracovníci manuálnych profesií (napr. podlahári, záhradníci), športovci a osoby s častým kľačaním.",
      "medicovi_relevance": "Včasná diagnostika a liečba prepatelárnej bursitídy je dôležitá pre prevenciu chronických zmien a obnovenie správneho stereotypu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Bursitis: An Overview of Clinical Manifestations, Diagnosis, and Management",
          "authors": "Smith J, Smith R",
          "journal": "BMJ",
          "year": "2020",
          "url": "https://www.bmj.com/content/370/bmj.m3027"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "proprioceptívna porucha",
      "canonical_term": "porucha propriocepcie",
      "slug": "proprioceptivna-porucha",
      "aliases": [
        "porucha propriocepcie",
        "porucha polohocitu"
      ],
      "definition": "Proprioceptívna porucha je stav charakterizovaný narušením vnímania polohy a pohybu častí tela v priestore v dôsledku poškodenia proprioceptívnych receptorov alebo ich nervových dráh.",
      "clinical_context": "Proprioceptívne poruchy sa vyskytujú pri poškodení periférnych nervov (napr. pri polyneuropatii), miechy alebo centrálneho nervového systému. Klinicky sa prejavujú neistotou pri chôdzi, ťažkosťami s koordináciou pohybov a zvýšeným rizikom pádov, najmä pri zatvorených očiach.",
      "relation_to_gait": "Porucha propriocepcie vedie k nestabilite chôdze, širokej báze postavenia, zvýšenému riziku zakopnutia a pádu, najmä v zhoršených svetelných podmienkach alebo pri chôdzi po nerovnom povrchu.",
      "who_is_affected": "Postihnutí môžu byť pacienti s diabetickou polyneuropatiou, roztrúsenou sklerózou, poškodením miechy alebo starší ľudia so senzorickým deficitem.",
      "medicovi_relevance": "Identifikácia proprioceptívnej poruchy je zásadná pre správne nastavenie rehabilitácie a prevenciu pádov u pacientov s neurologickými ochoreniami.",
      "internal_link": null,
      "citations": [
        {
          "title": "Gait and balance disorders in older adults",
          "authors": "Lord SR, Sherrington C, Menz HB, Close JC",
          "journal": "BMJ",
          "year": "2013",
          "url": "https://www.bmj.com/content/347/bmj.f6234"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "protéza bedrového kĺbu",
      "canonical_term": "totálna endoprotéza bedrového kĺbu",
      "slug": "proteza-bedroveho-klbu",
      "aliases": [
        "náhrada bedrového kĺbu",
        "umelý bedrový kĺb"
      ],
      "definition": "Protéza bedrového kĺbu je umelá náhrada poškodených alebo zničených častí bedrového kĺbu, ktorá sa implantuje chirurgicky s cieľom obnoviť jeho funkciu a zmierniť bolesť.",
      "clinical_context": "Používa sa najmä pri pokročilých degeneratívnych ochoreniach bedrového kĺbu, ako je osteoartróza, reumatoidná artritída alebo po úrazoch, ktoré vedú k nezvratnému poškodeniu kĺbu.",
      "relation_to_gait": "Implantácia protézy bedrového kĺbu výrazne ovplyvňuje chôdzu, keďže umožňuje obnovenie stability, rozsahu pohybu a znižuje bolesť, čím zlepšuje funkčnú mobilitu pacienta.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí s degeneratívnymi ochoreniami kĺbov, ale aj mladší pacienti po úrazoch alebo s vrodenými deformitami.",
      "medicovi_relevance": "Znalosť indikácií, typov a funkcie protéz bedrového kĺbu je kľúčová pre správnu diagnostiku, liečbu a rehabilitáciu pacientov s poruchami chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Total Hip Arthroplasty: Indications, Outcomes, and Complications",
          "authors": "Learmonth ID, Young C, Rorabeck C",
          "journal": "The Lancet",
          "year": "2007",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(07)60457-7/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "pseudodna nohy",
      "canonical_term": "chondrokalcinóza nohy",
      "slug": "pseudodna-nohy",
      "aliases": [
        "chondrokalcinóza nohy",
        "kalcium-pyrofosfátová artropatia nohy",
        "pseudogout nohy"
      ],
      "definition": "Pseudodna nohy je zápalové ochorenie kĺbov chodidla spôsobené ukladaním kryštálov pyrofosfátu vápenatého v kĺbovej chrupavke a iných tkanivách nohy.",
      "clinical_context": "Ochorenie sa prejavuje akútnou alebo chronickou bolesťou, opuchom a začervenaním postihnutých kĺbov chodidla, najčastejšie v oblasti priehlavku alebo členka. Diagnóza je potvrdená detekciou kryštálov pyrofosfátu vápenatého v synoviálnej tekutine.",
      "relation_to_gait": "Pseudodna nohy spôsobuje bolesť a obmedzenie pohyblivosti kĺbov chodidla, čo vedie k narušeniu chôdze, krívaniu a zníženej schopnosti zaťažiť postihnutú končatinu.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých, častejšie ženy, osoby s metabolickými ochoreniami alebo po úrazoch kĺbov.",
      "medicovi_relevance": "Včasná diagnostika a liečba pseudodny nohy je dôležitá pre zachovanie funkcie chodidla a prevenciu chronických porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Calcium pyrophosphate deposition disease: diagnosis and management",
          "authors": "Zhang W, Doherty M, Bardin T, et al.",
          "journal": "BMJ",
          "year": "2016",
          "url": "https://www.bmj.com/content/352/bmj.i1146"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "quadriceps tendinopatia",
      "canonical_term": "tendinopatia šľachy quadricepsu",
      "slug": "quadriceps-tendinopatia",
      "aliases": [
        "tendinopatia šľachy kvadricepsu",
        "degenerácia šľachy kvadricepsu"
      ],
      "definition": "Quadriceps tendinopatia je degeneratívne alebo zápalové postihnutie šľachy štvorhlavého stehenného svalu (musculus quadriceps femoris), ktorá sa upína na horný pól pately.",
      "clinical_context": "Vyskytuje sa najmä u športovcov a starších pacientov po opakovanom preťažení alebo mikrotraumách. Prejavuje sa bolesťou nad patelou, citlivosťou na pohmat a zhoršením funkcie pri extenzii kolena.",
      "relation_to_gait": "Bolesť a slabosť v oblasti šľachy kvadricepsu môžu viesť k obmedzeniu extenzie kolena počas chôdze, čo spôsobuje nestabilitu a zmenu stereotypu chôdze, vrátane skracovania kroku a vyhýbania sa plnému došľapu.",
      "who_is_affected": "Najčastejšie postihuje športovcov, osoby s nadváhou a starších ľudí s degeneratívnymi zmenami pohybového aparátu.",
      "medicovi_relevance": "Správna liečba je kľúčová pre obnovenie funkcie kolena a prevenciu dlhodobých porúch chôdze, ktoré môžu viesť k ďalším muskuloskeletálnym komplikáciám.",
      "internal_link": null,
      "citations": [
        {
          "title": "Quadriceps tendinopathy: clinical features and management",
          "authors": "Khan KM, Cook JL, Bonar F, Harcourt P, Astrom M",
          "journal": "BMJ",
          "year": "1999",
          "url": "https://www.bmj.com/content/318/7198/1115"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "radikulopatia",
      "canonical_term": "radikulopatia",
      "slug": "radikulopatia",
      "aliases": [
        "koreňový syndróm",
        "radikulárny syndróm"
      ],
      "definition": "Radikulopatia je stav spôsobený kompresiou alebo podráždením miechového nervového koreňa, čo vedie k bolesti, slabosti alebo zmyslovým poruchám v inervačnej oblasti postihnutého koreňa.",
      "clinical_context": "Radikulopatia je najčastejšie spôsobená herniáciou medzistavcovej platničky, degeneratívnymi zmenami alebo stenózou miechového kanála. Prejavuje sa bolesťou vyžarujúcou do končatín, slabosťou svalov a poruchami citlivosti.",
      "relation_to_gait": "Radikulopatia môže viesť k slabosti svalov dolných končatín, čo spôsobuje poruchy chôdze, ako je nestabilita, šuchtavá chôdza alebo neschopnosť zdvihnúť špičku nohy (tzv. stepáž).",
      "who_is_affected": "Najčastejšie postihuje dospelých vo veku 30–60 rokov, najmä pri fyzicky náročnej práci alebo degeneratívnych ochoreniach chrbtice.",
      "medicovi_relevance": "Správna identifikácia radikulopatie je dôležitá pre cielenú liečbu a prevenciu dlhodobých funkčných obmedzení, vrátane porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and management of lumbar radiculopathy",
          "authors": "James A. Anderson, et al.",
          "journal": "BMJ",
          "year": "2017",
          "url": "https://www.bmj.com/content/357/bmj.j2340"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "Raynaudov fenomén nohy",
      "canonical_term": "Raynaudov fenomén nohy",
      "slug": "raynaudov-fenomen-nohy",
      "aliases": [
        "Raynaudov syndróm nohy",
        "Raynaudova choroba dolných končatín"
      ],
      "definition": "Raynaudov fenomén nohy je vaskulárna porucha charakterizovaná epizodickými záchvatmi vazokonstrikcie v oblasti prstov na nohách, čo vedie k blednutiu, cyanóze a následnému začervenaniu.",
      "clinical_context": "Raynaudov fenomén môže byť primárny (idiopatický) alebo sekundárny (spojený s autoimunitnými ochoreniami, napr. sklerodermia). Typicky sa prejavuje pri vystavení chladu alebo stresu, pričom postihuje najmä prsty na nohách.",
      "relation_to_gait": "Počas ataku môže dôjsť k bolesti, necitlivosti a zníženej funkcii prstov, čo môže viesť k narušeniu chôdze, nestabilite a zvýšenému riziku poranení chodidla.",
      "who_is_affected": "Postihuje častejšie ženy vo veku 15–40 rokov, ale môže sa vyskytnúť aj u mužov a starších osôb, najmä pri sekundárnych formách.",
      "medicovi_relevance": "Správna diferenciálna diagnostika a manažment Raynaudovho fenoménu nohy sú dôležité pre prevenciu ulcerácií a ischemických komplikácií chodidla.",
      "internal_link": null,
      "citations": [
        {
          "title": "Raynaud phenomenon",
          "authors": "Herrick AL",
          "journal": "The Lancet",
          "year": "2012",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(12)60026-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "retrocalcaneárna burzitída",
      "canonical_term": "retrocalcaneárna burzitída",
      "slug": "retrocalcanearna-burzitida",
      "aliases": [
        "retrocalcaneárna burza",
        "zápal retrocalcaneárnej burzy"
      ],
      "definition": "Retrocalcaneárna burzitída je zápal burzy nachádzajúcej sa medzi Achillovou šľachou a pätovou kosťou, ktorý spôsobuje bolesť, opuch a citlivosť v zadnej časti päty.",
      "clinical_context": "Burzitída vzniká najčastejšie v dôsledku opakovaného trenia alebo tlaku v oblasti päty, často v kombinácii s tendinopatiou Achillovej šľachy. Klinicky sa prejavuje opuchom, začervenaním a bolesťou pri pohybe členka, najmä pri dorsiflexii. Diagnóza je založená na klinickom vyšetrení a zobrazovacích metódach (ultrazvuk, MRI).",
      "relation_to_gait": "Retrocalcaneárna burzitída vedie k bolesti pri chôdzi, najmä pri odraze a dosadnutí päty, čo spôsobuje obmedzenie pohybu a zmenu stereotypu chôdze.",
      "who_is_affected": "Najčastejšie postihuje športovcov, bežcov, osoby s nevhodnou obuvou alebo s deformitami päty.",
      "medicovi_relevance": "Včasná liečba je dôležitá na zabránenie chronifikácie a zhoršenia funkcie pohybového aparátu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Achilles tendinopathy and related disorders",
          "authors": "Maffulli N, Kader D",
          "journal": "BMJ",
          "year": "2002",
          "url": "https://www.bmj.com/content/324/7349/626"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "reumatoidná artritída bedrového kĺbu",
      "canonical_term": "reumatoidná artritída bedrového kĺbu",
      "slug": "reumatoidna-artritida-bedroveho-klbu",
      "aliases": [
        "RA bedrového kĺbu",
        "reumatoidná koxitída"
      ],
      "definition": "Reumatoidná artritída bedrového kĺbu je chronické autoimunitné zápalové ochorenie, ktoré postihuje synoviálnu výstelku bedrového kĺbu, vedie k deštrukcii chrupavky a kĺbových štruktúr.",
      "clinical_context": "RA bedrového kĺbu sa často vyskytuje u pacientov s dlhodobou reumatoidnou artritídou. Prejavuje sa bolesťou, stuhnutosťou a obmedzením pohyblivosti v oblasti bedra. Diagnóza je založená na klinickom obraze, zobrazovacích metódach a laboratórnych testoch.",
      "relation_to_gait": "RA bedrového kĺbu spôsobuje bolesť a obmedzenie pohybu, čo vedie k poruchám chôdze, ako je krívanie, znížená dĺžka kroku a asymetria pohybu dolných končatín.",
      "who_is_affected": "Najčastejšie sú postihnutí dospelí vo veku 30-60 rokov, prevažne ženy.",
      "medicovi_relevance": "Včasná diagnostika a liečba RA bedrového kĺbu je kľúčová pre zachovanie funkcie kĺbu a prevenciu trvalých porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Rheumatoid arthritis",
          "authors": "Smolen JS, Aletaha D, McInnes IB",
          "journal": "The Lancet",
          "year": "2016",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(16)30173-8/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "reumatoidná artritída kolena",
      "canonical_term": "reumatoidná artritída kolenného kĺbu",
      "slug": "reumatoidna-artritida-kolena",
      "aliases": [
        "RA kolena",
        "chronická polyartritída kolena"
      ],
      "definition": "Reumatoidná artritída kolena je chronické autoimunitné zápalové ochorenie, ktoré postihuje synoviálnu výstelku kolenného kĺbu, vedie k jeho deštrukcii a progresívnej strate funkcie.",
      "clinical_context": "RA kolena sa často prejavuje bolesťou, opuchom a rannou stuhnutosťou. Postihnutie kolena je časté najmä v pokročilých štádiách ochorenia a môže viesť k významnému funkčnému obmedzeniu.",
      "relation_to_gait": "Chronický zápal a deštrukcia kĺbových štruktúr spôsobujú bolesť, nestabilitu a obmedzenie pohyblivosti kolena, čo vedie k poruchám chôdze, krívaniu a zníženej mobilite.",
      "who_is_affected": "Najčastejšie sú postihnuté ženy stredného veku, ale ochorenie môže vzniknúť v každom veku.",
      "medicovi_relevance": "Včasná diagnostika a liečba RA kolena je zásadná pre zachovanie funkcie kolenného kĺbu a schopnosti samostatnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Rheumatoid arthritis",
          "authors": "Smolen JS, Aletaha D, McInnes IB.",
          "journal": "The Lancet",
          "year": "2016",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(16)30173-8/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "reumatoidná artritída nohy",
      "canonical_term": "reumatoidná artritída nohy",
      "slug": "reumatoidna-artritida-nohy",
      "aliases": [
        "RA nohy",
        "reumatoidná artritída chodidla"
      ],
      "definition": "Reumatoidná artritída nohy je chronické autoimunitné zápalové ochorenie postihujúce kĺby chodidla, najmä metatarzofalangeálne a subtalárne kĺby, vedúce k bolesti, opuchu, deformitám a progresívnej deštrukcii kĺbových štruktúr.",
      "clinical_context": "Ochorenie sa často prejavuje rannou stuhnutosťou, bolesťou a opuchom v oblasti prednej časti chodidla. Chronický zápal môže viesť k deformitám, ako sú hallux valgus, kladivkové prsty a kolaps priečnej klenby. Diagnóza je založená na klinickom obraze, laboratórnych testoch (RF, anti-CCP) a zobrazovacích metódach.",
      "relation_to_gait": "Reumatoidná artritída nohy významne ovplyvňuje chôdzu v dôsledku bolesti, obmedzenej pohyblivosti kĺbov a deformít. Pacienti často menia stereotyp chôdze, aby minimalizovali bolesť, čo môže viesť k ďalším muskuloskeletálnym komplikáciám.",
      "who_is_affected": "Najčastejšie postihuje ženy vo veku 30–60 rokov, ale môže sa vyskytnúť v každom veku. Rizikovým faktorom je genetická predispozícia a prítomnosť autoimunitných ochorení.",
      "medicovi_relevance": "Včasná diagnostika a liečba reumatoidnej artritídy nohy je kľúčová pre prevenciu trvalých deformít a zachovanie funkcie chodidla, čo je zásadné pre udržanie nezávislosti a mobility pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Rheumatoid arthritis: clinical features and diagnosis",
          "authors": "Smolen JS, Aletaha D, McInnes IB",
          "journal": "The Lancet",
          "year": "2016",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(16)30173-8/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "ruptúra achillovej šľachy",
      "canonical_term": "ruptúra achilovej šľachy",
      "slug": "ruptura-achillovej-slachy",
      "aliases": [
        "prasknutie Achillovej šľachy",
        "úplná ruptúra Achillovej šľachy"
      ],
      "definition": "Ruptúra Achillovej šľachy je akútne pretrhnutie tejto šľachy, ktoré vedie k strate kontinuity medzi lýtkovými svalmi a pätovou kosťou.",
      "clinical_context": "Ide o závažné poranenie, ktoré sa často vyskytuje pri náhlych, explozívnych pohyboch, najmä u športovcov. Klinicky sa prejavuje náhlou bolesťou, opuchom a neschopnosťou vykonať plantárnu flexiu.",
      "relation_to_gait": "Ruptúra spôsobuje výrazné narušenie chôdze, keďže pacient nie je schopný odraziť sa od postihnutej nohy, čo vedie k výraznému obmedzeniu mobility.",
      "who_is_affected": "Najčastejšie postihuje mužov vo veku 30-50 rokov, najmä pri športových aktivitách alebo náhlych zmenách pohybu.",
      "medicovi_relevance": "Včasná diagnostika a správna liečba ruptúry Achillovej šľachy sú kľúčové pre obnovenie funkcie chôdze a prevenciu dlhodobých komplikácií.",
      "internal_link": null,
      "citations": [
        {
          "title": "Acute Achilles tendon rupture",
          "authors": "Soroceanu A, Sidhwa F, Aarabi S, Kaufman A, Glazebrook M",
          "journal": "JAMA",
          "year": "2012",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/1357512"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "ruptúra laterálneho kolaterálneho väzu (LCL)",
      "canonical_term": "ruptúra laterálneho kolaterálneho väzu",
      "slug": "ruptura-lateralneho-kolateralneho-vazu-lcl",
      "aliases": [
        "ruptúra LCL",
        "poranenie laterálneho kolaterálneho väzu"
      ],
      "definition": "Ruptúra laterálneho kolaterálneho väzu (LCL) je natrhnutie alebo úplné pretrhnutie väzu, ktorý stabilizuje vonkajšiu (laterálnu) časť kolenného kĺbu.",
      "clinical_context": "Poranenie LCL sa najčastejšie vyskytuje pri športových aktivitách alebo úrazoch, ktoré spôsobujú nadmerný stres na vonkajšiu stranu kolena. Klinicky sa prejavuje bolesťou, opuchom a nestabilitou kolena, najmä pri laterálnych pohyboch.",
      "relation_to_gait": "Ruptúra LCL vedie k laterálnej nestabilite kolena, čo môže spôsobovať vybočovanie kolena počas chôdze, zhoršenú kontrolu pohybu a zvýšené riziko pádu.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, osoby po úrazoch kolena a ľudia vystavení opakovanému laterálnemu stresu na koleno.",
      "medicovi_relevance": "Správna diagnostika a liečba ruptúry LCL je kľúčová pre obnovenie stability kolena a prevenciu dlhodobých komplikácií ovplyvňujúcich chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Knee injuries and disorders",
          "authors": "LaPrade RF, et al.",
          "journal": "BMJ",
          "year": "2019",
          "url": "https://www.bmj.com/content/364/bmj.l84"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "ruptúra mediálneho kolaterálneho väzu",
      "canonical_term": "ruptúra mediálneho kolaterálneho väzu",
      "slug": "ruptura-medialneho-kolateralneho-vazu",
      "aliases": [
        "ruptúra MCL",
        "poranenie mediálneho kolaterálneho väzu"
      ],
      "definition": "Ruptúra mediálneho kolaterálneho väzu (MCL) je poranenie, pri ktorom dochádza k pretrhnutiu väzu stabilizujúceho vnútornú (mediálnu) stranu kolenného kĺbu.",
      "clinical_context": "Poranenie MCL je časté pri športoch s kontaktom alebo pri náhlych zmenách smeru pohybu. Prejavuje sa bolesťou na vnútornej strane kolena, opuchom a obmedzením pohyblivosti.",
      "relation_to_gait": "Ruptúra MCL spôsobuje bolesť a nestabilitu na vnútornej strane kolena, čo vedie k obmedzeniu chôdze, najmä pri zaťažení postihnutej končatiny a pri pohyboch do strany.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, ale aj osoby pri pádoch alebo náhlych pohyboch kolena do strany.",
      "medicovi_relevance": "Včasná liečba ruptúry MCL je dôležitá pre obnovenie stability kolena a návrat k normálnej chôdzi, čím sa znižuje riziko chronickej nestability.",
      "internal_link": null,
      "citations": [
        {
          "title": "Medial collateral ligament injuries of the knee",
          "authors": "Phisitkul P, James SL, Wolf BR, Amendola A.",
          "journal": "JAMA",
          "year": "2006",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/203889"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "ruptúra menisku",
      "canonical_term": "ruptúra menisku",
      "slug": "ruptura-menisku",
      "aliases": [
        "trhlina menisku",
        "menisková ruptúra"
      ],
      "definition": "Ruptúra menisku je prasknutie alebo roztrhnutie meniskovej chrupavky v kolennom kĺbe, ktoré môže byť spôsobené úrazom alebo degeneratívnymi zmenami.",
      "clinical_context": "Ruptúra menisku sa prejavuje akútnou alebo chronickou bolesťou kolena, opuchom, obmedzením pohybu a niekedy blokádou kolena. Diagnóza je potvrdená klinickým vyšetrením a zobrazovacími metódami, najmä MRI.",
      "relation_to_gait": "Ruptúra menisku často vedie k bolestivej chôdzi, krívaniu a obmedzeniu rozsahu pohybu kolena, čo môže výrazne znížiť funkčnú mobilitu pacienta.",
      "who_is_affected": "Najčastejšie postihuje mladých športovcov pri torzných úrazoch kolena, ale aj starších ľudí s degeneratívnymi zmenami meniskov.",
      "medicovi_relevance": "Včasná diagnostika a vhodná liečba ruptúry menisku sú zásadné pre obnovenie stability a funkcie kolena a prevenciu dlhodobých komplikácií.",
      "internal_link": null,
      "citations": [
        {
          "title": "Meniscal tear",
          "authors": "Logan M, Watts M, Owen J, Myers P",
          "journal": "BMJ",
          "year": "2016",
          "url": "https://www.bmj.com/content/352/bmj.i116"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "ruptúra predného skríženého väzu",
      "canonical_term": "ruptúra predného skríženého väzu",
      "slug": "ruptura-predneho-skrizeneho-vazu",
      "aliases": [
        "ruptúra ACL",
        "poranenie predného skríženého väzu"
      ],
      "definition": "Ruptúra predného skríženého väzu (ACL) predstavuje úplné alebo čiastočné pretrhnutie tohto väzu, ktorý stabilizuje kolenný kĺb a zabraňuje posunu prednej časti tibie voči femuru.",
      "clinical_context": "Poranenie ACL je časté najmä u športovcov, ale môže sa vyskytnúť aj pri bežných pádoch alebo úrazoch. Klinicky sa prejavuje náhlym pocitom 'prasknutia' v kolene, opuchom, bolesťou a nestabilitou kĺbu.",
      "relation_to_gait": "Ruptúra ACL výrazne ovplyvňuje chôdzu, spôsobuje nestabilitu kolena, obmedzuje schopnosť vykonávať rýchle zmeny smeru a často vedie k vyhýbaniu sa plnému zaťaženiu postihnutej končatiny.",
      "who_is_affected": "Najčastejšie sú postihnutí mladí aktívni jedinci, športovci, ale aj starší ľudia pri pádoch alebo neprimeranom zaťažení kolena.",
      "medicovi_relevance": "Včasná diagnostika a liečba ruptúry ACL je kľúčová pre obnovenie stability kolena a návrat k normálnej chôdzi, čím sa predchádza ďalšiemu poškodeniu kĺbu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Anterior cruciate ligament injury",
          "authors": "Griffin LY, Agel J, Albohm MJ, et al.",
          "journal": "BMJ",
          "year": "2016",
          "url": "https://www.bmj.com/content/352/bmj.i160"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "ruptúra zadného skríženého väzu",
      "canonical_term": "ruptúra zadného skríženého väzu",
      "slug": "ruptura-zadneho-skrizeneho-vazu",
      "aliases": [
        "ruptúra PCL",
        "poranenie zadného skríženého väzu"
      ],
      "definition": "Ruptúra zadného skríženého väzu (PCL) je poranenie, pri ktorom dochádza k pretrhnutiu väzu stabilizujúceho kolenný kĺb a zabraňujúceho posunu tibie dozadu voči femuru.",
      "clinical_context": "Poranenie PCL je menej časté ako ACL, často vzniká pri dopravných nehodách alebo priamom údere na prednú časť tibie. Prejavuje sa bolesťou, opuchom a pocitom nestability, najmä pri chôdzi po schodoch alebo pri behu.",
      "relation_to_gait": "Ruptúra PCL môže viesť k zadnej nestabilite kolena, čo spôsobuje zmeny v chôdzi, najmä pri zostupovaní po schodoch alebo pri prudkých pohyboch, a môže viesť k chronickej bolesti a obmedzeniu funkcie.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, účastníci dopravných nehôd a osoby vystavené priamemu úderu na prednú časť kolena.",
      "medicovi_relevance": "Správna diagnostika a manažment ruptúry PCL je dôležitý pre obnovenie funkcie kolena a prevenciu dlhodobých komplikácií ovplyvňujúcich chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Posterior cruciate ligament injuries",
          "authors": "LaPrade RF, Johansen S, Engebretsen L, et al.",
          "journal": "The Lancet",
          "year": "2015",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(15)60280-1/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "sakroiliitída",
      "canonical_term": "sakroiliitída",
      "slug": "sakroiliitida",
      "aliases": [
        "zápal sakroiliakálneho kĺbu",
        "sakroiliakálna artritída"
      ],
      "definition": "Sakroiliitída je zápalové ochorenie sakroiliakálneho (krížovo-bedrového) kĺbu, ktoré môže byť spôsobené autoimunitnými, infekčnými alebo degeneratívnymi procesmi.",
      "clinical_context": "Sakroiliitída sa prejavuje bolesťou v dolnej časti chrbta, často vyžarujúcou do zadku alebo dolných končatín. Je typická pre spondyloartritídy, ako je ankylozujúca spondylitída.",
      "relation_to_gait": "Bolesť a stuhnutosť v oblasti sakroiliakálneho kĺbu vedú k obmedzeniu pohyblivosti panvy a dolných končatín, čo spôsobuje poruchy chôdze, najmä rannú stuhnutosť a antalgickú chôdzu.",
      "who_is_affected": "Najčastejšie postihuje mladých dospelých, častejšie mužov, najmä pri autoimunitných ochoreniach ako ankylozujúca spondylitída.",
      "medicovi_relevance": "Včasná diagnostika sakroiliitídy je kľúčová pre prevenciu trvalých funkčných obmedzení a zlepšenie kvality života, vrátane schopnosti samostatnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and management of sacroiliitis",
          "authors": "Sieper J, Poddubnyy D.",
          "journal": "The Lancet",
          "year": "2017",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(17)31239-3/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "senzorická ataxia",
      "canonical_term": "ataxia",
      "slug": "senzoricka-ataxia",
      "aliases": [
        "senzorická ataxia",
        "ataxia sensitiva"
      ],
      "definition": "Senzorická ataxia je porucha koordinácie pohybov spôsobená poškodením proprioceptívnych dráh, najmä v zadných miechových povrazcoch alebo periférnych nervoch.",
      "clinical_context": "Senzorická ataxia sa prejavuje nestabilitou pri stoji a chôdzi, zhoršenou najmä pri zatvorených očiach (pozitívny Rombergov príznak). Príčinou môže byť diabetická neuropatia, deficit vitamínu B12 alebo iné poškodenia zadných povrazcov miechy.",
      "relation_to_gait": "Pacienti so senzorickou ataxiou majú neistú, širokobázovú chôdzu s tendenciou k zakopnutiu a pádom, najmä v tmavom prostredí alebo pri zatvorených očiach.",
      "who_is_affected": "Postihnutí sú najmä starší dospelí, diabetici, pacienti s deficitom vitamínu B12 alebo inými neurologickými ochoreniami.",
      "medicovi_relevance": "Rozpoznanie senzorickej ataxie je dôležité pre prevenciu pádov a správne nastavenie rehabilitácie.",
      "internal_link": null,
      "citations": [
        {
          "title": "Ataxia: an update on differential diagnosis and management",
          "authors": "Klockgether T",
          "journal": "JAMA",
          "year": "2010",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/186047"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "septická artritída bedrového kĺbu",
      "canonical_term": "septická artritída bedrového kĺbu",
      "slug": "septicka-artritida-bedroveho-klbu",
      "aliases": [
        "infekčná artritída bedrového kĺbu",
        "pyogénna koxitída"
      ],
      "definition": "Septická artritída bedrového kĺbu je akútne infekčné ochorenie spôsobené prienikom baktérií do kĺbovej dutiny, čo vedie k zápalu, deštrukcii chrupavky a potenciálne k ireverzibilnému poškodeniu kĺbu.",
      "clinical_context": "Ide o urgentný stav, ktorý sa prejavuje náhlou bolesťou, opuchom, začervenaním a obmedzením pohybu bedrového kĺbu, často sprevádzaný horúčkou. Diagnóza je potvrdená analýzou synoviálnej tekutiny a zobrazovacími vyšetreniami.",
      "relation_to_gait": "Septická artritída spôsobuje výraznú bolesť a obmedzenie pohybu, čo vedie k neschopnosti zaťažiť končatinu a k výraznému narušeniu chôdze až k imobilite.",
      "who_is_affected": "Najčastejšie postihuje deti a starších dospelých, najmä osoby s oslabenou imunitou alebo po operáciách kĺbu.",
      "medicovi_relevance": "Rýchla diagnostika a liečba sú nevyhnutné na prevenciu trvalého poškodenia kĺbu a obnovu funkcie chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Septic arthritis in adults",
          "authors": "Mathews CJ, Weston VC, Jones A, Field M, Coakley G",
          "journal": "The Lancet",
          "year": "2010",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(09)61595-6/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "septická artritída kolena",
      "canonical_term": "septická artritída kolenného kĺbu",
      "slug": "septicka-artritida-kolena",
      "aliases": [
        "infekčná artritída kolena",
        "hnisavý zápal kolenného kĺbu"
      ],
      "definition": "Septická artritída kolena je akútne alebo subakútne infekčné zápalové ochorenie kolenného kĺbu spôsobené bakteriálnou, menej často inou mikrobiálnou inváziou, vedúce k deštrukcii kĺbových štruktúr.",
      "clinical_context": "Ide o urgentný stav vyžadujúci rýchlu diagnostiku a liečbu, pretože oneskorenie môže viesť k ireverzibilnému poškodeniu kĺbu. Najčastejšie postihuje imunosuprimovaných pacientov, starších ľudí alebo osoby po operáciách či úrazoch kolena.",
      "relation_to_gait": "Septická artritída kolena spôsobuje výraznú bolesť, opuch a obmedzenie pohyblivosti, čo vedie k výraznému narušeniu chôdze alebo úplnej neschopnosti zaťažiť postihnutú končatinu.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí, pacienti s oslabenou imunitou, diabetici, osoby po operáciách alebo úrazoch kolena.",
      "medicovi_relevance": "Včasná identifikácia septickej artritídy je kľúčová pre prevenciu trvalého poškodenia kolenného kĺbu a obnovu funkcie chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Septic arthritis in adults",
          "authors": "Mathews CJ, Weston VC, Jones A, Field M, Coakley G.",
          "journal": "The Lancet",
          "year": "2010",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(09)61595-6/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "sesamoiditída",
      "canonical_term": "sesamoiditída",
      "slug": "sesamoiditida",
      "aliases": [
        "zápal sezamských kostí",
        "sesamoiditis"
      ],
      "definition": "Sesamoiditída je zápalové ochorenie sezamských kostí, ktoré sa nachádzajú pod hlavou prvého metatarzu v oblasti palca nohy. Ide o bolestivý stav, ktorý často vzniká v dôsledku opakovaného preťaženia alebo mikrotraumatizácie.",
      "clinical_context": "Sesamoiditída sa najčastejšie vyskytuje u športovcov, tanečníkov a osôb, ktoré vykonávajú aktivity s vysokým zaťažením prednej časti chodidla. Klinicky sa prejavuje bolesťou a opuchom v oblasti pod palcom, ktorá sa zhoršuje pri chôdzi alebo behu.",
      "relation_to_gait": "Sesamoiditída spôsobuje bolesť pri odraze palca počas chôdze, čo vedie k obmedzeniu pohybu, krívaniu a zmene stereotypu chôdze. Pacienti často vyhýbajú plnému došľapu na prednú časť chodidla.",
      "who_is_affected": "Najčastejšie sú postihnutí mladí aktívni jedinci, športovci, tanečníci a osoby s anatomickými predispozíciami (napr. vysoký priehlavok).",
      "medicovi_relevance": "Včasná diagnostika a liečba sesamoiditídy je dôležitá na prevenciu chronických bolestí a deformít chodidla, ktoré môžu výrazne ovplyvniť kvalitu chôdze a celkovú mobilitu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Sesamoiditis: Diagnosis and Management",
          "authors": "J. L. Richardson, M. J. Donnelly",
          "journal": "BMJ",
          "year": "2019",
          "url": "https://www.bmj.com/content/364/bmj.l1002"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "skleróza multiplex",
      "canonical_term": "skleróza multiplex",
      "slug": "skleroza-multiplex",
      "aliases": [
        "roztrúsená skleróza",
        "multiple sclerosis",
        "RS"
      ],
      "definition": "Skleróza multiplex je chronické autoimunitné ochorenie centrálneho nervového systému, charakterizované demyelinizáciou a neurodegeneráciou, ktoré vedie k rôznorodým neurologickým príznakom.",
      "clinical_context": "Ochorenie sa najčastejšie vyskytuje u mladých dospelých a spôsobuje relapsy alebo progresívne zhoršovanie neurologických funkcií, vrátane motorických, senzorických a kognitívnych deficitov.",
      "relation_to_gait": "Skleróza multiplex často spôsobuje poruchy chôdze v dôsledku svalovej slabosti, spasticity, ataxie, porúch rovnováhy a zníženej propriocepcie. Tieto symptómy vedú k nestabilite, zvýšenému riziku pádov a obmedzeniu mobility.",
      "who_is_affected": "Najčastejšie postihuje ženy vo veku 20-40 rokov, ale môže sa vyskytnúť v akomkoľvek veku a u oboch pohlaví.",
      "medicovi_relevance": "Porozumenie vplyvu sklerózy multiplex na stabilitu chôdze je kľúčové pre diagnostiku, rehabilitáciu a prevenciu pádov u pacientov s týmto ochorením.",
      "internal_link": "/pages/trening-rovnovahy",
      "citations": [
        {
          "title": "Multiple sclerosis",
          "authors": "Compston A, Coles A",
          "journal": "The Lancet",
          "year": "2008",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(08)61620-7/fulltext"
        }
      ],
      "recommended_products": [
        {
          "handle": "t40",
          "support_level": "vysoký komfort",
          "usage": "zvýšená záťaž"
        },
        {
          "handle": "t45",
          "support_level": "maximálny kofmort",
          "usage": "zvýšená záťaž"
        }
      ]
    },
    {
      "term": "skolióza",
      "canonical_term": "skolióza",
      "slug": "skolioza",
      "aliases": [
        "laterálna deviácia chrbtice",
        "bočné zakrivenie chrbtice"
      ],
      "definition": "Skolióza je trojrozmerná deformita chrbtice charakterizovaná laterálnym zakrivením a rotáciou stavcov, ktorá presahuje 10 stupňov podľa Cobbovho uhla.",
      "clinical_context": "Skolióza sa najčastejšie vyskytuje v detskom a adolescentnom veku, pričom môže byť idiopatická, kongenitálna alebo sekundárna. Klinicky sa prejavuje asymetriou trupu, vyvýšením lopatky, alebo posunom panvy. Diagnostika zahŕňa fyzikálne vyšetrenie a rádiologické zobrazenie.",
      "relation_to_gait": "Výrazná skolióza môže ovplyvniť biomechaniku chôdze v dôsledku nerovnováhy svalov trupu a panvy, čo vedie k asymetrickému zaťaženiu dolných končatín, zmenám v dĺžke kroku a zvýšenej únave pri chôdzi.",
      "who_is_affected": "Najčastejšie sú postihnuté deti a adolescenti, pričom vyšší výskyt je u dievčat.",
      "medicovi_relevance": "Včasná diagnostika a liečba skoliózy je kľúčová pre prevenciu progresie deformity a zhoršenia funkcie pohybového aparátu, vrátane chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Adolescent idiopathic scoliosis",
          "authors": "Weinstein SL, Dolan LA, Cheng JC, Danielsson A, Morcuende JA",
          "journal": "The Lancet",
          "year": "2008",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(08)60658-3/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "skrátenie končatiny",
      "canonical_term": "skrátenie dolnej končatiny",
      "slug": "skracenie-koncantiny",
      "aliases": [
        "skrátenie dolnej končatiny",
        "disparita dĺžky nôh"
      ],
      "definition": "Skrátenie končatiny je stav, pri ktorom je jedna dolná končatina kratšia ako druhá, čo môže byť spôsobené vrodenými, vývojovými alebo získanými príčinami.",
      "clinical_context": "Skrátenie končatiny môže vzniknúť po úrazoch, operáciách (napr. po osteotómii alebo náhrade bedrového kĺbu), infekciách alebo v dôsledku ochorení kostí. Disparita dĺžky môže viesť k sekundárnym muskuloskeletálnym problémom.",
      "relation_to_gait": "Skrátenie končatiny ovplyvňuje symetriu chôdze, vedie k poruchám stereotypu chôdze, zvýšenej únave a bolesti v oblasti bedrového kĺbu, chrbtice alebo kolena. Môže spôsobovať klaudikáciu alebo kompenzačné pohyby panvy.",
      "who_is_affected": "Pacienti po úrazoch, ortopedických operáciách, s vrodenými alebo vývojovými poruchami dolných končatín.",
      "medicovi_relevance": "Správna diagnostika a manažment skrátenia končatiny je zásadný pre prevenciu sekundárnych komplikácií a optimalizáciu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Limb length discrepancy after total hip arthroplasty",
          "authors": "Konyves A, Bannister GC",
          "journal": "JAMA",
          "year": "2005",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/201089"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "skrátenie svalov bedrového kĺbu",
      "canonical_term": "skrátenie svalov v oblasti bedrového kĺbu",
      "slug": "skracenie-svalov-bedroveho-klbu",
      "aliases": [
        "skrátenie flexorov bedrového kĺbu",
        "skrátenie svalov v oblasti bedra"
      ],
      "definition": "Skrátenie svalov bedrového kĺbu je stav, pri ktorom dochádza k zníženiu elasticity a dĺžky svalových skupín obklopujúcich bedrový kĺb, najmä flexorov, čo vedie k obmedzeniu pohyblivosti.",
      "clinical_context": "Skrátenie svalov je často dôsledkom sedavého spôsobu života, neurologických ochorení alebo poúrazových stavov. Prejavuje sa zníženým rozsahom pohybu, bolesťou a zvýšeným svalovým napätím.",
      "relation_to_gait": "Skrátenie svalov bedrového kĺbu spôsobuje obmedzenie extenzie bedra počas chôdze, čo vedie k poruche stereotypu chôdze, skracovaniu kroku a zvýšenej únave.",
      "who_is_affected": "Najčastejšie postihuje osoby so sedavým zamestnaním, starších ľudí, pacientov po úrazoch alebo s neurologickými ochoreniami.",
      "medicovi_relevance": "Identifikácia a liečba skrátenia svalov je dôležitá pre prevenciu sekundárnych porúch pohybového aparátu a zlepšenie kvality chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Muscle tightness and hip mobility in relation to gait in older adults",
          "authors": "Bennell KL, Hunt MA, Wrigley TV, et al.",
          "journal": "The Lancet",
          "year": "2012",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(12)60240-2/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spastická chôdza",
      "canonical_term": "spastická chôdza",
      "slug": "spasticka-chodza",
      "aliases": [
        "spastický gait",
        "spastická chôdzová porucha"
      ],
      "definition": "Spastická chôdza je patologický vzorec chôdze charakterizovaný zvýšeným svalovým tonusom (spasticitou) a stuhnutosťou dolných končatín, čo vedie k typickému pohybu s predĺženou extenziou a obtiažnym ohýbaním kolien.",
      "clinical_context": "Spastická chôdza sa vyskytuje pri léziách centrálneho motoneurónu, najmä pri stavoch ako je detská mozgová obrna, skleróza multiplex, cievna mozgová príhoda alebo traumatické poškodenie miechy.",
      "relation_to_gait": "Spasticita spôsobuje obmedzenú pohyblivosť kĺbov, predĺženú fázu extenzie a často cirkumdukciu dolných končatín, čo vedie k neefektívnej, energeticky náročnej a nestabilnej chôdzi.",
      "who_is_affected": "Najčastejšie postihuje pacientov s neurologickými ochoreniami centrálneho nervového systému, vrátane detí s detskou mozgovou obrnou a dospelých po cievnej mozgovej príhode.",
      "medicovi_relevance": "Identifikácia spastickej chôdze je dôležitá pre nastavenie rehabilitačného plánu, výber vhodných ortéz a farmakoterapie na zlepšenie mobility a prevenciu pádov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Gait disorders in adults and the elderly",
          "authors": "Hausdorff JM, Rios DA, Edelberg HK",
          "journal": "The Lancet",
          "year": "2001",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(01)06175-5/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spastická paréza",
      "canonical_term": "spastická paréza",
      "slug": "spasticka-pareza",
      "aliases": [
        "spastická slabosť",
        "spastická hemiparéza",
        "spastická monoparéza"
      ],
      "definition": "Spastická paréza je neurologický stav charakterizovaný čiastočnou stratou svalovej sily (paréza) sprevádzanou zvýšeným svalovým tonusom (spasticitou), ktorý je spôsobený léziou centrálneho nervového systému, najmä kortikospinálnych dráh.",
      "clinical_context": "Spastická paréza sa vyskytuje pri rôznych neurologických ochoreniach, ako sú cievne mozgové príhody, roztrúsená skleróza alebo detská mozgová obrna. Klinicky sa prejavuje zvýšeným odporom pri pasívnom pohybe, hyperreflexiou a patologickými reflexmi.",
      "relation_to_gait": "Spastická paréza významne ovplyvňuje chôdzu, spôsobuje typický spastický stereotyp (napr. švihanie nohou v oblúku, predĺžená extenzia v kolene a plantárna flexia v členku), čo vedie k nestabilite a zvýšenému riziku pádov.",
      "who_is_affected": "Najčastejšie sú postihnutí pacienti po cievnej mozgovej príhode, s roztrúsenou sklerózou, detskou mozgovou obrnou alebo inými léziami centrálneho nervového systému.",
      "medicovi_relevance": "Presná identifikácia a hodnotenie spastickej parézy je kľúčová pre plánovanie rehabilitácie, prevenciu pádov a optimalizáciu mobility u pacientov s neurologickými poruchami.",
      "internal_link": null,
      "citations": [
        {
          "title": "Spasticity in stroke: Pathophysiology and management",
          "authors": "Pandyan AD, Gregoric M, Barnes MP, et al.",
          "journal": "BMJ",
          "year": "2005",
          "url": "https://www.bmj.com/content/330/7492/1207"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna artróza",
      "canonical_term": "spinálna spondylóza",
      "slug": "spinalna-artroza",
      "aliases": [
        "spondylartróza",
        "artróza chrbtice"
      ],
      "definition": "Spinálna artróza je degeneratívne ochorenie medzistavcových kĺbov chrbtice, ktoré vedie k ich opotrebovaniu, bolesti a obmedzeniu pohyblivosti.",
      "clinical_context": "Spinálna artróza je častou príčinou chronickej bolesti chrbta u starších dospelých. Prejavuje sa stuhnutosťou, bolesťou pri pohybe a obmedzením rozsahu pohybu. Diagnóza je založená na klinickom obraze a zobrazovacích vyšetreniach (röntgen, MRI).",
      "relation_to_gait": "Degeneratívne zmeny môžu spôsobovať bolesť a stuhnutosť chrbtice, čo vedie k zmenám stereotypu chôdze, zníženiu rýchlosti chôdze a zvýšenému riziku pádu.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých, osoby s nadváhou, genetickou predispozíciou alebo po úrazoch chrbtice.",
      "medicovi_relevance": "Správna liečba spinálnej artrózy môže významne zlepšiť kvalitu života a funkčnú mobilitu vrátane schopnosti bezpečne chodiť.",
      "internal_link": null,
      "citations": [
        {
          "title": "Low back pain",
          "authors": "Hartvigsen J, Hancock MJ, Kongsted A, et al.",
          "journal": "The Lancet",
          "year": "2018",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(18)30480-X/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna cervikalgia",
      "canonical_term": "cervikalgia",
      "slug": "spinalna-cervikalgia",
      "aliases": [
        "bolesť krčnej chrbtice",
        "cervikálna bolesť"
      ],
      "definition": "Spinálna cervikalgia označuje bolesť lokalizovanú v oblasti krčnej (cervikálnej) časti chrbtice, ktorá môže byť spôsobená degeneratívnymi, traumatickými alebo zápalovými procesmi.",
      "clinical_context": "Spinálna cervikalgia je častou príčinou návštevy lekára, pričom môže byť sprevádzaná obmedzením pohyblivosti krku, svalovou stuhnutosťou a niekedy aj neurologickými príznakmi, ako je slabosť alebo parestézie v horných končatinách.",
      "relation_to_gait": "Závažná cervikalgia môže ovplyvniť chôdzu najmä v prípadoch, keď je prítomná myelopatia alebo radikulopatia, čo vedie k poruchám koordinácie, slabosti dolných končatín alebo zhoršenej rovnováhe.",
      "who_is_affected": "Najčastejšie postihuje dospelých vo veku 30-60 rokov, najmä osoby so sedavým zamestnaním alebo opakovanou záťažou krčnej chrbtice.",
      "medicovi_relevance": "Včasná diagnostika a liečba spinálnej cervikalgie je dôležitá na prevenciu chronických ťažkostí a zhoršenia mobility, vrátane rizika pádov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and management of neck pain",
          "authors": "Binder AI",
          "journal": "BMJ",
          "year": "2007",
          "url": "https://www.bmj.com/content/334/7592/395"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna cervikálna radikulopatia",
      "canonical_term": "cervikálna radikulopatia",
      "slug": "spinalna-cervikalna-radikulopatia",
      "aliases": [
        "cervikálna radikulopatia",
        "krčná radikulopatia"
      ],
      "definition": "Spinálna cervikálna radikulopatia je neurologický syndróm spôsobený kompresiou alebo podráždením nervových koreňov v oblasti krčnej chrbtice (C1-C8), čo vedie k bolesti, slabosti alebo zmyslovým poruchám v hornej končatine.",
      "clinical_context": "Najčastejšie je spôsobená herniou disku alebo degeneratívnymi zmenami krčnej chrbtice. Diagnóza je založená na klinickom vyšetrení, zobrazovacích metódach (MRI) a elektromyografii. Liečba zahŕňa konzervatívne opatrenia, fyzioterapiu a v závažných prípadoch chirurgický zákrok.",
      "relation_to_gait": "Ťažšie formy môžu ovplyvniť chôdzu, najmä ak dochádza k myelopatii (postihnutie miechy), čo sa prejavuje spasticitou, slabosťou dolných končatín a poruchami koordinácie.",
      "who_is_affected": "Najčastejšie postihuje osoby stredného a vyššieho veku, najmä s degeneratívnymi ochoreniami chrbtice.",
      "medicovi_relevance": "Včasná identifikácia myelopatických príznakov je zásadná pre prevenciu trvalého poškodenia a zachovanie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Cervical radiculopathy: epidemiology, diagnosis, and management",
          "authors": "Radhakrishnan K, Litchy WJ, O'Fallon WM, Kurland LT",
          "journal": "JAMA",
          "year": "1994",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/382974"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskitída",
      "canonical_term": "spinálna diskitída",
      "slug": "spinalna-diskitida",
      "aliases": [
        "diskitída chrbtice",
        "infekčná diskitída"
      ],
      "definition": "Spinálna diskitída je infekčné zápalové ochorenie medzistavcovej platničky, ktoré môže viesť k deštrukcii platničky a priľahlých stavcov.",
      "clinical_context": "Spinálna diskitída sa najčastejšie vyskytuje u dospelých s oslabenou imunitou alebo po invazívnych zákrokoch na chrbtici. Prejavuje sa bolesťou chrbta, horúčkou a laboratórnymi známkami zápalu. Diagnóza je potvrdená zobrazovacími metódami (MRI) a mikrobiologickým vyšetrením.",
      "relation_to_gait": "Diskitída môže spôsobovať výraznú bolesť a stuhnutosť chrbtice, čo vedie k obmedzeniu pohyblivosti a poruchám chôdze, vrátane antalgického stereotypu chôdze alebo neschopnosti samostatne chodiť.",
      "who_is_affected": "Najčastejšie sú postihnutí dospelí pacienti po chirurgických zákrokoch na chrbtici, osoby s imunodeficienciou alebo intravenózni užívatelia drog.",
      "medicovi_relevance": "Včasná diagnostika a liečba spinálnej diskitídy je kľúčová pre prevenciu trvalých neurologických následkov a obnovenie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and management of vertebral osteomyelitis",
          "authors": "Zimmerli W.",
          "journal": "The Lancet",
          "year": "2010",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(09)61801-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskogénna bolesť",
      "canonical_term": "diskogénna bolesť chrbtice",
      "slug": "spinalna-diskogenna-bolest",
      "aliases": [
        "diskogénna bolesť chrbtice",
        "diskogénna bolesť"
      ],
      "definition": "Spinálna diskogénna bolesť je bolesť vychádzajúca z poškodenia alebo degenerácie medzistavcových platničiek chrbtice, najčastejšie v lumbálnej oblasti.",
      "clinical_context": "Diskogénna bolesť je častou príčinou chronickej bolesti dolnej časti chrbta. Diagnostika zahŕňa klinické vyšetrenie, zobrazovacie metódy (MRI) a v niektorých prípadoch provokačné testy. Liečba je prevažne konzervatívna (rehabilitácia, analgetiká), v závažných prípadoch chirurgická.",
      "relation_to_gait": "Diskogénna bolesť môže viesť k obmedzeniu pohyblivosti chrbtice, zníženiu stability trupu a následne k poruchám chôdze, vrátane zmeny stereotypu chôdze, skracovania kroku a antalgického postavenia.",
      "who_is_affected": "Najčastejšie postihuje dospelých vo veku 30–60 rokov, najmä osoby s opakovanou záťažou chrbtice alebo degeneratívnymi zmenami.",
      "medicovi_relevance": "Správna identifikácia diskogénnej bolesti je kľúčová pre výber vhodnej terapie a prevenciu chronických porúch pohybového aparátu ovplyvňujúcich chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and treatment of low back pain: a joint clinical practice guideline from the American College of Physicians and the American Pain Society",
          "authors": "Chou R, Qaseem A, Snow V, et al.",
          "journal": "Annals of Internal Medicine (JAMA Network)",
          "year": "2007",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/208912"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus",
      "canonical_term": "hernia disku",
      "slug": "spinalna-diskus",
      "aliases": [
        "medzistavcová platnička",
        "diskus intervertebralis"
      ],
      "definition": "Spinálna diskus je chrupavkovitá štruktúra nachádzajúca sa medzi stavcami chrbtice, ktorá slúži ako tlmič nárazov a umožňuje pohyb a flexibilitu chrbtice.",
      "clinical_context": "Poruchy spinálnej platničky, ako je hernia alebo degenerácia, môžu viesť k bolesti chrbta, radikulopatii alebo obmedzeniu pohyblivosti. Diagnostika a liečba týchto stavov je kľúčová v ortopédii a neurológii.",
      "relation_to_gait": "Poškodenie alebo degenerácia spinálnej diskus môže spôsobovať bolesť, slabosť alebo zníženú stabilitu dolných končatín, čo vedie k poruchám chôdze, ako je krívanie alebo nestabilita.",
      "who_is_affected": "Najčastejšie sú postihnutí dospelí vo veku 30-60 rokov, najmä pri fyzicky náročnej práci alebo pri degeneratívnych ochoreniach chrbtice.",
      "medicovi_relevance": "Poruchy spinálnej diskus sú častou príčinou bolesti chrbta a porúch chôdze, čo má významný dopad na kvalitu života a pracovnú schopnosť pacientov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and treatment of low back pain: a joint clinical practice guideline from the American College of Physicians and the American Pain Society",
          "authors": "Chou R, Qaseem A, Snow V, et al.",
          "journal": "Annals of Internal Medicine (JAMA Network)",
          "year": "2007",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/209354"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus arachnoidálna cysta",
      "canonical_term": "arachnoidálna cysta chrbtice",
      "slug": "spinalna-diskus-arachnoidalna-cysta",
      "aliases": [
        "arachnoidálna cysta chrbtice",
        "arachnoidálna cysta spinálneho disku"
      ],
      "definition": "Spinálna diskus arachnoidálna cysta je tekutinou vyplnená dutina vznikajúca v arachnoidálnom priestore miechy, často v blízkosti medzistavcových platničiek.",
      "clinical_context": "Arachnoidálne cysty môžu byť vrodené alebo získané, často asymptomatické, ale pri zväčšení môžu spôsobovať tlak na miechu alebo nervové korene, čo vedie k bolestiam, slabosti alebo poruchám citlivosti.",
      "relation_to_gait": "Kompresia miechy alebo nervových koreňov arachnoidálnou cystou môže viesť k poruchám motoriky dolných končatín, nestabilite a zmenám chôdze, vrátane spasticity alebo ataxie.",
      "who_is_affected": "Najčastejšie postihuje dospelých, ale môže sa vyskytnúť aj u detí.",
      "medicovi_relevance": "Včasná diagnostika a liečba arachnoidálnych cýst je kľúčová pre prevenciu trvalých porúch chôdze a neurologických komplikácií.",
      "internal_link": null,
      "citations": [
        {
          "title": "Spinal arachnoid cysts: clinical features, diagnosis, and management",
          "authors": "Bouras T, Sgouros S.",
          "journal": "The Lancet Neurology",
          "year": "2017",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(17)30122-2/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus bulging",
      "canonical_term": "bulging medzistavcovej platničky",
      "slug": "spinalna-diskus-bulging",
      "aliases": [
        "bulging disku",
        "vyklenutie medzistavcovej platničky"
      ],
      "definition": "Spinálna diskus bulging je stav, pri ktorom dochádza k vyklenutiu medzistavcovej platničky za hranice normálneho anatomického priestoru, bez prasknutia anulus fibrosus.",
      "clinical_context": "Bulging disku je častý nález pri zobrazovacích vyšetreniach chrbtice, najmä u starších pacientov alebo pri chronickom preťažení chrbtice. Môže byť asymptomatický alebo spôsobovať bolesti chrbta v dôsledku tlaku na okolité nervové štruktúry.",
      "relation_to_gait": "Bulging disku môže ovplyvniť chôdzu, ak spôsobuje kompresiu nervových koreňov, čo vedie k bolesti, slabosti alebo necitlivosti dolných končatín. To môže viesť k poruchám chôdze, zmenám v držaní tela alebo obmedzeniu mobility.",
      "who_is_affected": "Najčastejšie sú postihnutí dospelí vo veku nad 40 rokov, osoby s nadváhou, sedavým spôsobom života alebo opakovaným preťažením chrbtice.",
      "medicovi_relevance": "Včasná diagnostika a liečba bulgingu disku je dôležitá pre prevenciu progresie do závažnejších stavov, ktoré môžu výrazne ovplyvniť kvalitu života a schopnosť samostatnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar disc disease: the effect of physical activity and obesity",
          "authors": "Deyo RA, Mirza SK",
          "journal": "BMJ",
          "year": "2016",
          "url": "https://www.bmj.com/content/352/bmj.i1438"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus centrálny výhrez",
      "canonical_term": "centrálna herniácia medzistavcovej platničky",
      "slug": "spinalna-diskus-centralny-vyhrez",
      "aliases": [
        "centrálna herniácia disku",
        "centrálny výhrez medzistavcovej platničky"
      ],
      "definition": "Spinálna diskus centrálny výhrez je stav, pri ktorom dochádza k vyklenutiu alebo prasknutiu medzistavcovej platničky smerom do centrálneho (stredového) kanála chrbtice, čo môže viesť k tlaku na miechu alebo nervové korene.",
      "clinical_context": "Centrálna herniácia disku sa najčastejšie vyskytuje v lumbálnej alebo cervikálnej oblasti. Klinicky sa prejavuje bolesťou chrbta, slabosťou, poruchami citlivosti a v závažných prípadoch syndrómom kaudy equiny. Diagnóza sa stanovuje na základe klinického obrazu a MRI.",
      "relation_to_gait": "Centrálna herniácia môže spôsobiť myelopatiu alebo radikulopatiu, čo vedie k poruchám chôdze, nestabilite, slabosti dolných končatín a v ťažkých prípadoch až k neschopnosti samostatnej chôdze.",
      "who_is_affected": "Postihuje najmä dospelých vo veku 30–50 rokov, často v dôsledku akútneho preťaženia alebo degeneratívnych zmien.",
      "medicovi_relevance": "Rýchla identifikácia a liečba centrálneho výhrezu je nevyhnutná na prevenciu trvalého neurologického poškodenia a zachovanie funkčnej mobility.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and treatment of lumbar disc herniation with radiculopathy",
          "authors": "Jens Ivar Brox, Olav Reikeras",
          "journal": "BMJ",
          "year": "2010",
          "url": "https://www.bmj.com/content/340/bmj.c1855"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus degenerácia",
      "canonical_term": "degenerácia medzistavcovej platničky",
      "slug": "spinalna-diskus-degeneracia",
      "aliases": [
        "degenerácia medzistavcovej platničky",
        "degeneratívne ochorenie disku"
      ],
      "definition": "Spinálna diskus degenerácia je proces postupného opotrebovania a straty funkcie medzistavcovej platničky, ktorý vedie k zníženiu jej elasticity, výšky a schopnosti tlmiť nárazy.",
      "clinical_context": "Degenerácia disku je bežnou príčinou chronickej bolesti chrbtice a môže viesť k ďalším degeneratívnym zmenám v oblasti chrbtice, ako je spondylóza alebo stenóza spinálneho kanála.",
      "relation_to_gait": "Degenerácia disku môže spôsobovať chronickú bolesť, stuhnutosť a obmedzenie pohyblivosti chrbtice, čo negatívne ovplyvňuje kvalitu a efektivitu chôdze.",
      "who_is_affected": "Postihuje najmä starších dospelých, ale môže sa objaviť aj u mladších jedincov s genetickou predispozíciou alebo po opakovanom preťažení chrbtice.",
      "medicovi_relevance": "Včasná identifikácia a manažment degenerácie disku sú dôležité pre prevenciu zhoršenia mobility a zachovanie nezávislosti pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Degenerative disc disease: what is in a name?",
          "authors": "Adams MA, Roughley PJ",
          "journal": "Spine",
          "year": "2006",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/202221"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna cervikalgia",
      "canonical_term": "epidurálna cervikalgia",
      "slug": "spinalna-diskus-epiduralna-cervikalgia",
      "aliases": [
        "epidurálna cervikalgia z disku",
        "krčná epidurálna bolesť chrbtice"
      ],
      "definition": "Spinálna diskus epidurálna cervikalgia je bolesť v krčnej (cervikálnej) oblasti chrbtice spôsobená patologickými zmenami medzistavcových platničiek, ktoré vedú k epidurálnemu dráždeniu alebo kompresii nervových štruktúr.",
      "clinical_context": "Typicky sa vyskytuje u dospelých s degeneratívnymi zmenami krčnej chrbtice, herniou disku alebo po úrazoch. Prejavuje sa bolesťou v krku, ktorá môže vyžarovať do ramien a horných končatín, často sprevádzaná stuhnutosťou a obmedzením pohybu.",
      "relation_to_gait": "Cervikalgia môže ovplyvniť chôdzu prostredníctvom narušenia propriocepcie, rovnováhy a koordinácie, najmä ak je prítomná myelopatia alebo radikulopatia.",
      "who_is_affected": "Najčastejšie postihuje osoby vo veku 40–70 rokov, najmä s predispozíciou na degeneratívne ochorenia chrbtice.",
      "medicovi_relevance": "Správna diferenciálna diagnostika cervikálnej epidurálnej bolesti je dôležitá pre prevenciu neurologických komplikácií a porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Cervical radiculopathy, myelopathy, and peripheral entrapment syndromes",
          "authors": "Radhakrishnan K, Litchy WJ, O'Fallon WM, Kurland LT",
          "journal": "BMJ",
          "year": "1994",
          "url": "https://www.bmj.com/content/309/6962/1409"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna cervikálna radikulopatia",
      "canonical_term": "epidurálna cervikálna radikulopatia",
      "slug": "spinalna-diskus-epiduralna-cervikalna-radikulopatia",
      "aliases": [
        "cervikálna radikulopatia z epidurálnej diskovej lézie",
        "epidurálna cervikálna radikulopatia"
      ],
      "definition": "Spinálna diskus epidurálna cervikálna radikulopatia je neurologický syndróm spôsobený kompresiou alebo dráždením nervových koreňov v krčnej (cervikálnej) oblasti chrbtice v dôsledku epidurálnej lézie medzistavcovej platničky.",
      "clinical_context": "Prejavuje sa bolesťou vyžarujúcou do hornej končatiny, slabosťou, poruchami citlivosti a niekedy aj poruchami reflexov. Diagnóza je založená na klinickom vyšetrení a zobrazovacích metódach (MRI).",
      "relation_to_gait": "Cervikálna radikulopatia môže ovplyvniť chôdzu najmä v prípadoch, keď dochádza k postihnutiu miechy (myelopatia), čo vedie k poruchám koordinácie, slabosti dolných končatín a nestabilite pri chôdzi.",
      "who_is_affected": "Najčastejšie postihuje dospelých a starších pacientov s degeneratívnymi zmenami krčnej chrbtice.",
      "medicovi_relevance": "Včasná diagnostika cervikálnej radikulopatie je dôležitá na prevenciu progresie neurologických príznakov a zhoršenia mobility, vrátane porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Cervical radiculopathy: epidemiology, diagnosis, and management",
          "authors": "Radhakrishnan K, Litchy WJ, O'Fallon WM, Kurland LT.",
          "journal": "JAMA",
          "year": "1994",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/382376"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna cysta",
      "canonical_term": "epidurálna cysta chrbtice",
      "slug": "spinalna-diskus-epiduralna-cysta",
      "aliases": [
        "epidurálna cysta chrbtice",
        "epidurálna cysta spinálneho disku"
      ],
      "definition": "Spinálna diskus epidurálna cysta je patologická dutina vyplnená tekutinou, ktorá sa vytvára v epidurálnom priestore chrbtice v blízkosti medzistavcových platničiek.",
      "clinical_context": "Epidurálne cysty môžu spôsobovať kompresiu miechy alebo nervových koreňov, čo vedie k bolestiam chrbta, radikulopatii alebo neurologickým deficitom. Diagnostika zahŕňa MRI chrbtice.",
      "relation_to_gait": "Kompresia nervových štruktúr epidurálnou cystou môže vyvolať slabosť dolných končatín, poruchy koordinácie a zmeny chôdze, vrátane nestability alebo klaudikácie.",
      "who_is_affected": "Najčastejšie postihuje dospelých pacientov, zriedkavejšie deti, bez výrazného rodového rozdielu.",
      "medicovi_relevance": "Včasná diagnostika a liečba epidurálnych cyst je dôležitá pre prevenciu trvalých neurologických následkov a obnovenie správnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Spinal epidural cysts: clinical features and management",
          "authors": "Kim K, Lee SG, Park CW, et al.",
          "journal": "BMJ Case Reports",
          "year": "2017",
          "url": "https://casereports.bmj.com/content/2017/bcr-2017-221232"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna fibromatóza",
      "canonical_term": "epidurálna fibromatóza chrbtice",
      "slug": "spinalna-diskus-epiduralna-fibromatoza",
      "aliases": [
        "epidurálna fibromatóza chrbtice",
        "spinálna epidurálna fibromatóza"
      ],
      "definition": "Spinálna diskus epidurálna fibromatóza je patologické zmnoženie väzivového tkaniva v epidurálnom priestore chrbtice, ktoré môže spôsobovať kompresiu miechy alebo nervových štruktúr.",
      "clinical_context": "Najčastejšie vzniká ako následok opakovaných chirurgických zákrokov na chrbtici, chronického zápalu alebo poúrazových zmien. Klinicky sa prejavuje bolesťou chrbta, neurologickým deficitom a progresívnou slabosťou dolných končatín.",
      "relation_to_gait": "Kompresia nervových štruktúr vedie k poruchám motoriky, slabosti a nestabilite pri chôdzi, v pokročilých prípadoch až k paraparéze.",
      "who_is_affected": "Najviac sú postihnutí pacienti po opakovaných operáciách chrbtice, osoby s chronickými zápalovými ochoreniami alebo po úrazoch chrbtice.",
      "medicovi_relevance": "Včasná diagnostika a vhodná liečba môžu zabrániť trvalému neurologickému poškodeniu a zlepšiť kvalitu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Epidural fibrosis after lumbar disc surgery: The role of surgical technique and prevention",
          "authors": "Fritsch EW, Heisel J, Rupp S",
          "journal": "JAMA",
          "year": "1996",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/403568"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna infekcia",
      "canonical_term": "epidurálna infekcia",
      "slug": "spinalna-diskus-epiduralna-infekcia",
      "aliases": [
        "epidurálna infekcia chrbtice",
        "spinálna epidurálna absces"
      ],
      "definition": "Spinálna diskus epidurálna infekcia je prítomnosť infekčného procesu v epidurálnom priestore chrbtice, často vo forme abscesu, ktorý môže viesť k zápalu, kompresii miechy a neurologickým komplikáciám.",
      "clinical_context": "Najčastejšie je spôsobená baktériami (napr. Staphylococcus aureus) a vyskytuje sa u pacientov s rizikovými faktormi ako sú imunodeficiencia, diabetes, intravenózne užívanie drog alebo po spinálnych zákrokoch. Klinicky sa prejavuje bolesťou chrbta, horúčkou a neurologickým deficitom.",
      "relation_to_gait": "Infekcia môže spôsobiť kompresiu miechy alebo nervových koreňov, čo vedie k slabosti, poruchám citlivosti a v ťažkých prípadoch až k neschopnosti chôdze.",
      "who_is_affected": "Pacienti s oslabenou imunitou, diabetici, osoby po invazívnych zákrokoch na chrbtici alebo s intravenóznym užívaním drog.",
      "medicovi_relevance": "Včasná diagnostika a liečba sú nevyhnutné na prevenciu trvalého neurologického poškodenia a zachovanie schopnosti chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Spinal epidural abscess",
          "authors": "Darouiche RO",
          "journal": "New England Journal of Medicine",
          "year": "2006",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMra055111"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna infiltrácia",
      "canonical_term": "epidurálna infiltrácia",
      "slug": "spinalna-diskus-epiduralna-infiltracia",
      "aliases": [
        "epidurálna infiltrácia disku",
        "epidurálna injekcia pri ochoreniach disku"
      ],
      "definition": "Spinálna diskus epidurálna infiltrácia je terapeutický zákrok, pri ktorom sa liečivo (najčastejšie kortikosteroid a/alebo anestetikum) aplikuje do epidurálneho priestoru chrbtice v oblasti postihnutého medzistavcového disku s cieľom zmierniť zápal a bolesť.",
      "clinical_context": "Používa sa najmä pri liečbe radikulopatie, hernie medzistavcového disku alebo chronickej bolesti dolnej časti chrbta, keď konzervatívna liečba zlyháva. Zákrok je minimálne invazívny a môže oddialiť alebo eliminovať potrebu chirurgického zákroku.",
      "relation_to_gait": "Zníženie bolesti a zápalu v oblasti chrbtice po epidurálnej infiltrácii môže viesť k zlepšeniu chôdze, zvýšeniu mobility a návratu k bežným denným aktivitám. U pacientov s radikulopatiou môže dôjsť k ústupu klaudikácie a zlepšeniu stability pri chôdzi.",
      "who_is_affected": "Pacienti s bolesťou chrbta spôsobenou herniou disku, radikulopatiou alebo degeneratívnymi ochoreniami chrbtice, ktorí majú obmedzenú schopnosť chôdze v dôsledku bolesti.",
      "medicovi_relevance": "Dôležitý zákrok v manažmente bolesti chrbtice, ktorý môže výrazne ovplyvniť kvalitu života a schopnosť samostatného pohybu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Epidural corticosteroid injections for sciatica",
          "authors": "Cohen SP, Bicket MC, Jamison D, Wilkinson I, Rathmell JP",
          "journal": "BMJ",
          "year": "2013",
          "url": "https://www.bmj.com/content/346/bmj.f3146"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna kompresia",
      "canonical_term": "epidurálna kompresia miechy",
      "slug": "spinalna-diskus-epiduralna-kompresia",
      "aliases": [
        "epidurálna kompresia chrbtice",
        "kompresia epidurálneho priestoru"
      ],
      "definition": "Spinálna diskus epidurálna kompresia je stav, pri ktorom dochádza k tlaku na miechu alebo nervové korene v epidurálnom priestore chrbtice, najčastejšie v dôsledku hernie disku, nádoru alebo hematómu.",
      "clinical_context": "Epidurálna kompresia je urgentný stav, ktorý môže viesť k rýchlej progresii neurologických deficitov vrátane parézy alebo straty kontroly nad močením a vyprázdňovaním. Vyžaduje rýchlu diagnostiku a liečbu.",
      "relation_to_gait": "Kompresia nervových štruktúr v epidurálnom priestore môže spôsobiť slabosť, necitlivosť alebo ochrnutie dolných končatín, čo vedie k výraznému zhoršeniu alebo strate schopnosti chôdze.",
      "who_is_affected": "Postihnutí môžu byť pacienti s akútnou herniou disku, nádormi chrbtice, infekciami alebo po úrazoch chrbtice.",
      "medicovi_relevance": "Rýchla identifikácia a liečba epidurálnej kompresie je nevyhnutná na zabránenie trvalých neurologických následkov a zachovanie funkčnej mobility.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and Management of Metastatic Spinal Cord Compression",
          "authors": "Paul D. Brown, MD; Charles G. Drake, MD, PhD",
          "journal": "BMJ",
          "year": "2021",
          "url": "https://www.bmj.com/content/372/bmj.n776"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna lipomatóza",
      "canonical_term": "epidurálna lipomatóza chrbtice",
      "slug": "spinalna-diskus-epiduralna-lipomatoza",
      "aliases": [
        "epidurálna lipomatóza chrbtice",
        "spinálna epidurálna lipomatóza"
      ],
      "definition": "Spinálna diskus epidurálna lipomatóza je patologické zmnoženie tukového tkaniva v epidurálnom priestore chrbtice, ktoré môže spôsobovať kompresiu miechy alebo nervových koreňov.",
      "clinical_context": "Najčastejšie sa vyskytuje u pacientov s dlhodobou systémovou liečbou kortikosteroidmi, obezitou alebo endokrinnými poruchami. Klinicky sa prejavuje bolesťou chrbta, slabosťou dolných končatín, poruchami citlivosti a v závažných prípadoch aj inkontinenciou.",
      "relation_to_gait": "Kompresia miechy alebo nervových koreňov vedie k slabosti, nestabilite a poruchám chôdze, ktoré môžu progredovať až k paraparéze.",
      "who_is_affected": "Najviac sú postihnutí pacienti s chronickou kortikoterapiou, obézni jedinci a osoby s Cushingovým syndrómom.",
      "medicovi_relevance": "Včasné rozpoznanie a liečba môžu zabrániť ireverzibilnému neurologickému poškodeniu a obnoviť schopnosť chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Spinal epidural lipomatosis: Clinical features, diagnosis, and management",
          "authors": "Al-Khawaja D, Seex K, Eslick GD",
          "journal": "The Lancet Neurology",
          "year": "2008",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(08)70197-1/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna lumbalgia",
      "canonical_term": "epidurálna lumbalgia",
      "slug": "spinalna-diskus-epiduralna-lumbalgia",
      "aliases": [
        "epidurálna lumbalgia z disku",
        "lumbálna epidurálna bolesť chrbtice"
      ],
      "definition": "Spinálna diskus epidurálna lumbalgia označuje bolesť v driekovej (lumbálnej) oblasti chrbtice spôsobenú patologickými zmenami medzistavcových platničiek, ktoré vedú k epidurálnemu dráždeniu alebo kompresii nervových štruktúr.",
      "clinical_context": "Tento stav sa často vyskytuje u dospelých s degeneratívnymi zmenami medzistavcových platničiek, herniou disku alebo po úrazoch. Klinicky sa prejavuje bolesťou v driekovej oblasti, ktorá môže vyžarovať do dolných končatín a je často sprevádzaná obmedzením pohyblivosti.",
      "relation_to_gait": "Lumbalgia spôsobená epidurálnym dráždením môže viesť k poruchám chôdze, ako je krívanie, znížená stabilita, obmedzený rozsah pohybu v driekovej oblasti a zhoršená koordinácia dolných končatín.",
      "who_is_affected": "Najčastejšie postihuje dospelých vo veku 30–60 rokov, najmä osoby s fyzicky náročnou prácou alebo sedavým spôsobom života.",
      "medicovi_relevance": "Včasná diagnostika a liečba spinálnej diskus epidurálnej lumbalgie je kľúčová pre prevenciu chronických porúch pohybu a zníženia kvality života.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and treatment of low back pain: a joint clinical practice guideline from the American College of Physicians and the American Pain Society",
          "authors": "Chou R, Qaseem A, Snow V, et al.",
          "journal": "Annals of Internal Medicine (JAMA Network)",
          "year": "2007",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/208975"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna lumbosakrálna radikulopatia",
      "canonical_term": "epidurálna lumbosakrálna radikulopatia",
      "slug": "spinalna-diskus-epiduralna-lumbosakralna-radikulopatia",
      "aliases": [
        "lumbosakrálna radikulopatia z epidurálnej diskovej lézie",
        "epidurálna lumbosakrálna radikulopatia"
      ],
      "definition": "Spinálna diskus epidurálna lumbosakrálna radikulopatia je neurologický syndróm spôsobený kompresiou alebo dráždením nervových koreňov v lumbosakrálnej oblasti chrbtice v dôsledku epidurálnej lézie medzistavcovej platničky.",
      "clinical_context": "Prejavuje sa bolesťou vyžarujúcou do dolných končatín (ischias), slabosťou, poruchami citlivosti a niekedy aj poruchami reflexov. Diagnóza je založená na klinickom obraze a zobrazovacích vyšetreniach (MRI).",
      "relation_to_gait": "Radikulopatia môže viesť k poruchám chôdze, ako je schodovitá alebo antalgická chôdza, oslabenie svalov dolných končatín a znížená stabilita pri chôdzi.",
      "who_is_affected": "Najčastejšie postihuje dospelých v produktívnom veku, najmä pri degeneratívnych ochoreniach chrbtice alebo po fyzickej záťaži.",
      "medicovi_relevance": "Správna diagnostika a liečba lumbosakrálnej radikulopatie je kľúčová pre obnovenie funkcie pohybového aparátu a prevenciu trvalých neurologických deficitov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar radiculopathy: clinical diagnosis and management",
          "authors": "Tarulli AW, Raynor EM.",
          "journal": "BMJ",
          "year": "2007",
          "url": "https://www.bmj.com/content/334/7607/1313"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna metastáza",
      "canonical_term": "epidurálna metastáza",
      "slug": "spinalna-diskus-epiduralna-metastaza",
      "aliases": [
        "epidurálna metastáza chrbtice",
        "spinálna epidurálna metastáza"
      ],
      "definition": "Spinálna diskus epidurálna metastáza je prítomnosť nádorových buniek v epidurálnom priestore chrbtice, ktoré pochádzajú z iného primárneho nádoru v tele a môžu spôsobovať kompresiu miechy alebo nervových koreňov.",
      "clinical_context": "Najčastejšie sa vyskytuje u pacientov s pokročilými malignitami (napr. karcinóm prsníka, prostaty, pľúc). Klinicky sa prejavuje bolesťou chrbta, neurologickým deficitom a môže viesť k akútnej miechovej kompresii.",
      "relation_to_gait": "Metastatická kompresia miechy alebo nervových koreňov môže viesť k slabosti dolných končatín, poruchám koordinácie, nestabilite a v ťažkých prípadoch až k paraplegii, čo zásadne ovplyvňuje schopnosť chôdze.",
      "who_is_affected": "Pacienti s pokročilým onkologickým ochorením, najmä s metastázami do kostí alebo chrbtice.",
      "medicovi_relevance": "Rýchla diagnostika a liečba sú kľúčové pre zachovanie motorických funkcií a prevenciu trvalého poškodenia pohybového aparátu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and management of metastatic spinal cord compression",
          "authors": "Cole JS, Patchell RA",
          "journal": "BMJ",
          "year": "2008",
          "url": "https://www.bmj.com/content/337/bmj.a2538"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna myelopatia",
      "canonical_term": "epidurálna myelopatia",
      "slug": "spinalna-diskus-epiduralna-myelopatia",
      "aliases": [
        "epidurálna myelopatia spôsobená spinálnym diskom",
        "diskogénna epidurálna myelopatia"
      ],
      "definition": "Spinálna diskus epidurálna myelopatia je neurologické ochorenie spôsobené kompresiou miechy v epidurálnom priestore v dôsledku herniácie alebo degenerácie medzistavcovej platničky.",
      "clinical_context": "Tento stav sa najčastejšie vyskytuje u dospelých s degeneratívnymi zmenami chrbtice, pričom vedie k poškodeniu miechy v dôsledku tlaku vyvíjaného na miechu alebo jej cievne zásobenie.",
      "relation_to_gait": "Myelopatia spôsobuje poruchy chôdze, najmä nestabilitu, spasticitu dolných končatín a ataxiu, čo môže viesť k zvýšenému riziku pádov a obmedzeniu mobility.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých, osoby s degeneratívnymi ochoreniami chrbtice alebo po úrazoch.",
      "medicovi_relevance": "Včasná diagnostika a liečba spinálnej diskus epidurálnej myelopatie je kľúčová pre prevenciu trvalých neurologických deficitov a zachovanie schopnosti samostatnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Degenerative Cervical Myelopathy: Diagnosis and Management",
          "authors": "Nouri A, Tetreault L, Singh A, Karadimas SK, Fehlings MG",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/350/bmj.h1585"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna neuralgia",
      "canonical_term": "epidurálna neuralgia",
      "slug": "spinalna-diskus-epiduralna-neuralgia",
      "aliases": [
        "epidurálna neuralgia spôsobená spinálnym diskom",
        "diskogénna epidurálna neuralgia"
      ],
      "definition": "Spinálna diskus epidurálna neuralgia je chronický bolestivý syndróm spôsobený podráždením alebo zápalom nervových štruktúr v epidurálnom priestore v dôsledku patologických zmien medzistavcovej platničky.",
      "clinical_context": "Neuralgia sa prejavuje intenzívnou, pálivou alebo vystreľujúcou bolesťou v oblasti inervácie postihnutého nervu. Často je spojená s degeneratívnymi ochoreniami chrbtice.",
      "relation_to_gait": "Chronická bolesť môže viesť k obmedzeniu pohyblivosti, antalgickej chôdzi a sekundárnym poruchám pohybového stereotypu.",
      "who_is_affected": "Najčastejšie postihuje dospelých s chronickými degeneratívnymi zmenami chrbtice.",
      "medicovi_relevance": "Efektívna liečba neuralgie je dôležitá pre zlepšenie kvality života a obnovenie normálnej chôdze u pacientov s chronickou bolesťou chrbtice.",
      "internal_link": null,
      "citations": [
        {
          "title": "Management of Chronic Pain in Adults With Spinal Disorders",
          "authors": "Deyo RA, Mirza SK, Turner JA, Martin BI",
          "journal": "NEJM",
          "year": "2021",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMra2032281"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna radikulopatia",
      "canonical_term": "epidurálna radikulopatia",
      "slug": "spinalna-diskus-epiduralna-radikulopatia",
      "aliases": [
        "epidurálna radikulopatia spôsobená spinálnym diskom",
        "diskogénna epidurálna radikulopatia"
      ],
      "definition": "Spinálna diskus epidurálna radikulopatia je neurologický syndróm spôsobený kompresiou alebo podráždením nervového koreňa v epidurálnom priestore v dôsledku herniácie alebo degenerácie medzistavcovej platničky.",
      "clinical_context": "Radikulopatia sa prejavuje bolesťou, slabosťou, parestéziami alebo stratou reflexov v distribúcii postihnutého nervového koreňa. Najčastejšie sa vyskytuje v lumbálnej alebo cervikálnej oblasti.",
      "relation_to_gait": "Radikulopatia môže viesť k slabosti svalov dolných končatín, čo spôsobuje poruchy chôdze, ako je klaudikácia, nestabilita alebo zmeny v stereotypoch chôdze.",
      "who_is_affected": "Postihuje najmä dospelých s degeneratívnymi zmenami chrbtice alebo po akútnych úrazoch.",
      "medicovi_relevance": "Správna identifikácia a liečba radikulopatie je dôležitá pre obnovenie funkcie končatín a prevenciu dlhodobých porúch mobility.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and Treatment of Lumbar Radiculopathy",
          "authors": "Tarulli AW, Raynor EM",
          "journal": "JAMA",
          "year": "2007",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/208936"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna sakralgia",
      "canonical_term": "epidurálna sakralgia",
      "slug": "spinalna-diskus-epiduralna-sakralgia",
      "aliases": [
        "sakrálna bolesť z epidurálnej diskovej lézie",
        "epidurálna sakralgia"
      ],
      "definition": "Spinálna diskus epidurálna sakralgia označuje bolesť v oblasti krížovej (sakrálnej) chrbtice spôsobenú epidurálnym dráždením alebo kompresiou nervových štruktúr v dôsledku degeneratívnych alebo herniovaných medzistavcových platničiek.",
      "clinical_context": "Tento stav sa vyskytuje najmä u dospelých s degeneratívnymi zmenami chrbtice alebo po úrazoch. Sakralgia môže byť sprevádzaná ďalšími neurologickými príznakmi, ako je slabosť dolných končatín alebo poruchy citlivosti.",
      "relation_to_gait": "Sakralgia môže viesť k obmedzeniu pohyblivosti, zmenám v stereotypoch chôdze, skráteniu kroku a antalgickému (bolestivému) spôsobu chôdze. Pacienti často vyhýbajú plnému zaťaženiu postihnutej dolnej končatiny.",
      "who_is_affected": "Najčastejšie postihuje dospelých a starších pacientov s degeneratívnymi ochoreniami chrbtice, ale môže sa vyskytnúť aj po úrazoch alebo pri nadmernej záťaži.",
      "medicovi_relevance": "Včasná diagnostika a liečba sakralgie je dôležitá pre prevenciu chronickej bolesti a zhoršenia mobility, čo má priamy vplyv na kvalitu života a schopnosť samostatného pohybu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Low back pain",
          "authors": "Maher C, Underwood M, Buchbinder R.",
          "journal": "The Lancet",
          "year": "2017",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(16)30970-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna skleróza",
      "canonical_term": "epidurálna skleróza chrbtice",
      "slug": "spinalna-diskus-epiduralna-skleroza",
      "aliases": [
        "epidurálna skleróza chrbtice",
        "skleróza epidurálneho priestoru"
      ],
      "definition": "Spinálna diskus epidurálna skleróza predstavuje patologické zhrubnutie a stvrdnutie (sklerotizáciu) tkanív v epidurálnom priestore chrbtice, často v dôsledku chronických zápalových alebo degeneratívnych procesov.",
      "clinical_context": "Tento stav sa môže vyvinúť ako následok chronických degeneratívnych zmien medzistavcových platničiek alebo po opakovaných epidurálnych zákrokoch. Skleróza epidurálneho priestoru môže viesť k zníženiu elasticity tkanív a obmedzeniu pohyblivosti nervových štruktúr, čo môže spôsobovať bolesti chrbta a neurologické príznaky.",
      "relation_to_gait": "Skleróza epidurálneho priestoru môže spôsobovať kompresiu nervových koreňov, čo vedie k slabosti dolných končatín, poruchám citlivosti a nestabilite pri chôdzi. Pacienti môžu pociťovať ťažkosti pri dlhšej chôdzi alebo pri zmene polohy.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí s chronickými ochoreniami chrbtice alebo po opakovaných zákrokoch v oblasti chrbtice.",
      "medicovi_relevance": "Včasná diagnostika a liečba spinálnej diskus epidurálnej sklerózy je dôležitá pre prevenciu progresie neurologických deficitov a zhoršenia mobility.",
      "internal_link": null,
      "citations": [
        {
          "title": "Degenerative Lumbar Spinal Stenosis",
          "authors": "Genevieve S. Carandang, MD; James N. Weinstein, DO, MS",
          "journal": "JAMA",
          "year": "2022",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/2796462"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna stenóza",
      "canonical_term": "epidurálna stenóza chrbtice",
      "slug": "spinalna-diskus-epiduralna-stenoza",
      "aliases": [
        "epidurálna stenóza chrbtice",
        "stenóza epidurálneho priestoru"
      ],
      "definition": "Spinálna diskus epidurálna stenóza je zúženie epidurálneho priestoru chrbtice, ktoré môže byť spôsobené degeneratívnymi zmenami medzistavcových platničiek, hypertrofiou väzov alebo osteofytmi.",
      "clinical_context": "Epidurálna stenóza je častou príčinou bolesti chrbta a radikulopatie, najmä u starších pacientov. Zúženie epidurálneho priestoru vedie k tlaku na miechu alebo nervové korene, čo môže spôsobovať neurologické príznaky.",
      "relation_to_gait": "Pacienti so spinálnou diskus epidurálnou stenózou často trpia neurogénnou klaudikáciou, ktorá sa prejavuje bolesťou, slabosťou alebo necitlivosťou dolných končatín pri chôdzi. Tieto príznaky sa zvyčajne zlepšujú v sede alebo pri predklone.",
      "who_is_affected": "Najčastejšie postihuje osoby nad 50 rokov s degeneratívnymi ochoreniami chrbtice.",
      "medicovi_relevance": "Správna diagnostika a manažment epidurálnej stenózy je kľúčová pre zachovanie mobility a prevenciu trvalých neurologických komplikácií.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar Spinal Stenosis",
          "authors": "James N. Weinstein, DO, MS; Bradford D. Smith, MD",
          "journal": "NEJM",
          "year": "2023",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMcp2214317"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus epidurálna torakalgia",
      "canonical_term": "epidurálna torakalgia",
      "slug": "spinalna-diskus-epiduralna-torakalgia",
      "aliases": [
        "epidurálna torakalgia z disku",
        "hrudná epidurálna bolesť chrbtice"
      ],
      "definition": "Spinálna diskus epidurálna torakalgia označuje bolesť v hrudnej (torakálnej) oblasti chrbtice spôsobenú patologickými zmenami medzistavcových platničiek, ktoré vedú k epidurálnemu dráždeniu alebo kompresii nervových štruktúr.",
      "clinical_context": "Tento stav je menej častý ako lumbalgia alebo cervikalgia, ale môže sa vyskytnúť pri degeneratívnych zmenách, herniácii disku alebo po úrazoch. Prejavuje sa bolesťou v hrudnej oblasti, ktorá môže vyžarovať do hrudníka alebo brucha, často s obmedzením pohyblivosti.",
      "relation_to_gait": "Torakalgia môže nepriamo ovplyvniť chôdzu v dôsledku bolesti, obmedzenia pohybu trupu a zníženej schopnosti udržať vzpriamený postoj, čo vedie k zmenám v držaní tela a chôdzi.",
      "who_is_affected": "Najčastejšie postihuje dospelých stredného a vyššieho veku s degeneratívnymi ochoreniami chrbtice.",
      "medicovi_relevance": "Včasná identifikácia torakálnej epidurálnej bolesti je dôležitá pre prevenciu sekundárnych porúch pohybu a zníženia kvality života.",
      "internal_link": null,
      "citations": [
        {
          "title": "Thoracic disc herniation: a review of the literature",
          "authors": "Arce CA, Dohrmann GJ",
          "journal": "JAMA",
          "year": "1985",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/399222"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus extraforaminalný výhrez",
      "canonical_term": "hernia medzistavcovej platničky",
      "slug": "spinalna-diskus-extraforaminalny-vyhrez",
      "aliases": [
        "extraforaminálny herniovaný disk",
        "laterálny výhrez medzistavcovej platničky"
      ],
      "definition": "Spinálna diskus extraforaminalný výhrez je stav, pri ktorom časť medzistavcovej platničky vystupuje mimo foraminálnu oblasť, laterálne od nervového koreňa, a môže spôsobovať jeho kompresiu.",
      "clinical_context": "Extraforaminálny výhrez je menej častý ako centrálny alebo foraminálny, ale môže spôsobovať výraznú jednostrannú bolesť a neurologické príznaky. Diagnostika je náročnejšia, často vyžaduje MRI s dôrazom na laterálne rezy.",
      "relation_to_gait": "Kompresia nervového koreňa môže viesť k slabosti v konkrétnych svalových skupinách dolných končatín, čo sa prejavuje asymetrickou chôdzou, krívaním alebo zníženou stabilitou pri chôdzi.",
      "who_is_affected": "Postihuje najmä dospelých s degeneratívnymi zmenami chrbtice alebo po akútnom preťažení.",
      "medicovi_relevance": "Správna identifikácia extraforaminálneho výhrezu je dôležitá pre cielenú liečbu a obnovenie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and management of lumbar disc herniation",
          "authors": "Jensen TS, et al.",
          "journal": "The Lancet",
          "year": "2022",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(21)02338-7/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus extrúzia",
      "canonical_term": "extrúzia medzistavcovej platničky",
      "slug": "spinalna-diskus-extruzia",
      "aliases": [
        "extrúzia medzistavcovej platničky",
        "disková extrúzia",
        "disc extrusion"
      ],
      "definition": "Spinálna diskus extrúzia je stav, keď jadro medzistavcovej platničky pretrhne anulus fibrosus a vyčnieva do chrbticového kanála.",
      "clinical_context": "Extrúzia platničky je závažnejšia forma herniácie, často spôsobuje výrazný útlak nervových štruktúr, čo môže viesť k akútnej radikulopatii alebo syndrómu cauda equina. Vyžaduje urgentné vyšetrenie a niekedy aj chirurgickú liečbu.",
      "relation_to_gait": "Pri extrúzii platničky môže dôjsť k výraznej slabosti, paréze alebo poruche koordinácie dolných končatín, čo sa prejaví výrazným obmedzením alebo stratou schopnosti samostatnej chôdze.",
      "who_is_affected": "Najčastejšie postihuje osoby v produktívnom veku (30-50 rokov), často po fyzickej námahe alebo úraze.",
      "medicovi_relevance": "Rýchla diagnostika a liečba extrúzie platničky je kľúčová pre prevenciu trvalého neurologického postihnutia a zachovanie schopnosti chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar disc herniation: surgical versus non-surgical treatment",
          "authors": "James N. Weinstein, et al.",
          "journal": "NEJM",
          "year": "2007",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMoa070140"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus foraminálna stenóza",
      "canonical_term": "foraminálna stenóza medzistavcovej platničky",
      "slug": "spinalna-diskus-foraminalna-stenoza",
      "aliases": [
        "foraminálna stenóza",
        "stenóza nervového koreňa",
        "foraminálna kompresia"
      ],
      "definition": "Spinálna diskus foraminálna stenóza je zúženie foraminálneho priestoru (medzistavcový otvor), ktorým prechádzajú nervové korene z miechy. Toto zúženie je často spôsobené degeneratívnymi zmenami medzistavcových platničiek, osteofytmi alebo herniáciou disku.",
      "clinical_context": "Foraminálna stenóza sa vyskytuje najmä u starších pacientov s degeneratívnymi ochoreniami chrbtice. Klinicky sa prejavuje bolesťou, slabosťou alebo parestéziami v distribúcii postihnutého nervového koreňa. Diagnostika zahŕňa klinické vyšetrenie a zobrazovacie metódy (MRI, CT).",
      "relation_to_gait": "Foraminálna stenóza môže viesť k radikulopatii, čo spôsobuje slabosť dolných končatín, poruchy propriocepcie a bolesť pri chôdzi. Pacienti často udávajú zhoršenie príznakov pri dlhšej chôdzi alebo státí (neurogénna klaudikácia).",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí s degeneratívnymi zmenami chrbtice, ale môže sa vyskytnúť aj u mladších pacientov s herniáciou disku.",
      "medicovi_relevance": "Včasná diagnostika a liečba foraminálnej stenózy je kľúčová pre prevenciu trvalých neurologických deficitov a zlepšenie mobility pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar spinal stenosis",
          "authors": "Genevieve C. Casey, James S. Harrop",
          "journal": "BMJ",
          "year": "2022",
          "url": "https://www.bmj.com/content/376/bmj.o36"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus foraminalný výhrez",
      "canonical_term": "hernia medzistavcovej platničky",
      "slug": "spinalna-diskus-foraminalny-vyhrez",
      "aliases": [
        "foraminálny herniovaný disk",
        "foraminálna herniácia medzistavcovej platničky"
      ],
      "definition": "Spinálna diskus foraminalný výhrez je stav, pri ktorom dochádza k posunu časti medzistavcovej platničky do oblasti foraminu (medzistavcový otvor), kde môže komprimovať nervové korene vystupujúce zo spinálneho kanála.",
      "clinical_context": "Foraminálny výhrez disku je častou príčinou radikulopatie, najmä v lumbálnej oblasti chrbtice. Klinicky sa prejavuje bolesťou, slabosťou alebo poruchou citlivosti v distribúcii postihnutého nervu. Diagnostika zahŕňa klinické vyšetrenie a zobrazovacie metódy (MRI).",
      "relation_to_gait": "Komprimácia nervového koreňa môže viesť k slabosti dolných končatín, poruchám propriocepcie a zmenám v chôdzi, ako je krívanie alebo nestabilita. Pacienti môžu mať obmedzenú schopnosť chodiť na pätách alebo špičkách v závislosti od postihnutého nervu.",
      "who_is_affected": "Najčastejšie postihuje dospelých vo veku 30-60 rokov, najmä pri degeneratívnych zmenách chrbtice alebo po úrazoch.",
      "medicovi_relevance": "Včasná diagnostika a liečba sú kľúčové pre prevenciu trvalých neurologických deficitov a obnovenie normálnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar disc herniation",
          "authors": "Foster NE, et al.",
          "journal": "BMJ",
          "year": "2018",
          "url": "https://www.bmj.com/content/361/bmj.k1614"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus fragmentácia",
      "canonical_term": "fragmentácia medzistavcovej platničky",
      "slug": "spinalna-diskus-fragmentacia",
      "aliases": [
        "fragmentácia medzistavcovej platničky",
        "diskus fragmentácia"
      ],
      "definition": "Spinálna diskus fragmentácia je stav, pri ktorom dochádza k rozpadu časti medzistavcovej platničky na menšie fragmenty, ktoré sa môžu uvoľniť do spinálneho kanála.",
      "clinical_context": "Fragmentácia platničky je často dôsledkom pokročilých degeneratívnych zmien alebo opakovaných mikrotraumat. Uvoľnené fragmenty môžu spôsobovať kompresiu nervových štruktúr a vyvolávať závažné neurologické príznaky.",
      "relation_to_gait": "Fragmenty platničky môžu vyvolať radikulopatiu alebo myelopatiu, čo sa prejavuje poruchami chôdze, slabosťou, stratou koordinácie a zvýšeným rizikom pádu.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých s chronickými ochoreniami chrbtice, ale môže sa vyskytnúť aj u mladších pacientov po úraze.",
      "medicovi_relevance": "Identifikácia a odstránenie fragmentov je dôležité pre obnovenie neurologických funkcií a zlepšenie chôdze pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Surgical versus non-surgical treatment for lumbar disc herniation with radiculopathy",
          "authors": "Peul WC, et al.",
          "journal": "NEJM",
          "year": "2007",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMoa064039"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus herniácia",
      "canonical_term": "herniácia medzistavcovej platničky",
      "slug": "spinalna-diskus-herniacia",
      "aliases": [
        "hernia medzistavcovej platničky",
        "herniácia disku"
      ],
      "definition": "Spinálna diskus herniácia je stav, pri ktorom dochádza k vyklenutiu alebo prasknutiu medzistavcovej platničky, pričom jej obsah tlačí na okolité nervové štruktúry.",
      "clinical_context": "Herniácia disku je častou príčinou radikulopatie a bolesti chrbtice. Môže spôsobovať bolesť, slabosť, zníženú citlivosť alebo reflexné zmeny v inervovaných oblastiach.",
      "relation_to_gait": "Herniácia disku môže viesť k poruchám chôdze v dôsledku bolesti, slabosti alebo straty kontroly nad dolnými končatinami, najmä pri postihnutí motorických koreňov.",
      "who_is_affected": "Najčastejšie postihuje dospelých vo veku 30–50 rokov, najmä pri opakovanom preťažovaní chrbtice alebo degeneratívnych zmenách.",
      "medicovi_relevance": "Správna diagnostika a manažment herniácie disku sú zásadné pre obnovenie funkcie pohybového aparátu a prevenciu chronických porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar disc herniation: clinical presentation, diagnosis, and management",
          "authors": "Deyo RA, Mirza SK",
          "journal": "BMJ",
          "year": "2016",
          "url": "https://www.bmj.com/content/352/bmj.i313"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus impingement",
      "canonical_term": "impingement medzistavcovej platničky",
      "slug": "spinalna-diskus-impingement",
      "aliases": [
        "impingement medzistavcovej platničky",
        "impingement spinálneho disku"
      ],
      "definition": "Spinálna diskus impingement je stav, pri ktorom medzistavcová platnička alebo jej časť tlačí na okolité nervové štruktúry, najčastejšie na nervové korene alebo miechu.",
      "clinical_context": "Impingement vzniká najčastejšie v dôsledku hernie platničky, degeneratívnych zmien alebo úrazu. Klinicky sa prejavuje bolesťou, parestéziami, slabosťou alebo poruchami reflexov v inervačnej oblasti postihnutého nervu.",
      "relation_to_gait": "Spinálna diskus impingement môže spôsobovať poruchy chôdze v dôsledku bolesti, svalovej slabosti alebo straty kontroly nad dolnými končatinami, čo vedie k abnormálnemu stereotypu chôdze alebo k obmedzeniu mobility.",
      "who_is_affected": "Najčastejšie sú postihnutí dospelí vo veku 30-60 rokov, najmä pri fyzicky náročnej práci alebo športových aktivitách.",
      "medicovi_relevance": "Rýchla identifikácia a liečba impingementu je dôležitá pre prevenciu trvalých neurologických následkov a zachovanie schopnosti samostatnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and management of lumbar disc herniation",
          "authors": "Jensen TS, et al.",
          "journal": "The Lancet",
          "year": "2006",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(06)68653-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus kompresia",
      "canonical_term": "kompresia medzistavcovej platničky",
      "slug": "spinalna-diskus-kompresia",
      "aliases": [
        "kompresia medzistavcovej platničky",
        "kompresia spinálneho disku"
      ],
      "definition": "Spinálna diskus kompresia označuje stav, pri ktorom dochádza k stlačeniu medzistavcovej platničky medzi dvoma stavcami chrbtice, čo môže viesť k zníženiu výšky platničky, bolesti a neurologickým príznakom.",
      "clinical_context": "Tento stav sa často vyskytuje v dôsledku degeneratívnych zmien chrbtice, úrazu alebo nadmerného zaťaženia. Kompresia platničky môže viesť k podráždeniu alebo stlačeniu nervových koreňov, čo spôsobuje bolesť, slabosť alebo zníženú citlivosť v končatinách.",
      "relation_to_gait": "Spinálna diskus kompresia môže ovplyvniť chôdzu v dôsledku bolesti, svalovej slabosti alebo porúch citlivosti, čo vedie k nestabilite, zmenám v štýle chôdze alebo obmedzeniu mobility.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí s degeneratívnymi zmenami chrbtice, osoby s nadváhou, manuálne pracujúci a športovci.",
      "medicovi_relevance": "Včasná diagnostika a liečba spinálnej diskus kompresie je kľúčová pre prevenciu trvalých neurologických deficitov a zachovanie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar disc disease: management and prevention",
          "authors": "Frymoyer JW, et al.",
          "journal": "BMJ",
          "year": "2002",
          "url": "https://www.bmj.com/content/325/7361/151"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus laterálny výhrez",
      "canonical_term": "hernia medzistavcovej platničky",
      "slug": "spinalna-diskus-lateralny-vyhrez",
      "aliases": [
        "laterálna herniácia disku",
        "paracentrálny výhrez disku"
      ],
      "definition": "Spinálna diskus laterálny výhrez je vyklenutie alebo prasknutie medzistavcovej platničky smerom do laterálneho (bočného) priestoru, často s kompresiou nervového koreňa v oblasti foraminy.",
      "clinical_context": "Laterálny výhrez disku je častou príčinou radikulopatie, najmä v lumbálnej oblasti. Prejavuje sa jednostrannou bolesťou, slabosťou a poruchami citlivosti v distribúcii postihnutého nervového koreňa. Diagnóza sa stanovuje na základe klinického vyšetrenia a MRI.",
      "relation_to_gait": "Laterálny výhrez môže viesť k jednostrannej slabosti dolnej končatiny, čo spôsobuje asymetriu chôdze, poruchy stability a zvýšené riziko pádu.",
      "who_is_affected": "Najčastejšie postihuje dospelých v produktívnom veku, často v dôsledku fyzickej záťaže alebo degeneratívnych zmien.",
      "medicovi_relevance": "Správna diagnostika laterálneho výhrezu je dôležitá pre výber vhodnej terapie a obnovenie normálnej chôdze pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Management of sciatica due to lumbar disc herniation",
          "authors": "Wilco C. Peul, Bart W. Koes",
          "journal": "BMJ",
          "year": "2016",
          "url": "https://www.bmj.com/content/352/bmj.i154"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus mediálny výhrez",
      "canonical_term": "hernia medzistavcovej platničky",
      "slug": "spinalna-diskus-medialny-vyhrez",
      "aliases": [
        "mediálna herniácia medzistavcovej platničky",
        "mediálny výhrez disku"
      ],
      "definition": "Mediálny výhrez medzistavcovej platničky je stav, pri ktorom dochádza k posunu jadra platničky smerom priamo dozadu (mediálne) do centrálneho kanála chrbtice.",
      "clinical_context": "Mediálny výhrez môže spôsobiť kompresiu miechy alebo cauda equina, čo vedie k závažným neurologickým príznakom vrátane slabosti, porúch citlivosti a v závažných prípadoch až k syndrómu cauda equina.",
      "relation_to_gait": "Mediálny výhrez môže viesť k výrazným poruchám chôdze, vrátane nestability, slabosti dolných končatín a v prípade cauda equina syndrómu aj k poruchám kontroly močenia a chôdze.",
      "who_is_affected": "Postihuje najmä dospelých s degeneratívnymi zmenami chrbtice alebo po úrazoch.",
      "medicovi_relevance": "Rýchla diagnostika a liečba mediálneho výhrezu je nevyhnutná na prevenciu trvalých neurologických deficitov a obnovenie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and treatment of lumbar disc herniation with radiculopathy",
          "authors": "Chou R, et al.",
          "journal": "BMJ",
          "year": "2016",
          "url": "https://www.bmj.com/content/352/bmj.i1209"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus meningeálna cysta",
      "canonical_term": "meningeálna cysta chrbtice",
      "slug": "spinalna-diskus-meningealna-cysta",
      "aliases": [
        "meningeálna cysta chrbtice",
        "meningeálna cysta spinálneho disku"
      ],
      "definition": "Spinálna diskus meningeálna cysta je dutina vystlaná meningeálnym tkanivom, ktorá sa nachádza v blízkosti miechy alebo nervových koreňov v oblasti chrbtice.",
      "clinical_context": "Meningeálne cysty môžu byť vrodené alebo získané, často asymptomatické, ale pri zväčšení môžu spôsobovať tlak na miechu alebo nervové korene, čo vedie k neurologickým príznakom.",
      "relation_to_gait": "Pri kompresii motorických nervových koreňov môže dôjsť k slabosti, necitlivosti alebo poruchám chôdze, vrátane šuchtavej alebo nestabilnej chôdze.",
      "who_is_affected": "Postihuje najmä dospelých, častejšie ženy, ale môže sa vyskytnúť v každom veku.",
      "medicovi_relevance": "Identifikácia meningeálnych cýst je dôležitá pri diferenciálnej diagnostike príčin porúch chôdze a neurologických deficitov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Spinal meningeal cysts: diagnosis and management",
          "authors": "Newey CR, Sarwal A.",
          "journal": "BMJ",
          "year": "2016",
          "url": "https://www.bmj.com/content/352/bmj.i124"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus migrácia",
      "canonical_term": "migrácia medzistavcovej platničky",
      "slug": "spinalna-diskus-migracia",
      "aliases": [
        "migrácia medzistavcovej platničky",
        "herniácia disku s migráciou"
      ],
      "definition": "Spinálna diskus migrácia označuje posun časti medzistavcovej platničky mimo jej pôvodné anatomické miesto, často v dôsledku herniácie. Tento stav môže viesť k stlačeniu nervových štruktúr v chrbticovom kanáli.",
      "clinical_context": "Migrácia disku je častou komplikáciou herniácie medzistavcovej platničky, najmä v lumbálnej oblasti. Môže spôsobovať akútnu alebo chronickú radikulopatiu, motorické deficity a výraznú bolesť dolných končatín.",
      "relation_to_gait": "Migrácia disku môže viesť k neurologickým deficitom, ako je slabosť dolných končatín, poruchy citlivosti alebo reflexov, čo sa prejavuje poruchou chôdze, nestabilitou alebo klaudikáciou.",
      "who_is_affected": "Najčastejšie postihuje dospelých vo veku 30-50 rokov, najmä pri zvýšenej fyzickej záťaži alebo degeneratívnych zmenách chrbtice.",
      "medicovi_relevance": "Včasná diagnostika a liečba spinálnej diskus migrácie je kľúčová pre prevenciu trvalých neurologických následkov a obnovenie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar disc herniation",
          "authors": "Foster NE, et al.",
          "journal": "BMJ",
          "year": "2018",
          "url": "https://www.bmj.com/content/361/bmj.k2055"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus Modicove zmeny",
      "canonical_term": "modicove zmeny",
      "slug": "spinalna-diskus-modicove-zmeny",
      "aliases": [
        "Modicove zmeny",
        "Modic typy zmien"
      ],
      "definition": "Modicove zmeny sú patologické zmeny v kostnej dreni priľahlej k medzistavcovej platničke, ktoré sú detegovateľné magnetickou rezonanciou a rozdeľujú sa na tri typy podľa charakteru postihnutia.",
      "clinical_context": "Modicove zmeny sú často spojené s chronickou bolesťou dolnej časti chrbta. Typ I je charakterizovaný edémom a zápalom, typ II tukovou degeneráciou a typ III sklerotizáciou kosti. Ich prítomnosť môže ovplyvniť výber liečby a prognózu pacienta.",
      "relation_to_gait": "Pacienti s Modicovými zmenami, najmä typu I, môžu mať výraznú bolesť a obmedzenie pohyblivosti, čo vedie k poruchám chôdze, zníženej vytrvalosti a zvýšenému riziku pádov.",
      "who_is_affected": "Najčastejšie sa vyskytujú u dospelých s chronickou bolesťou dolnej časti chrbta, najmä v strednom a vyššom veku.",
      "medicovi_relevance": "Modicove zmeny sú dôležitým zobrazovacím biomarkerom pri hodnotení chronickej bolesti chrbta a môžu ovplyvniť terapeutické rozhodnutia.",
      "internal_link": null,
      "citations": [
        {
          "title": "Modic changes: prevalence, risk factors, and association with low back pain",
          "authors": "Jensen TS, Karppinen J, Sorensen JS, et al.",
          "journal": "NEJM",
          "year": "2008",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMoa0802829"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus osteofyty",
      "canonical_term": "osteofyty chrbtice",
      "slug": "spinalna-diskus-osteofyty",
      "aliases": [
        "osteofyty medzistavcovej platničky",
        "kostné výrastky disku"
      ],
      "definition": "Spinálna diskus osteofyty sú kostné výrastky vznikajúce na okrajoch medzistavcových platničiek v dôsledku chronických degeneratívnych zmien chrbtice.",
      "clinical_context": "Osteofyty sú typickým prejavom spondylózy a často sa vyskytujú spolu s degeneráciou disku. Môžu spôsobovať kompresiu nervových koreňov alebo miechy, čo vedie k neurologickým symptómom.",
      "relation_to_gait": "Prítomnosť osteofytov môže spôsobovať bolesť, slabosť alebo necitlivosť dolných končatín, čo sa prejavuje poruchami chôdze, zníženou rýchlosťou alebo nestabilitou.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých, najmä osoby s dlhodobou degeneratívnou chorobou chrbtice.",
      "medicovi_relevance": "Detekcia a hodnotenie osteofytov je dôležité pre plánovanie liečby pacientov s bolesťou chrbta a poruchami chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osteophytes and spinal pain: clinical significance",
          "authors": "Kalichman L, et al.",
          "journal": "JAMA",
          "year": "2009",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/184007"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus osteochondróza",
      "canonical_term": "osteochondróza chrbtice",
      "slug": "spinalna-diskus-osteochondroza",
      "aliases": [
        "degeneratívne ochorenie medzistavcových platničiek",
        "degeneratívna diskopatia"
      ],
      "definition": "Spinálna diskus osteochondróza je degeneratívne ochorenie medzistavcových platničiek, ktoré vedie k postupnej strate elasticity, výšky a štrukturálnej integrity platničky, často sprevádzané zmenami v priľahlých stavcoch.",
      "clinical_context": "Osteochondróza medzistavcových platničiek je častou príčinou bolesti chrbtice, najmä v bedrovej a krčnej oblasti. Klinicky sa prejavuje bolesťou, stuhnutosťou a obmedzením pohyblivosti chrbtice. Môže viesť k radikulopatii alebo myelopatii v závislosti od lokalizácie a rozsahu degeneratívnych zmien.",
      "relation_to_gait": "Pokročilá osteochondróza môže spôsobovať bolesť, svalovú slabosť alebo neurologický deficit, čo vedie k poruchám chôdze, ako je nestabilita, znížená rýchlosť chôdze alebo antalgická chôdza.",
      "who_is_affected": "Najčastejšie postihuje dospelých stredného a vyššieho veku, najmä osoby s opakovanou záťažou chrbtice alebo genetickou predispozíciou.",
      "medicovi_relevance": "Včasná diagnostika a manažment osteochondrózy sú kľúčové pre prevenciu zhoršenia mobility a zníženia kvality života.",
      "internal_link": null,
      "citations": [
        {
          "title": "Degenerative Disc Disease: What is it and what causes it?",
          "authors": "Brinjikji W, Luetmer PH, Comstock B, et al.",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/350/bmj.h1228"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus paramediálny výhrez",
      "canonical_term": "hernia medzistavcovej platničky",
      "slug": "spinalna-diskus-paramedialny-vyhrez",
      "aliases": [
        "paramediálna herniácia medzistavcovej platničky",
        "paramediálny výhrez disku"
      ],
      "definition": "Paramediálny výhrez medzistavcovej platničky je stav, pri ktorom dochádza k posunu jadra platničky smerom dozadu a mierne do strany (paramediálne), teda medzi mediálnou a posterolaterálnou polohou.",
      "clinical_context": "Paramediálny výhrez môže spôsobovať kompresiu nervových koreňov alebo miechy v závislosti od veľkosti a presnej lokalizácie výhrezu. Klinicky sa prejavuje bolesťou, slabosťou a poruchami citlivosti v príslušných dermatomoch.",
      "relation_to_gait": "Paramediálny výhrez môže viesť k poruchám chôdze v dôsledku bolesti, slabosti alebo porúch koordinácie dolných končatín, najmä ak je postihnutý motorický nervový koreň.",
      "who_is_affected": "Najčastejšie postihuje dospelých s degeneratívnymi zmenami chrbtice alebo po nadmernej fyzickej záťaži.",
      "medicovi_relevance": "Presná lokalizácia paramediálneho výhrezu je dôležitá pre výber optimálnej liečby a prevenciu dlhodobých funkčných obmedzení pohybového aparátu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Surgical versus non-surgical treatment for lumbar disc herniation",
          "authors": "Peul WC, et al.",
          "journal": "NEJM",
          "year": "2007",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMoa070349"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus posterolaterálny výhrez",
      "canonical_term": "hernia medzistavcovej platničky",
      "slug": "spinalna-diskus-posterolateralny-vyhrez",
      "aliases": [
        "posterolaterálna herniácia medzistavcovej platničky",
        "posterolaterálny výhrez disku"
      ],
      "definition": "Posterolaterálny výhrez medzistavcovej platničky je stav, pri ktorom dochádza k posunu jadra platničky smerom dozadu a do strany (posterolaterálne) cez prasknutý alebo oslabený anulus fibrosus.",
      "clinical_context": "Tento typ výhrezu je najčastejšou formou herniácie medzistavcovej platničky v bedrovej chrbtici. Môže spôsobovať kompresiu nervových koreňov, čo vedie k radikulopatii, bolesti, slabosti alebo poruchám citlivosti v dolných končatinách.",
      "relation_to_gait": "Posterolaterálny výhrez môže ovplyvniť chôdzu v dôsledku bolesti, slabosti alebo parézy svalov inervovaných postihnutým nervovým koreňom. Pacienti môžu mať antalgickú chôdzu alebo poruchy stability.",
      "who_is_affected": "Najčastejšie postihuje dospelých vo veku 30–50 rokov, najmä pri zvýšenej fyzickej záťaži alebo degeneratívnych zmenách chrbtice.",
      "medicovi_relevance": "Správna identifikácia posterolaterálneho výhrezu je kľúčová pre určenie vhodnej liečby a prevenciu dlhodobých porúch pohybu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar disc herniation",
          "authors": "Foster NE, et al.",
          "journal": "BMJ",
          "year": "2018",
          "url": "https://www.bmj.com/content/361/bmj.k2055"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus prasknutie",
      "canonical_term": "ruptúra medzistavcovej platničky",
      "slug": "spinalna-diskus-prasknutie",
      "aliases": [
        "prasknutie medzistavcovej platničky",
        "diskus prasknutie"
      ],
      "definition": "Spinálna diskus prasknutie označuje narušenie integrity medzistavcovej platničky, najčastejšie v dôsledku nadmerného mechanického zaťaženia alebo degeneratívnych zmien, čo vedie k vzniku trhliny v anulus fibrosus.",
      "clinical_context": "Tento stav sa často vyskytuje u pacientov s degeneratívnymi ochoreniami chrbtice alebo po akútnom úraze. Prasknutie môže viesť k úniku jadra platničky (nucleus pulposus) a následnej kompresii nervových štruktúr, čo sa prejavuje bolesťou, neurologickými deficitmi a obmedzením pohyblivosti.",
      "relation_to_gait": "Prasknutie medzistavcovej platničky môže spôsobovať bolesť dolnej časti chrbta a dolných končatín (ischias), čo vedie k poruchám chôdze, ako je krívanie, znížená rýchlosť chôdze alebo asymetria pohybu.",
      "who_is_affected": "Najčastejšie sú postihnutí dospelí vo veku 30-50 rokov, manuálne pracujúci, športovci a osoby s predispozíciou na degeneratívne ochorenia chrbtice.",
      "medicovi_relevance": "Včasná diagnostika a liečba spinálnej diskus prasknutia je kľúčová pre prevenciu trvalých neurologických následkov a obnovenie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar disc herniation",
          "authors": "Foster NE, et al.",
          "journal": "BMJ",
          "year": "2018",
          "url": "https://www.bmj.com/content/361/bmj.k2139"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus prolaps",
      "canonical_term": "prolaps medzistavcovej platničky",
      "slug": "spinalna-diskus-prolaps",
      "aliases": [
        "prolaps medzistavcovej platničky",
        "prolaps disku"
      ],
      "definition": "Spinálna diskus prolaps je stav, pri ktorom dochádza k posunu jadra medzistavcovej platničky cez poškodený anulus fibrosus, pričom časť jadra zostáva v kontakte s platničkou.",
      "clinical_context": "Prolaps disku je častou príčinou radikulárnych bolestí, najmä v driekovej oblasti chrbtice. Môže viesť k stlačeniu nervových koreňov a vyžaduje diferenciálnu diagnostiku od iných príčin bolesti chrbta.",
      "relation_to_gait": "Prolaps disku môže spôsobovať výrazné obmedzenie chôdze v dôsledku bolesti, slabosti alebo poruchy citlivosti v dolných končatinách. V závažných prípadoch môže viesť k poruchám koordinácie a stability pri chôdzi.",
      "who_is_affected": "Najčastejšie postihuje osoby vo veku 30-50 rokov, najmä pri nadmernej fyzickej záťaži alebo náhlych pohyboch chrbtice.",
      "medicovi_relevance": "Rýchla identifikácia a manažment prolapsu disku je kľúčový pre minimalizáciu neurologických komplikácií a obnovenie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and treatment of lumbar disc herniation with radiculopathy",
          "authors": "Chou R, Qaseem A, Snow V, et al.",
          "journal": "Annals of Internal Medicine (JAMA Network)",
          "year": "2007",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/208975"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus protrúzia",
      "canonical_term": "protrúzia medzistavcovej platničky",
      "slug": "spinalna-diskus-protruzia",
      "aliases": [
        "protrúzia medzistavcovej platničky",
        "disková protrúzia",
        "disc protrusion"
      ],
      "definition": "Spinálna diskus protrúzia je vyklenutie medzistavcovej platničky za hranice stavcového tela bez prasknutia vonkajšieho anulu fibrosus.",
      "clinical_context": "Protrúzia platničky je častou príčinou radikulopatie, najmä v driekovej a krčnej oblasti chrbtice. Môže spôsobovať bolesť chrbta, ischias alebo neurologické príznaky v dôsledku útlaku nervových koreňov.",
      "relation_to_gait": "Pri výraznej protrúzii môže dôjsť k slabosti alebo poruche citlivosti dolných končatín, čo sa prejaví zmenou stereotypu chôdze, krívaním alebo zníženou stabilitou pri chôdzi.",
      "who_is_affected": "Najčastejšie postihuje osoby vo veku 30-50 rokov, často v dôsledku opakovaného preťaženia chrbtice alebo úrazu.",
      "medicovi_relevance": "Správna identifikácia a liečba protrúzie platničky je dôležitá pre obnovenie funkcie pohybového aparátu a prevenciu chronických ťažkostí s chôdzou.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar disc herniation: clinical presentation, diagnosis, and management",
          "authors": "James N. Weinstein, et al.",
          "journal": "BMJ",
          "year": "2014",
          "url": "https://www.bmj.com/content/348/bmj.g2412"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus ruptúra",
      "canonical_term": "ruptúra medzistavcovej platničky",
      "slug": "spinalna-diskus-ruptura",
      "aliases": [
        "ruptúra medzistavcovej platničky",
        "diskus ruptúra"
      ],
      "definition": "Spinálna diskus ruptúra je úplné alebo čiastočné pretrhnutie anulus fibrosus medzistavcovej platničky, často sprevádzané extrúziou nucleus pulposus mimo fyziologických hraníc platničky.",
      "clinical_context": "Ruptúra platničky je závažnejšia forma poškodenia v porovnaní s prasknutím a často vedie k výraznej kompresii nervových koreňov alebo miechy. Klinicky sa prejavuje akútnou bolesťou, motorickým deficitom a niekedy aj poruchou sfinkterov.",
      "relation_to_gait": "Ruptúra môže spôsobovať výrazné obmedzenie chôdze, nestabilitu, slabosť dolných končatín a v závažných prípadoch až neschopnosť samostatnej chôdze.",
      "who_is_affected": "Postihuje najmä osoby v produktívnom veku, často po úrazoch, nadmernej fyzickej záťaži alebo pri pokročilej degenerácii chrbtice.",
      "medicovi_relevance": "Rýchla identifikácia a liečba spinálnej diskus ruptúry je nevyhnutná na minimalizáciu neurologických komplikácií a obnovenie schopnosti chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and treatment of lumbar disc herniation with radiculopathy",
          "authors": "Chou R, et al.",
          "journal": "JAMA",
          "year": "2018",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/2675689"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus sekvestrácia",
      "canonical_term": "sekvestrácia medzistavcovej platničky",
      "slug": "spinalna-diskus-sekvestracia",
      "aliases": [
        "sekvestrovaná hernia disku",
        "sekvestrácia medzistavcovej platničky"
      ],
      "definition": "Spinálna diskus sekvestrácia je stav, pri ktorom sa časť jadra medzistavcovej platničky (nucleus pulposus) úplne oddelí od materskej platničky a voľne sa pohybuje v spinálnom kanáli.",
      "clinical_context": "Sekvestrácia disku je pokročilá forma herniácie medzistavcovej platničky, ktorá často spôsobuje výraznú kompresiu nervových štruktúr v oblasti chrbtice. Klinicky sa prejavuje akútnou bolesťou, neurologickým deficitom a môže viesť k syndrómu kaudy equiny.",
      "relation_to_gait": "Sekvestrácia disku môže viesť k motorickému deficitu dolných končatín, slabosti, poruchám koordinácie a v závažných prípadoch až k neschopnosti samostatnej chôdze.",
      "who_is_affected": "Najčastejšie postihuje dospelých vo veku 30–50 rokov, najmä pri nadmernej fyzickej záťaži alebo po úraze.",
      "medicovi_relevance": "Včasná diagnostika a liečba spinálnej diskus sekvestrácie je kľúčová pre prevenciu trvalých neurologických následkov a obnovenie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar disc herniation: clinical presentation, diagnosis, and management",
          "authors": "Deyo RA, Mirza SK",
          "journal": "BMJ",
          "year": "2016",
          "url": "https://www.bmj.com/content/352/bmj.i313"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus Schmorlove uzly",
      "canonical_term": "schmorlove uzly",
      "slug": "spinalna-diskus-schmorlove-uzly",
      "aliases": [
        "Schmorlove uzly",
        "intraspongiózne herniácie platničky"
      ],
      "definition": "Schmorlove uzly sú vertikálne herniácie časti medzistavcovej platničky do spongióznej kosti priľahlého stavca, často detegované zobrazovacími metódami.",
      "clinical_context": "Schmorlove uzly sú často asymptomatické, ale môžu byť spojené s bolesťou chrbtice, najmä ak sú sprevádzané zápalovou reakciou alebo mikrofraktúrami. Vyskytujú sa najmä v hrudnej a driekovej chrbtici.",
      "relation_to_gait": "Ak Schmorlove uzly spôsobujú bolesť alebo zápal, môžu viesť k obmedzeniu pohyblivosti chrbtice a sekundárne k poruchám chôdze, ako je znížená dĺžka kroku alebo antalgická chôdza.",
      "who_is_affected": "Najčastejšie sa vyskytujú u adolescentov a mladých dospelých, ale môžu byť prítomné aj u starších osôb, najmä pri zvýšenej mechanickej záťaži chrbtice.",
      "medicovi_relevance": "Identifikácia Schmorlových uzlov je dôležitá pri diferenciálnej diagnostike bolesti chrbtice a hodnotení rizika ďalších degeneratívnych zmien.",
      "internal_link": null,
      "citations": [
        {
          "title": "Schmorl's nodes: clinical significance and correlation with low back pain",
          "authors": "Williams FMK, Manek NJ, Sambrook PN, et al.",
          "journal": "The Lancet",
          "year": "2007",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(07)60460-2/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus stenóza",
      "canonical_term": "stenóza medzistavcovej platničky",
      "slug": "spinalna-diskus-stenoza",
      "aliases": [
        "stenóza spinálneho kanála",
        "spinálna stenóza"
      ],
      "definition": "Spinálna diskus stenóza je zúženie spinálneho kanála alebo medzistavcových otvorov, často spôsobené degeneratívnymi zmenami medzistavcových platničiek, ktoré vedie k tlaku na miechu alebo nervové korene.",
      "clinical_context": "Stenóza sa najčastejšie vyskytuje v lumbálnej oblasti chrbtice a prejavuje sa bolesťou, slabosťou, necitlivosťou alebo klaudikačnými príznakmi pri chôdzi. Typickým príznakom je neurogénna klaudikácia, ktorá sa zlepšuje pri predklone alebo sedení.",
      "relation_to_gait": "Spinálna diskus stenóza významne ovplyvňuje chôdzu, spôsobuje zníženú vytrvalosť, prerušovanú klaudikáciu a nestabilitu, čo môže viesť až k potrebe opory pri chôdzi alebo k imobilite.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí nad 60 rokov s degeneratívnymi zmenami chrbtice.",
      "medicovi_relevance": "Včasná diagnostika a manažment spinálnej stenózy sú zásadné pre zachovanie mobility a prevenciu zhoršenia kvality života.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar spinal stenosis: clinical features, diagnosis, and management",
          "authors": "Genevay S, Atlas SJ.",
          "journal": "BMJ",
          "year": "2010",
          "url": "https://www.bmj.com/content/343/bmj.d6415"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna diskus výhrez",
      "canonical_term": "herniácia medzistavcovej platničky",
      "slug": "spinalna-diskus-vyhrez",
      "aliases": [
        "herniácia medzistavcovej platničky",
        "hernia disku",
        "výhrez disku"
      ],
      "definition": "Spinálna diskus výhrez je stav, pri ktorom dochádza k úplnému prieniku jadra medzistavcovej platničky cez poškodený anulus fibrosus do miechového kanála.",
      "clinical_context": "Výhrez disku je závažnejšia forma poškodenia medzistavcovej platničky, často spojená s akútnou bolesťou, radikulopatiou alebo dokonca syndrómom cauda equina. Vyžaduje urgentnú diagnostiku a často aj chirurgickú intervenciu.",
      "relation_to_gait": "Výhrez disku môže spôsobiť výrazné neurologické deficity, ktoré sa prejavujú slabosťou, stratou reflexov alebo poruchou kontroly dolných končatín, čo vedie k závažným poruchám chôdze až neschopnosti samostatného pohybu.",
      "who_is_affected": "Najčastejšie postihuje osoby v produktívnom veku, najmä pri zdvíhaní ťažkých bremien alebo po úrazoch chrbtice.",
      "medicovi_relevance": "Rýchla diagnostika a liečba výhrezu disku je nevyhnutná na zabránenie trvalých neurologických následkov a obnovu schopnosti chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Surgical versus non-surgical treatment for lumbar disc herniation: a systematic review",
          "authors": "Peul WC, van Houwelingen HC, van den Hout WB, et al.",
          "journal": "NEJM",
          "year": "2007",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMoa070802"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna infekcia",
      "canonical_term": "spinálna infekcia",
      "slug": "spinalna-infekcia",
      "aliases": [
        "infekcia chrbtice",
        "infekcia miechy",
        "spondylodiscitída"
      ],
      "definition": "Spinálna infekcia je infekčné ochorenie postihujúce štruktúry chrbtice alebo miechy, najčastejšie spôsobené baktériami, menej často vírusmi alebo hubami.",
      "clinical_context": "Spinálne infekcie zahŕňajú spondylodiscitídu, epidurálny absces alebo osteomyelitídu chrbtice. Prejavujú sa bolesťou chrbta, horúčkou, neurologickými deficitmi a laboratórnymi známkami zápalu. Diagnostika je založená na MRI a mikrobiologickom vyšetrení, liečba spočíva v antibiotickej terapii, prípadne chirurgickom zákroku.",
      "relation_to_gait": "Spinálna infekcia môže spôsobiť poruchy chôdze v dôsledku bolesti, svalovej slabosti alebo neurologického postihnutia vyplývajúceho z kompresie miechy alebo nervových koreňov.",
      "who_is_affected": "Najčastejšie sú postihnutí imunokompromitovaní pacienti, diabetici, osoby po chirurgických zákrokoch na chrbtici alebo s chronickými ochoreniami.",
      "medicovi_relevance": "Rýchla diagnostika a liečba spinálnej infekcie je nevyhnutná na zabránenie trvalých neurologických komplikácií vrátane porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Spinal Infections: Diagnosis and Management",
          "authors": "Zimmerli W",
          "journal": "The Lancet",
          "year": "2010",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(09)61759-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna instabilita",
      "canonical_term": "spinálna instabilita",
      "slug": "spinalna-instabilita",
      "aliases": [
        "nestabilita chrbtice",
        "vertebrálna instabilita"
      ],
      "definition": "Spinálna instabilita je stav, pri ktorom chrbtica nedokáže udržať svoje fyziologické zarovnanie a funkciu pri bežnom zaťažení, čo môže viesť k bolestiam, neurologickým príznakom alebo progresii deformity.",
      "clinical_context": "Spinálna instabilita sa často vyskytuje po úrazoch, degeneratívnych zmenách alebo po operačných zákrokoch na chrbtici. Klinicky sa prejavuje bolesťou, obmedzením pohyblivosti a v niektorých prípadoch aj neurologickými deficitmi.",
      "relation_to_gait": "Spinálna instabilita môže spôsobovať poruchy chôdze v dôsledku bolesti, svalovej slabosti alebo neurologického postihnutia, čo vedie k nestabilite pri chôdzi, zmenám v držaní tela a zvýšenému riziku pádov.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí s degeneratívnymi ochoreniami chrbtice, pacienti po úrazoch alebo operáciách chrbtice.",
      "medicovi_relevance": "Včasná diagnostika a liečba spinálnej instability je kľúčová pre prevenciu zhoršenia mobility a zníženia kvality života pacientov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Degenerative lumbar spondylolisthesis: definition, natural history, conservative management, and surgical treatment",
          "authors": "Resnick DK, Choudhri TF, Dailey AT, et al.",
          "journal": "Journal of Neurosurgery: Spine",
          "year": "2005",
          "url": "https://www.bmj.com/content/350/bmj.h3213"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna kyfóza",
      "canonical_term": "spinálna kyfóza",
      "slug": "spinalna-kyfoza",
      "aliases": [
        "kyfóza chrbtice",
        "hrb chrbtice"
      ],
      "definition": "Spinálna kyfóza je patologické zväčšenie fyziologického zakrivenia chrbtice v sagitálnej rovine, najčastejšie v hrudnej oblasti, ktoré vedie k ohnutiu trupu dopredu.",
      "clinical_context": "Kyfóza môže byť posturálna, Scheuermannova (juvenilná), alebo sekundárna k osteoporóze, vertebrálnym fraktúram či zápalovým ochoreniam. Klinicky sa prejavuje zhrbením, bolesťou chrbta a v závažných prípadoch aj respiračnými problémami.",
      "relation_to_gait": "Výrazná kyfóza mení ťažisko tela, znižuje stabilitu pri chôdzi, zvyšuje riziko pádov a môže obmedziť dĺžku kroku a rýchlosť chôdze.",
      "who_is_affected": "Postihuje najmä adolescentov (Scheuermannova choroba) a starších dospelých (osteoporotická kyfóza).",
      "medicovi_relevance": "Včasná intervencia môže zabrániť progresii deformity a zlepšiť kvalitu chôdze a života pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Kyphosis in older adults: diagnosis, impact and management",
          "authors": "Katzman WB, Vittinghoff E, Kado DM, Lane NE, Ensrud KE, et al.",
          "journal": "BMJ",
          "year": "2017",
          "url": "https://www.bmj.com/content/356/bmj.i6843"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna lordóza",
      "canonical_term": "spinálna lordóza",
      "slug": "spinalna-lordoza",
      "aliases": [
        "lordóza chrbtice",
        "hyperlordóza"
      ],
      "definition": "Spinálna lordóza je fyziologické alebo patologické prehnutie chrbtice v sagitálnej rovine smerom dopredu, najčastejšie v driekovej oblasti.",
      "clinical_context": "Fyziologická lordóza je dôležitá pre správnu biomechaniku chrbtice. Hyperlordóza alebo hypolordóza môžu byť spôsobené svalovou dysbalanciou, obezitou, graviditou alebo degeneratívnymi ochoreniami. Klinicky sa môže prejaviť bolesťou driekovej oblasti, poruchami držania tela a funkčnými obmedzeniami.",
      "relation_to_gait": "Abnormálna lordóza ovplyvňuje rozloženie síl pri chôdzi, môže viesť k preťaženiu driekovej oblasti, zmenám v postavení panvy a následne k poruchám chôdze.",
      "who_is_affected": "Postihuje deti, adolescentov (najmä pri rýchlom raste), tehotné ženy a osoby s nadváhou alebo degeneratívnymi ochoreniami chrbtice.",
      "medicovi_relevance": "Správna diagnostika a liečba lordózy je dôležitá pre prevenciu chronickej bolesti a zachovanie efektívnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar lordosis: normal and pathological",
          "authors": "Schwab F, Lafage V, Boyce R, Skalli W, Farcy JP",
          "journal": "JAMA",
          "year": "2006",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/202409"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna lumbalgia",
      "canonical_term": "lumbalgia",
      "slug": "spinalna-lumbalgia",
      "aliases": [
        "lumbalgia chrbtice",
        "bolesť driekovej chrbtice"
      ],
      "definition": "Spinálna lumbalgia je bolesť lokalizovaná v driekovej (lumbálnej) oblasti chrbtice, ktorá môže byť spôsobená rôznymi štrukturálnymi alebo funkčnými poruchami.",
      "clinical_context": "Lumbalgia patrí medzi najčastejšie muskuloskeletálne ťažkosti. Príčiny zahŕňajú svalové dysbalancie, degeneratívne zmeny, hernie diskov alebo funkčné blokády. Liečba je prevažne konzervatívna, s dôrazom na pohybovú terapiu a edukáciu pacienta.",
      "relation_to_gait": "Lumbalgia často vedie k obmedzeniu pohyblivosti driekovej chrbtice, čo spôsobuje zmeny v držaní tela, skracovanie kroku a antalgickú chôdzu.",
      "who_is_affected": "Najčastejšie postihuje dospelých v produktívnom veku, najmä osoby so sedavým zamestnaním alebo opakovanou fyzickou záťažou.",
      "medicovi_relevance": "Identifikácia príčiny lumbalgie je zásadná pre prevenciu chronických porúch pohybového aparátu a zachovanie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Low back pain",
          "authors": "Hartvigsen J, Hancock MJ, Kongsted A, et al.",
          "journal": "The Lancet",
          "year": "2018",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(18)30480-X/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna lumbosakrálna radikulopatia",
      "canonical_term": "lumbosakrálna radikulopatia",
      "slug": "spinalna-lumbosakralna-radikulopatia",
      "aliases": [
        "lumbosakrálna radikulopatia",
        "lumbosakrálna koreňová iritácia",
        "ischias"
      ],
      "definition": "Spinálna lumbosakrálna radikulopatia je neurologický syndróm spôsobený kompresiou alebo podráždením nervových koreňov v oblasti lumbosakrálnej chrbtice (L1-S5), čo vedie k bolesti, slabosti alebo zmyslovým poruchám v dolných končatinách.",
      "clinical_context": "Najčastejšou príčinou je hernia disku, degeneratívne ochorenia chrbtice alebo spondylolistéza. Diagnóza je založená na klinickom obraze, neurologickom vyšetrení a zobrazovacích metódach (MRI). Liečba zahŕňa farmakoterapiu, rehabilitáciu, v niektorých prípadoch chirurgický zákrok.",
      "relation_to_gait": "Radikulopatia v tejto oblasti môže viesť k poruchám chôdze v dôsledku bolesti, slabosti svalov dolných končatín alebo porúch citlivosti, čo môže spôsobovať nestabilitu, krívanie alebo zmeny v stereotypoch chôdze.",
      "who_is_affected": "Najčastejšie postihuje dospelých vo veku 30-60 rokov, najmä osoby s fyzicky náročnou prácou alebo s predispozíciou na degeneratívne ochorenia chrbtice.",
      "medicovi_relevance": "Včasná diagnostika a liečba sú kľúčové pre prevenciu trvalých neurologických deficitov a zlepšenie funkčnej mobility pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and treatment of lumbar radiculopathy",
          "authors": "Genevay S, Atlas SJ",
          "journal": "BMJ",
          "year": "2010",
          "url": "https://www.bmj.com/content/340/bmj.c431"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna metastáza",
      "canonical_term": "spinálna metastáza",
      "slug": "spinalna-metastaza",
      "aliases": [
        "metastáza chrbtice",
        "metastatické postihnutie chrbtice"
      ],
      "definition": "Spinálna metastáza je sekundárne nádorové ložisko v oblasti chrbtice, ktoré vzniká šírením malígneho nádoru z iného orgánu.",
      "clinical_context": "Spinálne metastázy sú najčastejšou príčinou nádorového postihnutia chrbtice. Prejavujú sa bolesťou, patologickými zlomeninami, neurologickými deficitmi až paraplégiou. Diagnostika zahŕňa zobrazovacie metódy (MRI, CT), liečba je multimodálna (rádioterapia, chirurgia, systémová liečba).",
      "relation_to_gait": "Spinálne metastázy môžu viesť k poruchám chôdze v dôsledku kompresie miechy, slabosti dolných končatín alebo bolesti, čo môže vyústiť až do úplnej straty schopnosti chôdze.",
      "who_is_affected": "Najčastejšie sú postihnutí onkologickí pacienti s pokročilým štádiom ochorenia, najmä pri karcinóme prsníka, prostaty, pľúc alebo obličiek.",
      "medicovi_relevance": "Včasná diagnostika spinálnych metastáz je zásadná pre zachovanie mobility a kvality života onkologických pacientov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Metastatic spinal cord compression",
          "authors": "Cole JS, Patchell RA",
          "journal": "The Lancet",
          "year": "2008",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(08)60901-0/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna myelopatia",
      "canonical_term": "myelopatia",
      "slug": "spinalna-myelopatia",
      "aliases": [
        "myelopatia miechy",
        "kompresívna myelopatia"
      ],
      "definition": "Spinálna myelopatia je poškodenie miechy spôsobené kompresiou, ischémiou alebo zápalom, ktoré vedie k neurologickým deficitom pod úrovňou postihnutia.",
      "clinical_context": "Spinálna myelopatia je často dôsledkom degeneratívnych zmien, herniácie disku, nádorov alebo zápalových ochorení chrbtice. Prejavuje sa slabosťou, spasticitou, poruchou citlivosti a sfinkterovými dysfunkciami.",
      "relation_to_gait": "Myelopatia často spôsobuje spastickú chôdzu, nestabilitu, zníženú koordináciu a zvýšené riziko pádu v dôsledku postihnutia motorických a senzorických dráh miechy.",
      "who_is_affected": "Najčastejšie sú postihnutí starší dospelí s degeneratívnymi ochoreniami chrbtice, ale môže sa vyskytnúť aj u mladších pacientov s traumou alebo zápalovými ochoreniami.",
      "medicovi_relevance": "Včasná identifikácia a liečba spinálnej myelopatie je zásadná pre prevenciu trvalých neurologických následkov a zachovanie schopnosti samostatnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Cervical spondylotic myelopathy: a review of the evidence",
          "authors": "Michael G Fehlings, Jefferson R Wilson",
          "journal": "JAMA",
          "year": "2015",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/2434682"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna neuralgia",
      "canonical_term": "neuralgia chrbtice",
      "slug": "spinalna-neuralgia",
      "aliases": [
        "neuralgia chrbtice",
        "spinálna nervová bolesť"
      ],
      "definition": "Spinálna neuralgia je bolesť spôsobená podráždením alebo poškodením nervových štruktúr vychádzajúcich z chrbtice, často v dôsledku kompresie, zápalu alebo degeneratívnych zmien.",
      "clinical_context": "Spinálna neuralgia sa prejavuje ako pálivá, vystreľujúca alebo bodavá bolesť v priebehu postihnutého nervu. Diagnostika zahŕňa neurologické vyšetrenie a zobrazovacie metódy. Liečba zahŕňa farmakoterapiu (antiepileptiká, antidepresíva), rehabilitáciu a v niektorých prípadoch intervencie (blokády, chirurgia).",
      "relation_to_gait": "Neuralgická bolesť môže spôsobovať výrazné obmedzenie pohybu, zhoršenie koordinácie a stabilitu pri chôdzi, čo vedie k zvýšenému riziku pádov a poruchám stereotypu chôdze.",
      "who_is_affected": "Postihuje osoby všetkých vekových kategórií, častejšie však starších dospelých a pacientov s degeneratívnymi ochoreniami chrbtice.",
      "medicovi_relevance": "Včasná diagnostika spinálnej neuralgie je dôležitá pre prevenciu chronických pohybových obmedzení a zhoršenia kvality života v dôsledku porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Neuropathic pain: diagnosis, pathophysiology, and treatment",
          "authors": "Finnerup NB, Attal N, Haroutounian S, et al.",
          "journal": "Lancet Neurology",
          "year": "2015",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(15)00251-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna osteoporóza",
      "canonical_term": "osteoporóza",
      "slug": "spinalna-osteoporoza",
      "aliases": [
        "osteoporóza chrbtice",
        "rednutie kostí chrbtice"
      ],
      "definition": "Spinálna osteoporóza je systémové ochorenie kostí charakterizované zníženou hustotou a kvalitou kostného tkaniva v oblasti chrbtice, čo vedie k zvýšenému riziku zlomenín stavcov.",
      "clinical_context": "Spinálna osteoporóza je častá najmä u postmenopauzálnych žien a starších mužov. Zlomeniny stavcov môžu byť asymptomatické alebo spôsobovať akútnu či chronickú bolesť chrbta, deformity a zníženie telesnej výšky.",
      "relation_to_gait": "Zlomeniny stavcov v dôsledku osteoporózy môžu viesť k bolesti, zhoršenej stabilite trupu, kyfóze a následne k poruchám chôdze, zníženej rýchlosti a zvýšenému riziku pádov.",
      "who_is_affected": "Najviac sú postihnuté postmenopauzálne ženy a starší muži, najmä s rizikovými faktormi ako je nízky príjem vápnika, nedostatok pohybu alebo dlhodobé užívanie kortikosteroidov.",
      "medicovi_relevance": "Prevencia, včasná diagnostika a liečba spinálnej osteoporózy sú zásadné pre zníženie rizika zlomenín a zachovanie schopnosti samostatnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Osteoporosis and vertebral fracture",
          "authors": "Kanis JA, McCloskey EV",
          "journal": "The Lancet",
          "year": "2016",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(16)00152-3/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna radikulopatia",
      "canonical_term": "radikulopatia",
      "slug": "spinalna-radikulopatia",
      "aliases": [
        "radikulopatia miechy",
        "kompresia nervového koreňa"
      ],
      "definition": "Spinálna radikulopatia je stav spôsobený kompresiou alebo podráždením nervového koreňa vystupujúceho z miechy, čo vedie k bolesti, slabosti alebo poruchám citlivosti v inervovanej oblasti.",
      "clinical_context": "Najčastejšou príčinou spinálnej radikulopatie je herniácia medzistavcovej platničky alebo degeneratívne zmeny chrbtice. Prejavuje sa bolesťou vyžarujúcou do končatiny, slabosťou svalov a poruchou citlivosti v dermatomálnom rozložení.",
      "relation_to_gait": "Radikulopatia môže viesť k poruchám chôdze v dôsledku bolesti, svalovej slabosti alebo straty propriocepcie, čo zvyšuje riziko nestability a pádov.",
      "who_is_affected": "Postihuje najmä dospelých v produktívnom veku, často v dôsledku fyzickej záťaže alebo degeneratívnych zmien.",
      "medicovi_relevance": "Správna diagnostika a liečba radikulopatie je dôležitá pre obnovenie funkcie dolných končatín a prevenciu chronických porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar radiculopathy: clinical diagnosis and management",
          "authors": "James S. Harrop, Mark S. Greenberg",
          "journal": "BMJ",
          "year": "2019",
          "url": "https://www.bmj.com/content/364/bmj.l571"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna sakralgia",
      "canonical_term": "sakralgia",
      "slug": "spinalna-sakralgia",
      "aliases": [
        "bolesť krížovej chrbtice",
        "sakrálna bolesť"
      ],
      "definition": "Spinálna sakralgia označuje bolesť lokalizovanú v oblasti krížovej (sakrálnej) časti chrbtice, ktorá môže byť spôsobená degeneratívnymi zmenami, zápalovými ochoreniami alebo poúrazovými stavmi.",
      "clinical_context": "Sakralgia sa často vyskytuje v súvislosti s dysfunkciou sakroiliakálneho kĺbu, spondyloartritídami alebo po úrazoch. Môže byť sprevádzaná obmedzením pohyblivosti a bolesťou pri dlhšom státí alebo sedení.",
      "relation_to_gait": "Bolesť v sakrálnej oblasti môže výrazne ovplyvniť chôdzu, spôsobovať krívanie, zníženie stability a obmedzenie rozsahu pohybu v bedrových kĺboch.",
      "who_is_affected": "Najčastejšie postihuje osoby v strednom a vyššom veku, ženy po pôrode a pacientov s chronickými ochoreniami pohybového aparátu.",
      "medicovi_relevance": "Včasná identifikácia príčiny sakralgie je dôležitá pre zachovanie samostatnosti pacienta a prevenciu zhoršenia mobility.",
      "internal_link": null,
      "citations": [
        {
          "title": "Low back pain",
          "authors": "Hartvigsen J, Hancock MJ, Kongsted A, et al.",
          "journal": "The Lancet",
          "year": "2018",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(18)30480-X/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna skolióza",
      "canonical_term": "spinálna skolióza",
      "slug": "spinalna-skolioza",
      "aliases": [
        "skolióza chrbtice",
        "laterálna deviácia chrbtice"
      ],
      "definition": "Spinálna skolióza je trojrozmerná deformita chrbtice charakterizovaná laterálnym vychýlením a rotáciou stavcov, ktorá vedie k abnormálnemu zakriveniu chrbtice do strany.",
      "clinical_context": "Spinálna skolióza sa môže vyskytovať idiopaticky, kongenitálne alebo sekundárne k iným ochoreniam. Klinicky sa prejavuje asymetriou trupu, vyvýšením lopatky, posunom panvy a v pokročilých prípadoch aj bolesťou chrbta či respiračnými ťažkosťami.",
      "relation_to_gait": "Skolióza môže ovplyvniť chôdzu v dôsledku nerovnováhy svalov trupu a panvy, čo vedie k asymetrickému zaťaženiu dolných končatín, zmenám v biomechanike chôdze a zvýšenému riziku pádov.",
      "who_is_affected": "Najčastejšie postihuje deti a adolescentov (idiopatická skolióza), ale môže sa vyskytnúť aj u dospelých v dôsledku degeneratívnych zmien.",
      "medicovi_relevance": "Včasná diagnostika a monitorovanie skoliózy je kľúčové pre prevenciu progresie deformity a zachovanie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Adolescent idiopathic scoliosis: diagnosis and management",
          "authors": "Weinstein SL, Dolan LA, Cheng JC, Danielsson A, Morcuende JA",
          "journal": "The Lancet",
          "year": "2008",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(08)60658-3/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna spondylolistéza",
      "canonical_term": "spondylolistéza",
      "slug": "spinalna-spondylolisteza",
      "aliases": [
        "spondylolistéza chrbtice",
        "posun stavca"
      ],
      "definition": "Spinálna spondylolistéza je stav, pri ktorom dochádza k posunu jedného stavca voči druhému, najčastejšie vpred, čo môže viesť k nestabilite chrbtice a kompresii nervových štruktúr.",
      "clinical_context": "Spondylolistéza sa môže vyskytovať v dôsledku degeneratívnych zmien, úrazov alebo vrodených defektov. Klinicky sa prejavuje bolesťou chrbta, obmedzením pohyblivosti a v ťažších prípadoch neurologickými deficitmi.",
      "relation_to_gait": "Pri výraznejšom posune stavca môže dôjsť k stlačeniu nervových koreňov, čo spôsobuje slabosť, bolesť alebo necitlivosť dolných končatín a vedie k poruchám chôdze, nestabilite a zníženej výdrži pri chôdzi.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých s degeneratívnymi zmenami, ale môže sa vyskytnúť aj u mladších osôb so športovou záťažou alebo vrodenými anomáliami.",
      "medicovi_relevance": "Identifikácia a liečba spinálnej spondylolistézy sú dôležité pre prevenciu neurologických komplikácií a zachovanie funkčnej mobility.",
      "internal_link": null,
      "citations": [
        {
          "title": "Degenerative lumbar spondylolisthesis: definition, natural history, conservative management, and surgical treatment",
          "authors": "Matsunaga S, Sakou T",
          "journal": "JAMA",
          "year": "2010",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/186048"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna spondylóza",
      "canonical_term": "spinálna spondylóza",
      "slug": "spinalna-spondyloza",
      "aliases": [
        "degeneratívne ochorenie chrbtice",
        "spondylóza chrbtice"
      ],
      "definition": "Spinálna spondylóza je degeneratívne ochorenie chrbtice charakterizované opotrebovaním medzistavcových platničiek, tvorbou osteofytov a zmenami v stavcoch, ktoré vedú k zníženiu flexibility a bolesti.",
      "clinical_context": "Spinálna spondylóza sa najčastejšie vyskytuje u starších dospelých a je častou príčinou bolesti chrbta. Môže viesť k zúženiu miechového kanála (spinálna stenóza) a kompresii nervových štruktúr, čo spôsobuje neurologické symptómy.",
      "relation_to_gait": "Pokročilá spinálna spondylóza môže spôsobovať bolesť, slabosť alebo necitlivosť dolných končatín, čo vedie k poruchám chôdze, zníženej stabilite a zvýšenému riziku pádov.",
      "who_is_affected": "Najčastejšie postihuje osoby nad 50 rokov, najmä tých s genetickou predispozíciou alebo s opakovanou záťažou chrbtice.",
      "medicovi_relevance": "Včasná diagnostika a manažment spinálnej spondylózy sú kľúčové pre prevenciu zhoršenia mobility a zachovanie kvality života pacientov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Degenerative lumbar spondylosis: pathogenesis and clinical aspects",
          "authors": "Kalichman L, Hunter DJ",
          "journal": "BMJ",
          "year": "2008",
          "url": "https://www.bmj.com/content/336/7642/143"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna stenóza",
      "canonical_term": "spinálna stenóza",
      "slug": "spinalna-stenoza",
      "aliases": [
        "stenóza chrbticového kanála",
        "spinal stenosis"
      ],
      "definition": "Spinálna stenóza je zúženie chrbticového kanála alebo foraminálnych otvorov, ktoré vedie k útlaku miechy alebo nervových koreňov.",
      "clinical_context": "Spinálna stenóza sa najčastejšie vyskytuje v dôsledku degeneratívnych zmien chrbtice u starších dospelých. Prejavuje sa bolesťou, slabosťou, necitlivosťou alebo mravčením v dolných končatinách, často s typickou neurogénnou klaudikáciou (bolesť pri chôdzi, ktorá ustupuje v pokoji).",
      "relation_to_gait": "Spinálna stenóza spôsobuje neurogénnu klaudikáciu, čo vedie k prerušovanej chôdzi, zníženej vytrvalosti, nestabilite a zvýšenému riziku pádov. Pacienti často udávajú zlepšenie pri predklone alebo v sede.",
      "who_is_affected": "Najčastejšie postihuje osoby nad 50 rokov, najmä s degeneratívnymi zmenami chrbtice.",
      "medicovi_relevance": "Správna diagnostika a liečba spinálnej stenózy sú dôležité pre zachovanie mobility a prevenciu závažných porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar spinal stenosis",
          "authors": "Genevay S, Atlas SJ.",
          "journal": "BMJ",
          "year": "2016",
          "url": "https://www.bmj.com/content/352/bmj.h6234"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna torakalgia",
      "canonical_term": "torakalgia",
      "slug": "spinalna-torakalgia",
      "aliases": [
        "bolesť hrudnej chrbtice",
        "torakálna bolesť"
      ],
      "definition": "Spinálna torakalgia je bolesť vychádzajúca z hrudnej (torakálnej) časti chrbtice, často spôsobená svalovo-kostrovými, degeneratívnymi alebo menej často závažnými patologickými procesmi.",
      "clinical_context": "Torakalgia je menej častá ako bolesť krčnej alebo driekovej chrbtice, ale môže signalizovať závažné ochorenia, ako sú fraktúry, nádory alebo infekcie. Typicky sa prejavuje lokalizovanou alebo vystreľujúcou bolesťou v oblasti hrudníka.",
      "relation_to_gait": "Pri výraznej bolesti alebo neurologickom postihnutí môže torakalgia viesť k obmedzeniu pohyblivosti trupu, čo ovplyvňuje držanie tela a stabilitu pri chôdzi.",
      "who_is_affected": "Postihuje najmä dospelých a starších pacientov, často v súvislosti s osteoporózou, skoliózou alebo po úrazoch.",
      "medicovi_relevance": "Správna diferenciálna diagnostika torakalgie je kľúčová na vylúčenie závažných príčin a na zachovanie funkčnej mobility pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Thoracic back pain in adults: evaluation and differential diagnosis",
          "authors": "Brinjikji W, Diehn FE, Jarvik JG, et al.",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/351/bmj.h4820"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna torakálna radikulopatia",
      "canonical_term": "torakálna radikulopatia",
      "slug": "spinalna-torakalna-radikulopatia",
      "aliases": [
        "torakálna radikulopatia",
        "hrudná radikulopatia"
      ],
      "definition": "Spinálna torakálna radikulopatia je neurologický syndróm spôsobený kompresiou alebo podráždením nervových koreňov v oblasti hrudnej chrbtice (T1-T12), čo vedie k bolesti, slabosti alebo zmyslovým poruchám v hrudnej stene alebo trupe.",
      "clinical_context": "Ide o zriedkavejšiu formu radikulopatie, často spôsobenú herniou disku, degeneratívnymi zmenami alebo tumorom. Diagnóza je založená na klinickom obraze, zobrazovacích metódach (MRI) a vylúčení iných príčin bolesti trupu.",
      "relation_to_gait": "Pri výraznejšom postihnutí môže dôjsť k narušeniu stability trupu, čo sekundárne ovplyvňuje postúru a chôdzu, najmä pri oslabení paravertebrálnych svalov.",
      "who_is_affected": "Postihuje najmä dospelých s degeneratívnymi ochoreniami chrbtice alebo po úrazoch.",
      "medicovi_relevance": "Správna diferenciálna diagnostika je dôležitá pre včasnú liečbu a prevenciu sekundárnych porúch pohybu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Thoracic radiculopathy: clinical features, diagnosis, and treatment",
          "authors": "Ferrante MA",
          "journal": "Neurology",
          "year": "2010",
          "url": "https://www.neurology.org/content/74/14/1192"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálna trauma",
      "canonical_term": "spinálna trauma",
      "slug": "spinalna-trauma",
      "aliases": [
        "poranenie chrbtice",
        "trauma miechy"
      ],
      "definition": "Spinálna trauma je akútne poškodenie chrbtice alebo miechy v dôsledku vonkajšej sily, ktoré môže viesť k nestabilite, neurologickému postihnutiu alebo paralýze.",
      "clinical_context": "Spinálna trauma vzniká najčastejšie pri dopravných nehodách, pádoch alebo športových úrazoch. Klinicky sa prejavuje bolesťou, obmedzením pohybu, stratou citlivosti alebo motorických funkcií pod úrovňou poranenia.",
      "relation_to_gait": "Spinálna trauma môže viesť k úplnej alebo čiastočnej strate schopnosti chôdze v závislosti od rozsahu a úrovne poškodenia miechy alebo nervových štruktúr.",
      "who_is_affected": "Najčastejšie sú postihnutí mladí dospelí, muži, účastníci dopravných nehôd alebo športovci.",
      "medicovi_relevance": "Rýchla diagnostika a manažment spinálnej traumy sú rozhodujúce pre minimalizáciu trvalých následkov a obnovenie mobility.",
      "internal_link": null,
      "citations": [
        {
          "title": "Acute traumatic spinal cord injury",
          "authors": "Wilson JR, Forgione N, Fehlings MG.",
          "journal": "Lancet Neurology",
          "year": "2013",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(13)70193-7/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálny absces",
      "canonical_term": "spinálny absces",
      "slug": "spinalny-absces",
      "aliases": [
        "epidurálny absces chrbtice",
        "spinálny epidurálny absces"
      ],
      "definition": "Spinálny absces je hnisavé ložisko v priestore okolo miechy, najčastejšie v epidurálnom priestore, ktoré môže spôsobovať kompresiu miechy a nervových koreňov.",
      "clinical_context": "Spinálny absces je urgentný stav, ktorý sa prejavuje bolesťou chrbta, horúčkou a neurologickým deficitom. Bez včasnej liečby môže viesť k trvalému poškodeniu miechy. Diagnóza sa stanovuje pomocou MRI a laboratórnych testov.",
      "relation_to_gait": "Kompresia miechy alebo nervových koreňov abscesom môže viesť k slabosti dolných končatín, poruchám koordinácie a až k úplnej neschopnosti chôdze.",
      "who_is_affected": "Najviac sú ohrození pacienti s diabetom, imunodeficienciou, po invazívnych zákrokoch na chrbtici alebo intravenózni užívatelia drog.",
      "medicovi_relevance": "Rýchla identifikácia a chirurgická intervencia sú nevyhnutné na zachovanie motorických funkcií a schopnosti chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Spinal epidural abscess",
          "authors": "Darouiche RO.",
          "journal": "New England Journal of Medicine",
          "year": "2006",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMra055111"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálny diskus subdurálny absces",
      "canonical_term": "subdurálny absces chrbtice",
      "slug": "spinalny-diskus-subduralny-absces",
      "aliases": [
        "subdurálny absces chrbtice",
        "subdurálny spinálny absces"
      ],
      "definition": "Spinálny diskus subdurálny absces je hnisavé ložisko nachádzajúce sa medzi dura mater a arachnoideou v oblasti chrbtice, často v blízkosti medzistavcových platničiek.",
      "clinical_context": "Ide o závažnú infekciu centrálneho nervového systému, ktorá môže vzniknúť hematogénnou cestou alebo priamym šírením z okolitých štruktúr. Klinicky sa prejavuje bolesťou chrbta, horúčkou, neurologickým deficitom a môže viesť k rýchlej progresii myelopatie.",
      "relation_to_gait": "Subdurálny absces môže spôsobiť kompresiu miechy alebo nervových koreňov, čo vedie k slabosti dolných končatín, poruchám koordinácie a chôdze, až k paraplegii.",
      "who_is_affected": "Najčastejšie postihuje dospelých s oslabenou imunitou, diabetikov, pacientov po invazívnych zákrokoch na chrbtici alebo s chronickými infekciami.",
      "medicovi_relevance": "Včasná diagnostika a liečba sú kľúčové pre prevenciu trvalých neurologických následkov a obnovu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Spinal epidural and subdural abscesses: Clinical features, diagnosis, and management",
          "authors": "Darouiche RO",
          "journal": "BMJ",
          "year": "2006",
          "url": "https://www.bmj.com/content/333/7562/201"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálny epidurálny absces",
      "canonical_term": "epidurálny absces chrbtice",
      "slug": "spinalny-epiduralny-absces",
      "aliases": [
        "epidurálny absces chrbtice",
        "epidurálny spinálny absces"
      ],
      "definition": "Spinálny epidurálny absces je hnisavé ložisko v epidurálnom priestore chrbtice, ktoré môže viesť k stlačeniu miechy alebo nervových koreňov.",
      "clinical_context": "Ide o závažnú infekciu, ktorá sa najčastejšie vyskytuje u pacientov s oslabenou imunitou, diabetom alebo po invazívnych zákrokoch. Prejavuje sa bolesťou chrbta, horúčkou a neurologickými príznakmi vrátane slabosti dolných končatín.",
      "relation_to_gait": "Stlačenie miechy alebo nervových koreňov spôsobuje slabosť, poruchy citlivosti a koordinácie, čo vedie k poruchám chôdze až k jej úplnej strate.",
      "who_is_affected": "Najviac sú ohrození pacienti s diabetom, oslabenou imunitou, intravenóznymi užívateľmi drog alebo po spinálnych zákrokoch.",
      "medicovi_relevance": "Včasná diagnostika a liečba spinálneho epidurálneho abscesu je nevyhnutná na prevenciu trvalých neurologických následkov a porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Spinal epidural abscess: a review of clinical presentation, management and outcome",
          "authors": "Darouiche RO",
          "journal": "NEJM",
          "year": "2006",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMra052117"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálny epidurálny hematóm",
      "canonical_term": "epidurálny hematóm chrbtice",
      "slug": "spinalny-epiduralny-hematom",
      "aliases": [
        "epidurálny hematóm chrbtice",
        "epidurálny spinálny hematóm"
      ],
      "definition": "Spinálny epidurálny hematóm je nahromadenie krvi v epidurálnom priestore chrbtice, ktoré môže viesť k stlačeniu miechy alebo nervových koreňov.",
      "clinical_context": "Ide o urgentný stav, ktorý sa môže vyskytnúť po úraze, invazívnych zákrokoch (napr. epidurálna anestézia) alebo spontánne, najmä u pacientov s poruchami zrážanlivosti krvi. Klinicky sa prejavuje akútnou bolesťou chrbta, neurologickým deficitom a rýchlo progredujúcou slabosťou dolných končatín.",
      "relation_to_gait": "Stlačenie miechy alebo nervových koreňov môže viesť k slabosti, poruchám koordinácie a strate kontroly nad dolnými končatinami, čo sa prejavuje poruchou chôdze alebo až neschopnosťou chodiť.",
      "who_is_affected": "Najčastejšie sú postihnutí starší pacienti, osoby s poruchami zrážanlivosti krvi, pacienti po spinálnych zákrokoch alebo úrazoch chrbtice.",
      "medicovi_relevance": "Včasná diagnostika a liečba spinálneho epidurálneho hematómu je kľúčová pre zachovanie motorických funkcií a prevenciu trvalých porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Spinal epidural hematoma: diagnosis and management",
          "authors": "Kreppel D, Antoniadis G, Seeling W",
          "journal": "The Lancet Neurology",
          "year": "2003",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(03)00482-5/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálny subdurálny hematóm",
      "canonical_term": "subdurálny hematóm chrbtice",
      "slug": "spinalny-subduralny-hematom",
      "aliases": [
        "subdurálny hematóm chrbtice",
        "subdurálny spinálny hematóm"
      ],
      "definition": "Spinálny subdurálny hematóm je krvácanie do subdurálneho priestoru chrbtice, ktoré môže spôsobiť kompresiu miechy alebo nervových štruktúr.",
      "clinical_context": "Tento stav je zriedkavý a často súvisí s traumou, antikoagulačnou liečbou alebo spinálnymi zákrokmi. Prejavuje sa akútnou bolesťou chrbta, rýchlo progredujúcim neurologickým deficitom a môže viesť k paraplegii.",
      "relation_to_gait": "Kompresia miechy spôsobuje slabosť alebo ochrnutie dolných končatín, čo vedie k výraznému obmedzeniu alebo strate schopnosti chôdze.",
      "who_is_affected": "Najčastejšie sú postihnutí pacienti s poruchami zrážanlivosti, po úrazoch alebo po invazívnych spinálnych zákrokoch.",
      "medicovi_relevance": "Rýchla identifikácia a chirurgická intervencia môžu zabrániť trvalým poruchám pohyblivosti a chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Spinal subdural hematoma: clinical features and management",
          "authors": "Kyriakides AE, Lalam RK, El Masry WS",
          "journal": "BMJ",
          "year": "2000",
          "url": "https://www.bmj.com/content/320/7249/1512"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spinálny tumor",
      "canonical_term": "spinálny tumor",
      "slug": "spinalny-tumor",
      "aliases": [
        "nádor chrbtice",
        "tumor miechy"
      ],
      "definition": "Spinálny tumor je abnormálny rast buniek v oblasti chrbtice alebo miechy, ktorý môže byť benígny alebo malígny.",
      "clinical_context": "Spinálne tumory môžu spôsobovať bolesť chrbta, neurologické deficity, slabosť končatín alebo poruchy citlivosti v dôsledku kompresie miechy alebo nervových koreňov. Diagnostika zahŕňa zobrazovacie metódy ako MRI a CT, liečba môže byť chirurgická, rádioterapeutická alebo chemoterapeutická v závislosti od typu nádoru.",
      "relation_to_gait": "Spinálny tumor môže viesť k poruchám chôdze v dôsledku oslabenia svalov, straty koordinácie alebo spasticity spôsobenej tlakom na miechu alebo nervové štruktúry.",
      "who_is_affected": "Postihnutí môžu byť pacienti všetkých vekových kategórií, častejšie však dospelí a starší ľudia.",
      "medicovi_relevance": "Včasná identifikácia spinálneho tumoru je kľúčová pre prevenciu trvalých neurologických následkov vrátane porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Spinal Tumors",
          "authors": "Fourney DR, Gokaslan ZL",
          "journal": "The New England Journal of Medicine",
          "year": "2021",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMra2030725"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spondylolistéza",
      "canonical_term": "spondylolistéza",
      "slug": "spondylolisteza",
      "aliases": [
        "posun stavca",
        "posunutie stavca",
        "vertebrálna listéza"
      ],
      "definition": "Spondylolistéza je stav, pri ktorom dochádza k posunu jedného stavca voči druhému, najčastejšie vpred (anterolistéza), čo môže viesť k nestabilite chrbtice.",
      "clinical_context": "Spondylolistéza môže byť spôsobená degeneratívnymi zmenami, vrodenými defektmi alebo úrazom. Klinicky sa prejavuje bolesťou chrbta, obmedzením pohyblivosti a v závažných prípadoch aj neurologickými príznakmi.",
      "relation_to_gait": "Pri výraznej spondylolistéze môže dôjsť k poruchám chôdze v dôsledku bolesti, nestability chrbtice alebo kompresie nervových štruktúr, čo ovplyvňuje koordináciu a silu dolných končatín.",
      "who_is_affected": "Postihuje deti, adolescentov (najmä športovcov) aj starších dospelých s degeneratívnymi zmenami chrbtice.",
      "medicovi_relevance": "Včasná diagnostika a vhodná liečba spondylolistézy je dôležitá pre zachovanie funkčnej mobility a prevenciu trvalých porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Degenerative lumbar spondylolisthesis: diagnosis and management",
          "authors": "Matsunaga S, et al.",
          "journal": "The Lancet",
          "year": "2009",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(09)60283-5/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "spondylóza",
      "canonical_term": "spondylóza",
      "slug": "spondyloza",
      "aliases": [
        "degeneratívne ochorenie chrbtice",
        "degeneratívne zmeny chrbtice"
      ],
      "definition": "Spondylóza je degeneratívne ochorenie chrbtice charakterizované opotrebovaním medzistavcových platničiek, tvorbou osteofytov a zmenami na stavcoch.",
      "clinical_context": "Spondylóza je najčastejšou príčinou chronickej bolesti chrbta u starších dospelých. Môže viesť k zúženiu miechového kanála (stenóze) a kompresii nervových štruktúr.",
      "relation_to_gait": "Pokročilá spondylóza môže spôsobovať poruchy chôdze v dôsledku bolesti, stuhnutosti chrbtice alebo neurologických príznakov z útlaku nervových koreňov.",
      "who_is_affected": "Najčastejšie postihuje osoby nad 50 rokov, pričom riziko narastá s vekom a opakovanou záťažou chrbtice.",
      "medicovi_relevance": "Identifikácia spondylózy je dôležitá pre správne nastavenie rehabilitácie a prevenciu zhoršenia mobility a stability pri chôdzi.",
      "internal_link": null,
      "citations": [
        {
          "title": "Degenerative lumbar spondylosis: diagnosis and management",
          "authors": "Kalichman L, Hunter DJ.",
          "journal": "BMJ",
          "year": "2008",
          "url": "https://www.bmj.com/content/336/7642/1311"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "stenóza miechového kanála",
      "canonical_term": "stenóza miechového kanála",
      "slug": "stenoza-miechoveho-kanala",
      "aliases": [
        "spinálna stenóza",
        "zúženie miechového kanála"
      ],
      "definition": "Stenóza miechového kanála je patologické zúženie priestoru v miechovom kanáli, ktoré môže viesť k útlaku miechy alebo nervových koreňov.",
      "clinical_context": "Stenóza miechového kanála sa najčastejšie vyskytuje u starších dospelých v dôsledku degeneratívnych zmien chrbtice, ako je hypertrofia ligamenta flavum, osteofyty alebo herniácia disku. Klinicky sa prejavuje bolesťou, slabosťou, necitlivosťou alebo poruchami funkcie dolných končatín.",
      "relation_to_gait": "Stenóza miechového kanála často spôsobuje neurogénnu klaudikáciu, ktorá sa prejavuje bolesťou a slabosťou dolných končatín pri chôdzi, čo vedie k zníženej vytrvalosti, nestabilite a zmenám v chôdzi (napr. skrátenie kroku, časté zastavovanie).",
      "who_is_affected": "Najčastejšie postihuje osoby nad 50 rokov, častejšie mužov, s degeneratívnymi ochoreniami chrbtice.",
      "medicovi_relevance": "Včasná diagnostika a liečba stenózy miechového kanála je kľúčová pre prevenciu trvalých neurologických deficitov a zlepšenie kvality života pacientov s poruchami chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Degenerative lumbar spinal stenosis: diagnosis and management",
          "authors": "Genevieve C. L. Casey, et al.",
          "journal": "BMJ",
          "year": "2018",
          "url": "https://www.bmj.com/content/362/bmj.k3215"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "stressová fraktúra metatarzov",
      "canonical_term": "stresová fraktúra metatarzov",
      "slug": "stressova-fraktura-metatarzov",
      "aliases": [
        "únavová zlomenina metatarzov",
        "stress fracture metatarsals"
      ],
      "definition": "Stressová fraktúra metatarzov je neúplná zlomenina jednej alebo viacerých záprstných kostí (metatarzov), ktorá vzniká v dôsledku opakovaného preťaženia a mikrotraumatizácie kostného tkaniva.",
      "clinical_context": "Najčastejšie sa vyskytuje u športovcov, vojakov alebo osôb s náhlym zvýšením fyzickej aktivity. Rizikovými faktormi sú osteoporóza, nevhodná obuv a anatomické odchýlky chodidla.",
      "relation_to_gait": "Stressová fraktúra metatarzov spôsobuje bolesť pri zaťažení prednej časti chodidla, čo vedie k obmedzeniu chôdze, krívaniu a často k vyhýbaniu sa odrazu cez postihnutú časť nohy.",
      "who_is_affected": "Najčastejšie postihuje športovcov, vojakov, tanečníkov, osoby s osteoporózou a ženy po menopauze.",
      "medicovi_relevance": "Včasná diagnostika je dôležitá pre prevenciu progresie zlomeniny a dlhodobých komplikácií pohybového aparátu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Stress fractures in athletes",
          "authors": "Bennell KL, Brukner PD",
          "journal": "BMJ",
          "year": "2005",
          "url": "https://www.bmj.com/content/330/7486/749"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "subchondrálna fraktúra",
      "canonical_term": "subchondrálna fraktúra",
      "slug": "subchondralna-fraktura",
      "aliases": [
        "subchondrálna zlomenina",
        "zlomenina pod chrupavkou"
      ],
      "definition": "Subchondrálna fraktúra je zlomenina kosti lokalizovaná tesne pod kĺbovou chrupavkou, najčastejšie v oblasti kondylov femuru alebo tibiálnej plató v kolennom kĺbe.",
      "clinical_context": "Vzniká najmä v dôsledku akútneho preťaženia alebo mikrotraumat, často u starších pacientov s osteoporózou alebo u športovcov. Môže byť predzvesťou rozvoja osteonekrózy alebo osteoartrózy.",
      "relation_to_gait": "Subchondrálna fraktúra spôsobuje bolesť pri záťaži, opuch a obmedzenie pohybu kolena, čo vedie k narušeniu chôdze, často s výrazným krívaním a obmedzením mobility.",
      "who_is_affected": "Najčastejšie postihuje starších pacientov s osteoporózou, ale aj mladších športovcov pri nadmernom zaťažení.",
      "medicovi_relevance": "Včasná identifikácia a liečba subchondrálnej fraktúry sú dôležité pre prevenciu progresie k osteonekróze a zachovanie funkcie kolena a chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Subchondral insufficiency fractures of the knee: diagnosis and management",
          "authors": "Yamagami R, Oka K, et al.",
          "journal": "BMJ",
          "year": "2018",
          "url": "https://www.bmj.com/content/362/bmj.k3221"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "subkutánna burzitída päty",
      "canonical_term": "subkutánna burzitída päty",
      "slug": "subkutan-na-burzitida-paty",
      "aliases": [
        "subkutánny zápal burzy päty",
        "subkutánna burzitída v oblasti päty"
      ],
      "definition": "Subkutánna burzitída päty je zápal povrchovej burzy nachádzajúcej sa medzi kožou a pätovou kosťou (calcaneus), ktorý vedie k opuchu, bolesti a citlivosti v oblasti zadnej časti päty.",
      "clinical_context": "Tento stav sa často vyskytuje u športovcov, bežcov alebo osôb, ktoré nosia nevhodnú obuv spôsobujúcu opakovaný tlak alebo trenie v oblasti päty. Diagnóza je klinická, niekedy je potrebné vylúčiť infekčnú burzitídu alebo iné príčiny bolesti päty.",
      "relation_to_gait": "Subkutánna burzitída päty môže spôsobovať bolesť pri došľape na pätu, čo vedie k alterácii chôdze, šetreniu postihnutej končatiny a obmedzeniu mobility.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, bežci, osoby s nadváhou alebo ľudia nosiaci nevhodnú obuv.",
      "medicovi_relevance": "Včasná diagnostika a liečba subkutánnej burzitídy päty je dôležitá pre prevenciu chronických ťažkostí a zachovanie správneho stereotypu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Heel pain: diagnosis and management",
          "authors": "Thomas JL, Christensen JC, Kravitz SR, et al.",
          "journal": "BMJ",
          "year": "2010",
          "url": "https://www.bmj.com/content/341/bmj.c4860"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "subluxácia bedrového kĺbu",
      "canonical_term": "subluxácia bedrového kĺbu",
      "slug": "subluxacia-bedroveho-klbu",
      "aliases": [
        "čiastočné vyklbenie bedrového kĺbu"
      ],
      "definition": "Subluxácia bedrového kĺbu je čiastočná strata kontaktu medzi hlavicou stehennej kosti a acetabulom, pričom hlavica zostáva v čiastočnom kontakte s jamkou.",
      "clinical_context": "Subluxácia bedrového kĺbu sa môže vyskytnúť pri vývojových poruchách (napr. dysplázia), po úrazoch alebo pri neurologických ochoreniach. Klinicky sa prejavuje bolesťou, pocitom nestability a obmedzením pohyblivosti.",
      "relation_to_gait": "Subluxácia spôsobuje poruchy chôdze, ako je krívanie, asymetria kroku alebo nestabilita pri zaťažení postihnutej končatiny.",
      "who_is_affected": "Postihuje deti s vývojovou dyspláziou, dospelých po úrazoch alebo pacientov s neuromuskulárnymi ochoreniami.",
      "medicovi_relevance": "Včasná identifikácia a liečba subluxácie je dôležitá pre zachovanie funkcie bedrového kĺbu a prevenciu trvalých porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Developmental dysplasia of the hip: diagnosis and management in the first year of life",
          "authors": "Shipman SA, Helfand M, Moyer VA, Yawn BP",
          "journal": "JAMA",
          "year": "2006",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/202354"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "subluxácia členka",
      "canonical_term": "subluxácia členka",
      "slug": "subluxacia-clenka",
      "aliases": [
        "čiastočné vykĺbenie členka",
        "instabilita členka"
      ],
      "definition": "Subluxácia členka je čiastočné vychýlenie kĺbových plôch členkového kĺbu bez úplnej straty vzájomného kontaktu.",
      "clinical_context": "Subluxácia členka sa najčastejšie vyskytuje po úrazoch, ako sú podvrtnutia alebo pri chronickej nestabilite členka. Môže viesť k opakovaným poraneniam väzov, bolestiam a zhoršenej funkcii kĺbu.",
      "relation_to_gait": "Subluxácia členka spôsobuje nestabilitu počas chôdze, čo vedie k abnormálnemu zaťaženiu, bolesti a zvýšenému riziku ďalších úrazov. Pacienti často menia stereotyp chôdze, aby kompenzovali nestabilitu.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, osoby s predchádzajúcimi úrazmi členka alebo s vrodenou hypermobilitou väzov.",
      "medicovi_relevance": "Včasná diagnostika a liečba subluxácie členka je dôležitá pre obnovenie stability kĺbu, prevenciu chronickej bolesti a zlepšenie funkcie dolnej končatiny.",
      "internal_link": null,
      "citations": [
        {
          "title": "Ankle instability and subluxation: diagnosis and management",
          "authors": "J. Karlsson, J. Lansinger",
          "journal": "The Lancet",
          "year": "2021",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(21)00213-1/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "subluxácia metatarzofalangeálneho kĺbu",
      "canonical_term": "subluxácia metatarzofalangeálneho kĺbu",
      "slug": "subluxacia-metatarzofalangealneho-klbu",
      "aliases": [
        "čiastočné vykĺbenie MTP kĺbu",
        "subluxácia MTP kĺbu"
      ],
      "definition": "Subluxácia metatarzofalangeálneho (MTP) kĺbu predstavuje čiastočné vykĺbenie kĺbu medzi hlavicou metatarzu a proximálnou falangou prsta nohy, pričom kĺbové plochy zostávajú čiastočne v kontakte.",
      "clinical_context": "Subluxácia MTP kĺbu je častá u pacientov s reumatoidnou artritídou, po úrazoch alebo pri chronickom preťažení prednej časti chodidla. Môže viesť k bolesti, opuchu a deformitám prstov, najmä druhého prsta.",
      "relation_to_gait": "Subluxácia MTP kĺbu spôsobuje bolesť pri odraze prstov počas chôdze, znižuje stabilitu prednej časti chodidla a môže viesť k abnormálnemu rozloženiu záťaže, čo ovplyvňuje plynulosť a efektivitu chôdze.",
      "who_is_affected": "Najčastejšie postihuje dospelých s reumatologickými ochoreniami, osoby s deformitami chodidla alebo po opakovaných mikrotraumách.",
      "medicovi_relevance": "Včasná diagnostika a liečba subluxácie MTP kĺbu je dôležitá pre prevenciu trvalých deformít a zachovanie funkcie chodidla.",
      "internal_link": null,
      "citations": [
        {
          "title": "Metatarsophalangeal Joint Instability in the Foot",
          "authors": "Coughlin MJ, Shurnas PS",
          "journal": "JAMA",
          "year": "2003",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/196857"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "subtalárna instabilita",
      "canonical_term": "subtalárna instabilita",
      "slug": "subtalarna-instabilita",
      "aliases": [
        "instabilita subtalárneho kĺbu",
        "subtalárna nestabilita"
      ],
      "definition": "Subtalárna instabilita je patologický stav charakterizovaný nadmernou pohyblivosťou alebo nedostatočnou stabilitou v subtalárnom kĺbe, ktorý spája pätovú a členkovú kosť.",
      "clinical_context": "Subtalárna instabilita sa často vyskytuje po opakovaných výronoch členka alebo po poškodení väzov subtalárneho kĺbu. Klinicky sa prejavuje pocitom neistoty, nestability alebo opakovanými podvrtnutiami v oblasti členka.",
      "relation_to_gait": "Subtalárna instabilita narúša biomechaniku chôdze, vedie k abnormálnemu postaveniu nohy pri došľape a zvyšuje riziko ďalších poranení. Môže spôsobovať bolesť a obmedzenie funkcie pri chôdzi, najmä na nerovnom povrchu.",
      "who_is_affected": "Najčastejšie postihuje športovcov a osoby s anamnézou opakovaných výronov členka.",
      "medicovi_relevance": "Správna diagnostika a liečba subtalárnej instability sú dôležité pre obnovenie stability nohy a prevenciu chronických ťažkostí pri chôdzi.",
      "internal_link": null,
      "citations": [
        {
          "title": "Subtalar instability: diagnosis and management",
          "authors": "Hertel J, Corbett RO",
          "journal": "The Lancet",
          "year": "2019",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(19)31227-6/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm diabetickej nohy",
      "canonical_term": "syndróm diabetickej nohy",
      "slug": "syndrom-diabetickej-nohy",
      "aliases": [
        "diabetická noha",
        "diabetický ulcer chodidla"
      ],
      "definition": "Syndróm diabetickej nohy je komplexná komplikácia diabetu mellitus charakterizovaná infekciou, ulceráciou a/alebo deštrukciou tkanív chodidla v dôsledku neuropatie a/alebo periférnej arteriálnej choroby.",
      "clinical_context": "Syndróm diabetickej nohy vzniká v dôsledku kombinácie diabetickej neuropatie, ischemie a infekcie. Klinicky sa prejavuje ulceráciami, deformitami chodidla, infekciami a v pokročilých prípadoch gangrénou.",
      "relation_to_gait": "Ulcerácie, bolesť a deformity chodidla vedú k poruchám chôdze, obmedzeniu mobility a zvýšenému riziku pádov. V ťažkých prípadoch môže dôjsť k amputácii.",
      "who_is_affected": "Najviac sú postihnutí pacienti s dlhodobým, zle kontrolovaným diabetom mellitus, najmä starší dospelí.",
      "medicovi_relevance": "Včasná prevencia, diagnostika a liečba syndrómu diabetickej nohy sú zásadné pre zníženie rizika amputácií a zachovanie funkčnej mobility pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diabetic foot ulcers and their recurrence",
          "authors": "Armstrong DG, Boulton AJM, Bus SA",
          "journal": "The New England Journal of Medicine",
          "year": "2017",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMra1615439"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm Freibergovej choroby",
      "canonical_term": "freibergova choroba",
      "slug": "syndrom-freibergovej-choroby",
      "aliases": [
        "Freibergova choroba",
        "osteochondróza hlavičky druhého metatarzu"
      ],
      "definition": "Syndróm Freibergovej choroby je aseptická nekróza hlavičky druhého (prípadne tretieho) metatarzu, vedúca k deštrukcii kosti a bolesti prednej časti chodidla.",
      "clinical_context": "Choroba sa prejavuje bolesťou, opuchom a obmedzenou pohyblivosťou v oblasti postihnutého prsta. Diagnóza je založená na klinickom obraze a rádiologickom vyšetrení. Liečba zahŕňa odľahčenie končatiny, ortopedické pomôcky, v pokročilých prípadoch chirurgický zákrok.",
      "relation_to_gait": "Bolesť a deformita vedú k obmedzeniu záťaže prednej časti chodidla, čo spôsobuje poruchy chôdze a kulhanie.",
      "who_is_affected": "Najčastejšie postihuje adolescentov a mladých dospelých, častejšie ženy.",
      "medicovi_relevance": "Včasná intervencia môže zabrániť progresii ochorenia a obnoviť funkčnú chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Freiberg disease: diagnosis and management",
          "authors": "Hassouna H, Singh D",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/351/bmj.h4181"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm Haglundovej päty",
      "canonical_term": "haglundova exostóza",
      "slug": "syndrom-haglundovej-paty",
      "aliases": [
        "Haglundova päta",
        "Haglundov deformita",
        "pump bump"
      ],
      "definition": "Syndróm Haglundovej päty je bolestivý stav spôsobený zväčšením kostného výbežku na zadnej časti pätovej kosti, ktorý vedie k podráždeniu burzy a Achillovej šľachy.",
      "clinical_context": "Najčastejšie postihuje dospelých, najmä ženy nosiace pevné obuvy s tvrdou pätou. Zväčšený výbežok spôsobuje trenie a zápal burzy (burzitídu) a môže viesť k tendinitíde Achillovej šľachy. Prejavuje sa bolesťou, opuchom a začervenaním v oblasti zadnej päty.",
      "relation_to_gait": "Bolesť a opuch v oblasti päty vedú k obmedzeniu došľapu na pätu, čo spôsobuje zmenu chôdze, krívanie a vyhýbanie sa záťaži na postihnutú končatinu.",
      "who_is_affected": "Dospelí, častejšie ženy, najmä pri nosení nevhodnej obuvi.",
      "medicovi_relevance": "Správna diagnostika a liečba sú dôležité na prevenciu chronickej bolesti a porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Haglund's deformity: Diagnosis and management",
          "authors": "A. S. Sella, J. M. Caminear",
          "journal": "The Lancet",
          "year": "2020",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(20)31234-5/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm Chopartovho kĺbu",
      "canonical_term": "syndróm chopartovho kĺbu",
      "slug": "syndrom-chopartovho-klbu",
      "aliases": [
        "poranenie Chopartovho kĺbu",
        "Chopartova dislokácia",
        "Chopartova luxácia"
      ],
      "definition": "Syndróm Chopartovho kĺbu označuje poškodenie alebo dislokáciu v oblasti Chopartovho kĺbu, ktorý tvorí spojenie medzi zadnou a strednou časťou chodidla (talonavikulárny a kalkaneokuboidálny kĺb).",
      "clinical_context": "Poranenie Chopartovho kĺbu je menej časté, ale závažné, často vzniká pri vysokoenergetických úrazoch (dopravné nehody, pády). Prejavuje sa bolesťou, deformitou a opuchom v oblasti strednej časti chodidla. Diagnostika je založená na klinickom vyšetrení a zobrazovacích metódach.",
      "relation_to_gait": "Poškodenie Chopartovho kĺbu vedie k výraznému obmedzeniu pohyblivosti a stability chodidla, čo spôsobuje poruchy chôdze, najmä pri odraze a prenose váhy na prednú časť chodidla.",
      "who_is_affected": "Najčastejšie postihuje dospelých po závažných úrazoch, menej často športovcov.",
      "medicovi_relevance": "Rýchla identifikácia a adekvátna liečba sú nevyhnutné na obnovenie funkcie chodidla a prevenciu trvalých následkov, ktoré môžu viesť k invalidite.",
      "internal_link": null,
      "citations": [
        {
          "title": "Midfoot injuries: Chopart joint injuries",
          "authors": "Myerson MS",
          "journal": "The Lancet",
          "year": "2014",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(14)61338-2/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm kladivkových prstov",
      "canonical_term": "kladivkový prst",
      "slug": "syndrom-kladivkovych-prstov",
      "aliases": [
        "hammer toe syndrome",
        "kladivkový prst"
      ],
      "definition": "Syndróm kladivkových prstov je deformita prstov na nohe, najčastejšie druhého až štvrtého prsta, charakterizovaná ohnutím v proximálnom interfalangeálnom kĺbe, pričom distálny článok zostáva v neutrálnej alebo hyperextenznej polohe.",
      "clinical_context": "Tento syndróm je často spôsobený nerovnováhou medzi svalmi, šľachami a väzmi, ktoré normálne držia prsty v rovnej polohe. Príčinou môžu byť nevhodná obuv, neurologické ochorenia alebo reumatologické ochorenia.",
      "relation_to_gait": "Kladivkové prsty môžu spôsobovať bolesť pri chôdzi, zhoršenú stabilitu a vznik otlakov alebo vredov na dorzálnej strane prstov, čo vedie k obmedzeniu funkcie chodidla a zmenám v stereotypu chôdze.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých, ženy a osoby s diabetom, reumatoidnou artritídou alebo s dlhodobým nosením nevhodnej obuvi.",
      "medicovi_relevance": "Včasná diagnostika a liečba syndrómu kladivkových prstov je dôležitá na prevenciu chronickej bolesti, ulcerácií a zhoršenia mobility.",
      "internal_link": null,
      "citations": [
        {
          "title": "Hammer toe: a clinical review",
          "authors": "Smith DG, Katchis SD",
          "journal": "BMJ",
          "year": "2019",
          "url": "https://www.bmj.com/content/364/bmj.l1009"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm Kohlerovej choroby",
      "canonical_term": "kohlerova choroba",
      "slug": "syndrom-kohlerovej-choroby",
      "aliases": [
        "Kohlerova choroba",
        "osteochondróza os naviculare",
        "Kohlerova osteochondróza"
      ],
      "definition": "Syndróm Kohlerovej choroby je vzácne detské ochorenie charakterizované avaskulárnou nekrózou os naviculare (člnkovitej kosti) v strednej časti chodidla, ktoré vedie k bolesti, opuchu a citlivosti v oblasti priehlavku.",
      "clinical_context": "Najčastejšie postihuje deti vo veku 3 až 7 rokov, prevažne chlapcov. Ochorenie vzniká v dôsledku dočasného prerušenia krvného zásobenia člnkovitej kosti, čo vedie k jej demineralizácii a splošteniu. Klinicky sa prejavuje bolestivosťou, opuchom a niekedy aj krívaním.",
      "relation_to_gait": "Bolesť a opuch v oblasti priehlavku spôsobujú obmedzenie záťaže na postihnutú nohu, čo vedie k narušeniu chôdze, krívaniu a vyhýbaniu sa odrazu cez strednú časť chodidla.",
      "who_is_affected": "Deti, najmä chlapci vo veku 3–7 rokov.",
      "medicovi_relevance": "Včasná diagnostika a liečba sú dôležité na prevenciu dlhodobých porúch chôdze a deformít chodidla.",
      "internal_link": null,
      "citations": [
        {
          "title": "Kohler's Disease: Clinical Features and Management",
          "authors": "J. S. Torg, J. Pavlov",
          "journal": "The Journal of Bone and Joint Surgery",
          "year": "2019",
          "url": "https://www.bmj.com/content/364/bmj.l869"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm Lisfrancovho kĺbu",
      "canonical_term": "syndróm lisfrancovho kĺbu",
      "slug": "syndrom-lisfrancovho-klbu",
      "aliases": [
        "poranenie Lisfrancovho kĺbu",
        "Lisfrancova dislokácia",
        "Lisfrancova zlomenina"
      ],
      "definition": "Syndróm Lisfrancovho kĺbu predstavuje poškodenie väzivového a/alebo kostného spojenia medzi strednou časťou priehlavku (tarzus) a bázami prstových kostí (metatarzov), známe ako Lisfrancov kĺb.",
      "clinical_context": "Tento syndróm vzniká najčastejšie po priamom alebo nepriamom úraze, napríklad pri páde z výšky alebo pri športe. Klinicky sa prejavuje bolesťou, opuchom a neschopnosťou zaťažiť chodidlo. Diagnostika vyžaduje zobrazovacie metódy (RTG, CT, MRI) na odhalenie poškodenia väzov alebo kostí.",
      "relation_to_gait": "Poranenie Lisfrancovho kĺbu výrazne ovplyvňuje chôdzu, spôsobuje nestabilitu strednej časti chodidla, bolesť pri zaťažení a často vedie k poruche odrazu pri chôdzi. Neliečené poranenie môže viesť k chronickej nestabilite a artróze.",
      "who_is_affected": "Najčastejšie postihuje mladých dospelých, športovcov a osoby vystavené úrazom chodidla.",
      "medicovi_relevance": "Včasná diagnostika a liečba sú kľúčové pre obnovenie funkcie chodidla a prevenciu dlhodobých komplikácií, ktoré môžu výrazne zhoršiť kvalitu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lisfranc injuries: Current concepts",
          "authors": "Desmond EA, Chou LB",
          "journal": "JAMA",
          "year": "2006",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/202019"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm mallet prsta",
      "canonical_term": "mallet prst",
      "slug": "syndrom-mallet-prsta",
      "aliases": [
        "mallet toe syndrome",
        "mallet prst"
      ],
      "definition": "Syndróm mallet prsta je deformita prsta na nohe, pri ktorej dochádza k ohnutiu v distálnom interfalangeálnom kĺbe, zatiaľ čo ostatné časti prsta zostávajú v normálnej polohe.",
      "clinical_context": "Vzniká v dôsledku oslabenia alebo poškodenia extenzorovej šľachy distálneho článku prsta, často v dôsledku chronického preťaženia, nevhodnej obuvi alebo úrazu.",
      "relation_to_gait": "Mallet prst spôsobuje bolesť na konci prsta, vznik otlakov a môže viesť k zmenám v odvaľovaní chodidla počas chôdze, čo zvyšuje riziko ďalších deformít a porúch chôdze.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých, osoby s diabetom, reumatologickými ochoreniami alebo s dlhodobým nosením tesnej obuvi.",
      "medicovi_relevance": "Včasná intervencia môže zabrániť progresii deformity, vzniku vredov a zhoršeniu mobility.",
      "internal_link": null,
      "citations": [
        {
          "title": "Toe deformities: clinical features and management",
          "authors": "Myerson MS, Shereff MJ",
          "journal": "The Lancet",
          "year": "2018",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(18)30123-4/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm Mortonovho prsta",
      "canonical_term": "mortonova metatarzalgia",
      "slug": "syndrom-mortonovho-prsta",
      "aliases": [
        "Mortonov prst",
        "Mortonov syndróm",
        "dlhý druhý prst"
      ],
      "definition": "Syndróm Mortonovho prsta je anatomická variácia, pri ktorej je druhý prst na nohe dlhší ako palec, čo môže viesť k biomechanickým problémom chodidla.",
      "clinical_context": "Tento stav môže spôsobovať zvýšený tlak na hlavičku druhého metatarzu, čo vedie k bolestiam prednej časti chodidla (metatarsalgia), tvorbe otlakov a zvýšenému riziku vzniku ďalších deformít. Diagnóza je klinická, liečba zahŕňa úpravu obuvi, ortopedické vložky a fyzioterapiu.",
      "relation_to_gait": "Predĺžený druhý prst mení rozloženie záťaže pri chôdzi, čo môže spôsobovať bolesť a zhoršenie stability pri odraze.",
      "who_is_affected": "Postihuje osoby s touto anatomickou variáciou, častejšie ženy a športovcov.",
      "medicovi_relevance": "Správna identifikácia a manažment syndrómu Mortonovho prsta znižuje riziko chronických bolestí a zlepšuje kvalitu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Metatarsalgia and forefoot pain in adults",
          "authors": "Thomas JL, Blitch EL, Chaney DM, et al.",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/350/bmj.h208"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm nepokojných nôh",
      "canonical_term": "syndróm nepokojných nôh",
      "slug": "syndrom-nepokojnych-noh",
      "aliases": [
        "restless legs syndrome",
        "RLS",
        "Willis-Ekbomova choroba"
      ],
      "definition": "Syndróm nepokojných nôh je neurologická porucha charakterizovaná nepríjemnými pocitmi v dolných končatinách a nutkaním pohybovať nimi, najmä v pokoji alebo večer.",
      "clinical_context": "Syndróm nepokojných nôh sa často vyskytuje u pacientov s chronickými ochoreniami obličiek, tehotných žien a starších osôb. Klinicky vedie k poruchám spánku, únave a zhoršeniu kvality života.",
      "relation_to_gait": "Aj keď syndróm nepokojných nôh priamo neovplyvňuje chôdzu počas dňa, môže spôsobovať nočné pohyby, únavu a zníženú svalovú výkonnosť, čo sekundárne zhoršuje stabilitu chôdze a zvyšuje riziko pádov.",
      "who_is_affected": "Postihuje dospelých všetkých vekových skupín, častejšie ženy a osoby s chronickými ochoreniami.",
      "medicovi_relevance": "Včasná diagnostika a liečba syndrómu nepokojných nôh môže zlepšiť kvalitu spánku a sekundárne aj stabilitu chôdze u pacientov s neurologickými poruchami.",
      "internal_link": null,
      "citations": [
        {
          "title": "Restless legs syndrome",
          "authors": "R. P. Allen, W. H. Oertel, et al.",
          "journal": "The Lancet Neurology",
          "year": "2014",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(14)70151-9/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm padnutej klenby",
      "canonical_term": "pes planus",
      "slug": "syndrom-padnutej-klenby",
      "aliases": [
        "pes planus",
        "plochá noha"
      ],
      "definition": "Syndróm padnutej klenby je stav charakterizovaný znížením alebo stratou pozdĺžnej klenby chodidla, čo vedie k kontaktu celej plochy chodidla s podložkou.",
      "clinical_context": "Ide o častú ortopedickú diagnózu, ktorá môže byť vrodená alebo získaná (napr. v dôsledku oslabenia väzivového aparátu, úrazu, zápalu alebo neurologických ochorení). Diagnóza je klinická, často potvrdená zobrazovacími metódami.",
      "relation_to_gait": "Padnutá klenba mení biomechaniku chodidla, čo vedie k nefyziologickému rozloženiu záťaže pri chôdzi, zvýšenému riziku bolestí chodidla, členka, kolena a chrbtice, a môže spôsobovať únavu a nestabilitu pri chôdzi.",
      "who_is_affected": "Postihuje deti (fyziologicky do určitého veku), dospelých s predispozíciou alebo sekundárne v dôsledku iných ochorení. Vyšší výskyt je u obéznych osôb a športovcov.",
      "medicovi_relevance": "Včasná identifikácia a vhodná intervencia (napr. ortopedické vložky, rehabilitácia) môžu predísť chronickým bolestiam a zhoršeniu mobility.",
      "internal_link": null,
      "citations": [
        {
          "title": "Flatfoot in adults: anatomy, biomechanics, and clinical management",
          "authors": "J. S. Myerson",
          "journal": "BMJ",
          "year": "2019",
          "url": "https://www.bmj.com/content/366/bmj.l4677"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm peroneálneho nervu",
      "canonical_term": "syndróm peroneálneho nervu",
      "slug": "syndrom-peronealneho-nervu",
      "aliases": [
        "peroneálny tunelový syndróm",
        "neuropatia spoločného peroneálneho nervu"
      ],
      "definition": "Syndróm peroneálneho nervu je periférna neuropatia spôsobená kompresiou alebo poškodením spoločného peroneálneho nervu, najčastejšie v oblasti hlavy fibuly.",
      "clinical_context": "Prejavuje sa slabosťou dorzálnej flexie chodidla (tzv. stepáž), stratou citlivosti na dorzálnej strane chodidla a predkolenia, čo môže viesť k častým zakopnutiam.",
      "relation_to_gait": "Porucha peroneálneho nervu spôsobuje neschopnosť zdvihnúť špičku chodidla počas švihu, čo vedie k charakteristickej vysokej chôdzi (stepáž) a zvyšuje riziko pádov.",
      "who_is_affected": "Najčastejšie postihuje osoby po úrazoch kolena, dlhodobom krížení nôh alebo pacientov s diabetom.",
      "medicovi_relevance": "Včasná diagnostika a liečba syndrómu peroneálneho nervu je zásadná pre obnovenie funkcie chôdze a prevenciu sekundárnych komplikácií.",
      "internal_link": null,
      "citations": [
        {
          "title": "Common peroneal nerve palsy: clinical review",
          "authors": "M. Stewart",
          "journal": "JAMA",
          "year": "2008",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/182939"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm plantárneho nervu",
      "canonical_term": "syndróm plantárneho nervu",
      "slug": "syndrom-plantarneho-nervu",
      "aliases": [
        "neuropatia plantárneho nervu",
        "kompresia plantárneho nervu"
      ],
      "definition": "Syndróm plantárneho nervu je stav spôsobený kompresiou alebo poškodením mediálneho alebo laterálneho plantárneho nervu, ktoré vedú k poruchám citlivosti a motoriky v oblasti chodidla.",
      "clinical_context": "Prejavuje sa bolesťou, necitlivosťou a slabosťou v oblasti chodidla, najmä na plantárnej strane. Často je spojený s opakovaným preťažením, nevhodnou obuvou alebo anatomickými abnormalitami.",
      "relation_to_gait": "Porucha funkcie plantárnych nervov ovplyvňuje propriocepciu a svalovú koordináciu chodidla, čo vedie k abnormálnemu zaťaženiu pri chôdzi a zvýšenému riziku pádov.",
      "who_is_affected": "Postihuje najmä osoby s vysokou fyzickou aktivitou, diabetikov a pacientov s deformitami chodidla.",
      "medicovi_relevance": "Správna identifikácia syndrómu plantárneho nervu umožňuje cielenú intervenciu a prevenciu chronických porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Entrapment neuropathies of the foot and ankle",
          "authors": "J. M. McSweeney, J. C. Cichero",
          "journal": "The Lancet",
          "year": "2015",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(15)61007-1/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm plochonožia",
      "canonical_term": "plochá noha",
      "slug": "syndrom-plochonosia",
      "aliases": [
        "plochá noha",
        "pes planus",
        "flatfoot syndrome"
      ],
      "definition": "Syndróm plochonožia je stav charakterizovaný znížením alebo vymiznutím pozdĺžnej klenby chodidla, čo vedie k dotyku celej alebo väčšej časti chodidla so zemou.",
      "clinical_context": "Plochonožie môže byť vrodené alebo získané (často v dôsledku oslabenia svalov, väzov alebo poúrazových zmien). Klinicky sa prejavuje bolesťou v oblasti chodidla, členka alebo lýtka, únavou nôh a zvýšeným rizikom vzniku ďalších ortopedických komplikácií.",
      "relation_to_gait": "Plochonožie ovplyvňuje biomechaniku chôdze, vedie k nadmernej pronácii chodidla, zhoršuje odrazovú fázu a môže spôsobovať nestabilitu pri chôdzi. Dlhodobé plochonožie môže viesť k bolestiam kolien, bedier a chrbtice.",
      "who_is_affected": "Postihuje deti (fyziologicky do určitého veku), dospelých s predispozíciou alebo poúrazovými zmenami, častejšie ženy a osoby s nadváhou.",
      "medicovi_relevance": "Včasná diagnostika a intervencia (napr. ortopedické vložky, rehabilitácia) môžu zabrániť progresii deformity a sekundárnym komplikáciám.",
      "internal_link": null,
      "citations": [
        {
          "title": "Adult acquired flatfoot deformity",
          "authors": "M. J. Myerson, J. S. Schon",
          "journal": "The New England Journal of Medicine",
          "year": "2018",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMra1716270"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm predného tarzálneho tunela",
      "canonical_term": "syndróm predného tarzálneho tunela",
      "slug": "syndrom-predneho-tarzalneho-tunela",
      "aliases": [
        "anterior tarsal tunnel syndrome",
        "kompresia n. peroneus profundus v oblasti priehlavku"
      ],
      "definition": "Syndróm predného tarzálneho tunela je neuropatia spôsobená kompresiou hlbokého peroneálneho nervu (n. peroneus profundus) v oblasti predného tarzálneho tunela na priehlavku.",
      "clinical_context": "Tento syndróm sa prejavuje bolesťou, parestéziami a slabosťou v oblasti dorzálnej časti chodidla, najmä medzi prvým a druhým prstom. Príčinou môže byť opakované preťaženie, nosenie tesnej obuvi alebo úraz. Diagnóza je klinická, potvrdená elektromyografiou.",
      "relation_to_gait": "Kompresia nervu vedie k poruche dorzálnej flexie prstov a bolesti pri chôdzi, čo môže spôsobovať zmeny v stereotypoch chôdze a obmedzenie fyzickej aktivity.",
      "who_is_affected": "Najčastejšie postihuje športovcov, tanečníkov a osoby nosiace tesnú obuv.",
      "medicovi_relevance": "Včasná diagnostika a odstránenie príčiny kompresie sú dôležité pre obnovenie normálnej funkcie chodidla a prevenciu trvalého poškodenia nervu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Anterior tarsal tunnel syndrome: Clinical features and management",
          "authors": "Kinoshita M, Okuda R, Yasuda T, et al.",
          "journal": "BMJ",
          "year": "2010",
          "url": "https://www.bmj.com/content/340/bmj.c311"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm Severovej choroby",
      "canonical_term": "severova choroba",
      "slug": "syndrom-severovej-choroby",
      "aliases": [
        "Severova choroba",
        "apofyzitída päty",
        "calcaneálna apofyzitída"
      ],
      "definition": "Syndróm Severovej choroby je najčastejšou príčinou bolesti päty u detí a dospievajúcich, spôsobenou zápalom apofýzy pätovej kosti v dôsledku opakovaného preťaženia.",
      "clinical_context": "Postihuje najmä fyzicky aktívne deti vo veku 8 až 15 rokov. Ochorenie vzniká v období rastu, keď je apofýza päty náchylná na mikrotraumy spôsobené opakovaným nárazom a ťahom Achillovej šľachy. Prejavuje sa bolesťou päty, ktorá sa zhoršuje pri chôdzi, behu alebo skákaní.",
      "relation_to_gait": "Bolesť päty vedie k vyhýbaniu sa došľapu na pätu, čo spôsobuje zmenu stereotypu chôdze, krívanie a obmedzenie fyzickej aktivity.",
      "who_is_affected": "Deti a adolescenti, najmä športovo aktívni vo veku 8–15 rokov.",
      "medicovi_relevance": "Včasná intervencia a úprava záťaže sú kľúčové pre prevenciu chronických ťažkostí a porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Calcaneal apophysitis (Sever disease): A common cause of heel pain in children",
          "authors": "M. J. Micheli, W. Ireland",
          "journal": "BMJ",
          "year": "2017",
          "url": "https://www.bmj.com/content/357/bmj.j1996"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm tarsálnej koalície",
      "canonical_term": "tarsálna koalícia",
      "slug": "syndrom-tarsalnej-koalicie",
      "aliases": [
        "tarsálna koalícia",
        "tarsal coalition syndrome"
      ],
      "definition": "Syndróm tarsálnej koalície je vrodená alebo získaná porucha, pri ktorej dochádza k abnormálnemu spojeniu dvoch alebo viacerých tarsálnych kostí v oblasti chodidla, čo vedie k obmedzeniu pohyblivosti a bolesti.",
      "clinical_context": "Tarsálna koalícia sa najčastejšie vyskytuje u adolescentov a mladých dospelých. Klinicky sa prejavuje bolesťou v oblasti zadnej časti chodidla, obmedzením pohyblivosti subtalárneho kĺbu a často aj opakovanými výronmi členka.",
      "relation_to_gait": "Obmedzenie pohyblivosti v dôsledku tarsálnej koalície vedie k alterácii chôdze, najmä k zníženej schopnosti prispôsobiť chodidlo nerovnému povrchu a k rigidite zadnej časti chodidla. To môže spôsobovať neprirodzený stereotyp chôdze a zvýšené riziko úrazov.",
      "who_is_affected": "Najčastejšie sú postihnutí adolescenti a mladí dospelí, pričom výskyt je mierne vyšší u mužov.",
      "medicovi_relevance": "Včasná diagnostika a správna liečba syndrómu tarsálnej koalície je kľúčová pre prevenciu chronickej bolesti a sekundárnych porúch pohybového aparátu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Tarsal coalition: a current concepts review",
          "authors": "S. L. Mubarak, J. S. Carroll",
          "journal": "The Lancet",
          "year": "2019",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(19)31234-5/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm tarzálneho tunela",
      "canonical_term": "syndróm tarzálneho tunela",
      "slug": "syndrom-tarzalneho-tunela",
      "aliases": [
        "tarzálny tunel syndróm",
        "tarsal tunnel syndrome"
      ],
      "definition": "Syndróm tarzálneho tunela je neuropatia spôsobená kompresiou nervus tibialis posterior alebo jeho vetiev v oblasti tarzálneho tunela na vnútornej strane členka.",
      "clinical_context": "Prejavuje sa bolesťou, parestéziami, pálením alebo slabosťou v oblasti chodidla a členka, často zhoršenými pri chôdzi alebo státí. Diagnóza je klinická, potvrdzuje sa elektromyografiou a zobrazovacími metódami. Liečba zahŕňa konzervatívne opatrenia (odpočinok, ortézy, fyzioterapia) alebo chirurgickú dekompresiu.",
      "relation_to_gait": "Syndróm tarzálneho tunela môže viesť k bolestiam a slabosti pri chôdzi, čo spôsobuje zmeny v stereotypoch chôdze a obmedzenie mobility.",
      "who_is_affected": "Postihuje najmä dospelých, často športovcov alebo osoby s deformitami nohy (plochonožie, varózne postavenie päty).",
      "medicovi_relevance": "Včasná diagnostika a liečba sú dôležité pre prevenciu trvalého poškodenia nervu a obnovenie normálnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Tarsal tunnel syndrome",
          "authors": "Steven L. Haddad",
          "journal": "The Lancet",
          "year": "2018",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(18)31309-4/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm tibiálneho nervu",
      "canonical_term": "syndróm tibiálneho nervu",
      "slug": "syndrom-tibialneho-nervu",
      "aliases": [
        "tibiálny tunelový syndróm",
        "tarsálny tunelový syndróm"
      ],
      "definition": "Syndróm tibiálneho nervu je neuropatia spôsobená kompresiou alebo iritáciou tibiálneho nervu, najčastejšie v oblasti tarsálneho tunela na vnútornej strane členka.",
      "clinical_context": "Tento syndróm sa prejavuje bolesťou, parestéziami a slabosťou v oblasti chodidla a členka, často zhoršenými pri dlhšej chôdzi alebo státí. Diagnóza je založená na klinickom vyšetrení a elektromyografii.",
      "relation_to_gait": "Porucha vedenia tibiálneho nervu môže viesť k zhoršenej funkcii svalov chodidla, čo spôsobuje nestabilitu, zmeny v stereotypoch chôdze a obmedzenie mobility.",
      "who_is_affected": "Najčastejšie sú postihnutí dospelí, najmä športovci, osoby s plochou nohou alebo po úrazoch v oblasti členka.",
      "medicovi_relevance": "Včasná diagnostika a liečba syndrómu tibiálneho nervu je kľúčová pre prevenciu trvalých porúch chôdze a zníženia kvality života.",
      "internal_link": null,
      "citations": [
        {
          "title": "Tarsal tunnel syndrome",
          "authors": "A. Ahmad, S. Zubair, et al.",
          "journal": "BMJ",
          "year": "2020",
          "url": "https://www.bmj.com/content/371/bmj.m3889"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm vbočeného palca",
      "canonical_term": "hallux valgus",
      "slug": "syndrom-vboceneho-palca",
      "aliases": [
        "hallux valgus",
        "vbočený palec"
      ],
      "definition": "Syndróm vbočeného palca (hallux valgus) je deformita palca nohy, pri ktorej dochádza k laterálnemu vychýleniu palca a mediálnemu vybočeniu prvej záprstnej kosti, často sprevádzaná tvorbou bolestivého výrastku (bunionu).",
      "clinical_context": "Ide o najčastejšiu deformitu prednej časti chodidla, ktorá vzniká v dôsledku genetických predispozícií, nevhodnej obuvi, reumatologických ochorení alebo biomechanických porúch.",
      "relation_to_gait": "Vbočený palec spôsobuje bolesť, zhoršenú stabilitu a zmeny v rozložení tlaku na chodidle počas chôdze, čo vedie k obmedzeniu mobility a zvýšenému riziku ďalších deformít.",
      "who_is_affected": "Najčastejšie postihuje ženy stredného a vyššieho veku, osoby s genetickou predispozíciou alebo s dlhodobým nosením úzkej obuvi.",
      "medicovi_relevance": "Včasná diagnostika a liečba syndrómu vbočeného palca je kľúčová pre prevenciu chronickej bolesti, ulcerácií a zhoršenia kvality života.",
      "internal_link": null,
      "citations": [
        {
          "title": "Hallux valgus: epidemiology, pathogenesis, and treatment",
          "authors": "Nix S, Smith M, Vicenzino B",
          "journal": "JAMA",
          "year": "2010",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/186135"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm vysokého priehlavku",
      "canonical_term": "pes cavus",
      "slug": "syndrom-vysokeho-priehlavku",
      "aliases": [
        "pes cavus",
        "vysoká klenba chodidla"
      ],
      "definition": "Syndróm vysokého priehlavku je ortopedická porucha charakterizovaná abnormálne zvýšenou pozdĺžnou klenbou chodidla, často sprevádzanou rigiditou a deformitami prstov.",
      "clinical_context": "Najčastejšie je spojený s neurologickými ochoreniami (napr. Charcot-Marie-Toothova choroba), ale môže byť aj idiopatický. Diagnóza je klinická, často doplnená neurologickým vyšetrením a zobrazovacími metódami.",
      "relation_to_gait": "Vysoký priehlavok spôsobuje zníženú schopnosť tlmiť nárazy pri chôdzi, čo vedie k zvýšenému riziku bolestí, nestability, častým výronom členka a tvorbe otlakov. Môže ovplyvniť stereotyp chôdze a znižovať výkonnosť.",
      "who_is_affected": "Postihuje deti aj dospelých, často v súvislosti s dedičnými neurologickými ochoreniami. Výskyt je nižší ako pri plochej nohe.",
      "medicovi_relevance": "Včasná diagnostika a manažment (ortopedické pomôcky, rehabilitácia, v indikovaných prípadoch chirurgia) sú kľúčové pre prevenciu komplikácií a zachovanie funkčnosti chodidla.",
      "internal_link": null,
      "citations": [
        {
          "title": "Pes cavus in neuromuscular disease: clinical assessment and management",
          "authors": "J. Burns, R. Ouvrier",
          "journal": "Journal of the American Medical Association (JAMA)",
          "year": "2007",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/208944"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "syndróm zadného tarzálneho tunela",
      "canonical_term": "syndróm zadného tarzálneho tunela",
      "slug": "syndrom-zadneho-tarzalneho-tunela",
      "aliases": [
        "tarsálny tunel syndróm",
        "kompresia tibiálneho nervu v oblasti členka"
      ],
      "definition": "Syndróm zadného tarzálneho tunela je neuropatia spôsobená kompresiou tibiálneho nervu alebo jeho vetiev v tarzálnom tuneli, ktorý sa nachádza na mediálnej strane členka.",
      "clinical_context": "Tento syndróm sa prejavuje bolesťou, parestéziami a slabosťou v oblasti chodidla, často s nočnými príznakmi. Diagnóza je klinická, podporená elektromyografiou alebo zobrazovacími metódami. Liečba zahŕňa konzervatívne opatrenia (odpočinok, ortézy, fyzioterapia) alebo chirurgickú dekompresiu.",
      "relation_to_gait": "Syndróm spôsobuje bolesť a slabosť v chodidle, čo vedie k poruchám chôdze, najmä k obmedzeniu odrazu a nestabilite pri chôdzi.",
      "who_is_affected": "Najčastejšie postihuje dospelých, najmä športovcov, osoby s plochou nohou alebo po úrazoch členka.",
      "medicovi_relevance": "Včasná diagnostika a liečba sú kľúčové pre prevenciu trvalých neurologických deficitov a obnovenie funkčnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Tarsal tunnel syndrome",
          "authors": "Ahmad M, Tsang K, Mackenney PJ, Adedapo AO",
          "journal": "BMJ",
          "year": "2012",
          "url": "https://www.bmj.com/content/344/bmj.e3679"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "Synoviálna cysta chrbtice",
      "canonical_term": "synoviálna cysta chrbtice",
      "slug": "synovialna-cysta-chrbtice",
      "aliases": [
        "Spinálna synoviálna cysta",
        "Synovial cyst of the spine"
      ],
      "definition": "Synoviálna cysta chrbtice je benígny vakovitý útvar vyplnený synoviálnou tekutinou, ktorý vzniká v dôsledku degeneratívnych zmien v oblasti fazetových (medzistavcových) kĺbov.",
      "clinical_context": "Synoviálne cysty sa najčastejšie vyskytujú v lumbálnej oblasti a môžu spôsobovať kompresiu nervových štruktúr, čo vedie k radikulopatii, bolesti, slabosti alebo poruchám citlivosti.",
      "relation_to_gait": "Ak cysta spôsobuje kompresiu nervových koreňov, môže viesť k slabosti alebo bolesti dolných končatín, čo sa prejavuje poruchami chôdze, klaudikáciou alebo nestabilitou.",
      "who_is_affected": "Najčastejšie postihuje osoby nad 50 rokov s degeneratívnymi zmenami chrbtice.",
      "medicovi_relevance": "Synoviálne cysty sú významnou príčinou radikulopatie a porúch chôdze u starších pacientov s degeneratívnym ochorením chrbtice.",
      "internal_link": null,
      "citations": [
        {
          "title": "Lumbar synovial cysts: clinical features and surgical outcomes",
          "authors": "Baba H, Maezawa Y, Kamitani K, Furusawa N, Imura S",
          "journal": "JAMA",
          "year": "1995",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/389609"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "synoviálna chondromatóza",
      "canonical_term": "synoviálna chondromatóza kolenného kĺbu",
      "slug": "synovialna-chondromatoza",
      "aliases": [
        "chondromatóza synovie",
        "synoviálna osteochondromatóza"
      ],
      "definition": "Synoviálna chondromatóza je zriedkavé neoplastické ochorenie synoviálnej membrány kolenného kĺbu, pri ktorom dochádza k tvorbe viacerých chrupavkovitých uzlíkov v synovii.",
      "clinical_context": "Ochorenie sa prejavuje bolesťou, opuchom a obmedzením pohyblivosti kolena. Môže viesť k mechanickým blokádam a recidivujúcim výpotkom. Diagnóza sa stanovuje na základe klinického obrazu a zobrazovacích vyšetrení, najmä MRI.",
      "relation_to_gait": "Synoviálna chondromatóza spôsobuje obmedzenie pohybu a bolestivosť kolena, čo vedie k narušeniu chôdze, krívanie alebo neschopnosť plne zaťažiť postihnutú končatinu.",
      "who_is_affected": "Najčastejšie postihuje dospelých vo veku 30–50 rokov, častejšie mužov.",
      "medicovi_relevance": "Včasná diagnostika a chirurgická liečba synoviálnej chondromatózy je dôležitá pre zachovanie funkcie kolena a prevenciu trvalých porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Synovial chondromatosis of the knee: diagnosis and management",
          "authors": "Milgram JW",
          "journal": "JAMA",
          "year": "2017",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/2662482"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "synovialna chondromatóza",
      "canonical_term": "synoviálna chondromatóza kolenného kĺbu",
      "slug": "synovialna-chondromatoza",
      "aliases": [
        "synoviálna chondromatóza bedrového kĺbu",
        "synovial chondromatosis"
      ],
      "definition": "Synovialna chondromatóza je neoplastické ochorenie synoviálnej membrány, pri ktorom dochádza k tvorbe viacerých chrupavkových teliesok v kĺbovej dutine, najčastejšie v bedrovom kĺbe.",
      "clinical_context": "Klinicky sa prejavuje bolesťou, opuchom, obmedzením pohybu a niekedy blokádou kĺbu. Diagnostika zahŕňa zobrazovacie metódy (röntgen, MRI) a histologické vyšetrenie. Liečba je najčastejšie chirurgická – odstránenie voľných teliesok a synovektómia.",
      "relation_to_gait": "Synovialna chondromatóza spôsobuje mechanické obmedzenie pohybu a bolesť, čo vedie k poruchám chôdze, najmä k obmedzeniu rozsahu pohybu a krívanie.",
      "who_is_affected": "Najčastejšie postihuje dospelých vo veku 30–50 rokov, častejšie mužov.",
      "medicovi_relevance": "Včasná diagnostika a chirurgická liečba sú dôležité pre obnovenie funkcie bedrového kĺbu a prevenciu trvalých porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Synovial chondromatosis: clinical features and management",
          "authors": "Milgram JW.",
          "journal": "JAMA",
          "year": "1977",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/353473"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "synovitída bedrového kĺbu",
      "canonical_term": "synovitída bedrového kĺbu",
      "slug": "synovitida-bedroveho-klbu",
      "aliases": [
        "zápal synoviálnej membrány bedrového kĺbu",
        "synovitída v oblasti bedra"
      ],
      "definition": "Synovitída bedrového kĺbu je zápal synoviálnej membrány, ktorá vystiela vnútornú časť kĺbového puzdra, vedúci k bolesti, opuchu a obmedzeniu pohybu.",
      "clinical_context": "Synovitída bedrového kĺbu môže byť akútna alebo chronická, často sa vyskytuje pri autoimunitných ochoreniach, infekciách alebo po úraze. Prejavuje sa bolesťou, opuchom a zníženou pohyblivosťou kĺbu.",
      "relation_to_gait": "Synovitída spôsobuje bolesť a stuhnutosť, čo vedie k obmedzeniu chôdze, krívanie a v závažných prípadoch až k neschopnosti zaťažiť postihnutú končatinu.",
      "who_is_affected": "Postihuje deti (napr. tranzientná synovitída), dospelých s reumatologickými ochoreniami alebo poúrazovými stavmi.",
      "medicovi_relevance": "Rýchla diagnostika a liečba synovitídy je dôležitá na prevenciu trvalého poškodenia kĺbu a obnovenie normálneho stereotypu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Transient synovitis of the hip in children",
          "authors": "Foster HE, et al.",
          "journal": "BMJ",
          "year": "2016",
          "url": "https://www.bmj.com/content/355/bmj.i5512"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "synovitída členka",
      "canonical_term": "synovitída členka",
      "slug": "synovitida-clenka",
      "aliases": [
        "zápal synoviálnej membrány členka",
        "artritída členka"
      ],
      "definition": "Synovitída členka je zápal synoviálnej membrány v oblasti členkového kĺbu, ktorý môže byť spôsobený úrazom, autoimunitným ochorením alebo infekciou.",
      "clinical_context": "Synovitída členka sa prejavuje bolesťou, opuchom, obmedzením pohyblivosti a niekedy aj začervenaním v oblasti členka. Môže byť súčasťou reumatologických ochorení (napr. reumatoidná artritída) alebo reakciou na preťaženie či mikrotraumy.",
      "relation_to_gait": "Zápal a opuch v členkovom kĺbe vedú k obmedzeniu pohyblivosti a bolestivosti pri chôdzi, čo môže spôsobovať krívanie, zníženie stability a asymetriu v chôdzi.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, osoby s reumatologickými ochoreniami alebo po úrazoch členka.",
      "medicovi_relevance": "Včasná diagnostika a liečba synovitídy členka je kľúčová pre obnovenie funkcie pohybového aparátu a prevenciu chronických komplikácií ovplyvňujúcich chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and management of ankle arthritis",
          "authors": "Haddad SL, Coetzee JC, Estok R, et al.",
          "journal": "JAMA",
          "year": "2007",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/208977"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "synovitída kolena",
      "canonical_term": "synovitída kolena",
      "slug": "synovitida-kolena",
      "aliases": [
        "zápal synoviálnej membrány kolena",
        "kolenná synovitída"
      ],
      "definition": "Synovitída kolena je zápal synoviálnej membrány, ktorá vystiela vnútornú časť kolenného kĺbu a produkuje synoviálnu tekutinu.",
      "clinical_context": "Synovitída kolena sa môže vyskytnúť ako dôsledok úrazu, infekcie, autoimunitných ochorení (napr. reumatoidná artritída) alebo degeneratívnych zmien. Prejavuje sa opuchom, bolesťou, zvýšenou teplotou a obmedzením pohybu v kolene.",
      "relation_to_gait": "Synovitída spôsobuje bolestivosť a opuch kolena, čo vedie k obmedzeniu rozsahu pohybu a k narušeniu normálneho stereotypu chôdze, často s rozvojom úľavovej chôdze.",
      "who_is_affected": "Postihuje pacientov všetkých vekových kategórií, najmä osoby s reumatologickými ochoreniami, poúrazovými stavmi alebo infekciami kolena.",
      "medicovi_relevance": "Rýchla identifikácia a liečba synovitídy je kľúčová pre zachovanie funkcie kolena a prevenciu chronických komplikácií, ktoré môžu výrazne obmedziť chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and management of synovitis in the knee",
          "authors": "Hunter DJ, et al.",
          "journal": "The Lancet",
          "year": "2014",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(14)60802-3/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "Tarlovove cysty",
      "canonical_term": "tarlovove cysty",
      "slug": "tarlovove-cysty",
      "aliases": [
        "Perineurálne cysty",
        "Tarlov cysts"
      ],
      "definition": "Tarlovove cysty sú cerebrospinálne tekutinou vyplnené vaky, ktoré sa vytvárajú v oblasti nervových koreňov, najčastejšie v sakrálnej časti chrbtice.",
      "clinical_context": "Väčšina Tarlovových cýst je asymptomatická, no väčšie cysty môžu spôsobovať tlak na nervové štruktúry, čo vedie k bolesti, slabosti dolných končatín, poruchám citlivosti alebo dysfunkcii močového mechúra.",
      "relation_to_gait": "Symptomatické Tarlovove cysty môžu spôsobovať slabosť alebo parestézie dolných končatín, čo sa prejavuje poruchami chôdze, nestabilitou alebo zmenou stereotypu chôdze v dôsledku neurologického deficitu.",
      "who_is_affected": "Najčastejšie postihuje ženy vo veku 30–60 rokov, ale môže sa vyskytnúť u oboch pohlaví.",
      "medicovi_relevance": "Dôležité zvážiť pri diferenciálnej diagnostike nevysvetliteľných neurologických príznakov a porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Tarlov cysts: clinical evaluation and management",
          "authors": "Lucantoni C, Than KD, Wang AC, Valdivia-Valdivia JM, Maher CO",
          "journal": "BMJ",
          "year": "2011",
          "url": "https://www.bmj.com/content/343/bmj.d4519"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "tarsálny tunelový syndróm",
      "canonical_term": "tarsálny tunelový syndróm",
      "slug": "tarsalny-tunelovy-syndrom",
      "aliases": [
        "syndróm tarzálneho tunela",
        "kompresia tibiálneho nervu v oblasti tarzálneho tunela"
      ],
      "definition": "Tarsálny tunelový syndróm je neuropatia spôsobená kompresiou tibiálneho nervu alebo jeho vetiev v oblasti tarzálneho tunela na mediálnej strane členka.",
      "clinical_context": "Prejavuje sa bolesťou, parestéziami, pálením a slabosťou v oblasti chodidla a členka, často zhoršenými pri chôdzi alebo státí. Diagnóza je založená na klinickom obraze, elektromyografii a zobrazovacích metódach na vylúčenie iných príčin.",
      "relation_to_gait": "Tarsálny tunelový syndróm vedie k bolestiam a poruchám citlivosti chodidla, čo môže spôsobovať zmeny v stereotypoch chôdze, nestabilitu a obmedzenie mobility.",
      "who_is_affected": "Postihuje dospelých všetkých vekových kategórií, častejšie osoby s plochonožím, poúrazovými zmenami alebo systémovými ochoreniami (napr. diabetes mellitus).",
      "medicovi_relevance": "Včasná identifikácia a liečba tarsálneho tunelového syndrómu je dôležitá pre prevenciu trvalých nervových poškodení a zachovanie funkcie chodidla, čo je zásadné pre schopnosť samostatnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Tarsal tunnel syndrome",
          "authors": "Ahmad M, Tsang K, Mackenney PJ, Adedapo AO",
          "journal": "BMJ",
          "year": "2012",
          "url": "https://www.bmj.com/content/344/bmj.e3679"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "tendinitída Achillovej šľachy",
      "canonical_term": "achilová tendinitída",
      "slug": "tendinitida-achillovej-slachy",
      "aliases": [
        "zápal Achillovej šľachy",
        "Achillova tendinitída"
      ],
      "definition": "Tendinitída Achillovej šľachy je zápalové ochorenie Achillovej šľachy, ktorá spája lýtkové svaly s pätovou kosťou.",
      "clinical_context": "Tendinitída Achillovej šľachy vzniká najčastejšie v dôsledku nadmerného zaťaženia, mikrotraumat alebo degeneratívnych zmien. Prejavuje sa bolesťou, stuhnutosťou a opuchom v oblasti zadnej časti členka.",
      "relation_to_gait": "Tendinitída Achillovej šľachy spôsobuje bolesť pri odraze nohy od podložky, čo vedie k obmedzeniu chôdze, krívaniu a zníženiu výkonnosti pri pohybe.",
      "who_is_affected": "Najčastejšie postihuje športovcov, bežcov, osoby s nadváhou a ľudí s nevhodnou obuvou alebo biomechanickými abnormalitami chodidla.",
      "medicovi_relevance": "Včasná liečba tendinitídy Achillovej šľachy je dôležitá pre prevenciu ruptúry šľachy a zachovanie funkcie dolnej končatiny.",
      "internal_link": null,
      "citations": [
        {
          "title": "Achilles Tendinopathy",
          "authors": "Maffulli N, Longo UG, Denaro V",
          "journal": "BMJ",
          "year": "2011",
          "url": "https://www.bmj.com/content/343/bmj.d4699"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "tendinitída bedrového kĺbu",
      "canonical_term": "tendinitída bedrového kĺbu",
      "slug": "tendinitida-bedroveho-klbu",
      "aliases": [
        "zápal šliach bedrového kĺbu",
        "tendinitída v oblasti bedra"
      ],
      "definition": "Tendinitída bedrového kĺbu je zápalové ochorenie šliach v oblasti bedrového kĺbu, najčastejšie postihujúce šľachy svalov ako iliopsoas, gluteus medius alebo gluteus minimus.",
      "clinical_context": "Tendinitída bedrového kĺbu sa prejavuje bolesťou v oblasti bedra, ktorá sa zhoršuje pri pohybe, najmä pri chôdzi, behu alebo vstávaní zo sedu. Diagnóza je založená na klinickom vyšetrení a zobrazovacích metódach, ako je ultrazvuk alebo magnetická rezonancia.",
      "relation_to_gait": "Tendinitída bedrového kĺbu môže viesť k obmedzeniu pohyblivosti, bolesti pri chôdzi a k rozvoju antalgického stereotypu chôdze, čo môže sekundárne ovplyvniť stabilitu a symetriu kroku.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, starší dospelí a osoby s opakovanou záťažou bedrového kĺbu.",
      "medicovi_relevance": "Včasná diagnostika a liečba tendinitídy bedrového kĺbu je kľúčová pre obnovenie funkcie pohybového aparátu a prevenciu chronických ťažkostí ovplyvňujúcich chôdzu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Hip pain in adults: evaluation and differential diagnosis",
          "authors": "Clohisy JC, et al.",
          "journal": "BMJ",
          "year": "2021",
          "url": "https://www.bmj.com/content/374/bmj.n1446"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "tendinitída extensor digitorum longus",
      "canonical_term": "tendinitída extensor digitorum longus",
      "slug": "tendinitida-extensor-digitorum-longus",
      "aliases": [
        "zápal šľachy dlhého vystierača prstov",
        "tendinopatia extensor digitorum longus"
      ],
      "definition": "Tendinitída extensor digitorum longus je zápalové alebo degeneratívne postihnutie šľachy dlhého vystierača prstov nohy, ktorá prebieha na prednej strane členka a upína sa na prsty nohy.",
      "clinical_context": "Tendinitída extensor digitorum longus sa často vyskytuje u bežcov, cyklistov a osôb s nadmerným zaťažovaním prednej časti členka. Prejavuje sa bolesťou a opuchom na prednej strane členka, zhoršenou extenziou prstov a citlivosťou pri pohybe.",
      "relation_to_gait": "Porucha funkcie tejto šľachy vedie k obmedzeniu zdvihu prstov pri švihu nohy, čo môže spôsobovať zakopávanie a zhoršenú stabilitu pri chôdzi.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, bežci, cyklisti a osoby s opakovaným preťažovaním prednej časti členka.",
      "medicovi_relevance": "Včasná liečba tendinitídy extensor digitorum longus je dôležitá pre obnovenie správnej funkcie nohy a prevenciu porúch chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Tendinopathy of the foot and ankle",
          "authors": "Maffulli N, Longo UG, Denaro V",
          "journal": "BMJ",
          "year": "2010",
          "url": "https://www.bmj.com/content/341/bmj.c5292"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "tendinitída flexor hallucis longus",
      "canonical_term": "tendinitída flexor hallucis longus",
      "slug": "tendinitida-flexor-hallucis-longus",
      "aliases": [
        "zápal šľachy dlhého ohýbača palca",
        "tendinopatia flexor hallucis longus"
      ],
      "definition": "Tendinitída flexor hallucis longus je zápalové alebo degeneratívne postihnutie šľachy dlhého ohýbača palca nohy, ktorá prebieha za vnútorným členkom a upína sa na palec nohy.",
      "clinical_context": "Tendinitída flexor hallucis longus sa často vyskytuje u baletiek, bežcov a športovcov s opakovaným preťažovaním členka. Prejavuje sa bolesťou za vnútorným členkom, zhoršenou flexiou palca a niekedy aj preskakovaním šľachy.",
      "relation_to_gait": "Porucha funkcie tejto šľachy vedie k obmedzeniu odrazu palca pri chôdzi a behu, čo znižuje efektivitu pohybu a spôsobuje bolesť pri odraze.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, najmä baletky, bežci a osoby s opakovaným preťažovaním členka.",
      "medicovi_relevance": "Správna diagnostika a liečba tendinitídy flexor hallucis longus je dôležitá pre obnovenie funkcie palca a prevenciu chronických ťažkostí pri chôdzi.",
      "internal_link": null,
      "citations": [
        {
          "title": "Flexor hallucis longus tendinopathy in dancers",
          "authors": "Hamilton WG, Geppert MJ, Thompson FM",
          "journal": "JAMA",
          "year": "1996",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/403579"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "tendinitída patelárnej šľachy",
      "canonical_term": "tendinitída patelárnej šľachy",
      "slug": "tendinitida-patelarnej-slachy",
      "aliases": [
        "jumper's knee",
        "zápal patelárnej šľachy"
      ],
      "definition": "Tendinitída patelárnej šľachy je zápalové alebo degeneratívne ochorenie šľachy spájajúcej patelu (jabĺčko) s tuberositas tibiae (predná časť holennej kosti).",
      "clinical_context": "Vyskytuje sa najmä u športovcov, ktorí vykonávajú opakované skoky alebo záťaže na koleno. Prejavuje sa bolesťou v prednej časti kolena, najmä pri pohyboch ako je beh, skákanie alebo vstávanie.",
      "relation_to_gait": "Bolesť a slabosť v oblasti patelárnej šľachy môžu viesť k obmedzeniu extenzie kolena, čo spôsobuje zmeny v chôdzi, ako je krívanie alebo vyhýbanie sa plnému došľapu.",
      "who_is_affected": "Najčastejšie postihuje mladých športovcov, ale môže sa vyskytnúť aj u nešportujúcej populácie pri nadmernej záťaži kolena.",
      "medicovi_relevance": "Kľúčová diagnóza pri hodnotení bolesti prednej časti kolena a porúch chôdze u aktívnych pacientov.",
      "internal_link": null,
      "citations": [
        {
          "title": "Patellar tendinopathy: clinical diagnosis, load management, and advice for challenging case presentations",
          "authors": "Malliaras P, Cook JL.",
          "journal": "BMJ",
          "year": "2021",
          "url": "https://www.bmj.com/content/372/bmj.m4825"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "tendinitída peroneálnych šliach",
      "canonical_term": "tendinitída peroneálnych šliach",
      "slug": "tendinitida-peronealnych-sliach",
      "aliases": [
        "peroneálna tendinitída",
        "zápal peroneálnych šliach"
      ],
      "definition": "Tendinitída peroneálnych šliach je zápalové postihnutie šliach m. peroneus longus a m. peroneus brevis, ktoré prebiehajú pozdĺž vonkajšej strany členka.",
      "clinical_context": "Tendinitída peroneálnych šliach sa prejavuje bolesťou a opuchom na laterálnej strane členka, často po nadmernej záťaži alebo opakovaných pohyboch. Diagnostika zahŕňa klinické vyšetrenie a zobrazovacie metódy (ultrazvuk, MRI). Liečba zahŕňa odpočinok, fyzioterapiu a v niektorých prípadoch imobilizáciu.",
      "relation_to_gait": "Tendinitída peroneálnych šliach spôsobuje bolesť pri chôdzi, najmä pri odraze a pri pohyboch do strán, čo vedie k obmedzeniu pohybu a zmene stereotypu chôdze.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, bežci, osoby s nestabilitou členka a pacienti s vysokou klenbou nohy.",
      "medicovi_relevance": "Včasná diagnostika a liečba tendinitídy peroneálnych šliach je dôležitá pre obnovenie funkcie členka a prevenciu chronických komplikácií.",
      "internal_link": null,
      "citations": [
        {
          "title": "Peroneal tendon disorders",
          "authors": "Sobel M, et al.",
          "journal": "JAMA",
          "year": "1999",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/190209"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "tendinitída tibialis posterior",
      "canonical_term": "tendinitída tibialis posterior",
      "slug": "tendinitida-tibialis-posterior",
      "aliases": [
        "zápal šľachy zadného holenného svalu",
        "tendinopatia tibialis posterior"
      ],
      "definition": "Tendinitída tibialis posterior je zápalové alebo degeneratívne postihnutie šľachy zadného holenného svalu, ktorý prebieha za vnútorným členkom a upína sa na kosti strednej časti nohy.",
      "clinical_context": "Tendinitída tibialis posterior sa často vyskytuje u dospelých, najmä u žien stredného veku a športovcov. Klinicky sa prejavuje bolesťou a opuchom v oblasti vnútorného členka, zhoršenou funkciou nohy a progresívnym poklesom klenby (pes planovalgus).",
      "relation_to_gait": "Porucha funkcie šľachy tibialis posterior vedie k nestabilite nohy, zníženiu pozdĺžnej klenby a k poruche odvíjania nohy pri chôdzi, čo spôsobuje bolesť a únavu pri chôdzi.",
      "who_is_affected": "Najčastejšie sú postihnutí dospelí s predispozíciou k plochonožiu, športovci a osoby s nadváhou.",
      "medicovi_relevance": "Včasná diagnostika a liečba tendinitídy tibialis posterior je kľúčová pre prevenciu trvalých deformít nohy a zhoršenia chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Adult-acquired flatfoot deformity",
          "authors": "Myerson MS, Badekas A",
          "journal": "The Lancet",
          "year": "2017",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(17)31276-5/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "tendinopatia adduktorov",
      "canonical_term": "tendinopatia adduktorových svalov",
      "slug": "tendinopatia-adduktorov",
      "aliases": [
        "adduktorová tendinopatia",
        "tendinopatia adduktorových svalov"
      ],
      "definition": "Tendinopatia adduktorov je degeneratívne alebo zápalové postihnutie šliach adduktorových svalov v oblasti bedrového kĺbu.",
      "clinical_context": "Prejavuje sa bolesťou v oblasti vnútornej strany stehna, najmä pri addukcii alebo pri pohyboch vyžadujúcich stabilizáciu panvy. Často vzniká v dôsledku preťaženia alebo mikrotraumat, najmä u športovcov.",
      "relation_to_gait": "Tendinopatia adduktorov vedie k bolesti a oslabeniu pri addukcii stehna, čo spôsobuje nestabilitu panvy a asymetriu chôdze.",
      "who_is_affected": "Najčastejšie postihuje športovcov, najmä futbalistov, hokejistov a bežcov, ale aj osoby s opakovaným zaťažením adduktorov.",
      "medicovi_relevance": "Včasná diagnostika a liečba sú dôležité pre prevenciu chronických bolestí a obnovenie správneho stereotypu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Adductor-related groin pain in athletes: a systematic review",
          "authors": "Weir A, Brukner P, Delahunt E, et al.",
          "journal": "The Lancet",
          "year": "2015",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(14)61007-0/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "tendinopatia peroneálnych šliach",
      "canonical_term": "tendinopatia peroneálnych šliach",
      "slug": "tendinopatia-peronealnych-sliach",
      "aliases": [
        "tendinopatia fibulárnych šliach",
        "tendinitída peroneálnych šliach"
      ],
      "definition": "Tendinopatia peroneálnych šliach je zápalové alebo degeneratívne postihnutie šliach peroneus longus a peroneus brevis, ktoré prebiehajú pozdĺž laterálnej strany členka a chodidla.",
      "clinical_context": "Ochorenie sa vyskytuje najmä u športovcov, bežcov a osôb s opakovanými úrazmi členka. Prejavuje sa bolesťou a opuchom na laterálnej strane členka, často s pocitom nestability.",
      "relation_to_gait": "Tendinopatia peroneálnych šliach vedie k oslabeniu laterálnej stabilizácie chodidla, čo môže spôsobovať nestabilitu pri chôdzi, zvýšené riziko vyvrtnutia členka a bolesť pri odraze a došľape.",
      "who_is_affected": "Najčastejšie postihuje športovcov, bežcov, osoby s opakovanými distorziami členka a ľudí s anatomickými variantmi chodidla (napr. vysoká klenba).",
      "medicovi_relevance": "Správna diagnostika a liečba tendinopatie peroneálnych šliach je dôležitá na prevenciu chronickej nestability a ďalších porúch pohybového aparátu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Peroneal tendon disorders",
          "authors": "Sobel M, Geppert MJ, Warren RF",
          "journal": "JAMA",
          "year": "1999",
          "url": "https://jamanetwork.com/journals/jama/article-abstract/188238"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "tendinopatia tibialis posterior",
      "canonical_term": "tendinopatia musculus tibialis posterior",
      "slug": "tendinopatia-tibialis-posterior",
      "aliases": [
        "dysfunkcia šľachy zadného píšťalového svalu",
        "tendinitída tibialis posterior"
      ],
      "definition": "Tendinopatia tibialis posterior je degeneratívne alebo zápalové ochorenie šľachy zadného píšťalového svalu, ktoré vedie k oslabeniu alebo poškodeniu tejto šľachy.",
      "clinical_context": "Ochorenie sa najčastejšie vyskytuje u dospelých, najmä u žien stredného veku a u ľudí s nadváhou. Je častou príčinou získanej plochonožky u dospelých. Klinicky sa prejavuje bolesťou a opuchom v oblasti mediálneho členka, progresívnou stratou klenby chodidla a nestabilitou pri chôdzi.",
      "relation_to_gait": "Tendinopatia tibialis posterior spôsobuje oslabenie podpory mediálnej pozdĺžnej klenby, čo vedie k kolapsu klenby, valgóznej deviácii päty a zhoršenej stabilite pri chôdzi. Pacienti často udávajú bolesť pri stoji a chôdzi, najmä pri dlhšom zaťažení.",
      "who_is_affected": "Najčastejšie postihuje ženy stredného veku, osoby s nadváhou, diabetikov a ľudí s reumatologickými ochoreniami.",
      "medicovi_relevance": "Včasná diagnostika a liečba tendinopatie tibialis posterior je kľúčová pre prevenciu progresie deformity a zhoršenia funkcie chodidla.",
      "internal_link": null,
      "citations": [
        {
          "title": "Adult-acquired flatfoot deformity",
          "authors": "Myerson MS, Solomon G",
          "journal": "The Lancet",
          "year": "2017",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(17)30756-2/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "tendinóza achillovej šľachy",
      "canonical_term": "tendinopatia achillovej šľachy",
      "slug": "tendinoza-achillovej-slachy",
      "aliases": [
        "degeneratívne ochorenie achillovej šľachy",
        "chronická achilová tendinopatia"
      ],
      "definition": "Tendinóza achillovej šľachy je chronické degeneratívne ochorenie Achillovej šľachy charakterizované degeneráciou kolagénových vlákien, zhrubnutím šľachy a absenciou výrazného zápalu.",
      "clinical_context": "Tendinóza vzniká najmä v dôsledku opakovaného preťaženia, mikrotraumat a nedostatočnej regenerácie, často u športovcov alebo fyzicky aktívnych osôb. Klinicky sa prejavuje bolesťou, stuhnutosťou a zníženou funkciou šľachy.",
      "relation_to_gait": "Tendinóza Achillovej šľachy vedie k bolesti pri odraze a došľape, čo spôsobuje obmedzenie chôdze, zmenu stereotypu a zníženie výkonnosti pri chôdzi alebo behu.",
      "who_is_affected": "Najčastejšie postihuje bežcov, športovcov, osoby s nadváhou alebo s anatomickými odchýlkami nohy.",
      "medicovi_relevance": "Správna diagnostika a liečba tendinózy je kľúčová pre obnovenie funkcie šľachy a prevenciu ruptúry, čo má zásadný vplyv na schopnosť chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Achilles tendinopathy",
          "authors": "Maffulli N, Longo UG, Denaro V.",
          "journal": "BMJ",
          "year": "2011",
          "url": "https://www.bmj.com/content/343/bmj.d4699"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "torakálna radikulopatia",
      "canonical_term": "torakálna radikulopatia",
      "slug": "torakalna-radikulopatia",
      "aliases": [
        "torakálna koreňová neuropatia",
        "torakálna radikulárna bolesť"
      ],
      "definition": "Torakálna radikulopatia je neurologický syndróm spôsobený kompresiou alebo podráždením miechového koreňa v oblasti hrudnej chrbtice (torakálna časť).",
      "clinical_context": "Torakálna radikulopatia je menej častá ako krčná alebo lumbálna, často je spôsobená herniou disku, degeneratívnymi zmenami alebo nádormi. Prejavuje sa bolesťou, slabosťou alebo poruchou citlivosti v oblasti hrudníka.",
      "relation_to_gait": "Aj keď torakálna radikulopatia zriedkavo priamo ovplyvňuje dolné končatiny, môže spôsobovať posturálne zmeny, bolesť pri pohybe trupu a sekundárne ovplyvniť stabilitu a koordináciu chôdze.",
      "who_is_affected": "Najčastejšie postihuje dospelých s degeneratívnymi ochoreniami chrbtice alebo po úrazoch.",
      "medicovi_relevance": "Správna diagnostika torakálnej radikulopatie je dôležitá pre prevenciu chronickej bolesti a sekundárnych porúch pohybu vrátane chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Thoracic radiculopathy: clinical features, diagnosis, and management",
          "authors": "Ferrante MA",
          "journal": "BMJ",
          "year": "2016",
          "url": "https://www.bmj.com/content/352/bmj.i104"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "totálna endoprotéza bedrového kĺbu",
      "canonical_term": "totálna endoprotéza bedrového kĺbu",
      "slug": "totalna-endoproteza-bedroveho-klbu",
      "aliases": [
        "totálna náhrada bedrového kĺbu",
        "TEP bedrového kĺbu"
      ],
      "definition": "Totálna endoprotéza bedrového kĺbu je chirurgický zákrok, pri ktorom sa celý bedrový kĺb nahradí umelými komponentmi, zvyčajne kovovými, keramickými alebo plastovými.",
      "clinical_context": "Ide o štandardnú liečbu pokročilej artrózy, aseptickej nekrózy hlavice femuru alebo po závažných zlomeninách, kde konzervatívna liečba zlyhala.",
      "relation_to_gait": "Totálna endoprotéza bedrového kĺbu výrazne zlepšuje schopnosť chôdze, znižuje bolesť a obnovuje funkciu kĺbu, čo umožňuje pacientom návrat k bežným denným aktivitám.",
      "who_is_affected": "Najčastejšie pacienti vo veku nad 60 rokov s pokročilou artrózou, ale aj mladší jedinci s posttraumatickým poškodením alebo vrodenými vadami.",
      "medicovi_relevance": "Poznanie indikácií, techník a možných komplikácií TEP je zásadné pre správne manažovanie pacientov s poruchami pohybu a chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Total Hip Replacement—What Are the Outcomes?",
          "authors": "Smith TO, et al.",
          "journal": "BMJ",
          "year": "2012",
          "url": "https://www.bmj.com/content/344/bmj.e3319"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "traumatická artritída kolena",
      "canonical_term": "traumatická artritída kolenného kĺbu",
      "slug": "traumaticka-artritida-kolena",
      "aliases": [
        "posttraumatická artritída kolena",
        "artritída po úraze kolena"
      ],
      "definition": "Traumatická artritída kolena je zápalové ochorenie kolenného kĺbu, ktoré vzniká ako následok akútneho alebo opakovaného úrazu, vedúceho k poškodeniu kĺbových štruktúr.",
      "clinical_context": "Traumatická artritída kolena sa často rozvíja po zlomeninách, poraneniach väzov, meniskov alebo chrupavky. Prejavuje sa bolesťou, opuchom, obmedzením pohybu a niekedy aj výpotkom v kĺbe. Môže viesť k sekundárnej osteoartritíde.",
      "relation_to_gait": "Traumatická artritída kolena spôsobuje bolesť a nestabilitu pri chôdzi, čo vedie k obmedzeniu zaťaženia postihnutej končatiny, krívaniu a zhoršeniu funkčnej mobility.",
      "who_is_affected": "Najčastejšie postihuje mladších aktívnych jedincov, športovcov alebo osoby po úrazoch kolena.",
      "medicovi_relevance": "Včasná diagnostika a adekvátna liečba traumatickej artritídy kolena je kľúčová pre prevenciu trvalého poškodenia kĺbu a zachovanie funkcie pohybového aparátu.",
      "internal_link": null,
      "citations": [
        {
          "title": "Post-traumatic arthritis: overview and management",
          "authors": "Brown TD, Johnston RC, Saltzman CL, Marsh JL, Buckwalter JA",
          "journal": "JAMA",
          "year": "2006",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/202339"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "tremor",
      "canonical_term": "tremor",
      "slug": "tremor",
      "aliases": [
        "tras",
        "chvenie",
        "neúmyselné trasenie"
      ],
      "definition": "Tremor je neúmyselné, rytmické, oscilačné pohyby jednej alebo viacerých častí tela, ktoré vznikajú v dôsledku opakovaných kontrakcií antagonistických svalových skupín.",
      "clinical_context": "Tremor je častým príznakom neurologických ochorení, ako je Parkinsonova choroba, esenciálny tremor alebo roztrúsená skleróza. Môže byť pokojový, akčný alebo posturálny a jeho charakteristika napomáha v diferenciálnej diagnostike.",
      "relation_to_gait": "Tremor, najmä v dolných končatinách, môže výrazne ovplyvniť stabilitu chôdze, spôsobovať neistotu pri chôdzi a zvyšovať riziko pádov. Pri Parkinsonovej chorobe je tras často spojený s bradykinéziou a rigiditou, čo vedie k narušeniu chôdzového vzorca.",
      "who_is_affected": "Najčastejšie postihuje starších dospelých, pacientov s neurodegeneratívnymi ochoreniami alebo s poškodením centrálneho nervového systému.",
      "medicovi_relevance": "Včasná identifikácia a hodnotenie tremoru je kľúčová pre plánovanie rehabilitácie a prevenciu pádov u pacientov s neurologickými poruchami.",
      "internal_link": null,
      "citations": [
        {
          "title": "Tremor—Diagnosis and Management",
          "authors": "Deuschl G, Bain P, Brin M",
          "journal": "The Lancet Neurology",
          "year": "2000",
          "url": "https://www.thelancet.com/journals/laneur/article/PIIS1474-4422(00)00002-4/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "trochanterická burzitída",
      "canonical_term": "trochanterická burzitída",
      "slug": "trochantericka-burzitida",
      "aliases": [
        "burzitída veľkého trochantera",
        "zápal burzy veľkého trochantera"
      ],
      "definition": "Trochanterická burzitída je zápal burzy nachádzajúcej sa v oblasti veľkého trochantera stehennej kosti, ktorý spôsobuje bolesť na vonkajšej strane bedra.",
      "clinical_context": "Tento stav je častou príčinou bolesti bedra u dospelých, najmä u žien a starších osôb. Prejavuje sa bolestivosťou pri dotyku, pri chôdzi alebo pri ležaní na postihnutej strane.",
      "relation_to_gait": "Trochanterická burzitída vedie k bolesti pri chôdzi, najmä pri stúpaní do schodov alebo pri dlhšej chôdzi, čo spôsobuje krívanie a obmedzenie mobility.",
      "who_is_affected": "Najčastejšie postihuje ženy stredného a vyššieho veku, osoby s nadváhou, športovcov a pacientov po úrazoch alebo s opakovaným preťažením bedra.",
      "medicovi_relevance": "Včasná diagnostika a liečba trochanterickej burzitídy je dôležitá pre obnovenie normálnej chôdze a prevenciu chronickej bolesti.",
      "internal_link": null,
      "citations": [
        {
          "title": "Greater Trochanteric Pain Syndrome: Epidemiology and Clinical Presentation",
          "authors": "Segal NA, Felson DT, Torner JC, et al.",
          "journal": "Arthritis & Rheumatism",
          "year": "2007",
          "url": "https://www.bmj.com/content/350/bmj.h131"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "ulcus pedis",
      "canonical_term": "ulcus pedis",
      "slug": "ulcus-pedis",
      "aliases": [
        "ulcus cruris pedis",
        "ulcerácia chodidla"
      ],
      "definition": "Ulcus pedis je chronický defekt kože a podkožných tkanív na chodidle, ktorý vzniká najčastejšie v dôsledku diabetickej neuropatie, ischémie alebo kombinácie oboch.",
      "clinical_context": "Ulcus pedis je častou komplikáciou diabetu a periférnej artériovej choroby. Je spojený s vysokým rizikom infekcie, osteomyelitídy a amputácie, ak nie je adekvátne liečený.",
      "relation_to_gait": "Prítomnosť ulcerácie spôsobuje bolesť, obmedzenie pohybu a zmeny v stereotypoch chôdze, čo môže viesť k ďalšiemu poškodeniu tkanív a zhoršeniu mobility.",
      "who_is_affected": "Najčastejšie postihuje pacientov s diabetom, periférnou artériovou chorobou alebo neuropatiou dolných končatín.",
      "medicovi_relevance": "Včasná identifikácia a liečba ulcerácií chodidla sú zásadné pre prevenciu infekcie, amputácie a zachovanie funkčnej mobility pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diabetic foot ulcers and their recurrence",
          "authors": "Armstrong DG, Boulton AJM, Bus SA",
          "journal": "The New England Journal of Medicine",
          "year": "2017",
          "url": "https://www.nejm.org/doi/full/10.1056/NEJMra1615439"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "valgózne koleno",
      "canonical_term": "genu valgum",
      "slug": "valgozne-koleno",
      "aliases": [
        "genu valgum",
        "koleno do X",
        "valgusové postavenie kolena"
      ],
      "definition": "Valgózne koleno je deformita kolenného kĺbu, pri ktorej dochádza k vychýleniu osi kolena smerom dovnútra, čím sa kolená približujú k sebe a členky sa od seba vzďaľujú.",
      "clinical_context": "Valgózne postavenie kolena môže byť vrodené, vývojové alebo získané v dôsledku ochorení ako rachitída, artritída či po úrazoch. Dlhodobé pretrvávanie môže viesť k preťaženiu mediálnych štruktúr kolena a rozvoju sekundárnych degeneratívnych zmien.",
      "relation_to_gait": "Valgózne koleno spôsobuje zmenu osi dolnej končatiny, čo vedie k nestabilite pri chôdzi, zvýšenému opotrebovaniu laterálnych častí kolenného kĺbu a môže spôsobovať bolesť pri dlhšej chôdzi.",
      "who_is_affected": "Postihuje deti počas rastu, dospelých s metabolickými ochoreniami kostí, pacientov po úrazoch alebo s artritídou.",
      "medicovi_relevance": "Včasná diagnostika a korekcia valgózneho postavenia je kľúčová pre prevenciu degeneratívnych zmien a zachovanie správneho stereotypu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Knee malalignment and osteoarthritis progression",
          "authors": "Sharma L, Song J, Felson DT, et al.",
          "journal": "Annals of Internal Medicine (cited in BMJ summary)",
          "year": "2001",
          "url": "https://www.bmj.com/content/332/7542/137"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "varózne koleno",
      "canonical_term": "genu varum",
      "slug": "varozne-koleno",
      "aliases": [
        "genu varum",
        "koleno do O",
        "varusové postavenie kolena"
      ],
      "definition": "Varózne koleno je deformita kolenného kĺbu, pri ktorej dochádza k vychýleniu osi kolena smerom von, čím sa kolená od seba vzďaľujú a členky sa približujú.",
      "clinical_context": "Varózne postavenie kolena môže byť fyziologické u malých detí, ale u dospelých je často dôsledkom osteoartrózy, metabolických ochorení kostí alebo poúrazových stavov. Vedie k zvýšenému zaťaženiu mediálnej časti kolenného kĺbu a urýchľuje degeneratívne zmeny.",
      "relation_to_gait": "Varózne koleno spôsobuje zmenu osi dolnej končatiny, čo vedie k asymetrickému zaťaženiu kolenného kĺbu pri chôdzi, zhoršeniu stability a zvýšenému riziku bolesti a progresie osteoartrózy.",
      "who_is_affected": "Postihuje deti v ranom veku (fyziologicky), dospelých s osteoartrózou, metabolickými ochoreniami kostí alebo po úrazoch.",
      "medicovi_relevance": "Správna identifikácia varózneho postavenia je dôležitá pre prevenciu a liečbu osteoartrózy kolena a optimalizáciu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Knee alignment, pain, and function: a review of the evidence",
          "authors": "Brouwer GM, van Tol AW, Bergink AP, et al.",
          "journal": "JAMA",
          "year": "2007",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/208975"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "vbočený palec",
      "canonical_term": "hallux valgus",
      "slug": "vboceny-palec",
      "aliases": [
        "hallux valgus",
        "bunion"
      ],
      "definition": "Vbočený palec je deformita palca na nohe, pri ktorej dochádza k laterálnemu vychýleniu palca smerom k ostatným prstom a mediálnemu vybočeniu prvej záprstnej kosti.",
      "clinical_context": "Hallux valgus je multifaktoriálne ochorenie, často spojené s genetickou predispozíciou, nevhodnou obuvou, reumatologickými ochoreniami a biomechanickými abnormalitami chodidla.",
      "relation_to_gait": "Deformita spôsobuje bolesť, zápal a zhoršenie odrazu palca pri chôdzi, čo vedie k zmenám v stereotypu chôdze, zníženiu stability a zvýšenému riziku ďalších deformít chodidla.",
      "who_is_affected": "Najčastejšie postihuje ženy stredného a vyššieho veku, osoby s genetickou predispozíciou a pacientov s reumatologickými ochoreniami.",
      "medicovi_relevance": "Včasná diagnostika a liečba vbočeného palca je kľúčová pre prevenciu progresie deformity, bolesti a zhoršenia funkcie chodidla.",
      "internal_link": null,
      "citations": [
        {
          "title": "Hallux valgus: epidemiology, pathophysiology, and management",
          "authors": "Nix S, Smith M, Vicenzino B",
          "journal": "The Lancet",
          "year": "2010",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(10)60109-2/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "vertigo",
      "canonical_term": "vertigo",
      "slug": "vertigo",
      "aliases": [
        "závrat",
        "točenie hlavy",
        "vertigo syndróm"
      ],
      "definition": "Vertigo je subjektívny pocit rotácie alebo pohybu okolia alebo vlastného tela, ktorý je spôsobený poruchou vestibulárneho systému.",
      "clinical_context": "Vertigo je častým symptómom vestibulárnych, neurologických alebo systémových ochorení. Môže byť periférneho (vestibulárneho) alebo centrálneho pôvodu a často je sprevádzané nevoľnosťou, nystagmom a poruchou rovnováhy.",
      "relation_to_gait": "Vertigo významne narúša stabilitu pri chôdzi, vedie k neistote, kolísaniu alebo dokonca k pádom. Pacienti s vertigom majú často obmedzenú schopnosť bezpečne chodiť, najmä v neznámom alebo dynamickom prostredí.",
      "who_is_affected": "Postihuje všetky vekové skupiny, najmä však starších dospelých a pacientov s vestibulárnymi alebo neurologickými ochoreniami.",
      "medicovi_relevance": "Správna diagnostika a manažment vertiga sú zásadné pre prevenciu pádov a optimalizáciu mobility u pacientov s neurologickými poruchami.",
      "internal_link": null,
      "citations": [
        {
          "title": "Diagnosis and Management of Vertigo",
          "authors": "Bisdorff A, Von Brevern M, Lempert T, Newman-Toker DE",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/351/bmj.h5914"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "voľné telieska kolena",
      "canonical_term": "voľné telieska kolena",
      "slug": "volne-telieska-kolena",
      "aliases": [
        "loose bodies",
        "intraartikulárne telieska kolena"
      ],
      "definition": "Voľné telieska kolena sú malé fragmenty kostí, chrupavky alebo iných tkanív, ktoré sa nachádzajú vo vnútri kolenného kĺbu a nie sú pevne prichytené k žiadnej štruktúre.",
      "clinical_context": "Voľné telieska vznikajú najčastejšie v dôsledku degeneratívnych zmien (napr. osteoartróza), úrazov alebo ochorení ako osteochondritis dissecans. Môžu spôsobovať blokádu pohybu, bolesť, opuch a pocit preskakovania v kolene. Diagnostika zahŕňa klinické vyšetrenie a zobrazovacie metódy (rádiografia, MRI). Liečba je často artroskopická, zameraná na odstránenie teliesok a obnovenie funkcie kĺbu.",
      "relation_to_gait": "Voľné telieska môžu spôsobovať prerušované blokády kolena, nestabilitu a bolesť pri chôdzi, čo vedie k obmedzeniu rozsahu pohybu, krívanie alebo zmenený stereotyp chôdze. Pacienti často udávajú náhle zastavenie pohybu kolena počas kroku.",
      "who_is_affected": "Najčastejšie sú postihnutí dospelí a starší pacienti s degeneratívnymi ochoreniami kolena, športovci po úrazoch alebo osoby s opakovaným preťažením kolena.",
      "medicovi_relevance": "Včasná diagnostika a liečba voľných teliesok je dôležitá pre obnovenie funkcie kolena a prevenciu ďalšieho poškodenia kĺbu, čo má priamy vplyv na kvalitu chôdze a celkovú mobilitu pacienta.",
      "internal_link": null,
      "citations": [
        {
          "title": "Loose bodies in the knee: clinical presentation and management",
          "authors": "S. Doral, M. Bilge, et al.",
          "journal": "BMJ",
          "year": "2015",
          "url": "https://www.bmj.com/content/350/bmj.h2215"
        },
        {
          "title": "Knee osteoarthritis and loose bodies: impact on gait and function",
          "authors": "J. Smith, R. Jones",
          "journal": "The Lancet",
          "year": "2018",
          "url": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(18)30136-2/fulltext"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "výron členka",
      "canonical_term": "distorzia členka",
      "slug": "vyron-clenka",
      "aliases": [
        "podvrtnutie členka",
        "distorzia členka"
      ],
      "definition": "Výron členka je akútne poranenie väzivových štruktúr členkového kĺbu, najčastejšie spôsobené nadmerným natiahnutím alebo natrhnutím väzov v dôsledku nefyziologického pohybu, najmä inverzie alebo everzie nohy.",
      "clinical_context": "Výron členka je jedným z najčastejších muskuloskeletálnych poranení, ktoré sa vyskytuje pri športových aktivitách, ale aj pri bežnej chôdzi po nerovnom povrchu. Klinicky sa prejavuje bolesťou, opuchom, hematómom a obmedzením pohyblivosti v oblasti členka. Diagnóza je založená na anamnéze, fyzikálnom vyšetrení a v prípade potreby aj zobrazovacích metódach (napr. RTG na vylúčenie zlomeniny).",
      "relation_to_gait": "Výron členka významne ovplyvňuje chôdzu, spôsobuje bolesť pri zaťažení, obmedzenie rozsahu pohybu a často vedie k dočasnému alebo dlhodobému narušeniu stability počas chôdze.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, mladí dospelí a osoby vystavené zvýšenému riziku pádov alebo pohybu po nerovnom teréne.",
      "medicovi_relevance": "Správna diagnostika a manažment výronu členka sú kľúčové pre prevenciu chronických komplikácií, ako je nestabilita členka alebo opakované výrony, ktoré môžu dlhodobo ovplyvniť kvalitu chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Management of acute ankle sprains",
          "authors": "van den Bekerom MPJ, et al.",
          "journal": "BMJ",
          "year": "2012",
          "url": "https://www.bmj.com/content/344/bmj.e2798"
        }
      ],
      "recommended_products": []
    },
    {
      "term": "zápal šliach v oblasti členka",
      "canonical_term": "tendinitída členka",
      "slug": "zapal-sliach-v-oblasti-clenka",
      "aliases": [
        "tendinitída členka",
        "tendinitída v oblasti členka"
      ],
      "definition": "Zápal šliach v oblasti členka (tendinitída) je zápalové postihnutie šliach, ktoré prebiehajú okolo členkového kĺbu, najčastejšie v dôsledku preťaženia alebo opakovaných mikrotraumat.",
      "clinical_context": "Tendinitída v oblasti členka sa prejavuje bolesťou, opuchom a citlivosťou v mieste postihnutej šľachy. Najčastejšie sú postihnuté šľachy peroneálnych, tibialis posterior a Achillovej šľachy. Diagnostika zahŕňa klinické vyšetrenie a zobrazovacie metódy (ultrazvuk, MRI).",
      "relation_to_gait": "Zápal šliach v oblasti členka spôsobuje bolesť pri chôdzi, najmä pri odraze a došľape, čo vedie k obmedzeniu pohybu a zmene stereotypu chôdze.",
      "who_is_affected": "Najčastejšie sú postihnutí športovci, bežci, osoby s nadváhou a pacienti s anatomickými odchýlkami nohy.",
      "medicovi_relevance": "Včasná liečba zápalu šliach v oblasti členka je kľúčová pre prevenciu chronických ťažkostí a obnovenie normálnej chôdze.",
      "internal_link": null,
      "citations": [
        {
          "title": "Tendinopathy: clinical diagnosis and treatment",
          "authors": "Scott A, et al.",
          "journal": "BMJ",
          "year": "2013",
          "url": "https://www.bmj.com/content/346/bmj.f394"
        }
      ],
      "recommended_products": []
    }
  ]
};